(function() {
  'use strict';

  angular
    .module('winwins', [ 'mgo-angular-wizard', 'duScroll', 'winwins.config', 'ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngAria', 'restangular', 'ui.router', 'ngMaterial', 'toastr', 'satellizer', 'gettext', 'ngImgCrop', '720kb.socialshare', 'angular-loading-bar', 'infinite-scroll', 'am.date-picker', 'angular-google-analytics', 'ngTagsInput', 'angular.filter', 'textAngular', 'ezfb']);

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('winwin', winwin);

  /** @ngInject */
  function winwin($log, Restangular, $q) {

    var _winwin = {};

    var rWinwin = Restangular.all('winwins');
    var rParametric = Restangular.all('parametric');

    var abortUpload;

    _winwin.getInterests = function() {
      return rParametric.customGET('interests');
    };

    _winwin.getQuorums = function() {
      return rParametric.customGET('quorums');
    };


    _winwin.getTags = function() {
      return rParametric.customGET('tags');
    };

    _winwin.getList = function(page, filter, offset) {
      var default_offset = 15;
      var default_page = 0;
      var default_list = 'all';

      page  = typeof page !== 'undefined' ? page : default_page;
      filter = typeof filter !== 'undefined' ? filter : default_list;
      offset = typeof offset !== 'undefined' ? offset : default_offset;

      var paginateUrl = 'paginate' + '/' + page + '/' + offset + '/' + filter;
      return rWinwin.customGET(paginateUrl);
    };

    _winwin.getListByCategory = function(page, categories, offset) {
      var default_offset = 15;
      var default_page = 0;

      page  = typeof page !== 'undefined' ? page : default_page;
      offset = typeof offset !== 'undefined' ? offset : default_offset;

      var paginateUrl = 'paginate' + '/' + page + '/' + offset;
      return rWinwin.customGET(paginateUrl, {categories: [categories]});
    };

    _winwin.getWinwin = function(id) {
      return Restangular.one('winwins', id).get();
    }

    _winwin.getConversations = function(id) {
      return Restangular.one('winwins', id).customGET('conversations');
    };

    _winwin.saveWinwin = function(winwin) {
      return Restangular.all('winwins').post(winwin);
    };

    _winwin.editWinwin = function(winwin) {
      return Restangular.all('winwins').post(winwin);
    };

    _winwin.uploadImage = function(data, name) {
      var fd = new FormData();
      fd.append('file', data, name);

      return Restangular.one('winwins')
      .withHttpConfig({transformRequest: angular.identity})
      .customPOST(fd, 'upload', undefined, {'Content-Type': undefined})
    }

    _winwin.uploadPostImage = function(data, name) {
      _winwin.abortImageUpload();

      abortUpload = $q.defer();
      var fd = new FormData();
      fd.append('file', data, name);

      return Restangular.one('posts')
      .withHttpConfig({transformRequest: angular.identity, timeout: abortUpload.promise})
      .customPOST(fd, 'upload', undefined, {'Content-Type': undefined})
    }

    _winwin.abortImageUpload = function() {
      // Si quedó un upload anterior, lo cancelo
      if (abortUpload) abortUpload.resolve();
    }

    _winwin.getPosts = function(id) {
      return Restangular.one('posts/winwin', id).one('posts').get();
    }

    _winwin.createPost = function(post) {
      return Restangular.all('posts').post(post);
    }

    _winwin.updatePost = function(id, content) {
          return Restangular.one('posts', id).customPOST({
              content: content,
              type: 'WW_EDIT_POST'
          }, 'update', undefined, undefined);
      }


    _winwin.getGroups = function(id) {
      return Restangular.one('winwins').one('groups', id).get();
    }

    _winwin.createComment = function(id, content, media_id, media_type, media_path) {
      return Restangular.one('posts', id).customPOST({
        content: content,
        media_id: media_id,
        media_type: media_type,
        media_path: media_path,
        type: 'WW_COMMENT'
      }, 'comment', undefined, undefined);
    }

    _winwin.votePost = function(id, positive) {
      return Restangular.one('posts', id).customPOST({positive: positive}, 'vote', undefined, undefined);
    }

    _winwin.stickyPost = function(id, sticky) {
      return Restangular.one('posts', id).customPOST({sticky: sticky}, 'sticky', undefined, undefined);
    }

    _winwin.removePost = function(id) {
      return Restangular.one('posts', id).customPOST(undefined, 'remove', undefined, undefined);
    }

    _winwin.activate = function(id) {
      return Restangular.one('winwins/activate', id).get();
    }

    _winwin.campanada = function(id,body) {
      return Restangular.one('winwins/campanada', id).customPOST({body: body}, undefined, undefined, undefined);
    }

    _winwin.join = function(id) {
      return Restangular.one('winwins/join', id).get();
    }

    _winwin.left = function(id) {
     return Restangular.one('winwins/left', id).get();
    }

    _winwin.close = function(id, reason) {
     return Restangular.one('winwins', id).customPOST({body: reason}, 'close', undefined, undefined);
    }

    _winwin.setUserNormal = function(winwin_id, user_id) {
      return Restangular.one('winwins', winwin_id).one('state/normal', user_id).post();
    }

    _winwin.setUserActivator = function(winwin_id, user_id) {
      return Restangular.one('winwins', winwin_id).one('state/activator', user_id).post();
    }

    _winwin.shareMails = function(id, mails) {
      return Restangular.one('winwins', id).customPOST({mails: mails}, 'share/mails', undefined, undefined);
    }

    _winwin.createPoll = function(id, poll) {
     poll.type = "WINWIN";
     return Restangular.one('winwins', id).customPOST(poll, 'poll', undefined, undefined);
    }

    _winwin.getPoll = function(id) {
      return Restangular.one('polls', id).customGET("poll", {
        type: "WINWIN"
      });
    }

    _winwin.votePoll = function(poll) {
      return Restangular.one('poll', poll.id).one('vote', poll.selected_answer).customPOST({positive: true}, undefined, undefined, undefined);
    }

    _winwin.removePoll = function(id) {
      return Restangular.one('polls', id).remove();
    }

    _winwin.reportWinwin = function(report) {
       return Restangular.one('report/create').customPOST({
        reference_id: report.winwinId,
        type: report.type,
        reason: report.report_reason
      }, undefined, undefined, undefined);
    }

    _winwin.requestSponsorship = function(model) {
      return Restangular.one('winwins', model.winwinId).customPOST({org: model.org, contact: model.contact,
        tel: model.tel, email: model.email, msj: model.mensaje}, 'request/sponsorship', undefined, undefined);
    }

    return _winwin;
  }

})();

(function() {
  'use strict';

angular
  .module('winwins')
  .service('$wait', wait);

    wait.$inject = ['$mdDialog', '$rootScope', '$timeout', '$document', '$log'];

    function wait($mdDialog,  $rootScope, $timeout, $document){

     return {
       hideWait: hideWait,
       showWait: showWait,
       hideCancel: hideCancel,
       showCancel: showCancel,
       messageWait: messageWait
     }

     function messageWait(message) {
      $rootScope.$emit("message_wait", {message: message});
     }

     function hideWait(){
          $timeout(function(){
                   $rootScope.$emit("hide_wait");
                },5);
      }

     function showWait(message, _cancelAction){
              $timeout(function(){
                   $rootScope.$emit("cancel_action", {cancelAction: _cancelAction});
                },100);
              return $mdDialog.show({
                controller: 'WaitController',
                controllerAs: 'vm',
                templateUrl: 'app/components/utils/wait.tmpl.html',
                parent: angular.element($document[0].body),
                multiple: true,
                clickOutsideToClose:false,
                fullscreen: false,
                locals: {
                  message: message
                }
              });
       }

      function hideCancel(){
        $rootScope.$emit("hide_cancel");
      }

      function showCancel(){
        $rootScope.$emit("show_cancel");
      }
    }
})();

(function () {
    angular.module('winwins').controller('WaitController', WaitController);

    WaitController.$inject = ['$mdDialog', '$rootScope', '$log'];

    function WaitController($mdDialog, $rootScope, $log, message) {
        var vm = this;
        vm.showCancel = true;

        if (message) {
            vm.message = message;
        } else {
            vm.message = "";
        }

        var deregisterationCallback = $rootScope.$on("hide_wait", function (event, args) {
            $mdDialog.cancel();
        });

        var deregisterationCallback2 = $rootScope.$on("message_wait", function (event, args) {
            //$log.log(args.message);
            vm.message = args.message;
        });

        var deregisterationCallback3 = $rootScope.$on("hide_cancel", function (event, args) {
            vm.showCancel = false;
        });

        var deregisterationCallback4 = $rootScope.$on("show_cancel", function (event, args) {
            vm.showCancel = true;
        });

        var deregisterationCallback5 = $rootScope.$on("cancel_action", function (event, args) {
            vm.cancelAction = args.cancelAction;
            //$log.log(vm.cancelAction);
        });

    }
})();

(function () {
  'use strict'

  angular
    .module('winwins')
    .directive('statusRibbon', function () {
    return {
      restrict: 'E',
      scope: {
        backgroundColor: '@',
        caption: '@'
      },
      bindToController: true,
      controllerAs: 'vm',
      controller: function(){
        // nothing, so far...
      },
      compile: function(element, attrs){
         if (!attrs.color) { attrs.color = '#4cae4e'; }
         if (!attrs.caption) { attrs.caption = 'Testing'; }
      },
      templateUrl: 'app/components/utils/statusribbon.tmpl.html'
    }
  });



})();

(function() {
  'use strict';

angular
  .module('winwins')
  .directive('scroll', function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attr) {
      scope.$watchCollection(attr.scroll, function(newVal) {
        $timeout(function() {
         element[0].scrollTop = element[0].scrollHeight;
        });
      });
    }
  }
});


})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('user', user);

  /** @ngInject */
  function user($log, Restangular) {

    var _user = {};
    var rActivities = Restangular.all('activities');


    _user.getUser = function(id) {
    $log.log()
      return Restangular.one('users', id).get();
    };

    _user.getConversations = function(id) {
      return Restangular.one('users', id).customGET('conversations');
    };

    _user.saveProfile = function(user) {
      return Restangular.all('profile').post(user);
    };

    _user.resendActivationMail = function() {
      return Restangular.one('users/resend/activation').get();
    }

    _user.getGroups = function() {
      return Restangular.one('groups/creator').get();
    }

    _user.sendMailContact = function(contact) {
      return Restangular.one('users').customPOST({contact:contact}, 'sent_mail_contact', undefined, undefined);
    }

    _user.getSkills = function(queryText) {
      return Restangular.all('skills').customPOST({ q: queryText }, "search", undefined, undefined);
    }

    _user.getNotifications = function(id, page, offset) {
      var default_offset = 15;
      var default_page = 0;

      page  = typeof page !== 'undefined' ? page : default_page;
      offset = typeof offset !== 'undefined' ? offset : default_offset;

      var paginateUrl = 'notifications' +  '/' + page + '/' + offset;

      return Restangular.one('users', id).customGET(paginateUrl);
    };

    _user.follow = function (id){
      return Restangular.one('users/follow', id).get();
    }

    _user.unfollow = function (id){
      return Restangular.one('users/unfollow', id).get();
    }

    _user.sendMessage = function(msj) {
          return Restangular.all('users/send').post(msj);
    }

     _user.removeMsg = function(id) {
          return Restangular.one('users/messages', id).customPOST(undefined, 'removeMessage', undefined, undefined);
      }

     _user.getActivities = function(id, page, offset) {
         var default_offset = 5;
         var default_page = 0;

         page  = typeof page !== 'undefined' ? page : default_page;
         offset = typeof offset !== 'undefined' ? offset : default_offset;

         var paginateUrl = 'users'+ '/' + id + '/' + 'activities' + '/' + page + '/' + offset;


         return rActivities.customGET(paginateUrl);

      }


    return _user;
  }

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('sponsor', sponsor);

  /** @ngInject */
  function sponsor($log, Restangular) {

    var _sponsor = {};

    var rSponsors = Restangular.all('sponsors');

    _sponsor.getMainList = function() {
      return rSponsors.customGET('main');
    };

    _sponsor.getList = function(page, offset) {
      var default_offset = 15;
      var default_page = 0;

      page = typeof page !== 'undefined' ? page : default_page;
      offset = typeof offset !== 'undefined' ? offset : default_offset;

      var paginateUrl = 'paginate' + '/' + page + '/' + offset + '/';
      return rSponsors.customGET(paginateUrl);
    };

    _sponsor.getListByWinwin = function(winwin_id) {
      return Restangular.one('winwins', winwin_id).one('sponsors').get();  
    }

    return _sponsor;
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeSponsor', acmeSponsor);

  /** @ngInject */
  function acmeSponsor() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sponsor/sponsor.html',
      scope: {
        items: '=',
        title: '=',
        viewmore: '='
      },
      controller: ['ENV', SponsorController],
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function SponsorController(ENV) {
      var vm = this;
      vm.imageServer = ENV.imageServer;
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('search', search);

  /** @ngInject */
  function search($log, Restangular) {

    var _search = {};

    _search.search = function(query) {
      return Restangular.one('ww').customGET('search', {q: query});
    };

    return _search;
  }

})();
(function() {
  'use strict';

  angular
      .module('winwins')
      .service('partner', partner);

  /** @ngInject */
  function partner($log, Restangular, $q) {

    var _partner = {};

    var testData = [
      { id: 1, nombre: 'Partner1' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet1.com' },
      { id: 2, nombre: 'Partner2' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet2.com' },
      { id: 3, nombre: 'Partner3' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet3.com' },
      { id: 4, nombre: 'Partner4' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet4.com' },
      { id: 5, nombre: 'Partner5' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet5.com' },
      { id: 6, nombre: 'Partner6' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet6.com' },
      { id: 7, nombre: 'Partner7' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet7.com' },
      { id: 8, nombre: 'Partner8' , imagen: 'assets/images/partner.jpg', link: 'http://www.partnet8.com' }
    ];

    _partner.getList = function() {
      var dfd = $q.defer();
      dfd.resolve(testData);
      return dfd.promise;
    };

    return _partner;
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmePartner', acmePartner);

  /** @ngInject */
  function acmePartner() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partner/partner.html',
      scope: {
        items: '='
      },
      controller: [ 'ENV', PartnerController ],
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function PartnerController(ENV) {
      var vm = this;
      vm.imageServer = ENV.imageServer;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment, $mdSidenav, $rootScope, ENV, $auth, account, $mdDialog, $document, user, $window, search, $state, $log) {
      var vm = this;

      vm.imageServer = ENV.imageServer;
      vm.isActive = true;
      vm.userId = null;
      vm.sentActivationMail = false;

      vm.search_query = "";

      vm.isAuthenticated = function() {
        return $auth.isAuthenticated();
      };

      vm.back = function() {
        history.back();
        vm.apply();
      };

      var event1 = $rootScope.$on('account_change',function(event){
        if (vm.isAuthenticated()) {
          account.getProfile()
          .then(function(data) {
            $log.log(data);
            vm.account = data.profile;
            vm.account.email = data.user.email;
            vm.isActive = data.active;
            vm.userId = data.user.id;

            user.getUser(data.user.id)
            .then(function(user_data) {
              vm.notifications = $window._.sortBy(user_data.notifications, function(notification) {
                return -notification.id;
              });
            });
          });
        }
      });

      $rootScope.$broadcast('account_change');

      vm.openLeftMenu = function() {
        $mdSidenav('left').toggle();
      };

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();

      vm.onChange = function(event, state) {
        var es = ENV.availableLangs[0];
        var en =  ENV.availableLangs[1];
        var args = ((state === true)? en : es);
        $rootScope.$emit(event, args);
      };

      vm.logout = function () {
        $auth.logout();
      };

      vm.search = function() {
        if (vm.search_query.trim().length > 0) {
          $state.go('home.search', {
            query: vm.search_query
          });
        }
      }

      vm.showLoginDialog = function(redirect) {
        if (redirect) {
          $rootScope.returnState = {
            state: redirect
          };
        }
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        });
      };

      vm.showNotificationsDialog = function(redirect) {
        $mdDialog.show({
          controller: 'NotificationsController',
          controllerAs: 'vm',
          templateUrl: 'app/notifications/notifications.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true,
          locals: {
              notifications: vm.notifications,
              current_user: vm.account
            }
        });
      };

      vm.resendActivationMail = function() {
        user.resendActivationMail()
        .then(function() {
          vm.sentActivationMail = true;
        });
      };
    }
  }

  angular
    .module('winwins')
    .directive('enter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if(event.which === 13) {
                scope.$apply(function (){
                    scope.$eval(attrs.enter);
                });

                event.preventDefault();
            }
        });
    };
  })

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('miembro', miembro);

  /** @ngInject */
  function miembro($log, Restangular) {

    var _miembro = {};

    var rMiembro = Restangular.all('users');

    _miembro.getList = function(page, offset, order) {
      var default_offset = 15;
      var default_page = 0;
      var default_order = 'lastname';

      page  = typeof page !== 'undefined' ? page : default_page;
      offset = typeof offset !== 'undefined' ? offset : default_offset;
      order = typeof order !== 'undefined' ? order : default_order;

      var paginateUrl = 'paginate' + '/' + page + '/' + offset + '/' + order;
      return rMiembro.customGET(paginateUrl);
    };

    return _miembro;
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeMiembro', acmeMiembro);

  /** @ngInject */
  function acmeMiembro() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/miembro/miembro.html',
      scope: {
        items: '=',
        hideExtra: '=',
        scroll: '&onScroll'
      },
      controller: MiembroController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MiembroController(ENV, $mdDialog, $document, $auth) {
      var vm = this;
      vm.imageServer = ENV.imageServer;

      vm.isAuthenticated = function() {
        return $auth.isAuthenticated();
      };
      
      vm.showLoginDialog = function(ev) {
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose:true
        });
      };

      vm.nextPage = function() {
        vm.scroll();
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeHighlighted', acmeHighlighted);



      /** @ngInject */
  function acmeHighlighted() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/highlighted/highlighted.html',
      scope: {
        items: '=',
        title: '=',
        icon: '=',
        viewmore: '=',
        loading: '=',
        showDescription: '='


      },
      controller: HighlightedController,
      controllerAs: 'vm',
      bindToController: true,
      compile: function(element, attrs) {
        if (!attrs.showDescription) {
          attrs.showDescription = true;
        }
      }
    };

    return directive;

    /** @ngInject */
    function HighlightedController(ENV) {
      var vm = this;
      vm.imageServer = ENV.imageServer;
      vm.base = ENV.base;
      vm.facebookId = ENV.satellizer.facebook.clientId;
    }

    /** @ngInject */
    function ModalShareController(current_winwin, ENV) {
      var vm = this;

      vm.base = ENV.base;
      vm.imageServer = ENV.imageServer;
      vm.facebookId = ENV.satellizer.facebook.clientId;
      vm.winwin = current_winwin;
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('winwins')
        .controller('MisGruposListController', MisGruposListController);

  /** @ngInject */
  function MisGruposListController(ENV, user) {
    var vm = this;

    vm.imageServer = ENV.imageServer;

    user.getGroups().then(function(data) {
      vm.grupos = data;
    });
  }

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('grupo', grupo);

  /** @ngInject */
  function grupo($log, Restangular) {

    var _grupo = {};

    var rGrupo = Restangular.all('groups');
    var rParametric = Restangular.all('parametric');

    _grupo.getList = function(page, offset) {
      var default_offset = 15;
      var default_page = 0;

      page  = typeof page !== 'undefined' ? page : default_page;
      offset = typeof offset !== 'undefined' ? offset : default_offset;

      var paginateUrl = 'paginate' + '/' + page + '/' + offset;
      return rGrupo.customGET(paginateUrl);
    };

    _grupo.getInterests = function() {
      return rParametric.customGET('interests');
    };

    _grupo.getGroup = function(id) {
      return Restangular.one('group', id).get();
    }

    _grupo.saveGrupo = function(grupo) {
       return Restangular.all('groups').post(grupo);
    };

    _grupo.close = function(id, reason) {
     return Restangular.one('group', id).customPOST({body: reason}, 'close', undefined, undefined);
    }

    _grupo.uploadImage = function(data, name) {
      var fd = new FormData();
      fd.append('file', data, name);

      return Restangular.one('groups')
          .withHttpConfig({transformRequest: angular.identity})
          .customPOST(fd, 'upload', undefined, {'Content-Type': undefined})
    }

    _grupo.getPosts = function(id) {
      return Restangular.one('posts/group', id).one('posts').get();
    }

    _grupo.createPost = function(post) {
      return Restangular.all('posts').post(post);
    }

    _grupo.createComment = function(id, content, media_id, media_type, media_path) {
      return Restangular.one('posts', id).customPOST({
        content: content,
        media_id: media_id,
        media_type: media_type,
        media_path: media_path,
        type: 'WWG_COMMENT'
      }, 'comment', undefined, undefined);
    }

    _grupo.votePost = function(id, positive) {
      return Restangular.one('posts', id).customPOST({positive: positive}, 'vote', undefined, undefined);
    }

    _grupo.stickyPost = function(id, sticky) {
      return Restangular.one('posts', id).customPOST({sticky: sticky}, 'sticky', undefined, undefined);
    }

    _grupo.removePost = function(id) {
      return Restangular.one('posts', id).customPOST(undefined, 'remove', undefined, undefined);
    }

    _grupo.join = function(id){
      return Restangular.one('groups/join', id).get();
    }

    _grupo.left = function(id) {
     return Restangular.one('groups/left', id).get(); 
    }

    _grupo.addWinwin = function(groupId, winwinId){
      return Restangular.one('groups', groupId).one('add_winwin', winwinId).get();
    }

    _grupo.shareMails = function(id, mails) {
      return Restangular.one('groups', id).customPOST({mails: mails}, 'share/mails', undefined, undefined);
    }

    _grupo.uploadPostImage = function(data, name) {
      var fd = new FormData();
      fd.append('file', data, name);

      return Restangular.one('posts')
      .withHttpConfig({transformRequest: angular.identity})
      .customPOST(fd, 'upload', undefined, {'Content-Type': undefined})
    }

    _grupo.createPoll = function(id, poll) {
     poll.type = "GROUP";
     return Restangular.one('winwins', id).customPOST(poll, 'poll', undefined, undefined);
    }

    _grupo.getPoll = function(id) {
      return Restangular.one('polls', id).customGET("poll", {
        type: "GROUP"
      });
    }

    _grupo.votePoll = function(poll) {
      return Restangular.one('poll', poll.id).one('vote', poll.selected_answer).customPOST({positive: true}, undefined, undefined, undefined);
    }

    _grupo.removePoll = function(id) {
      return Restangular.one('polls', id).remove();
    }


    return _grupo;
  }

})();

(function() {
    'use strict';

    angular
        .module('winwins')
        .directive('groupList', groupList);

    /** @ngInject */
    function groupList() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/group_list/group_list.html',
            scope: {
                items: '=',
                title: '=',
                viewmore: '=',
                scroll: '&onScroll'
            },
            controller: GroupListController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    /** @ngInject */
    function GroupListController(ENV, grupo) {
        var vm = this;
        vm.imageServer = ENV.imageServer;
    }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeFooter', acmeFooter);

  /** @ngInject */
  function acmeFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
        items: '='
      },
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController($mdDialog, $document, $rootScope, $auth) {
      var vm = this;

      vm.isAuthenticated = function() {
        return $auth.isAuthenticated();
      };
      
      vm.showLoginDialog = function(redirect) {
        if (redirect) {
          $rootScope.returnState = {
            state: redirect
          };
        }
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        });
      };

      vm.showQueEsDialog = function() {
        $mdDialog.show({
          controller: function() {},
          controllerAs: 'vm',
          templateUrl: 'app/components/footer/que-es-winwins.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        });
      }
    }
  }

  angular
    .module('winwins')
    .directive('scrollTop', function() {
    return {
      restrict: 'A',
      link: function(scope, $elm) {
        $elm.on('click', function() {
          angular.element("body").animate({scrollTop: angular.element("body").offset().top}, "slow");
        });
      }
    };
  });

  angular
    .module('winwins')
    .directive("scroll", function ($window, $document) {
    return function(scope, element, attrs) {
      angular.element($window).bind("scroll", function() {
        scope.boolChangeClass = this.pageYOffset >= 100 && $document[0].body.scrollHeight - this.pageYOffset - $window.innerHeight >= 260;
        scope.$apply();
      });
    };
  });

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .directive('acmeContador', acmeContador);

  /** @ngInject */
  function acmeContador() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/contador/contador.html',
      scope: {
        items: '='
      },
      controller: ContadorController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function ContadorController() {
      //var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('winwins')
      .service('account', account);

  /** @ngInject */
  function account($log, Restangular, $http, ENV) {

    var _account = {};

    var rAccount = Restangular.one('me');

    _account.getProfile = function() {
      return rAccount.get();
    };

    _account.uploadImage = function(data, name) {
      var fd = new FormData();
      fd.append('file', data, name);

      return rAccount
      .withHttpConfig({transformRequest: angular.identity})
      .customPOST(fd, 'upload', undefined, {'Content-Type': undefined})
    }

    _account.emailResetPass = function(email){
      return $http.post(ENV.base + '/password/email', {"email": email});
    }

    _account.notificactionsRed = function(user){
      return rAccount.customGET('notificactions/read', {user: user});
    }

    _account.notificactionRed = function(user, id){
      return rAccount.one('notificactions/read',id).get({user: user});
    }

    return _account;
  }

})();

(function() {
  'use strict';

  angular
  .module('winwins')
  .controller('WinwinController', WinwinController);

  /** @ngInject */
  function WinwinController($scope, $stateParams, winwin, ENV, $mdDialog, $document, $sce, account, $auth, $rootScope, $window, $q, user, sponsor, $log, $state, $wait) {
    var vm = this;

    var alert = function showAlert(title, text) {
      alert = $mdDialog.alert({
        title: title,
        textContent: text,
        ok: 'Continuar',
        clickOutsideToClose: true
      });

      $mdDialog
      .show( alert )
      .finally(function() {
        alert = undefined;
      });
    }

    vm.base = ENV.base;
    vm.imageServer = ENV.imageServer;
    vm.facebookId = ENV.satellizer.facebook.clientId;

    vm.winwinId = $stateParams.winwinId;
    vm.showFirstPostModal = $stateParams.showFirstPostModal;
    var confirmation = $stateParams.confirmation;

    vm.post = [];
    vm.postInputFocus = false;


    var updateWinwin = function(){
      var p1 = winwin.getWinwin(vm.winwinId).then(function(winwin_data) {

        vm.winwin = winwin_data;
        $log.log(typeof vm.winwin.closing_date == "string")
        if (typeof vm.winwin.closing_date == "string")
          vm.winwin.closing_date = new Date(vm.winwin.closing_date.replace(/-/g,"/")); // Necesario para evitar null en safari
        else
          vm.winwin.closing_date = new Date(vm.winwin.closing_date);
        vm.polls = vm.winwin.polls;

        vm.quorum_fijo = winwin_data.quorum_data[0].name == 'QUORUM_FIJO';
        vm.quorum_movil = winwin_data.quorum_data[0].name == 'QUORUM_MOVIL';
        vm.quorum_ilimitado = winwin_data.quorum_data[0].name == 'QUORUM_ILIMITADO';
        vm.sanitized_description = $sce.trustAsHtml(winwin_data.description);

        account.getProfile().then(function(data) {
          vm.account = data.profile;
          vm.user_id = data.user.id;
          vm.campanadas = winwin_data.campanadas;
          vm.isCreator = winwin_data.user_id == vm.user_id;
          vm.showSendMessageButton = function(){
            return (vm.isAuthenticated() && !vm.winwin.is_moderator && vm.conversations.length == 0);
          }
        });


        $window._.each(vm.polls, function(poll) {
          winwin.getPoll(poll.id).then(function(data) {
            poll.data = data;
          });
        });

        // sponsor.getListByWinwin(vm.winwinId).then(function(sponsor_data) {
        //   vm.sponsors = $window._.filter(sponsor_data, function(model) {
        //     return model.pivot.ww_accept == 1 && model.pivot.sponsor_accept == 1;
        //   });
        // });

        sponsor.getList().then(function(sponsor_data) {
          vm.sponsors = sponsor_data;
        });

        vm.post = {content: '', reference_id: winwin_data.id, type: 'WINWIN'};

          if (vm.showFirstPostModal) {
          $mdDialog.show({
            controller: FirstPostModalController,
            controllerAs: 'winwin',
            templateUrl: 'app/winwin/modal-first-post-and-share.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            locals: {
              parent_ctrl : vm
            }
          }).then(function(){
            var postInput = $window.document.getElementById("post-input-focus");
            if (postInput) {
              postInput.focus();
            }
          });
        }
      });
      var p2 = winwin.getConversations(vm.winwinId)
                .then(function(conversations) {
                  vm.conversations = conversations.filter(function (element) {
                        return element.winwin_id == vm.winwinId;
                    });

                });
      return $q.all([p1, p2]);
    };

    var wwPromise = updateWinwin();

    winwin.getPosts(vm.winwinId).then(function(posts_data) {
      vm.posts = posts_data.posts;
    });

    vm.submitPost = function() {
      var goOn = true;
      if (vm.post.content == '' && !vm.post.media_path && !vm.post.cover_post_image) {
        return;
      }

      if (vm.post.media_type == 'IMAGE' && vm.post.cover_post_image) {
        $wait.showWait("Enviando imagen...", cancelUpload);
        winwin.uploadPostImage(dataURItoBlob(vm.post.cover_post_image.file), vm.post.cover_post_image.name)
        .then(function(data) {
            $wait.hideWait();
            $wait.hideCancel();
            if (vm.post.cover_post_image) {
              vm.post.media_id = data.media_id;
              vm.post.media_path = data.filename;
              vm.post.cover_post_image = null;
            }
            if (goOn) {
              finishSubmitPost(data);
            }
          }, function (reason) {
            $wait.hideWait();
            $log.log('Upload failed');
            $log.log(reason);
          });
      } else {
        if (goOn) {
          finishSubmitPost([]);
        }
      }

      function cancelUpload() {
        $log.log("cancelando...")
        goOn = false;
        winwin.abortImageUpload();
      }
    };


    var finishSubmitPost = function(data) {

        vm.post.user_id = vm.user_id;
        winwin.createPost(vm.post)
        .then(function(data){
          $rootScope.$broadcast('post-submitted');
          if (!vm.winwin.published && !vm.winwin.canceled) {
            winwin.activate(vm.winwinId).then(function() {
              vm.winwin.published = true;
            });
          }

          winwin.getPosts(vm.winwinId).then(function(posts_data) {
            vm.posts = posts_data.posts;
          });
          vm.post = {content: '', reference_id: vm.winwinId, type: 'WINWIN'}
        });
    };

    vm.reportWinwin = function() {
      $mdDialog.show({
        controller: ReportController,
        controllerAs: 'vm',
        templateUrl: 'app/reports/modal_confirm_send_report.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          winwinId: vm.winwinId
        }
      });
    }

    vm.showMessageModal = function(conversationId, conversation_messages) {
      var updateFlag = conversation_messages.length==0;
      $mdDialog.show({
        controller: MessageModalController,
        controllerAs: 'msgController',
        templateUrl: 'app/profile/message-modal-controller.tmpl.html',
        clickOutsideToClose: true,
        locals: {
          myself_id: vm.account.id,
          conversation_id: conversationId,
          to_user_id: vm.winwin.user_id,
          conversation_messages: conversation_messages,
          winwin_id: vm.winwinId
        }
      }).then(function(message){
        // Se creó una nueva conversación en el winwin y hay que cargarla
        if (updateFlag)
          updateWinwin(); // TODO: cambiar a un updateConversations para hacerlo más rápido
      });
    }

    vm.showRequestSponsorshipMessageModal = function() {
      $mdDialog.show({
        controller: RequestSponsorshipModalController,
        controllerAs: 'reqSponsorController',
        templateUrl: 'app/winwin/request-sponsorship-modal-controller.tmpl.html',
        clickOutsideToClose: true,
        locals: {
          winwin_id: vm.winwinId
        }
      });
    }

    var dataURItoBlob = function(dataURI) {
      var binary = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var array = [];
      for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {type: mimeString});
    };

    vm.getIframeSrc = function (videoId) {
      return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+videoId+'?autoplay=0');
    };

    /* Esta regla se movió al backend
    vm.canJoin = function() {
      if (vm.winwin && vm.winwin.quorum_data) {
        var quorum_data_name = vm.winwin.quorum_data[0].name;
        return (quorum_data_name == "QUORUM_FIJO" && vm.winwin.published && !vm.winwin.is_successful && !vm.winwin.already_joined && !vm.winwin.canceled) ||
        (quorum_data_name == "QUORUM_MOVIL" && vm.winwin.published && !vm.winwin.saturated && !vm.winwin.already_joined && !vm.winwin.canceled) ||
        (quorum_data_name == "QUORUM_ILIMITADO" && vm.winwin.published && !vm.winwin.already_joined && !vm.winwin.canceled);
      } else
      return undefined;
    }
    */

    vm.join = function() {
      if($auth.isAuthenticated()) {
        if (vm.winwin.canJoin)
          $mdDialog.show({
            controller: ModalConfirmacionSumarseController,
            controllerAs: 'vm',
            templateUrl: 'app/winwin/modal-confirmacion-sumarse.tmpl.html',
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: true,
            locals: {
              winwin_id: vm.winwinId,
              winwin_image: vm.winwin.image
            }
          });
      } else {
        $rootScope.returnState = {
          state : 'no_redir'
        };
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        }).then(function(success) {
          if (success)
            updateWinwin().then( function() {
              vm.join();
            });
        })
      }
    }

    vm.showGroupsModal = function() {
      winwin.getGroups(vm.winwinId).then(function(groups_data){
        vm.grupos = groups_data;
        account.getProfile().then(function(data) {
          vm.user_id = data.profile.id;
          user.getUser(data.user.id).then(function(user_data){
            vm.user_groups = user_data.groups;
            $mdDialog.show({
              controller: ModalBindWinwinToGroup,
              controllerAs: 'vm',
              templateUrl: 'app/grupo/modal-vincular-grupo-a-winwin.tmpl.html',
              parent: angular.element($document.body),
              clickOutsideToClose: true,
              locals: {
                group_list: vm.grupos,
                user_groups: vm. user_groups,
                winwin_id: vm.winwinId
              }
            });
          });
        });
      });
    }

    vm.left = function() {
      return $mdDialog.show({
        controller: ModalAbandonarController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-abandonar.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_winwin: vm.winwin
        }
      })
      .then(function(data) {
        winwin.getWinwin(vm.winwinId).then(function(winwin_data) {
          vm.winwin = winwin_data;
          if (typeof vm.winwin.closing_date == "string")
            vm.winwin.closing_date = new Date(vm.winwin.closing_date.replace(/-/g,"/")); // Necesario para evitar null en safari
          else
            vm.winwin.closing_date = new Date(vm.winwin.closing_date);
        });
      });
    }

    vm.close = function() {
      $mdDialog.show({
        controller: ModalCloseController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-close.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_winwin: vm.winwin
        }
      })
      .then(function(data) {
        winwin.getWinwin(vm.winwinId).then(function(winwin_data) {
          vm.winwin = winwin_data;
          if (typeof vm.winwin.closing_date == "string")
            vm.winwin.closing_date = new Date(vm.winwin.closing_date.replace(/-/g,"/")); // Necesario para evitar null en safari
          else
            vm.winwin.closing_date = new Date(vm.winwin.closing_date);
        });
      });
    }

    vm.vote = function(post, positive) {
      winwin.votePost(post.id, positive).then(function() {
        winwin.getPosts(vm.winwinId).then(function(posts_data) {
          vm.posts = posts_data.posts;
        });
      });
    };

    vm.setSticky = function(post, sticky) {
      winwin.stickyPost(post.id, sticky).then(function() {
        winwin.getPosts(vm.winwinId).then(function(posts_data) {
          vm.posts = posts_data.posts;
        });
      });
    };

    vm.removePost = function(post) {
      $mdDialog.show({
        controller: ModalRemoveController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-remove.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_post: post
        }
      })
      .then(function(data) {
        winwin.getPosts(vm.winwinId).then(function(posts_data) {
          vm.posts = posts_data.posts;
        });
      });
    };

    vm.votePoll = function(poll) {
      winwin.votePoll(poll).then(function() {
        $window._.each(vm.polls, function(poll) {
          winwin.getPoll(poll.id).then(function(data) {
            poll.data = data;
          });
        });
      });
    }

      vm.showRemovePoll = function(poll) {
          $mdDialog.show({
              controller: ModalRemovePollController,
              controllerAs: 'vm',
              templateUrl: 'app/winwin/modal-remove-poll.tmpl.html',
              parent: angular.element($document.body),
              clickOutsideToClose:true,
              locals: {
                  current_poll: poll
              }
          })
              .then(function() {
                  $state.reload()
                  });
      };

    vm.percentage_votes = function(poll, answer) {
      if(!poll.data.total_votes) {
        return 0;
      }
      var result = (answer.vote_count * 100 / poll.data.total_votes);
      return result;
    };

    vm.showCampanadasDialog = function() {
      $mdDialog.show({
        controller: CampanadasController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-campanadas.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          campanadas: vm.campanadas,
          winwin_id: vm.winwinId,
          current_user: vm.account,
          is_creator: vm.isCreator
        }
      });
    }

    vm.showReplyDialog = function(post) {
      vm.modalReply = {
        controller: ReplyController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-comment.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        preserveScope:true,
        locals: {
          current_post: post,
          current_account: vm.account,
          current_scope: vm,
          comment: {},
          cover_comment_image: null
        }
      }

      $mdDialog.show(vm.modalReply).then(function(data) {
        winwin.getPosts(vm.winwinId).then(function(posts_data) {
          vm.posts = posts_data.posts;
        });
      });
    };

    vm.showMasDetalleDialog = function(ev) {
      $mdDialog.show({
        controller: MasDetalleController,
        templateUrl: 'app/winwin/ver-mas-detalle.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        locals: {
          winwin: vm.winwin
        }
      });
    };

    vm.showModalVideoPostDialog = function(ev) {
      $mdDialog.show({
        controller: ModalVideoPostController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-video-post.tmpl.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose:true
      })
      .then(function(video) {
        vm.post.media_type = 'VIDEO';
        vm.post.media_path = video;
      });
    };

    vm.showModalShareEmailDialog = function() {
      $mdDialog.show({
        controller: ModalShareEmailController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-share-email.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_winwin: vm.winwin
        }
      });
    }

    vm.showModalPollDialog = function() {
      $mdDialog.show({
        controller: ModalPollController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-poll.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_winwin: vm.winwin
        }
      })
      .then(function(data) {
        vm.polls.push(data);
        $window._.each(vm.polls, function(poll) {
          winwin.getPoll(poll.id).then(function(data) {
            poll.data = data;
          });
        });
      });
    }

    vm.showParticipantesDialog = function(ev) {
      $mdDialog.show({
        controller: ParticipantesController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/participantes.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        locals: {
          users: vm.winwin.users,
          winwin_id: vm.winwin.id,
          is_moderator: vm.winwin.is_moderator
        }
      })
      .then(null, function(){
        winwin.getWinwin(vm.winwinId).then(function(winwin_data) {
          vm.winwin = winwin_data;
        });
      });
    };

    vm.showCropPostImageDialog = function(ev) {
      $mdDialog.show({
        controller: CropPostImageController,
        templateUrl: 'app/winwin/cover_post_image.tmpl.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose:true
      })
      .then(function(image) {
        vm.post.media_type = 'IMAGE';
        vm.post.cover_post_image = image;
      });
    };

    vm.removeCoverPostImageOrVideo = function() {
      vm.post.media_type = null;
      vm.post.cover_post_image = null;
    }

    vm.showSharePost = function(post) {
      $mdDialog.show({
        controller: ModalSharePostController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-share-post.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true,
        locals: {
          current_post: post
        }
      });
    }
    vm.isAuthenticated = function() {
      return $auth.isAuthenticated();
    };

    var confirm = function() {
      switch (confirmation) {
        case "yes":
        if (!vm.winwin.already_joined)
          winwin.join(vm.winwinId).then(function (data) {
            updateWinwin()
          });
        alert('','¡Muchas gracias por confirmar!');
        break;
        case "no":
        if (vm.winwin.already_joined)
          vm.left().then(function (){
            alert('','Has abandonado este Winwin');
          });
        break;
      }
    }

    var afterLogin = function(loggedMethod, notLoggedMethod, redir) {
      if($auth.isAuthenticated()) {
        loggedMethod();
      } else {
        $rootScope.returnState = {
          state : redir
        };
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        }).then(function(success) {
          notLoggedMethod();
        })
      }
    };

    if (confirmation == "yes" || confirmation == "no")
      wwPromise.then(function() {
        afterLogin(confirm, function(){
          updateWinwin().then(function () {
            confirm();
          });
        },'no_redir');
      });


      vm.editPost = function() {

          //$log.log('tratoeditar');
          if (vm.comment.content == '' && !vm.comment.media_path && !vm.cover_comment_image) {
              return;
          }

          if (!vm.comment.content) {
              vm.comment.content = '';
          }

          var promises = [];


          $q.all(promises).then(function(data) {
              winwin.updatePost(vm.commentId, vm.comment.content)
                  .then(function(data){
                      $mdDialog.hide(data);
                      vm.showEditInput = false;
                  })
              .then(function(data) {
                  winwin.getPosts(vm.winwinId).then(function(posts_data) {
                      vm.posts = posts_data.posts;
                      vm.commentId = null;
                      vm.hideCommentEditor = 1;
                  });
              });
          });
      }


      vm.showEditDialog = function(postOrComment) {
          var posta = postOrComment;
          if (postOrComment.post_edit) {
            if (postOrComment.post_edit.length != 0)
              posta = postOrComment.post_edit[0];
          }
          else if (postOrComment.comment_edit)
            if (postOrComment.comment_edit.length != 0)
              posta = postOrComment.comment_edit[0];
          vm.modalEdit = {
              controller: EditController,
              controllerAs: 'vm',
              templateUrl: 'app/winwin/modal-edit-winwin-post.tmpl.html',
              parent: angular.element($document.body),
              clickOutsideToClose:true,
              preserveScope:true,
              locals: {
                  current_content: posta.content,
                  current_post: postOrComment,
                  current_account: vm.account,
                  current_scope: vm,
                  comment: {content : (' ' + posta.content).slice(1)}, //force string copy
                  content: {}
              }
          }

          $mdDialog.show(vm.modalEdit).then(function(data) {
              winwin.getPosts(vm.winwinId).then(function(posts_data) {
                  vm.posts = posts_data.posts;
              });
          });
      };

     vm.cancelarEdit = function() {
       vm.hideCommentEditor = 1;
     }

     vm.hasUsersLeft = function() {
      return !vm.quorum_ilimitado && (vm.winwin && vm.winwin.users_left > 0);
     }
  }


  /** @ngInject */
  function MessageModalController(ENV, conversation_id, to_user_id, conversation_messages, user, winwin_id, $mdDialog, $state, $timeout, myself_id){
    var vm = this;

    vm.imageServer = ENV.imageServer
    vm.conversation_messages = conversation_messages;
    vm.toUserId = to_user_id;
    vm.mensaje = "";
    vm.sendMessageStatus = "notSended";
    vm.conversationId = conversation_id;
    vm.winwinId = winwin_id;
    vm.mySelfId = myself_id;

    vm.sendMessage = function(){
      user.sendMessage({
        conversation_id: vm.conversationId,
        message: vm.mensaje,
        winwin_id : vm.winwinId,
        receiver_id: vm.toUserId,
        subject : 'asunto new conversation'
      }).then(function(data){
        if(data.result =='enviado'){
          vm.sendMessageStatus = "Sended";
          vm.conversation_messages.push(data.message);
          //$state.reload();
          $timeout(function() {
            $mdDialog.hide(data.message);
          }, 3000);
        }
      });
    }
      vm.removeMsg = function(message) {
          user.removeMsg(message.id).then(function (data) {
              $mdDialog.hide(data);
              $state.reload();
          })
      };
  }

  /** @ngInject */
  function CampanadasController(campanadas,winwin_id, is_creator, winwin, current_user, $state, $timeout, account, $rootScope){
    var vm = this;

    vm.body = "";
    vm.sendMessageStatus = "notSended";
    vm.campanadas = campanadas;
    vm.winwin_id = winwin_id;
    vm.current_user = current_user;
    vm.is_creator = is_creator;

    vm.sendMessage = function(){
      winwin.campanada(vm.winwin_id, vm.body).then(function(data){
        if(data.message =='winwin_campanada_sent'){
          vm.sendMessageStatus = "Sended";
          vm.body = "";
          vm.campanadas.push(data.campanada);
          $timeout(function() {
            vm.sendMessageStatus = "notSended";
          }, 3000);
          account.notificactionRed(current_user,data.campanada.id).then(function() {
            $rootScope.$broadcast('account_change');
          });
        }
      });
    }
  }

  function ModalSharePostController(current_post, ENV) {
    var vm = this;

    vm.base = ENV.base;
    vm.imageServer = ENV.imageServer;
    vm.facebookId = ENV.satellizer.facebook.clientId;
    vm.post = current_post;
  }

  /** @ngInject */
  function MasDetalleController($scope, winwin, $sce) {
    $scope.winwin = winwin;
    $scope.sanitized_description = $sce.trustAsHtml(winwin.description);
  }

  /** @ngInject */
  function ParticipantesController(users, winwin_id, ENV, winwin, is_moderator){
    var vm = this;

    vm.imageServer = ENV.imageServer;
    vm.users = users;
    vm.normal_success = false;
    vm.activator_success = false;
    vm.is_moderator = is_moderator;

    vm.makeNormal = function(participante, index) {
      vm.activated_name = participante.username;
      winwin.setUserNormal(winwin_id, participante.id).then(function(data){
        vm.normal_success = true;
        vm.users[index].pivot.moderator = false;
      });
    };

    vm.makeActivator = function(participante, index) {
      vm.activated_name = participante.username;
      winwin.setUserActivator(winwin_id, participante.id).then(function(data){
        vm.activator_success = true;
        vm.users[index].pivot.moderator = true;
      });
    };
  }

  angular
  .module('winwins')
  .filter('moment', function(moment) {
    return function(dateString, format) {
      return moment(dateString).format(format);
    };
  });

  /** @ngInject */
  function ReplyController(current_post, current_account, $mdDialog, $document, current_scope, comment, cover_comment_image, winwin, $wait, $log) {
    var vm = this;

    vm.account = current_account;
    vm.post = current_post;

    vm.comment = comment;
    vm.cover_comment_image = cover_comment_image;

    vm.modal_reply = current_scope.modalReply;

    vm.showModalVideoPostDialog = function() {
      $mdDialog.show({
        controller: ModalVideoPostController,
        controllerAs: 'vm',
        templateUrl: 'app/winwin/modal-video-post.tmpl.html',
        multiple: true,
        clickOutsideToClose:true
      })
      .then(function(video) {
        vm.comment.media_type = 'VIDEO';
        vm.comment.media_path = video;
      });
    };

    vm.showCropPostImageDialog = function(ev) {
      $mdDialog.show({
        controller: CropPostImageController,
        templateUrl: 'app/winwin/cover_post_image.tmpl.html',
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose:true
      })
      .then(function(image) {
        vm.comment.media_type = 'IMAGE';
        vm.cover_comment_image = image
      });
    };

    vm.removeCoverCommentImageOrVideo = function() {
      vm.comment.media_type = null;
      vm.cover_comment_image = null;
    }

    vm.submitComment = function() {
      var goOn = true;
      if (!vm.comment.content) {
        vm.comment.content = '';
      }
      if (vm.comment.content == '' && !vm.comment.media_path && !vm.cover_comment_image) {
        return;
      }

      if (vm.comment.media_type == 'IMAGE' && vm.cover_comment_image) {
        $wait.showWait("Enviando imagen...", cancelUpload);
        winwin.uploadPostImage(dataURItoBlob(vm.cover_comment_image.file), vm.cover_comment_image.name).then(function(data) {
          if (vm.cover_comment_image) {
            vm.comment.media_id = data.media_id;
            vm.comment.media_path = data.filename;
            vm.cover_comment_image = null;
            $wait.hideWait();
            if (goOn)
              finishSubmitComment();
          }
        }, function (reason) {
            $wait.hideWait();
            $log.log('Upload failed');
            $log.log(reason);
          });
      } else {
        if (goOn)
          finishSubmitComment();
      }

      function cancelUpload() {
        goOn = false;
        winwin.abortImageUpload();
      }
    }

    var finishSubmitComment = function() {
      winwin.createComment(vm.post.id, vm.comment.content, vm.comment.media_id, vm.comment.media_type, vm.comment.media_path)
        .then(function(data){
          $mdDialog.hide(data);
        });
    }

    var dataURItoBlob = function(dataURI) {
      var binary = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var array = [];
      for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {type: mimeString});
    };
  }

  /** @ngInject */
  function ModalConfirmacionSumarseController($window, $timeout, winwin_image, winwin_id, ENV, winwin, $mdDialog, $scope) {
    var vm = this;

    vm.base = ENV.base;
    vm.imageServer = ENV.imageServer;
    vm.facebookId = ENV.satellizer.facebook.clientId;
    vm.status = 'honorCode';
    vm.winwin = {};
    vm.winwinId = winwin_id;
    vm.emailsOK = false;
    vm.image = winwin_image;
    vm.winwinId = winwin_id;
    vm.mails = [];
    vm.winwin.title = $scope.winwin.winwin.title;
    vm.noEmailsFlag = false;

    vm.cancel = function() {
      $mdDialog.cancel()
    };

    vm.join = function() {
      winwin.join(vm.winwinId).then(function (data) {
        winwin.getWinwin(vm.winwinId).then(function (winwin_data) {
          $scope.winwin.winwin = winwin_data;
          if (typeof $scope.winwin.winwin.closing_date == "string")
            $scope.winwin.winwin.closing_date = new Date(winwin_data.closing_date.replace(/-/g,"/")); // Necesario para evitar null en safari
          else
            $scope.winwin.winwin.closing_date = new Date(winwin_data.closing_date);
          vm.status = 'success';
          $timeout(function () {
            vm.status = 'share';
          }, 3000);
        });
      });
    };

    vm.validateMail = function(chip) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(chip))
      {
        var index = vm.mails.indexOf(chip);
        vm.mails.splice(index, 1);
      } else {
        vm.noEmailsFlag = false;
      }
    };


    vm.sentInvitations = function() {
      if (vm.mails.length==0 && vm.mail) {
        vm.mails.push(vm.mail);
        vm.validateMail(vm.mail)
        vm.mail = '';
      }
      if (vm.mails.length == 0) {
        vm.noEmailsFlag = true;
        return;
      }
      winwin.shareMails(vm.winwinId, vm.mails).then(function() {
        vm.mails = [];
        vm.emailsOK = true;
      });
    }
  }

  /** @ngInject */
  function ModalShareEmailController(current_winwin, winwin) {
    var vm = this;

    vm.winwin = current_winwin;
    vm.emailsOK = false;
    vm.noEmailsFlag = false;

    vm.mails = [];

    vm.validateMail = function(chip) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(chip))
      {
        var index = vm.mails.indexOf(chip);
        vm.mails.splice(index, 1);
      } else {
        vm.noEmailsFlag = false;
      }
    }

    vm.sentInvitations = function() {
      if (vm.mails.length==0 && vm.mail) {
        vm.mails.push(vm.mail);
        vm.validateMail(vm.mail)
        vm.mail = '';
      }
      if (vm.mails.length == 0) {
        vm.noEmailsFlag = true;
        return;
      }
      winwin.shareMails(vm.winwin.id, vm.mails).then(function() {
        vm.mails = [];
        vm.emailsOK = true;
      });
    }
  }

  /** @ngInject */
  function ModalAbandonarController(current_winwin, $mdDialog, winwin) {
    var vm = this;

    vm.left = function() {
      winwin.left(current_winwin.id).then(function(data) {
       $mdDialog.hide(data);
     });
    }

    vm.cancel = function() {
      $mdDialog.cancel();
    }
  }

  /** @ngInject */
  function FirstPostModalController($mdDialog, winwin, parent_ctrl, $scope, $window) {
    var vm = this;
    // TODO: Hacer una directiva para el posteador así evitamos hacer toda esta copia
    //$log.log(vm);
    //$log.log(winwin);
    $window.jQuery.extend(vm, parent_ctrl);
    //vm.winwin = winwin.winwin;
    vm.show_box_muro = true;
    //vm.post = winwin.post;
    //vm.submitPost = winwin.submitPost;
    //vm.showModalVideoPostDialog = winwin.showModalVideoPostDialog;
    //vm.showCropPostImageDialog = winwin.showCropPostImageDialog;
    //

    vm.emailsOK = false;
    vm.mails = [];

    $scope.$on('post-submitted', function(event, args) {
      //$log.log('post-submitted');
      vm.toShareStage();
    });

    vm.winwinName = parent_ctrl.winwin.title;
    vm.status = 'post';
    vm.noEmailsFlag = false;

    vm.validateMail = function(chip) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(chip))
      {
        var index = vm.mails.indexOf(chip);
        vm.mails.splice(index, 1);
      } else {
        vm.noEmailsFlag = false;
      }
    }

    vm.toShareStage = function(){
      vm.status = 'share';
    }

    vm.mails = [];
    vm.sentInvitations = function() {
      if (vm.mails.length==0 && vm.mail) {
        vm.mails.push(vm.mail);
        vm.validateMail(vm.mail)
        vm.mail = '';
      }
      if (vm.mails.length == 0) {
        vm.noEmailsFlag = true;
        return;
      }
      winwin.shareMails(vm.winwin.id, vm.mails).then(function() {
        vm.mails = [];
        vm.emailsOK = true;
      });
    }

  }

  /** @ngInject */
  function ModalCloseController(current_winwin, $mdDialog, winwin) {
    var vm = this;

    vm.close = function() {
      winwin.close(current_winwin.id, vm.reason).then(function(data) {
       $mdDialog.hide(data);
     });
    }

    vm.cancel = function() {
      $mdDialog.cancel();
    }
  }

  /** @ngInject */
  function ModalRemoveController(current_post, $mdDialog, winwin) {
    var vm = this;

          vm.remove = function () {
              winwin.removePost(current_post.id).then(function (data) {
                  $mdDialog.hide(data);
              });
          }
      vm.cancel = function() {
      $mdDialog.cancel();
    }
  }


  /** @ngInject */
    function ModalRemovePollController(current_poll, $mdDialog, winwin) {
        var vm = this;

      vm.removePoll = function() {
          winwin.removePoll(current_poll.id).then(function (data) {
              $mdDialog.hide(data);
          })
      };
      vm.cancel = function() {
          $mdDialog.cancel();
      }
    }


    /** @ngInject */
  function ModalBindWinwinToGroup($mdDialog, group_list, user_groups, $window, winwin_id, grupo) {
    var vm = this;
    vm.group_list = group_list;
    vm.winwin_groups;
    vm.user_groups = user_groups;
    vm.groups_already_added = group_list;
    vm.success = false;
    vm.winwin_id = winwin_id;
    vm.user_have_groups = vm.user_groups.length == 0 ? false : true;
    vm.not_added_user_groups = $window._.filter(vm.user_groups, function(user_group){

      var isGroupInList = $window._.filter(vm.groups_already_added, function(group_already_added){
        return user_group.id == group_already_added.id;
      })

      return isGroupInList.length == 0;
    });

    vm.addWinwinToGroup = function(grupoId) {
      grupo.addWinwin(grupoId, vm.winwin_id).then(function(){
        vm.success = true;
      })
    }
  }

  /** @ngInject */
  function ModalVideoPostController($mdDialog) {
    var vm = this;

    vm.setVideo = function() {
      $mdDialog.hide(vm.matchYoutubeUrl(vm.video));
    }

    vm.cancel = function() {
      $mdDialog.cancel();
    }

    vm.previewVideo = function(e) {
      vm.video_path = vm.matchYoutubeUrl(e.originalEvent.clipboardData.getData('text/plain'));
    }

    vm.matchYoutubeUrl = function(url){
      var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      return (url.match(p)) ? RegExp.$1 : false ;
    }
  }

  /** @ngInject */
  function ModalPollController(winwin, current_winwin, $mdDialog, $timeout) {
    var vm = this;
    vm.poll = {};
    vm.pollOk = false
    vm.poll.selected = false;

    vm.submitPoll = function() {
      winwin.createPoll(current_winwin.id, vm.poll).then(function(data) {
        vm.pollOk = true;
        $timeout(function() {
          $mdDialog.hide(data);
        }, 3000);
      });
    }
  }

  /** @ngInject */
  function ReportController(winwin, winwinId) {
    var vm = this;

    vm.report = {};
    vm.report.winwinId = winwinId;
    vm.report.type = "WINWIN";
    vm.reportSuccess = false;

    vm.sendReport = function(){
      winwin.reportWinwin(vm.report).then(function(){
        vm.reportSuccess = true;
      })
    };
  }

  /** @ngInject */
  function CropPostImageController($scope, $mdDialog) {
    $scope.myImage='';
    $scope.myCroppedImage='';
    $scope.fileName='';

    $scope.handleFileSelect = function(evt) {
      var file=evt.files[0];
      $scope.fileName = file.name;
      var reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$apply(function($scope){
          $scope.myImage=evt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };

    $scope.cropImage = function() {
      $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
    }
  }

  /** @ngInject */
  function RequestSponsorshipModalController(ENV, winwin_id, user, winwin, $mdDialog, $timeout){
    var vm = this;

    vm.imageServer = ENV.imageServer
    vm.winwinId = winwin_id,
    vm.org = "";
    vm.contact = "";
    vm.tel = "";
    vm.email = "";
    vm.mensaje = "Nos interesa sponsorear este winwin...";
    vm.sendMessageStatus = "notSended";

    vm.sendMessage = function(){
      if(vm.reqSponsorForm.$valid)
        winwin.requestSponsorship(vm).then(function(data){
          if(data[0]=='winwin_emails_sent'){
            vm.sendMessageStatus = "Sended";
            $timeout(function() {
              $mdDialog.hide(data);
            }, 2000);
          }
        });
      else
        angular.forEach( vm.reqSponsorForm , function( formElement , fieldName ) {
                    // Sólo modifico los campos del formulario
                    if ( fieldName[0] === '$' ) return;
                    // Les cambio estas propiedades para que aparezcan todos los mensajes de error
                    formElement.$pristine = false;
                    formElement.$dirty = true;
                });
    }
  }

   /** @ngInject */
    function EditController(current_post, current_account, $mdDialog, current_scope, comment, winwin, $q) {
        var vm = this;

        vm.account = current_account;
        vm.post = current_post;

        vm.comment = comment;
        vm.modal_edit = current_scope.modalEdit;



        vm.editPost = function() {
            if (vm.comment.content == '' && !vm.comment.media_path && !vm.cover_comment_image) {
                return;
            }

            if (!vm.comment.content) {
                vm.comment.content = '';
            }

            var promises = [];


            $q.all(promises).then(function(data) {
                winwin.updatePost(vm.post.id, vm.comment.content)
                    .then(function(data){
                        $mdDialog.hide(data);
                        vm.showEditInput = false;
                    });
            });
        }
     vm.editComment = function() {
         if (vm.comment.content == '' && !vm.comment.media_path && !vm.cover_comment_image) {
             return;
         }

         if (!vm.comment.content) {
             vm.comment.content = '';
         }

         var promises = [];


         $q.all(promises).then(function(data) {
             winwin.updatePost(vm.comment.id, vm.comment.content)
                 .then(function(data){
                     $mdDialog.hide(data);
                 });
         });
     }


    }

})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('WinwinListController', WinwinListController);

  /** @ngInject */
  function WinwinListController(winwin, gettextCatalog, gettext) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';

    vm.current_page = 0;

    winwin.getList(vm.current_page, 'last', 9).then(function(data) {
      vm.winwins = data;
    });

    winwin.getInterests().then(function(data) {
      vm.interests = data;
    });

    vm.loadingDestacados = false;
    vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Destacados'));
    var _filter = 'last';
    var _categories = [];
    vm.doFilter = function(filter, next) {
      if (!next) {
        vm.current_page = 0;
        vm.stop_paged = false;
        vm.loadingDestacados = true;
      }

      _categories = [];
      _filter = filter;
      winwin.getList(vm.current_page, filter, 9).then(function(data) {
        if (next) {
          vm.winwins.push.apply(vm.winwins, data);   
        } else {
          vm.winwins = data;
          vm.loadingDestacados = false;
        }
        if (data.length < (vm.current_page + 1) * 9){
          vm.stop_paged = true;
        }

        switch(filter) {
          case 'select':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Destacados'));
            break;
          case 'popular':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Populares'));
            break;
          case 'last':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Todos los Winwins'));
            break;
          case 'finishing':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins por terminar'));
            break;
          case 'success':
            vm.destacadosTitle  = gettextCatalog.getString(gettext('Winwins concretados'));
            break;
        }
      });
    };
    
    vm.doCategories = function(id, next) {
      if (!next) {
        vm.current_page = 0;
      }

      var _index = _categories.indexOf(id);
      
      if (_index == -1) {
        _categories.push(id);
      } else {
        _categories.splice(_index, 1);
      }

      if (_categories.length == 0) {
        vm.doFilter(_filter);
      } else {
        winwin.getListByCategory(vm.current_page, _categories.join(',')).then(function(data) {
          vm.winwins = data;
        });
      }
    };

    vm.nextPage = function() {
      if (!vm.stop_paged && !vm.loadingDestacados){
        vm.current_page = vm.current_page + 1;
        vm.doFilter(_filter, true);
      }
    }

    vm.isChecked = function(id) {
      return _categories.indexOf(id) > -1;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('MisWinwinController', MisWinwinController);

  /** @ngInject */
  function MisWinwinController(winwin, gettextCatalog, gettext, account, user, $window) {
    var vm = this;

    account.getProfile()
    .then(function(data) {
      vm.account = data;

      user.getUser(data.user.id)
      .then(function(user_data) {
        vm.uId = user_data.id;
        vm.user_detail = user_data;

        vm.creadospormi = $window._.filter(vm.user_detail.winwins, function(winwin) {
          return winwin.user_id == vm.account.user.id; 
        });

        vm.enqueparticipo = $window._.filter(vm.user_detail.winwins, function(winwin) {
          return winwin.user_id != vm.account.user.id; 
        });
      });
    });

    vm.tcreadospormi = gettextCatalog.getString(gettext('Creados por mi'));
    vm.tenqueparticipo = gettextCatalog.getString(gettext('En que participo'));
  }

})();
(function() {
    'use strict';

    angular
        .module('winwins')
        .controller('EditarWinwinController', EditarWinwinController);

    /** @ngInject */
    function EditarWinwinController($stateParams, $state, winwin, ENV, $location, $mdDialog, $document, $q, $window, $element, $auth, $rootScope, $log, account, WizardHandler) {
        var vm = this;
        vm.editarWinwin = true;

        vm.winwinId = $stateParams.winwinId;

        var getWinwin = function() {
            var $qp = winwin.getQuorums().then(function(data) {
                vm.quorums = data;
                // vm.winwin.tipo_quorum = vm.quorumId('QUORUM_ILIMITADO');
            });
            var $wp = winwin.getWinwin(vm.winwinId)
            $q.all([$qp, $wp]).then(function(data){
                var winwin_data = data[1];
                vm.winwin = winwin_data;
                vm.preview_image = vm.imageServer + '/smart/' + winwin_data.image;
                if (vm.quorum_fijo())
                    vm.users_amount_fijo = winwin_data.users_amount;
                else if (vm.quorum_movil()) {
                    vm.users_amount_movil = winwin_data.users_amount;
                    vm.min_users_amount = winwin_data.min_users_amount;
                }
                if (winwin_data.closing_date)
                    vm.winwin.closing_date = new Date(winwin_data.closing_date);
                else
                    // Si no lo dejo null me pone una fecha estándar en 1969 al convertir a Date
                    vm.winwin.closing_date = new winwin_data.closing_date;
            });
        };
        getWinwin();





        vm.base = ENV.base;
        vm.imageServer = ENV.imageServer;
        vm.facebookId = ENV.satellizer.facebook.clientId;
        vm.stage = 1;
        vm.emailsOK = false;

        vm.mails = [];
        vm.minDate = new Date();
        vm.hoy = new Date().toLocaleDateString();



        vm.winwin = {
               interests: [],
               tags: [],
               tipo_quorum: 1,
               scope: 'GLOBAL'
           }

        vm.nexStage = function() {
            if (!vm.winwin.terms){
                vm.crearForm1.terms.$setValidity("notTerms", false);
                return;
            }
            vm.stage = 2;

            vm.setup_geo_component();
        }

        vm.setup_geo_component = function () {
            var input = $element.find('#winwin_location'),
                options = {
                    types: []
                };
            var searchBox = new $window.google.maps.places.Autocomplete(input[0], options);

            searchBox.addListener('place_changed', function() {
                var place = searchBox.getPlace();
                vm.winwin.location = $window._.extend(place, {
                    coordinates: place.geometry.location.toJSON()
                });
            });
        };


        vm.tryToSaveWinwin = function() {
            if (!vm.winwin.terms){
                vm.crearForm1.terms.$setValidity("notTerms", false);
                return;
            }
            if ($auth.isAuthenticated()) {
                vm.saveWinwin();
            } else {
                $rootScope.returnState = {
                    state : 'no_redir'
                };
                $mdDialog.show({
                    controller: 'LoginController',
                    controllerAs: 'login',
                    templateUrl: 'app/login/login.tmpl.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose:true
                }).then(function(success) {
                    if (success) {
                        account.getProfile()
                            .then(function(data) {
                                vm.isActive = data.active;
                                if (vm.isActive)
                                    vm.saveWinwin();
                            });
                    }
                });
            }
        };

        /*vm.login_hook = $rootScope.$on('account_change', function () {
         if (vm.waitingToSave && $auth.isAuthenticated()) {
         vm.saveWinwin();
         }
         });*/

        vm.saveWinwin = function() {
            if (vm.quorum_fijo()) {
                vm.winwin.users_amount = vm.users_amount_fijo;
            } else if (vm.quorum_movil()) {
                vm.winwin.min_users_amount = vm.min_users_amount;
                vm.winwin.users_amount = vm.users_amount_movil;
            }

            if (!vm.winwin.location && vm.winwin.scope == 'LOCAL'){
                vm.crearForm2.winwin_location.$setValidity("notLocation", false);
                return;
            }

            var promises = [];

            if (vm.cover_image) {
                promises.push(winwin.uploadImage(dataURItoBlob(vm.cover_image.file), vm.cover_image.name));
            }

            $q.all(promises).then(function(data) {
                if (vm.cover_image) {
                    vm.winwin.image = data[0].filename;
                }

                winwin.editWinwin(vm.winwin)
                    .then(function(data){
                        // $location.path('winwin/' + vm.winwin.id + '/true');
                        $state.go('home.winwin', {
                            showFirstPostModal: false,
                            winwinId: vm.winwin.id
                        });
                    });

                vm.processing = false;
            });
        }

        var dataURItoBlob = function(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        vm.clearError = function() {
            if (vm.winwin.terms) {
                vm.crearForm1.terms.$setValidity("notTerms", true);
            }
            if (vm.crearForm2.winwin_location.$error.notLocation){
                vm.winwin.location = null;
                vm.crearForm2.winwin_location.$setValidity("notLocation", true);
            }
        }

        winwin.getInterests().then(function(data) {
            vm.interests = data;
        });

        vm.checkStage1 = function() {
            return vm.crearForm1.title && vm.crearForm1.title.$valid;
        }

        vm.check1andNext = function() {
            if (vm.checkStage1())
                WizardHandler.wizard().next();
            else
                vm.crearForm1.title.$dirty = true;
        }

        vm.checkStage2 = function() {
            return vm.quorum_ilimitado() || (vm.quorum_fijo() && vm.crearForm1.users_amount.$valid) ||
                (vm.quorum_movil() && vm.crearForm1.min_users_amount.$valid && vm.crearForm1.users_amount2.$valid);
        }

        vm.check2andNext = function() {
            if (vm.checkStage2())
                WizardHandler.wizard().next();
            else {
                vm.crearForm1.users_amount.$dirty = true;
                vm.crearForm1.min_users_amount.$dirty = true;
                vm.crearForm1.users_amount2.$dirty = true;
            }
        }

        vm.checkStage3 = function() {
            return vm.crearForm1.what_we_do && vm.crearForm1.what_we_do.$valid;
        }

        vm.check3andNext = function() {
            if (vm.checkStage3())
                WizardHandler.wizard().next();
            else
                vm.crearForm1.what_we_do.$dirty = true;
        }

        vm.quorum_fijo = function() {
            return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_FIJO');
        }

        vm.setQuorumFijo = function() {
            vm.winwin.tipo_quorum = vm.quorumId('QUORUM_FIJO');
        }

        vm.quorum_movil = function() {
            return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_MOVIL');
        }

        vm.setQuorumMovil = function() {
            vm.winwin.tipo_quorum = vm.quorumId('QUORUM_MOVIL');
        }

        vm.quorum_ilimitado = function() {
            return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_ILIMITADO');
        }

        vm.quorumId = function(quorumName) {
            var quorum;
            if (vm.quorums) {
                quorum = vm.quorums.filter(function(obj) {
                    return obj.name == quorumName;
                })[0];
                if (quorum)
                    return quorum.id;
                else
                    return undefined;
            }
            else {
                return undefined;
            }
        }

        vm.translate = function(code) {
            var res = "";
            switch(code) {
                case 'QUORUM_FIJO':
                    res = "Con QUORUM EXACTO *Un numero exacto de personas necesarias.";
                    break;
                case 'QUORUM_MOVIL':
                    res = "Con QUORUM FLEXIBLE *Un numero entre un minimo y un maximo de personas necesarias";
                    break;
                case "QUORUM_ILIMITADO":
                    res = "Con QUORUM INFINITO *Cantidad ilimitada de personas";
                    break;
                default:
                    res = code;
            }
            return res;
        }

        vm.getCurrentQuorum = function() {
            if (vm.quorums) {
                var quorum = vm.quorums.filter(function(obj) {
                    return obj.id == vm.winwin.tipo_quorum;
                })[0];
                return quorum;
            }
            else {
                return undefined;
            }
        }

        vm.showAmounts = function() {
            var quorum = vm.getCurrentQuorum();
            return quorum && quorum.name != "QUORUM_ILIMITADO";
        }

        vm.showMinAmount = function() {
            var quorum = vm.getCurrentQuorum();
            return quorum && quorum.name == "QUORUM_MOVIL";
        }

        vm.maxMinUsersAmount = function() {
            if (vm.quorum_movil() && vm.users_amount_movil)
                return vm.users_amount_movil;
            else
                return 10000000000;
        }

        vm.minUsersAmount = function() {
            if (vm.quorum_movil() && vm.min_users_amount)
                return vm.min_users_amount + 1;
            else
                return 1;
        }

        winwin.getTags().then(function(data) {
            vm.tags = data;
        });

        vm.validateMail = function(chip) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(chip))
            {
                var index = vm.mails.indexOf(chip);
                vm.mails.splice(index, 1);
            }
        }

        vm.sentInvitations = function() {
            winwin.shareMails(vm.winwin.id, vm.mails).then(function() {
                vm.mails = [];
                vm.emailsOK = true;
            });
        }

        vm.showGaleriaDialog = function(ev) {
            $mdDialog.show({
                controller: ShowGaleriaController,
                controllerAs: 'vm',
                templateUrl: 'app/winwin/modal-galeria.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals: {
                    image_gallery_selected: vm.winwin.image
                }
            })
                .then(function(image) {
                    vm.winwin.image = image;
                    vm.preview_image = vm.imageServer + '/smart/' + image;
                    vm.cover_image = null;
                    vm.winwin.video = null;
                });
        };

        vm.showModalVideoPostDialog = function(ev) {
            $mdDialog.show({
                controller: ModalVideoPostController,
                controllerAs: 'vm',
                templateUrl: 'app/winwin/modal-video-post.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(video) {
                    vm.winwin.video = video;
                    vm.preview_image = 'http://img.youtube.com/vi/'+video+'/hqdefault.jpg';
                    vm.cover_image = null;
                    vm.winwin.image = null;
                });
        };

        vm.showCropCoverDialog = function(ev) {
            $mdDialog.show({
                controller: CropCoverController,
                templateUrl: 'app/winwin/cover_crop.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(image) {
                    vm.cover_image = image;
                    vm.preview_image = image.file;
                    vm.winwin.video = null;
                    vm.winwin.image = null;
                });
        };
    }

    /** @ngInject */
    function ShowGaleriaController($mdDialog, image_gallery_selected) {
        var vm = this;

        vm.image_gallery_selected = image_gallery_selected;

        vm.setImage = function(image) {
            $mdDialog.hide(image);
        }
    }

    /** @ngInject */
    function ModalVideoPostController($mdDialog) {
        var vm = this;

        vm.setVideo = function() {
            $mdDialog.hide(vm.matchYoutubeUrl(vm.video));
        }

        vm.cancel = function() {
            $mdDialog.cancel();
        }

        vm.previewVideo = function(e) {
            vm.video_path = vm.matchYoutubeUrl(e.originalEvent.clipboardData.getData('text/plain'));
        }

        vm.matchYoutubeUrl = function(url){
            var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            return (url.match(p)) ? RegExp.$1 : false ;
        }
    }

    /** @ngInject */
    function CropCoverController($scope, $mdDialog) {
        $scope.myImage='';
        $scope.myCroppedImage='';
        $scope.fileName='';

        $scope.handleFileSelect = function(evt) {
            var file=evt.files[0];
            $scope.fileName = file.name;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function($scope){
                    $scope.myImage=evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        $scope.cropImage = function() {
            $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
        }
    }

})();



  (function() {
    'use strict';

    angular
    .module('winwins')
    .controller('CrearWinwinController', CrearWinwinController);

    /** @ngInject */
    function CrearWinwinController($stateParams, $state, winwin, ENV, $location, $mdDialog, $document, $q, $window, $element, $auth, $rootScope, $log, account, WizardHandler, $timeout, $anchorScroll) {
      var vm = this;

      $anchorScroll.yOffset = 60; //Evitar el navbar

      vm.crearWinwin = true;
      vm.base = ENV.base;
      vm.imageServer = ENV.imageServer;
      vm.facebookId = ENV.satellizer.facebook.clientId;
      vm.stage = 1;
      vm.emailsOK = false;

      vm.mails = [];
      vm.minDate = new Date();
      vm.hoy = new Date().toLocaleDateString();

      vm.winwin = {
        interests:[],
        tags:[],
        tipo_quorum: 1,
        scope: 'GLOBAL'
      };

      vm.nexStage = function() {
        if (!vm.winwin.terms){
          vm.crearForm1.terms.$setValidity("notTerms", false);
          return;
        }
        vm.stage = 2;

        vm.setup_geo_component();
      }

      vm.setup_geo_component = function () {
        var input = $element.find('#winwin_location'),
        options = {
          types: []
        };
        var searchBox = new $window.google.maps.places.Autocomplete(input[0], options);

        searchBox.addListener('place_changed', function() {
          var place = searchBox.getPlace();
          vm.winwin.location = $window._.extend(place, {
            coordinates: place.geometry.location.toJSON()
          });
        });
      };


      vm.tryToSaveWinwin = function() {
        if (vm.crearForm1.$invalid) {
          vm.crearForm1.title.$dirty = true;
          vm.crearForm1.category.$dirty = true;
          if (!vm.winwin.terms){
            vm.crearForm1.terms.$setValidity("notTerms", false);
          }
          return;
        }
        if ($auth.isAuthenticated()) {
          vm.saveWinwin();
        } else {
          $rootScope.returnState = {
            state : 'no_redir'
          };
          $mdDialog.show({
            controller: 'LoginController',
            controllerAs: 'login',
            templateUrl: 'app/login/login.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true
          }).then(function(success) {
            if (success) {
              account.getProfile()
              .then(function(data) {
                vm.isActive = data.active;
                if (vm.isActive)
                  vm.saveWinwin();
              });
            }
          });
        }
      };

    /*vm.login_hook = $rootScope.$on('account_change', function () {
        if (vm.waitingToSave && $auth.isAuthenticated()) {
          vm.saveWinwin();
        }
      });*/

      vm.saveWinwin = function() {
        if (vm.quorum_fijo()) {
          vm.winwin.users_amount = vm.users_amount_fijo;
        } else if (vm.quorum_movil()) {
          vm.winwin.min_users_amount = vm.min_users_amount;
          vm.winwin.users_amount = vm.users_amount_movil;
        }

        if (!vm.winwin.location && vm.winwin.scope == 'LOCAL'){
          vm.crearForm2.winwin_location.$setValidity("notLocation", false);
          return;
        }

        var promises = [];

        if (vm.cover_image) {
          promises.push(winwin.uploadImage(dataURItoBlob(vm.cover_image.file), vm.cover_image.name));
        }

        $q.all(promises).then(function(data) {
          if (vm.cover_image) {
            vm.winwin.image = data[0].filename;
          }

          winwin.saveWinwin(vm.winwin)
          .then(function(data){
            vm.winwin.id = data.id;
          // $location.path('winwin/' + vm.winwin.id + '/true');
          $state.go('home.winwin', {
            showFirstPostModal: true,
            winwinId: vm.winwin.id
          });
        });

          vm.processing = false;
        });
      }

      var dataURItoBlob = function(dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var array = [];
        for(var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: mimeString});
      };

      vm.clearError = function() {
        if (vm.winwin.terms) {
          vm.crearForm1.terms.$setValidity("notTerms", true);
        }
        if (vm.crearForm2.winwin_location.$error.notLocation){
          vm.winwin.location = null;
          vm.crearForm2.winwin_location.$setValidity("notLocation", true);
        }
      }

      winwin.getInterests().then(function(data) {
        vm.interests = data;
      });

      winwin.getQuorums().then(function(data) {
        vm.quorums = data;
        vm.winwin.tipo_quorum = vm.quorumId('QUORUM_ILIMITADO');
      });


      vm.checkStage1 = function() {
        return vm.quorum_ilimitado() || (vm.quorum_fijo() && vm.crearForm1.users_amount.$valid) ||
        (vm.quorum_movil() && vm.crearForm1.min_users_amount.$valid && vm.crearForm1.users_amount2.$valid);
      }

      vm.check1andNext = function() {
        if (vm.checkStage1()) {
          WizardHandler.wizard().next();
          $location.hash('scrollToTop');
          $timeout(function(){
            $anchorScroll();
          });
        } else {
            vm.crearForm1.users_amount.$dirty = true;   
            vm.crearForm1.min_users_amount.$dirty = true;   
            vm.crearForm1.users_amount2.$dirty = true;   
          }
      }

      vm.checkStage2 = function() {
        return vm.crearForm1.what_we_do && vm.crearForm1.what_we_do.$valid;
      }

      vm.check2andNext = function() {
        if (vm.checkStage2()) {
          WizardHandler.wizard().next();
          $location.hash('scrollToTop');
          $timeout(function(){
            $anchorScroll();
          });
        } else
          vm.crearForm1.what_we_do.$dirty = true;   
      }

      vm.check3andNext = function() {
        WizardHandler.wizard().next();
        $location.hash('scrollToTop');
        $timeout(function(){
          $anchorScroll();
        });
      }

      vm.quorum_fijo = function() {
        return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_FIJO');
      }

      vm.setQuorumFijo = function() {
        vm.winwin.tipo_quorum = vm.quorumId('QUORUM_FIJO');
      }

      vm.quorum_movil = function() {
        return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_MOVIL');
      }

      vm.setQuorumMovil = function() {
        vm.winwin.tipo_quorum = vm.quorumId('QUORUM_MOVIL');
      }

      vm.quorum_ilimitado = function() {
        return vm.winwin.tipo_quorum == vm.quorumId('QUORUM_ILIMITADO');
      }

      vm.quorumId = function(quorumName) {
        var quorum;
        if (vm.quorums) {
          quorum = vm.quorums.filter(function(obj) {
            return obj.name == quorumName;
          })[0];
          if (quorum)
            return quorum.id;
          else
            return undefined;
        }
        else {
          return undefined;
        }
      }

      vm.translate = function(code) {
        var res = "";
        switch(code) {
          case 'QUORUM_FIJO':
          res = "Con QUORUM EXACTO *Un numero exacto de personas necesarias.";
          break;
          case 'QUORUM_MOVIL':
          res = "Con QUORUM FLEXIBLE *Un numero entre un minimo y un maximo de personas necesarias";
          break;
          case "QUORUM_ILIMITADO":
          res = "Con QUORUM INFINITO *Cantidad ilimitada de personas";
          break;
          default:
          res = code;
        }
        return res;
      }

      vm.getCurrentQuorum = function() {
        if (vm.quorums) {
          var quorum = vm.quorums.filter(function(obj) {
            return obj.id == vm.winwin.tipo_quorum;
          })[0];
          return quorum;
        }
        else {
          return undefined;
        }
      }

      vm.showAmounts = function() {
        var quorum = vm.getCurrentQuorum();
        return quorum && quorum.name != "QUORUM_ILIMITADO";
      }

      vm.showMinAmount = function() {
        var quorum = vm.getCurrentQuorum();
        return quorum && quorum.name == "QUORUM_MOVIL";
      }

      vm.maxMinUsersAmount = function() {
        if (vm.quorum_movil() && vm.users_amount_movil)
          return vm.users_amount_movil;
        else
          return 10000000000;
      }

      vm.minUsersAmount = function() {
        if (vm.quorum_movil() && vm.min_users_amount)
          return vm.min_users_amount + 1;
        else
          return 1;
      }

      winwin.getTags().then(function(data) {
        vm.tags = data;
      });

      vm.validateMail = function(chip) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(chip))
        {
          var index = vm.mails.indexOf(chip);
          vm.mails.splice(index, 1);
        }
      }

      vm.sentInvitations = function() {
        winwin.shareMails(vm.winwin.id, vm.mails).then(function() {
          vm.mails = [];
          vm.emailsOK = true;
        });
      }

      vm.showGaleriaDialog = function(ev) {
        $mdDialog.show({
          controller: ShowGaleriaController,
          controllerAs: 'vm',
          templateUrl: 'app/winwin/modal-galeria.tmpl.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          locals: {
            image_gallery_selected: vm.winwin.image
          }
        })
        .then(function(image) {
          vm.winwin.image = image;
          vm.preview_image = vm.imageServer + '/smart/' + image;
          vm.cover_image = null;
          vm.winwin.video = null;
        });
      };

      vm.showModalVideoPostDialog = function(ev) {
        $mdDialog.show({
          controller: ModalVideoPostController,
          controllerAs: 'vm',
          templateUrl: 'app/winwin/modal-video-post.tmpl.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose:true
        })
        .then(function(video) {
          vm.winwin.video = video;
          vm.preview_image = 'http://img.youtube.com/vi/'+video+'/hqdefault.jpg';
          vm.cover_image = null;
          vm.winwin.image = null;
        });
      };

      vm.showCropCoverDialog = function(ev) {
        $mdDialog.show({
          controller: CropCoverController,
          templateUrl: 'app/winwin/cover_crop.tmpl.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose:true
        })
        .then(function(image) {
          vm.cover_image = image;
          vm.preview_image = image.file;
          vm.winwin.video = null;
          vm.winwin.image = null;
        });
      };
    }

    /** @ngInject */
    function ShowGaleriaController($mdDialog, image_gallery_selected) {
      var vm = this;

      vm.image_gallery_selected = image_gallery_selected;

      vm.setImage = function(image) {
        $mdDialog.hide(image);
      }
    }

    /** @ngInject */
    function ModalVideoPostController($mdDialog) {
      var vm = this;

      vm.setVideo = function() {
        $mdDialog.hide(vm.matchYoutubeUrl(vm.video));
      }

      vm.cancel = function() {
        $mdDialog.cancel();
      }

      vm.previewVideo = function(e) {
        vm.video_path = vm.matchYoutubeUrl(e.originalEvent.clipboardData.getData('text/plain'));
      }

      vm.matchYoutubeUrl = function(url){
        var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return (url.match(p)) ? RegExp.$1 : false ;
      }
    }

    /** @ngInject */
    function CropCoverController($scope, $mdDialog) {
      $scope.myImage='';
      $scope.myCroppedImage='';
      $scope.fileName='';

      $scope.handleFileSelect = function(evt) {
        var file=evt.files[0];
        $scope.fileName = file.name;
        var reader = new FileReader();
        reader.onload = function (evt) {
          $scope.$apply(function($scope){
            $scope.myImage=evt.target.result;
          });
        };
        reader.readAsDataURL(file);
      };

      $scope.cropImage = function() {
        $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
      }
    }

  })();



(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('WeareController', WeareController);

  /** @ngInject */
  function WeareController() {
    var vm = this;
    vm.users = ['Javier Alvarez', 'Leonardo Garcia', 'Demian Adler', 'Mariana Berruezo', 'Andres Corbo', 'Miguel Martinez Soler', 'Manuel Garcia Llano', 'Agustin Barg', 'Ornella Ponsiglione', 'Gabriela Brenes', 'Matias', 'John Lennon'];
  }

})();

/*angular.module('winwins')
  .controller('team', function($scope) {
    $scope.users = ['Javier Alvarez', 'Leonardo Garcia', 'Demian Adler', 'Mariana Berruezo', 'Andres Corbo', 'Miguel Martinez Soler', 'Manuel Garcia Llano', 'Agustin Barg', 'Ornella Ponsiglione', 'Gabriela Brenes', 'Matias', 'John Lennon'];
  });*/

angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('en', {"+ Crear Winwin":"+ Add Winwin","+ Ver todos los participantes":"+ View all participants","+ Ver todos los winwins":"+ List all winwins","Buscar":"Search","Comenzar":"Start","Cómo funciona":"How works","Crear Winwin":"Add Winwin","Hola,":"Hi,","Ir a mi cuenta":"Account","Mi perfil":"Profile","Miembros":"Members","MIEMBROS":"MEMBERS","Mis Winwins":"My winwins","Organizaciones que contribuyen a la realización de un WinWin":"Organizations that contribute to make a Winwin possible.","PARTNERS\n      <small>ALGUNAS DE LAS <span>ORGANIZACIONES</span><br> QUE <span>CONSTRUYEN</span> JUNTO A <span>WINWINS</span></small>":"PARTNERS\n      <small>Few <span>ORGANIZATIONS</span><br> THAT <span>BUILD</span> WITH <span>WINWINS</span></small>","Personas que crean y participan en acciones de consenso colectivo":"People that creates and participate in actions with consensus ","Salir":"Exit","Se sponsor oficial del <strong>cambio</strong> global.":"Be official sponsor of global <strong>change</strong>.","Sólo faltas vos, sumáte!":"Only missing you, log","Somos":"We are","Sponsors":"Sponsors","SPONSORS":"SPONSORS","Sumate y comenza":"Log in and Start","Últimos winwins creados":"Last winwins added","Winwins":"Winwins","Winwins Destacados":"Featured Winwin","WINWINS RECIENTES":"LAST WINWINS","Your browser does not support HTML5 video":"El navegador no soporte HTML5 Video"});
/* jshint +W100 */
}]);
(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('TermsController', TermsController);

  /** @ngInject */
  function TermsController() {
  }

})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('SearchController', SearchController);

  /** @ngInject */
  function SearchController($stateParams, search, $window) {
    var vm = this;

    vm.query = $stateParams.query;

    search.search(vm.query).then(function(data) {
      vm.winwins = $window._.filter(data, function(result) {
        return result._type == 'winwins' && result._source.canceled != 1; 
      }).map(function(obj){ 
        return obj._source;
      });

      vm.users = $window._.filter(data, function(result) {
        return result._type == 'users'; 
      }).map(function(obj){ 
        return obj._source;
      });

      vm.result_length = vm.winwins.length + vm.users.length;
    });
  }

})();
(function() {
    'use strict';

    angular
        .module('winwins')
        .controller('PublicProfileController', PublicProfileController);

    /** @ngInject */
    function PublicProfileController(user, $q, ENV, $state, $timeout, $mdSidenav, $document, $stateParams, $window, account, $mdDialog, winwin, $auth, $rootScope, $log, $scope) {
        var vm = this;

        vm.userId = $stateParams.userId;
        vm.imageServer = ENV.imageServer;
        vm.user = {interests_list: []};
        vm.is_public = true;
        vm.avatar = '';
        vm.current_page = 0;
        vm.activity = {};
        vm.working = false;



        // con este codigo (jquery) se diferencia si el usuario esta en mobile o desktop

        // var width = $window.innerWidth || $document.documentElement.clientWidth || $document.body.clientWidth;
        //
        // if(width > 480) {
        //     vm.mobile = false;
        //     $log.log('desk')
        // }
        // if (width < 480) {
        //     vm.mobile = true;
        //     $log.log('mobile')
        // }
        //

        vm.closeDialog = function() {
            $mdDialog.hide();
        }

        vm.activityLoop = function () {

            for (var i = 0; i < vm.activity.length; i++) {

                if (vm.activity.length >= 1 && vm.activity.length <= 5) {
                    vm.working = false;
                    $log.log('entre 0 y 4')
                }


                switch (vm.activity[i].type.split('_')[0]) {
                    case "WW":
                        vm.activity[i].activity_url = "http://" + $window.location["hostname"] + ":" + $window.location["port"] +
                            '/#/winwin/' + vm.activity[i].id;
                        break;
                    case "GROUP":
                        vm.activity[i].activity_url = "http://" + $window.location["hostname"] + ":" + $window.location["port"] +
                            '/#/grupo/' + vm.activity[i].id;
                        break;

                    default:
                        vm.activity[i].activity_url = "http://" + $window.location["hostname"] + ":" + $window.location["port"] +
                            '/#/profile/' + vm.activity[i].id;
                }

                switch (vm.activity[i].type) {
                    case 'CAMPANADA':

                        break;
                    case 'WW_JOIN':
                        vm.activity[i].mensajito = ' se unió al winwin ';
                        break;
                    case 'WW_LEFT' :
                        vm.activity[i].mensajito = ' abandonó el winwin ';
                        break;
                    case 'WW_CREATED':
                        vm.activity[i].mensajito = ' creó el winwin ';
                        break;
                    case 'WW_SUCCESSFUL':
                        vm.activity[i].mensajito = ' participó en el winwin ';
                        break;
                    case 'GROUP_CREATED':
                        vm.activity[i].mensajito = ' creó el grupo ';
                        break;
                    case 'GROUP_JOIN':
                        vm.activity[i].mensajito = ' se unió al grupo ';
                        break;
                    case 'GROUP_LEFT':
                        vm.activity.mensajito = ' abandonó el grupo ';
                        break;
                    case 'FOLLOWING':
                        vm.activity[i].mensajito = 'ahora sigue a';
                        break;
                    case 'UNFOLLOWING':
                        vm.activity[i].mensajito = 'no sigue mas a ';
                        break;
                }


            }
        }



        user.getActivities(vm.userId, vm.current_page, 5).then(function (activity_data) {
            vm.activity = activity_data.activity;
            vm.activityLoop();
        })




        vm.nextPage = function() {
            vm.working = true;
            vm.current_page++;
            vm.getNewActivities = user.getActivities(vm.userId, vm.current_page, 5, vm.activity).then(function (activity_data) {
                vm.newActivity = activity_data.activity;
                vm.activity = vm.activity.concat(vm.newActivity);
                vm.activityLoop();
                if (vm.activity.length > 0) {
                    vm.working = false;
                }
                if (vm.newActivity.length < 5) {
                    vm.working = true;
                    $log.log(vm.working)
                }

            })

        }



        vm.showMobileAct = function() {
            $mdDialog.show({
                controller: 'PublicProfileController',
                controllerAs: 'profile',
                templateUrl: 'app/profile/mobile-activity.tmpl.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            })
        }


        var updateUser = function(){
            user.getUser(vm.userId)
                .then(function(user_data) {
                    vm.user = user_data;
                    if (user_data.myself)
                        vm.conversation_title = "Bandeja de Entrada";
                    else
                        vm.conversation_title = "Mensajes con " + vm.user.name;

                    vm.is_complete = (user_data.name && user_data.lastname && user_data.email && user_data.birthdate);
                    vm.groups = user_data.groups;
                    if (vm.user.birthdate) {
                        vm.user.birthdate = new Date(vm.user.birthdate);
                    }

                    vm.creadospormi = $window._.filter(vm.user.winwins, function(winwin) {
                        return winwin.user_id == vm.user.user_id && winwin.canceled == 0;
                    });

                    vm.enqueparticipo = $window._.filter(vm.user.winwins, function(winwin) {
                        return winwin.user_id != vm.user.user_id && winwin.canceled == 0;
                    });

                    vm.winwins_length = vm.creadospormi.length + vm.enqueparticipo.length;
                    vm.avatar = vm.imageServer+'/smart/'+vm.user.photo;
                });
            user.getConversations(vm.userId)
                .then(function(conversations) {
                  vm.conversations = conversations.filter(function (element) {
                        return element.winwin_id == null;
                    });
                });
        };

        updateUser();

        vm.toggleLeft = buildDelayedToggler('left');
        vm.toggleRight = buildToggler('right');
        vm.isOpenRight = function(){
            return $mdSidenav('right').isOpen();
        };

        /**
         * Supplies a function that will continue to operate until the
         * time is up.
         */
        function debounce(func, wait, context) {
            var timer;

            return function debounced() {
                var context = vm,
                    args = Array.prototype.slice.call(arguments);
                $timeout.cancel(timer);
                timer = $timeout(function() {
                    timer = undefined;
                    func.apply(context, args);
                }, wait || 10);
            };
        }

        /**
         * Build handler to open/close a SideNav; when animation finishes
         * report completion in console
         */
        function buildDelayedToggler(navID) {
            return debounce(function() {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                        $log.debug("toggle " + navID + " is done");
                    });
            }, 200);
        }

        function buildToggler(navID) {
            return function() {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                        $log.debug("toggle " + navID + " is done");
                    });
            }
        }

        vm.closeLeft = function () {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav('left').close()
                .then(function () {
                    $log.debug("close LEFT is done");
                });

        };

        vm.closeRight = function () {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav('right').close()
                .then(function () {
                    $log.debug("close RIGHT is done");
                });
        };


        var dataURItoBlob = function(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        vm.showCropAvatarDialog = function(ev) {
            $mdDialog.show({
                controller: CropAvatarController,
                templateUrl: 'app/profile/avatar_crop.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(image) {
                    vm.avatar_image = image;
                    vm.avatar = image.file;
                }).then(function(){
                vm.current_password_wrong_message = '';

                var promises = [];

                if (vm.avatar_image) {
                    promises.push(account.uploadImage(dataURItoBlob(vm.avatar_image.file), vm.avatar_image.name));
                }
                if (vm.cover_image) {
                    promises.push(account.uploadImage(dataURItoBlob(vm.cover_image.file), vm.cover_image.name));
                }

                $q.all(promises).then(function(data) {
                    var indexAvatar = 0;
                    var indexCover = 1;
                    if (!vm.avatar_image) {
                        indexCover = 0;
                    }

                    if (vm.avatar_image) {
                        vm.user.photo = data[indexAvatar].filename;
                    }
                    if (vm.cover_image) {
                        vm.user.cover_photo = data[indexCover].filename;
                    }

                    vm.user.language_code = 'ES';

                    user.saveProfile(vm.user)
                        .then(function(){
                            $rootScope.$broadcast('account_change');

                            $mdDialog.show({
                                controller: CropAvatarController,
                                templateUrl: 'app/profile/modal_success.tmpl.html',
                                parent: angular.element($document.body),
                                clickOutsideToClose:true
                            });

                            $state.go('home.public-profile', {
                                userId: vm.user.id
                            });
                        })
                        .catch(function(response) {
                            if(response.data) {
                                if(response.data.message == 'user_current_password_wrong') {
                                    //$scope.profileForm.current_password.$setValidity("currentPasswordWrong", false);
                                }
                            }
                        });


                    //vm.processing = false;
                });
            });
        };

        vm.unfollow = function(id){
            user.unfollow(id).then(function(data){
                $mdDialog.show({
                    controller: 'PublicProfileController',
                    controllerAs: 'profile',
                    templateUrl: 'app/profile/modal-unfollow.tmpl.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose:true
                });
                if(data[0] =='unfollow'){
                    user.getUser(id).then(function(data){
                        vm.user = data;
                        $state.reload();
                    })
                }
            });
        }

        vm.follow = function(id){

            if($auth.isAuthenticated()) {
                user.follow(id).then(function(data){
                    $mdDialog.show({
                        controller: 'PublicProfileController',
                        controllerAs: 'profile',
                        templateUrl: 'app/profile/modal-follow.tmpl.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose:true
                    });
                    if(data[0]=='follow'){
                        user.getUser(id).then(function(data){
                            vm.user = data;
                            $state.reload();
                        })
                    }
                });

            } else {
                $mdDialog.show({
                    controller: 'LoginController',
                    controllerAs: 'login',
                    templateUrl: 'app/login/login.tmpl.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose:true
                }).then(function(success) {
                    vm.follow(vm.userId);
                    $state.reload();
                })
            }
        }

        vm.sendMessage = function(convid, msj){
            user.sendMessage({
                conversation_id: convid,
                message: msj,
                receiver_id: vm.userId,
                subject : 'asunto new conversation'
            }).then(function(data){
            })
        }

        vm.inbox = function ($http) {
            $mdDialog.show({
                controller: 'PublicProfileController',
                controllerAs: 'profile',
                templateUrl: 'app/profile/modal-inbox.tmpl.html',
                clickOutsideToClose: true
            });
        };

        vm.mensaje= function ($http) {
            $mdDialog.show({
                controller: 'PublicProfileController',
                controllerAs: 'profile',
                templateUrl: 'app/profile/modal-mensaje.tmpl.html',
                clickOutsideToClose: true,
                parent: angular.element($document.body)
            });
        };

        vm.gotoBottom = function($scope, $location, $anchorScroll) {
            $location.hash('bottom');
            $anchorScroll();
        };

        vm.showMessageModal = function(conversationId, conversation_messages) {
            var updateFlag = conversation_messages.length==0;
            $mdDialog.show({
                controller: MessageModalController,
                controllerAs: 'msgController',
                templateUrl: 'app/profile/message-modal-controller.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    myself_id: vm.user.mySelfId,
                    conversation_id: conversationId,
                    to_user_id: vm.userId,
                    conversation_messages: conversation_messages
                }
            }).then(function(data){
                if(data.result=='enviado'){
                    vm.sendMessageStatus = "Sended";
                }
                if (updateFlag)
                    updateUser(); // TODO: cambiar a un updateConversations para hacerlo más rápido
            })
        };




        vm.showLoginDialog = function(redirect) {
            if (redirect) {
                $rootScope.returnState = {
                    state: redirect
                };
            }
            $mdDialog.show({
                controller: 'LoginController',
                controllerAs: 'login',
                templateUrl: 'app/login/login.tmpl.html',
                parent: angular.element($document.body),
                clickOutsideToClose:true
            });
        };
        vm.isAuthenticated = function() {
            return $auth.isAuthenticated();
        };

        vm.canShowSendMessageButton = function() {
            return !vm.user.myself && vm.user.already_following && vm.conversations.length == 0;
        };

        vm.canShowConversations = function() {
            if (vm.conversations)
                return vm.conversations.length > 0 && (vm.user.already_following || vm.user.myself);
            else
                return undefined;
        };
    }

    function CropAvatarController($scope, $mdDialog) {
        $scope.myImage='';
        $scope.myCroppedImage='';
        $scope.fileName='';

        $scope.handleFileSelect = function(evt) {
            var file=evt.files[0];
            $scope.fileName = file.name;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function($scope){
                    $scope.myImage=evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        $scope.cropImage = function() {
            $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
        }
    }





    /** @ngInject */
    function MessageModalController(ENV, conversation_id, to_user_id, conversation_messages, user, $mdDialog, $state, $timeout, myself_id){
        var vm = this;

        vm.imageServer = ENV.imageServer
        vm.conversation_messages = conversation_messages,
        vm.toUserId = to_user_id;
        vm.mensaje = "";
        vm.sendMessageStatus = "notSended";
        vm.conversationId = conversation_id;
        vm.mySelfId = myself_id;

        vm.sendMessage = function(){
            user.sendMessage({
                conversation_id: vm.conversationId,
                message: vm.mensaje,
                winwin_id : vm.winwinId,
                receiver_id: vm.toUserId,
                subject : 'asunto new conversation'
            }).then(function(data){
                if(data.result =='enviado'){
                    vm.sendMessageStatus = "Sended";
                    vm.conversation_messages.push(data.message);
                    //$state.reload();
                    $timeout(function() {
                        $mdDialog.hide(data);
                    }, 3000);
                }
            });
        }
        vm.removeMsg = function(message) {
            user.removeMsg(message.id).then(function (data) {
                $mdDialog.hide(data);
                $state.reload();
            })
        };

    }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .controller('ProfileController', ProfileController);



  /** @ngInject */
  function ProfileController($window, account, user, $mdDialog, $q, ENV, $state, $auth, $rootScope, $scope, $document, winwin, $log) {
    var vm = this;

    if (!$auth.isAuthenticated()) {
      $state.go('home');
    }

    vm.avatar = '';
    vm.portrait = '';
    vm.imageServer = ENV.imageServer;
    vm.loading = true;

    vm.loadSkills = function(queryText){

      vm.skills = [];

      return user.getSkills(queryText).then(function(skills_data){
        angular.forEach(skills_data, function(skill){
          vm.skills.push({
            id: skill.id,
            text: skill.name
          });
        });

        return vm.skills;
      });

    };

    vm.user = {
      interests_list:[],
      skills_list:[]
    };

    account.getProfile()
    .then(function(data) {
      vm.isActive = data.active;
      user.getUser(data.user.id)
      .then(function(user_data) {
        vm.user = user_data;
        if (user_data.birthdate){
          var a = new Date(user_data.birthdate);
          a.setTime(a.getTime() + a.getTimezoneOffset()*60*1000);
          vm.user.birthdate = a;
          $log.log(vm.user.birthdate);
        } else {
          // Si no lo dejo null me pone una fecha estándar en 1969 al convertir a Date
          vm.user.birthdate = user_data.birthdate;
        }
        vm.is_complete = (user_data.name && user_data.lastname && user_data.email && user_data.birthdate);
        if (vm.user.birthdate) {
          vm.user.birthdate = new Date(user_data.birthdate.toString().replace(/-/g,'/'));
        }
        vm.creadospormi = $window._.filter(vm.user.winwins, function(winwin) {
          return winwin.user_id == vm.user.user_id && winwin.canceled == 0;
        });
        vm.enqueparticipo = $window._.filter(vm.user.winwins, function(winwin) {
          return winwin.user_id != vm.user.user_id && winwin.canceled == 0;
        });

        vm.winwins_length = vm.creadospormi.length + vm.enqueparticipo.length;
        winwin.getInterests().then(function(data) {
          vm.interests = data;
        });

        vm.user.skills_list = user_data.skills;

        vm.loading = false;

        vm.avatar = vm.imageServer+'/smart/'+vm.user.photo;
        vm.portrait = vm.imageServer+'/'+vm.user.cover_photo;
      });
    });

    vm.saveProfile = function() {
      //vm.processing = true;
      vm.current_password_wrong_message = '';

      var promises = [];

      if (vm.avatar_image) {
        promises.push(account.uploadImage(dataURItoBlob(vm.avatar_image.file), vm.avatar_image.name));
      }
      if (vm.cover_image) {
        promises.push(account.uploadImage(dataURItoBlob(vm.cover_image.file), vm.cover_image.name));
      }

      $q.all(promises).then(function(data) {
        var indexAvatar = 0;
        var indexCover = 1;
        if (!vm.avatar_image) {
          indexCover = 0;
        }

        if (vm.avatar_image) {
          vm.user.photo = data[indexAvatar].filename;
        }
        if (vm.cover_image) {
          vm.user.cover_photo = data[indexCover].filename;
        }

        vm.user.language_code = 'ES';

        user.saveProfile(vm.user)
        .then(function(){
          $rootScope.$broadcast('account_change');

          $mdDialog.show({
            controller: CropAvatarController,
            templateUrl: 'app/profile/modal_success.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true
          });

          $state.go('home.public-profile', {
            userId: vm.user.id
          });
        })
        .catch(function(response) {
          if(response.data) {
            if(response.data.message == 'user_current_password_wrong') {
              $scope.profileForm.current_password.$setValidity("currentPasswordWrong", false);
            }
          }
        });


        //vm.processing = false;
      });
    };

    var dataURItoBlob = function(dataURI) {
      var binary = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var array = [];
      for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {type: mimeString});
    };

    vm.showCropAvatarDialog = function(ev) {
      $mdDialog.show({
        controller: CropAvatarController,
        templateUrl: 'app/profile/avatar_crop.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true
      })
      .then(function(image) {
        vm.avatar_image = image;
        vm.avatar = image.file;
      });
    };

    vm.showCropCoverDialog = function(ev) {
      $mdDialog.show({
        controller: CropCoverController,
        templateUrl: 'app/profile/cover_crop.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true
      })
      .then(function(image) {
        vm.cover_image = image;
        vm.portrait = image.file;
      });
    };
  }

  function CropAvatarController($scope, $mdDialog) {
    $scope.myImage='';
    $scope.myCroppedImage='';
    $scope.fileName='';

    $scope.handleFileSelect = function(evt) {
      var file=evt.files[0];
      $scope.fileName = file.name;
      var reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$apply(function($scope){
          $scope.myImage=evt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };

    $scope.cropImage = function() {
      $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
    }
  }

  function CropCoverController($scope, $mdDialog) {
    $scope.myImage='';
    $scope.myCroppedImage='';
    $scope.fileName='';

    $scope.handleFileSelect = function(evt) {
      var file=evt.files[0];
      $scope.fileName = file.name;
      var reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$apply(function($scope){
          $scope.myImage=evt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };

    $scope.cropImage = function() {
      $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('ActivacionController', ActivacionController);

  /** @ngInject */
  function ActivacionController($auth, account) {
		var vm = this;

		vm.isAuthenticated = function() {
      return $auth.isAuthenticated();
    };

    account.getProfile()
    .then(function(data) {
       vm.account = data.profile;
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .controller('NotificationsController', NotificationsController);

  /** @ngInject */
  function NotificationsController(notifications, $mdDialog, user, current_user, account, $rootScope) {
    var vm = this;
    var page = 0;
    var offset = notifications.length;

    account.notificactionsRed(current_user).then(function() {
      $rootScope.$broadcast('account_change');
    });

    vm.notifications = notifications
    vm.working = false;

    vm.nextPage = function() {
      vm.working = true;
      page++;

      user.getNotifications(current_user.id, page, offset).then(function (new_notifications){
        if (new_notifications.length > 0) {
          vm.notifications.push.apply(vm.notifications, new_notifications);
          vm.working = false;
        }
      });
    }

    vm.close = function() {
      $mdDialog.cancel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .controller('MiembrosController', MiembrosController);

  /** @ngInject */
  function MiembrosController(miembro) {
    var vm = this;

    vm.current_page = 0

    miembro.getList(vm.current_page, 18).then(function(data) {
      vm.miembros = data;
    });

    vm.nextPage = function() {
      if (!vm.stop_paged){
        vm.current_page = vm.current_page + 1;
      
        miembro.getList(vm.current_page, 18).then(function(data) {
          vm.miembros.push.apply(vm.miembros, data);
          if (data.length < 18){
            vm.stop_paged = true;
          }    
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .controller('MainController', MainController);

  angular
      .module('winwins')
      .directive('scrollTop', function() {
        return {
          restrict: 'A',
          link: function(scope, $elm) {
            $elm.on('click', function() {
              angular.element("body").animate({scrollTop: angular.element("body").offset().top}, "slow");
            });
          }
        };
      });

  angular
      .module('winwins')
      .directive("scroll", function ($window, $document) {
        return function(scope, element, attrs) {
          angular.element($window).bind("scroll", function() {
            scope.boolChangeClass = this.pageYOffset >= 100 && $document[0].body.scrollHeight - this.pageYOffset - $window.innerHeight >= 260;
            scope.$apply();
          });
        };
      });

  /** @ngInject */
  function MainController($timeout,sponsor, ENV, $rootScope, winwin ,miembro, gettextCatalog ,gettext ,$auth ,$mdDialog ,$window ,$document,$sce ,Analytics ,grupo, $log) {
    var vm = this;

    /*  miembro.getList(0, 18).then(function(data) {
      vm.miembros = data;
    });*/

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.imageServer = ENV.imageServer;

    var w = angular.element($window);

    vm.isAuthenticated = function() {
      return $auth.isAuthenticated();
    };

    vm.showLoginDialog = function(redirect) {
      if (redirect) {
        $rootScope.returnState = {
          state: redirect
        };
      }
      $mdDialog.show({
        controller: 'LoginController',
        controllerAs: 'login',
        templateUrl: 'app/login/login.tmpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true
      });
    };

    sponsor.getList(0, (w.width() < 481) ? 4 : 4).then(function(data) {
      vm.sponsors = data;
      vm.sponsorsDestacadosTitle = "SPONSORS DESTACADOS";
    });

    sponsor.getMainList().then(function(data) {
      vm.partners = data;
    });

    winwin.getList(0, 'select', (w.width() < 481) ? 24   : 8).then(function(data) {
      vm.monthWinwin = data[0];
      vm.destacados = data;
    });

    grupo.getList(0, 4).then(function(data) {
      vm.gruposDestacados = data;
    });

    miembro.getList(0, (w.width()<481) ? 12 : 54, 'last_registered').then(function(data) {
      vm.miembros = data;
    });

    winwin.getInterests().then(function(data) {
      vm.interests = data;
    });

    vm.isAuthenticated = function() {
      var userIsAuthenticated = $auth.isAuthenticated();
      //TODO acceso global a id de usuario if (userIsAuthenticated) {
      //   Analytics.set('&uid', "test");
      // }
      return userIsAuthenticated;
    };

    vm.loadingDestacados = false;
    vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Destacados'));
    var _filter = 'select'
    var _categories = [];
    vm.doFilter = function(filter) {
      _categories = [];
      _filter = filter;
      vm.loadingDestacados = true;
      winwin.getList(0, filter, 8).then(function(data) {
        switch(filter) {
          case 'select':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Destacados'));
            break;
          case 'popular':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Populares'));
            break;
          case 'last':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins Recientes'));
            break;
          case 'finishing':
            vm.destacadosTitle = gettextCatalog.getString(gettext('Winwins por terminar'));
            break;
          case 'success':
            vm.destacadosTitle  = gettextCatalog.getString(gettext('Winwins concretados'));
            break;
        }
        vm.destacados = data;
        vm.loadingDestacados = false;
      });
    };

    vm.doCategories = function(id) {
      var _index = _categories.indexOf(id);

      if (_index == -1) {
        _categories.push(id);
      } else {
        _categories.splice(_index, 1);
      }

      if (_categories.length == 0) {
        vm.doFilter(_filter);
      } else {
        winwin.getListByCategory(0, _categories.join(','), 12).then(function(data) {
          vm.destacados = data;
        });
      }
    };

    vm.isChecked = function(id) {
      return _categories.indexOf(id) > -1;
    }

    vm.showLoginDialog = function(ev) {
      $mdDialog.show({
        controller: 'LoginController',
        controllerAs: 'login',
        templateUrl: 'app/login/login.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true
      });
    };

    vm.showVideoDialog = function(ev) {
      $mdDialog.show({
        controller: VideoController,
        controllerAs: 'vm',
        templateUrl: 'app/main/video.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true
      });
    };

    vm.getIframeSrc = function (videoId) {
        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+videoId+'?autoplay=0&controls=0');
    };

    vm.showMoreDetailMonthWinwin = function(ev) {
      $mdDialog.show({
        controller: MonthWinwinMoreDetailController,
        templateUrl: 'app/winwin/ver-mas-detalle.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        locals: {
          winwin: vm.monthWinwin
        }
      });
    }

  }



  /** @ngInject */

  function MonthWinwinMoreDetailController($scope, winwin) {
    $scope.winwin = winwin;
  }

  function VideoController($sce){
    var vm = this;

    vm.getIframeSrc = function (videoId) {
        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+videoId+'?autoplay=0');
    };
  }

})();


(function() {
  'use strict';

  angular
    .module('winwins')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($mdDialog, $auth, $state, $timeout, account, $rootScope, $log) {
    var vm = this;

    //$log.log($state);
    vm.login_status = 'login'

    vm.login = function() {
      $auth.login({ email: vm.login.email, password: vm.login.password })
      .then(function() {
        $rootScope.$broadcast('account_change');
        complete(getNextState($state));
        vm.login_status = 'success';
      })
      .catch(function() {
        vm.login_status = 'error';
      });
    };

    vm.authenticate = function(provider) {
      $auth.authenticate(provider)
      .then(function() {
        vm.provider = provider;
        $rootScope.$broadcast('account_change');
        complete(getNextState($state));
        vm.login_status = 'success';
      })
      .catch(function() {
        vm.login_status = 'error';
      });
    };

    /**
     * Calcula el estado posterior al login en función del estado
     * actual que se pasa como parámetro.
     * @param {Object} $state
     *
     */
    var getNextState = function($state) {
      if ($state.current.name == 'home')
        return {name: 'home.winwin-list', params: undefined};
      else
        return {name: $state.current.name, params: $state.params};
    }

    vm.register_status = 'register';

    vm.signup = function() {
      if (!vm.register.terms){
        vm.registerForm.terms.$setValidity("notTerms", false);
        return;
      }
      $auth.signup({
        username: vm.register.name + ' ' + vm.register.lastname,
        lastname: vm.register.lastname,
        email: vm.register.email,
        password: vm.register.password,
        name: vm.register.name,
        language_code: 'ES'
      })
      .then(function() {
        $auth.login({ email: vm.register.email, password: vm.register.password })
        .then(function() {
          $rootScope.$broadcast('account_change');
          complete({name: 'home.profile', params: undefined});
          vm.register_status = 'success';
        });
      })
      .catch(function(response) {
        vm.register_status = 'error';
        vm.message = "Error en su registracion";
        if(response.data) {
          if(response.data.message == 'email_already_taken') {
            vm.message = 'El correo ya existe';
          }
        }
      });
    };

    vm.change_pass_status = 'change_pass';

    vm.changePass = function() {
      account.emailResetPass(vm.changePass.email)
      .then(function() {
        vm.change_pass_status = 'success';
      })
      .catch(function(response) {
        vm.change_pass_status = 'error';
      });
    }

    var complete = function(redirect) {
      account.getProfile();
      $timeout(function() {
        $mdDialog.hide(true);
        if($rootScope.returnState) {
            //$log.log($rootScope.returnState);
            //$log.log($rootScope.returnState.state);
            switch($rootScope.returnState.state) {
              case 'home.winwin':
                var winwinId = $rootScope.returnState.parameters.winwinId;
                $rootScope.returnState = null;
                $state.go('home.winwin', {
                    winwinId: winwinId
                 });
                break;
              case 'home.crear-winwin':
                $rootScope.returnState = null;
                $state.go('home.crear-winwin');
                break;
              case 'no_redir':
                //Stay in the same state
                break;
              default:
                $rootScope.returnState = null;
                $state.go('home.winwin-list');
            }
        } else {
          if (redirect) {
            $state.go(redirect.name, redirect.params);
          }
        }
      }, 3000);
    };
  }

  angular
    .module('winwins')
    .directive('passwordVerify', passwordVerify);

    /** @ngInject */
  function passwordVerify() {
    var directive = {
      require: "ngModel",
      scope: {
        passwordVerify: '='
      },
      link: function(scope, element, attrs, ctrl) {
        scope.$watch(function() {
          var combined;

          if (scope.passwordVerify || ctrl.$viewValue) {
            combined = scope.passwordVerify + '_' + ctrl.$viewValue;
          }
          return combined;
        }, function(value) {
          if (value) {
            ctrl.$parsers.unshift(function(viewValue) {
              var origin = scope.passwordVerify;
              if (origin !== viewValue) {
                ctrl.$setValidity("passwordVerify", false);
                return undefined;
              } else {
                ctrl.$setValidity("passwordVerify", true);
                return viewValue;
              }
            });
          }
        });
      }
    };
    return directive;
  }

})();

(function() {
    'use strict';
    angular
        .module('winwins')
        .controller('PublicGrupoProfileController', PublicGrupoProfileController);

    /** @ngInject */
    function PublicGrupoProfileController(ENV, grupo, $stateParams, user, $mdDialog, $sce, $auth, $rootScope, $document, account, sponsor, $window, $q) {
        var vm = this;

        vm.base = ENV.base;
        vm.imageServer = ENV.imageServer;
        vm.groupId = $stateParams.groupId;
        vm.facebookId = ENV.satellizer.facebook.clientId;
        
        grupo.getGroup(vm.groupId).then(function(group_data) {
            vm.profile = group_data;

            user.getUser(group_data.user_id).then(function(user_data){
                vm.group_creator = user_data;
                sponsor.getList().then(function(sponsor_data) {
                    vm.sponsors = sponsor_data;
                      grupo.getPosts(vm.groupId).then(function(posts_data) {
                        vm.posts = posts_data.posts;

                        vm.post = {content: '', reference_id: group_data.id, type: 'GROUP'}
                      });
                });
            });

            vm.polls = vm.profile.polls;

            $window._.each(vm.polls, function(poll) {
              grupo.getPoll(poll.id).then(function(data) {
                poll.data = data;
              });
            });
        });

      sponsor.getList().then(function(sponsor_data) {
        vm.sponsors = sponsor_data;
      });

      account.getProfile().then(function(data) {
        vm.account = data.profile;

        vm.campanadas = $window._.filter(data.user.notifications, function(notification) {
          return notification.type == "CAMPANADA" && notification.object_id == vm.groupId; 
        });
      });

        vm.votePoll = function(poll) {
          grupo.votePoll(poll).then(function() {
            $window._.each(vm.polls, function(poll) {
              grupo.getPoll(poll.id).then(function(data) {
                poll.data = data;
              });
            });
          });
        }

        vm.removePoll = function(poll, index) {
          grupo.removePoll(poll.id).then(function() {
            vm.polls.splice(index, 1);
          });
        }

        vm.percentage_votes = function(poll, answer) {
          if(!poll.data.total_votes) {
            return 0;
          }
          var result = (answer.vote_count * 100 / poll.data.total_votes);
          return result;
        };

        vm.showModalPollDialog = function() {
          $mdDialog.show({
            controller: ModalPollController,
            controllerAs: 'vm',
            templateUrl: 'app/winwin/modal-poll.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            locals: {
              current_group: vm.profile
            }
          })
          .then(function(data) {
            vm.polls.push(data);
            $window._.each(vm.polls, function(poll) {
              grupo.getPoll(poll.id).then(function(data) {
                poll.data = data;
              });
            });
          });
        }

        vm.submitPost = function() {
          if (vm.post.content == '' && !vm.post.media_path && !vm.cover_post_image) {
            return;
          }

          var promises = [];

          if (vm.post.media_type == 'IMAGE' && vm.cover_post_image) {
            promises.push(grupo.uploadPostImage(dataURItoBlob(vm.cover_post_image.file), vm.cover_post_image.name));
          }

          $q.all(promises).then(function(data) {
            if (vm.cover_post_image) {
              vm.post.media_id = data[0].media_id;
              vm.post.media_path = data[0].filename;
              vm.cover_post_image = null;
            }

            grupo.createPost(vm.post)
            .then(function(data){
              grupo.getPosts(vm.groupId).then(function(posts_data) {
                vm.posts = posts_data.posts;
              });
              vm.post = {content: '', reference_id: vm.groupId, type: 'GROUP'}
            });
          });
        }

        var dataURItoBlob = function(dataURI) {
          var binary = atob(dataURI.split(',')[1]);
          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
          var array = [];
          for(var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        vm.getIframeSrc = function (videoId) {
            return $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+videoId+'?autoplay=0');
        };

        vm.showReplyDialog = function(post) {
          vm.modalReply = {
            controller: ReplyController,
            controllerAs: 'vm',
            templateUrl: 'app/winwin/modal-comment.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            preserveScope:true,
            locals: {
              current_post: post,
              current_account: vm.account,
              current_scope: vm,
              comment: {},
              cover_comment_image: null
            }
          }

          $mdDialog.show(vm.modalReply).then(function(data) {
            grupo.getPosts(vm.groupId).then(function(posts_data) {
              vm.posts = posts_data.posts;
            });
          });
        };

        vm.showParticipantesDialog = function(ev) {
          $mdDialog.show({
            controller: ParticipantesController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/participantes.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals: {
              users: vm.profile.users
            }
          })
        };

        vm.join = function() {
            if($auth.isAuthenticated()) {
                grupo.join(vm.groupId).then(function(group_data) {

                    $mdDialog.show({
                        controller: ModalConfirmacionSumarseController,
                        controllerAs: 'vm',
                        templateUrl: 'app/grupo/modal-confirmacion-sumarse-a-grupo.tmpl.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose:true,
                        locals: {
                            current_grupo: vm.profile
                        }
                    });

                });
            } else {
                $rootScope.returnState = {
                    state: 'home.grupo-profile',
                    parameters: {
                        groupId: vm.groupId
                    }
                };
                $mdDialog.show({
                    controller: 'LoginController',
                    controllerAs: 'login',
                    templateUrl: 'app/login/login.tmpl.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose:true
                });
            }
        }

        vm.setSticky = function(post, sticky) {
          grupo.stickyPost(post.id, sticky).then(function() {
            grupo.getPosts(vm.groupId).then(function(posts_data) {
              vm.posts = posts_data.posts;
            });
          });
        };

        vm.removePost = function(post) {
          $mdDialog.show({
            controller: ModalRemoveController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/modal-remove.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            locals: {
              current_post: post
            }
          })
          .then(function(data) {
            grupo.getPosts(vm.groupId).then(function(posts_data) {
              vm.posts = posts_data.posts;
            });
          });
        };

        vm.showCropPostImageDialog = function(ev) {
          $mdDialog.show({
            controller: CropPostImageController,
            templateUrl: 'app/grupo/cover-post-image.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose:true
          })
          .then(function(image) {
            vm.post.media_type = 'IMAGE';
            vm.cover_post_image = image;
          });
        };

        vm.vote = function(post, positive) {
          grupo.votePost(post.id, positive).then(function() {
            grupo.getPosts(vm.groupId).then(function(posts_data) {
              vm.posts = posts_data.posts;
            });
          });
        };

        vm.left = function() {
          $mdDialog.show({
            controller: ModalAbandonarGrupoController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/modal-abandonar-grupo.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            locals: {
              current_group: vm.profile
            }
          })
          .then(function(data) {
            vm.profile.already_joined = false;
          });
        }

        vm.showModalShareEmailDialog = function() {
          $mdDialog.show({
            controller: ModalShareEmailController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/modal-share-email.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            locals: {
              current_group: vm.profile
            }
          });
        }

        vm.showMasDetalleDialog = function(ev) {
          $mdDialog.show({
            controller: MasDetalleController,
            templateUrl: 'app/grupo/ver-mas-detalle.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            locals: {
              grupo: vm.profile
            }
          });
        };

        vm.showUserWinwinsModal = function() {
            if ($auth.isAuthenticated()) {
                account.getProfile().then(function(profile_data) {
                    user.getUser(profile_data.user.id).then(function(user_data){
                        $mdDialog.show({
                            controller: ModalVerWinwinsDeUsuario,
                            controllerAs: 'vm',
                            templateUrl: 'app/grupo/modal-agregar-winwin-a-grupo.tmpl.html',
                            parent: angular.element($document.body),
                            clickOutsideToClose:true,
                            locals: {
                                user_winwins: user_data.winwins,
                                winwins_already_add: vm.profile.winwins, 
                                groupId: vm.groupId,
                                groupName: vm.profile.name,
                                currentScope : vm
                            }
                        });                        
                    })
                })
            } else {
                $rootScope.returnState = {
                    state: 'home.grupo-profile',
                    parameters: {
                        groupId: vm.groupId
                    }
                };
                $mdDialog.show({
                    controller: 'LoginController',
                    controllerAs: 'login',
                    templateUrl: 'app/login/login.tmpl.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose:true
                });
            }
        }

        vm.showModalVideoPostDialog = function(ev) {
          $mdDialog.show({
            controller: ModalVideoPostController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/modal-video-post.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose:true
          })
          .then(function(video) {
            vm.post.media_type = 'VIDEO';
            vm.post.media_path = video;
          });
        };

        vm.close = function() {
          $mdDialog.show({
            controller: ModalCloseController,
            controllerAs: 'vm',
            templateUrl: 'app/grupo/modal-close.tmpl.html',
            parent: angular.element($document.body),
            clickOutsideToClose:true,
            locals: {
              current_group: vm.profile
            }
          })
          .then(function(data) {
          });
        }
    }

    /** @ngInject */
    function ModalVerWinwinsDeUsuario(ENV, grupo, user, user_winwins, winwins_already_add, groupId, $window, groupName, currentScope) {
        var vm = this;

        vm.base = ENV.base;
        vm.imageServer = ENV.imageServer;
        vm.user_winwins = user_winwins;
        vm.winwins_already_add = winwins_already_add;
        vm.grupoId = groupId;
        vm.groupName = groupName;
        vm.success = false;
        vm.user_have_winwins = vm.user_winwins.length == 0 ? false : true;
        vm.not_added_winwins = $window._.filter(vm.user_winwins, function(user_winwin){

            var isWinwinInList = $window._.filter(vm.winwins_already_add, function(winwin_already_add){
                return user_winwin.id == winwin_already_add.id;
            })

            return isWinwinInList.length == 0;
        });

        vm.all_user_winwins_added = vm.user_have_winwins && vm.not_added_winwins.length == 0;

        vm.addWinwinToGroup = function(winwinId) {
            grupo.addWinwin(vm.grupoId, winwinId).then(function(group_data){
                vm.success = true;
                currentScope.profile.winwins = group_data.winwins;
            })
        }

        user.getUser(grupo.user_id).then(function(user_data){
            vm.group_creator = user_data;
        });
    }

    /** @ngInject */
    function ModalShareEmailController(current_group, grupo) {
        var vm = this;

        vm.grupo = current_group;
        vm.emailsOK = false;
        vm.mails = [];

        vm.validateMail = function(chip) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(chip))
            {
                var index = vm.mails.indexOf(chip);
                vm.mails.splice(index, 1);
            }
        }

        vm.sentInvitations = function() {
            grupo.shareMails(vm.grupo.id, vm.mails).then(function() {
                vm.mails = [];
                vm.emailsOK = true;
            });
        }
    }


    /** @ngInject */
    function ModalConfirmacionSumarseController(current_grupo, ENV) {
        var vm = this;

        vm.base = ENV.base;
        vm.imageServer = ENV.imageServer;
        vm.facebookId = ENV.satellizer.facebook.clientId;
        vm.status = 'success';
        vm.grupo = current_grupo;
    }

    /** @ngInject */
    function MasDetalleController($scope, grupo) {
        $scope.grupo = grupo;
    }

    /** @ngInject */
    function ModalPollController(grupo, current_group, $mdDialog, $timeout) {
      var vm = this;
      vm.pollOk = false;
      vm.poll = {};
      vm.poll.selected = false;

      vm.submitPoll = function() {
        grupo.createPoll(current_group.id, vm.poll).then(function(data) {
          vm.pollOk = true;
          $timeout(function() {
            $mdDialog.hide(data);  
          }, 3000);
        });
      }
    }

    /** @ngInject */
    function ModalAbandonarGrupoController(current_group, $mdDialog, grupo) {
        var vm = this;

        vm.left = function() {
          grupo.left(current_group.id).then(function(data) {
             $mdDialog.hide(data);
          });
        }

        vm.cancel = function() {
          $mdDialog.cancel();
        }
    }

    /** @ngInject */
    function ModalCloseController(current_group, $mdDialog, grupo) {
      var vm = this;

      vm.close = function() {
        grupo.close(current_group.id, vm.reason).then(function(data) {
           $mdDialog.hide(data);
        });
      }

      vm.cancel = function() {
        $mdDialog.cancel();
      }
    }

    /** @ngInject */
    function ModalVideoPostController($mdDialog) {
        var vm = this;

        vm.setVideo = function() {
          $mdDialog.hide(vm.matchYoutubeUrl(vm.video));
        }

        vm.cancel = function() {
          $mdDialog.cancel();
        }

        vm.previewVideo = function(e) {
          vm.video_path = vm.matchYoutubeUrl(e.originalEvent.clipboardData.getData('text/plain'));
        }

        vm.matchYoutubeUrl = function(url){
          var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
          return (url.match(p)) ? RegExp.$1 : false ;
        }
    }

    /** @ngInject */
    function ModalRemoveController(current_post, $mdDialog, grupo) {
        var vm = this;

        vm.remove = function() {
          grupo.removePost(current_post.id).then(function(data) {
             $mdDialog.hide(data);
          });
        }

        vm.cancel = function() {
          $mdDialog.cancel();
        }
    }

    /** @ngInject */
    function ParticipantesController(users, ENV){
      var vm = this;

      vm.imageServer = ENV.imageServer;
      vm.users = users;
    }

    /** @ngInject */
    function CropPostImageController($scope, $mdDialog) {
        $scope.myImage='';
        $scope.myCroppedImage='';
        $scope.fileName='';
        var vm = this;

        $scope.resizeImageContainer = function() {
          $scope.imageDirective = "hola";
        }

        $scope.handleFileSelect = function(evt) {
          var file=evt.files[0];
          $scope.fileName = file.name;
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function($scope){
              $scope.myImage=evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };

        $scope.cropImage = function() {
          $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
        }
    }

        /** @ngInject */
        function ReplyController(current_post, current_account, $mdDialog, $document, current_scope, comment, cover_comment_image, grupo, $q) {
            var vm = this;

            vm.account = current_account;
            vm.post = current_post;

            vm.comment = comment;
            vm.cover_comment_image = cover_comment_image;

            vm.modal_reply = current_scope.modalReply;

            vm.showModalVideoPostDialog = function() {
              $mdDialog.show({
                controller: ModalVideoPostController,
                controllerAs: 'vm',
                templateUrl: 'app/winwin/modal-video-post.tmpl.html',
                clickOutsideToClose:true
              })
              .then(function(video) {
                vm.comment.media_type = 'VIDEO';
                vm.comment.media_path = video;
                $mdDialog.show(vm.modal_reply);
              }, 
              function() {
                $mdDialog.show(vm.modal_reply);
              });
            };

            vm.showCropPostImageDialog = function(ev) {
              $mdDialog.show({
                controller: CropPostImageController,
                templateUrl: 'app/grupo/cover-post-image.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true
              })
              .then(function(image) {
                vm.comment.media_type = 'IMAGE';
                vm.modal_reply.locals.cover_comment_image = image
                $mdDialog.show(vm.modal_reply);
              }, 
              function() {
                $mdDialog.show(vm.modal_reply);
              });
            };

            vm.submitComment = function() {
              if (vm.comment.content == '' && !vm.comment.media_path && !vm.cover_comment_image) {
                return;
              }

              if (!vm.comment.content) {
                vm.comment.content = '';
              }

              var promises = [];

              if (vm.comment.media_type == 'IMAGE' && vm.cover_comment_image) {
                promises.push(grupo.uploadPostImage(dataURItoBlob(vm.cover_comment_image.file), vm.cover_comment_image.name));
              }

              $q.all(promises).then(function(data) {
                if (vm.cover_comment_image) {
                  vm.comment.media_id = data[0].media_id;
                  vm.comment.media_path = data[0].filename;
                  vm.cover_comment_image = null;
                }

                grupo.createComment(vm.post.id, vm.comment.content, vm.comment.media_id, vm.comment.media_type, vm.comment.media_path)
                .then(function(data){
                  $mdDialog.hide(data);
                  vm.post.comments.push(vm.comment);
                });
              });
            }

            var dataURItoBlob = function(dataURI) {
              var binary = atob(dataURI.split(',')[1]);
              var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
              var array = [];
              for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
              }
              return new Blob([new Uint8Array(array)], {type: mimeString});
            };
        }

})();


(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('GrupoListController', GrupoListController);

  /** @ngInject */
  function GrupoListController(ENV, grupo) {
    var vm = this;

    vm.imageServer = ENV.imageServer;

    grupo.getList(0, 15).then(function(data) {
      vm.grupos = data;
    });

  }

})();

(function() {
    'use strict';

    angular
        .module('winwins')
        .controller('CrearGrupoController', CrearGrupoController);

    /** @ngInject */
    function CrearGrupoController($stateParams, grupo, winwin, ENV, $mdDialog, $document, $q, $window, $element, $state) {
        var vm = this;
        vm.base = ENV.base;
        vm.imageServer = ENV.imageServer;
        vm.facebookId = ENV.satellizer.facebook.clientId;
        vm.stage = 1;
        vm.emailsOK = false;
        vm.grupo = {
            interests:[]
        };
    
        grupo.getInterests().then(function(data) {
          vm.interests = data;
        });


        vm.clearError = function () {
            if (vm.grupo.terms) {
                vm.crearForm.terms.$setValidity("notTerms", true);
            }
        }

        vm.nextStage = function() {
            if (!vm.grupo.terms){
                vm.crearForm.terms.$setValidity("notTerms", false);
                return;
            }
            vm.stage = 2;
        }

        vm.saveGrupo = function () {

            if (!vm.grupo.terms) {
                vm.crearForm.terms.$setValidity("notTerms", false);
                return;
            }

            var promises = [];

            if (vm.cover_image) {
                promises.push(grupo.uploadImage(dataURItoBlob(vm.cover_image.file), vm.cover_image.name));
            }

            $q.all(promises).then(function (data) {
                if (vm.cover_image) {
                    vm.grupo.photo = data[0].filename;
                }

                grupo.saveGrupo(vm.grupo)
                    .then(function (data) {
                        vm.grupo.id = data.id;
                            $state.go('home.grupo-profile', {
                              groupId: vm.grupo.id
                            });
                    });
            });
        }

        vm.showCropCoverDialog = function(ev) {
            $mdDialog.show({
                    controller: CropCoverController,
                    templateUrl: 'app/grupo/group-cover.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true
                })
                .then(function(image) {
                    vm.cover_image = image;
                    vm.preview_image = image.file;
                    vm.grupo.video = null;
                    vm.grupo.image = null;
                });
        };

        var dataURItoBlob = function(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };
    }

    /** @ngInject */
    function CropCoverController($scope, $mdDialog) {
        $scope.myImage='';
        $scope.myCroppedImage='';
        $scope.fileName='';

        $scope.handleFileSelect = function(evt) {
            var file=evt.files[0];
            $scope.fileName = file.name;
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function($scope){
                    $scope.myImage=evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        $scope.cropImage = function() {
            $mdDialog.hide({file:$scope.myCroppedImage, name:$scope.fileName});
        }
    }
    
})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController(user, $mdDialog, $state, $document) {
    var vm = this;

    vm.sendMailContact = function() {
      user.sendMailContact(vm.contact).then(function(){
        $state.go('home');

        $mdDialog.show({
          controller: SuccessController,
          templateUrl: 'app/contact/modal_success.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true
        });
      })
    }
  }

  function SuccessController(){
  }

})();

(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController() {
  }

})();




(function() {
  'use strict';
  angular
    .module('winwins')
    .controller('BlogController', BlogController);

  /** @ngInject */
  function BlogController() {
  }

})();

angular.module("winwins.config", [])

.constant("ENV", {
	"name": "prod",
	"base": "https://winwins.org/",
	"apiBase": "https://winwins.org/api",
	"imageServer": "https://images.winwins.org",
	"defaultLang": "es",
	"baseLang": "es",
	"availableLangs": [
		"es",
		"en"
	],
	"satellizer": {
		"facebook": {
			"clientId": "1998007110476409",
			"scope": "email,public_profile"
		},
		"google": {
			"clientId": "313110710680-p22p1s5brqn7tfaqj9v16u67bic5smqk.apps.googleusercontent.com"
		},
		"yahoo": {
			"clientId": "dj0yJmk9SDVkM2RhNWJSc2ZBJmQ9WVdrOWIzVlFRMWxzTXpZbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0yYw--"
		},
		"twitter": {
			"url": "/auth/twitter"
		}
	}
})

;
(function() {
  'use strict';

  angular
    .module('winwins')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, gettextCatalog, ENV, Analytics, $auth, $state, $mdDialog, $document) {

    var changeLang = function(event, lang) {
      gettextCatalog.setCurrentLanguage(lang);
    };

    // With var, so can destroy it
    var event1 = $rootScope.$on('changeLang', changeLang);

    gettextCatalog.baseLanguage = ENV.baseLang;
    changeLang(null, ENV.defaultLang);

    if(ENV.name !== 'prod') {
      gettextCatalog.debug = true;
      gettextCatalog.debugPrefix = '[Missing]:';
    }

    // On $rootCcope, so we can reference it on templates
    // without setting on controller
    $rootScope.imageServer = ENV.imageServer;

    var event4 = $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
        $rootScope.containerClass = toState.containerClass;
    });

    $rootScope.loadingFlag = false;
    var event2 = $rootScope.$on('cfpLoadingBar:started', function () {
        $rootScope.loadingFlag = true;
    });
    var event3 = $rootScope.$on('cfpLoadingBar:completed', function () {
        if($rootScope.loadingFlag){
            $rootScope.loadingFlag = false;
        }
    });

    $rootScope.createWinwin = function() {
      $state.go('home.crear-winwin');
      /*if ($auth.isAuthenticated()) {
        $state.go('home.crear-winwin');
      } else {
        $rootScope.returnState = {
          state : 'home.crear-winwin'
        };
        $mdDialog.show({
          controller: 'LoginController',
          controllerAs: 'login',
          templateUrl: 'app/login/login.tmpl.html',
          parent: angular.element($document.body),
          clickOutsideToClose:true,
        });
      }*/
    }
      $rootScope.editWinwin = function() {
          $state.go('home.editar-winwin');
      }

  }

})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        views: {
          'master': {
            templateUrl: 'app/master/master.html',
            containerClass: 'home'
          },
          'content@home': {
            templateUrl: 'app/main/main.html',
            controller: 'MainController',
            controllerAs: 'main',
            resolve: {
              partners: function(partner) {
                return partner.getList();
              }
            }
          }
        }
      })
      .state('home.profile',{
        url: 'profile',
        views: {
          'content@home': {
            templateUrl: 'app/profile/profile.html',
            controller: 'ProfileController',
            controllerAs: 'profile'
          }
        }
      })
      .state('home.public-profile',{
        url: 'profile/:userId',
        containerClass: 'back-color',
        views: {
          'content@home': {
            templateUrl: 'app/profile/public-profile.html',
            controller: 'PublicProfileController',
            controllerAs: 'profile'
          }
        }
      })
      .state('home.winwin',{
        url: 'winwin/:winwinId',
        params: {
          showFirstPostModal: false,
          confirmation : ""
        },
        views: {
          'content@home': {
            templateUrl: 'app/winwin/winwin.html',
            controller: 'WinwinController',
            controllerAs: 'winwin'
          }
        }
      })
      .state('home.winwinConfirmation',{
        url: 'winwin/{winwinId}/{confirmation}',
        params: {
          showFirstPostModal: false
        },
        views: {
          'content@home': {
            templateUrl: 'app/winwin/winwin.html',
            controller: 'WinwinController',
            controllerAs: 'winwin'
          }
        }
      })
      .state('home.activacion',{
        url: 'activacion',
        views: {
          'content@home': {
            templateUrl: 'app/profile/activacion.html',
            controller: 'ActivacionController',
            controllerAs: 'activacion'
          }
        }
      })
      .state('home.crear-winwin',{
        url: 'crear-winwin',
        views: {
          'content@home': {
            templateUrl: 'app/winwin/crear-winwin.html',
            controller: 'CrearWinwinController',
            controllerAs: 'winwin'
            }
        }
      })
        .state('home.editar-winwin',{
            url: 'editar-winwin/{winwinId}',
            views: {
                'content@home': {
                    templateUrl: 'app/winwin/crear-winwin.html',
                    controller: 'EditarWinwinController',
                    controllerAs: 'winwin'
                }
            }
        })
      .state('home.terms',{
        url: 'terms',
        views: {
          'content@home': {
            templateUrl: 'app/terms/terms.html',
            controller: 'TermsController',
            controllerAs: 'terms'
          }
        }
      })
      .state('home.contact',{
        url: 'contact',
        views: {
          'content@home': {
            templateUrl: 'app/contact/contact.html',
            controller: 'ContactController',
            controllerAs: 'contact'
          }
        }
      })
      .state('home.notifications',{
        url: 'notifications',
        views: {
          'content@home': {
            templateUrl: 'app/notifications/notifications.html',
            controller: 'NotificationsController',
            controllerAs: 'notifications'
          }
        }
      })
      .state('home.about',{
        url: 'about',
        containerClass: 'back-color',
        views: {
          'content@home': {
            templateUrl: 'app/about/about.html',
            controller: 'AboutController',
            controllerAs: 'about'
          }
        }
      })
       .state('home.blog',{
        url: 'blog',
        containerClass: 'back-color',
        views: {
          'content@home': {
            templateUrl: 'app/blog/blog.html',
            controller: 'BlogController',
            controllerAs: 'blog'
          }
        }
      })
      .state('home.weare',{
        url: 'weare',
        containerClass: 'back-color',
        views: {
          'content@home': {
            templateUrl: 'app/weare/weare.html',
            controller: 'WeareController',
            controllerAs: 'weare'
          }
        }
      })
      .state('home.winwin-list',{
        url: 'winwin-list',
        containerClass: 'back-color',
        views: {
          'content@home': {
            templateUrl: 'app/winwin/winwin-list.html',
            controller: 'WinwinListController',
            controllerAs: 'winwin'
          }
        }
      })
      .state('home.grupo-list',{
        url: 'grupo-list',
        views: {
          'content@home': {
            templateUrl: 'app/grupo/group_list_index.html',
            controller: 'GrupoListController',
            controllerAs: 'grupo'
          }
        }
      })
      .state('home.mis-grupos-list',{
        url: 'mis-grupos-list',
        views: {
          'content@home': {
            templateUrl: 'app/grupo/group_list_index.html',
            controller: 'MisGruposListController',
            controllerAs: 'grupo'
          }
        }
      })
      .state('home.grupo-profile',{
        url: 'grupo/:groupId',
        views: {
          'content@home': {
            templateUrl: 'app/grupo/grupo-profile.html',
            controller: 'PublicGrupoProfileController',
            controllerAs: 'grupo'
          }
        }
      })
      .state('home.grupo-creacion',{
        url: 'crear-grupo',
        views: {
          'content@home': {
            templateUrl: 'app/grupo/crear-grupo.html',
            controller: 'CrearGrupoController',
            controllerAs: 'grupo'
          }
        }
      })
      .state('home.miembros',{
        url: 'miembros',
        views: {
          'content@home': {
            templateUrl: 'app/miembros/miembros.html',
            controller: 'MiembrosController',
            controllerAs: 'miembros'
          }
        }
      })
      .state('home.mis-winwin',{
        url: 'mis-winwin',
        views: {
          'content@home': {
            templateUrl: 'app/winwin/mis-winwin.html',
            controller: 'MisWinwinController',
            controllerAs: 'winwin'
            }
        }
      })
      .state('home.search',{
        url: 'search/:query',
        views: {
          'content@home': {
            templateUrl: 'app/search/search.html',
            controller: 'SearchController',
            controllerAs: 'search'
          }
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('winwins')
    .constant('moment', moment);
})();

(function() {
  'use strict';

  angular
    .module('winwins')
    .config(config)
    .config(function (ezfbProvider, ENV) {
        ezfbProvider.setLocale('es_LA'); // TODO: adaptar esto al idioma del usuario o del sitio
        ezfbProvider.setInitParams({
            // This is my FB app id for plunker demo app
            appId: ENV.satellizer.facebook.clientId
        });
    })
    .config(function($mdDateLocaleProvider) {
      // Example of a Spanish localization.
      $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                                      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
      $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
      // Can change week display to start on Monday.
      $mdDateLocaleProvider.firstDayOfWeek = 1;
      // Optional.
      //$mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, 7,8,9,10,11,12,13,14,15,16,17,18,19,
      //                               20,21,22,23,24,25,26,27,28,29,30,31];
      // In addition to date display, date components also need localized messages
      // for aria-labels for screen-reader users.
      $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
        return 'Semana ' + weekNumber;
      };
      $mdDateLocaleProvider.msgCalendar = 'Calendario';
      $mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendario';
    });

  /** @ngInject */
  function config($logProvider, toastrConfig, ENV, RestangularProvider, $authProvider, cfpLoadingBarProvider, amDatePickerConfigProvider, AnalyticsProvider, $httpProvider, $cookiesProvider) {

    // Enable log
    var debug = true;
    if(ENV.name === 'prod') {
      debug = false;
    }
    $logProvider.debugEnabled(debug);

    // Toastr Set options
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // Restangular Set options
    RestangularProvider.setBaseUrl(ENV.apiBase);
    RestangularProvider.setRequestSuffix('/');
    RestangularProvider.setRestangularFields({
      selfLink: 'url'
    });

    // Satellizer set options
    $authProvider.baseUrl = ENV.base + '/';
    $authProvider.httpInterceptor = true;
    $authProvider.facebook(ENV.satellizer.facebook);
    $authProvider.google(ENV.satellizer.google);
    $authProvider.yahoo(ENV.satellizer.yahoo);
    $authProvider.twitter(ENV.satellizer.twitter);

    // Google Analytics
//    if(ENV.name === 'prod') {
//        AnalyticsProvider.setAccount({
//                                        tracker: 'UA-79951335-1',
//                                        trackEvent: true
//                                    });
//        AnalyticsProvider.trackPages(true);
//        AnalyticsProvider.setDomainName('winwins.org');
//    } else {
//        AnalyticsProvider.setAccount({
//                                        tracker: 'UA-79951335-2',
//                                        trackEvent: true
//                                    });
//        AnalyticsProvider.trackPages(true);
//        AnalyticsProvider.setDomainName('dev-winwins.net');
//    }

    // angular-loading-bar
    cfpLoadingBarProvider.includeSpinner = true;

    amDatePickerConfigProvider.setOptions({
        calendarIcon: '/assets/images/ic_today_black_24px.svg',
        clearIcon: '/assets/images/ic_close_black_24px.svg',
        nextIcon: '/assets/images/ic_keyboard_arrow_right_black_24px.svg',
        prevIcon: '/assets/images/ic_keyboard_arrow_left_black_24px.svg'
    })

  }

})();

angular.module("winwins").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<md-content class=\"acme-weare\" style=\"background: #fff\"><div layout=\"row\" layout-xs=\"column\" style=\"background-color: #e56f29; position: fixed; width: 100%; color: #fff; text-align: center; padding:20px; font-weight: bold; margin-top: 10px;\"><div flex=\"\"><a href=\"#desafios\" style=\"color: #fff; text-decoration: none;\" du-smooth-scroll=\"\">LOS DESAFIOS WINWIN</a></div><div flex=\"\"><a href=\"#simple\" style=\"color: #fff; text-decoration: none;\" du-smooth-scroll=\"\">SIMPLE Y FACIL</a></div><div flex=\"\"><a href=\"#crea\" style=\"color: #fff; text-decoration: none;\" du-smooth-scroll=\"\">CREA TU DESAFIO</a></div><div flex=\"\"><a href=\"#accion\" style=\"color: #fff; text-decoration: none;\" du-smooth-scroll=\"\">UN WINWIN EN ACCION</a></div><div flex=\"\"><a href=\"#usuarios\" style=\"color: #fff; text-decoration: none;\" du-smooth-scroll=\"\">USUARIOS</a></div></div><br><br><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><div class=\"container\" style=\"padding-bottom: 0px;\"><div layout=\"row\"><div flex=\"\"><h1 class=\"big-title-b\" style=\"color: #fff\">¿C&oacute;mo funciona?</h1></div></div></div></div><br><br><br><br><div layout=\"row\" layout-xs=\"column\"><div layout=\"container\" style=\"display: block; margin-left: auto; margin-right: auto;\"><div layout=\"row\" layout-xs=\"column\" style=\"text-align: center\"><br><br><br><br><div flex=\"\" layout-align=\"center center\"><img src=\"../assets/images/icon-recientes-title.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Crea o sumate a un Winwin</h4><p>Crea tus propios desaf&iacute;os<br>sumate a los de otras personas.</p><br></div><div flex=\"\"><img src=\"../assets/images/share.png\"><h4 style=\"font-size: 20px; margin-bottom: 0px; margin-top:\">Invita gente y difundilo</h4><p>Invitá a gente a participar y difundí<br>tus desafíos en las redes sociales.</p><br></div><div flex=\"\"><img src=\"../assets/images/counter-sponsors-icon.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Consegu&iacute; apoyo</h4><p>Conseguí el apoyo de personas, sponsors y organizaciones.</p><br></div><div flex=\"\"><img src=\"../assets/images/wingsa.png\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Gana Alas y Reconocimientos</h4><p>Ganá alas, reconocimiento y<br>beneficios por tus acciones.</p><br><br><br><br><br>.</div></div></div></div><div id=\"desafios\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br>.<br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\">Los desaf&iacute;os Winwin</h1>Los winwins te invitan a colaborar para lograr algo juntos, algo que interesa y beneficia también a los demás. Son <strong>propuestas de beneficio mutuo</strong> que buscan sumar voluntades para llevarlas a cabo. Por eso, el creador de un winwin, además de formular su propuesta de acción colectiva, <strong>establece cuál es la cantidad de participantes necesarios</strong> para pasar a la acción. Una vez que se alcanza la cantidad de participantes, el sistema alerta a todos que ya están dadas las condiciones para concretar el winwin. <strong>Si no se alcanza el quórum, no hay obligación de participar.</strong><p></p></div></div><div flex=\"\"><img src=\"../assets/images/winwin.gif\" height=\"300\"></div></div></div><div id=\"simple\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\">Simple y f&aacute;cil</h1>Creá winwins o sumate a las propuestas de otros, invita a participar en ellas, difundilas, conseguí apoyos y mucho m&aacute;s.<br>Podés también seguir a los usuarios que te inspiran, y otros seguirte a vos.<br>Logueate con tu sesión de Facebook, o generá tu usuario desde “Entrar” y comenzá esta aventura por un mundo en el que todos ganemos.<p></p></div></div><div flex=\"\"><iframe width=\"100%\" height=\"330px\" src=\"https://www.youtube.com/embed/npWNX0woM7o?autoplay=0;rel=0&amp;showinfo=0\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div><div id=\"crea\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\">Cre&aacute; tu Winwin</h1>Elegí un nombre y avatar atractivo para tu winwin y formulá tu propuesta de forma simple y concreta.<br><br>Indicá cuántos participantes deben sumarse para hacerlo realidad.<br><br>Agregá información adicional sobre sus características, las razones que te implusan a proponerla, los resultados que buscás, etc.<br><br>Podés también establecer una fecha límite para participar, un área geográfica determinada, etc.<br><br>ATENCIÓN! Sólo podrás editar tu winwin hasta alcanzar la primera adhesión.<p></p></div></div><div flex=\"\"><h1>Y si ya creaste tu winwin…</h1><strong>PROMOCIONARLO</strong>es clave para lograr resultados.<br><br><strong>COMPARTILO</strong>con tus amigas y amigos para alcanzar el quorum necesario, y pediles a ellos que también lo hagan.<br><br><strong>PUBLICÁ</strong> en el muro del winwin información y videos que generen motivación y debate constructivo entre los participantes.</div></div></div><div id=\"accion\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px\"></div><div class=\"container\"><br><br><br><br><h1 style=\"color:#547bc0; margin-bottom:0px; text-align: center\">Un winwin en acci&oacute;n</h1><h1 style=\"color:#585858; font-size: 18px; text-align: center\">Componentes y herramientas disponibles</h1><br><div layout=\"row\" layout-xs=\"column\" style=\"padding-top: 20px;\"><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-play\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#1\" du-smooth-scroll=\"\" style=\"color: #585858; text-decoration: none;\">ABC DE UN WINWIN</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px; text-decoration: none;\"><i class=\"fa fa-plus\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#2\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Sumarte al Winwin</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px; text-decoration: none;\"><i class=\"fa fa-share\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#3\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Invitar al winwin</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-share-alt\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#4\" du-smooth-scroll=\"\" style=\"color: #585858\">Compartir vía RRSS</a></h1></span></div></div><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-comments\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#5\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Muro del winwin</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-users\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#6\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Participantes</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-bell\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#7\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Campanada</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-comment-o\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#8\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Mensaje al Creador</a></h1></span></div></div><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-bookmark\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#9\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Destacar post</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-server\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#10\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Crear encuestas</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-handshake-o\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#15\" style=\"color: #585858;text-decoration: none;\" du-smooth-scroll=\"\">Sponsors</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-bullhorn\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#16\" du-smooth-scroll=\"\" style=\"color: #585858;text-decoration: none;\">Difusi&oacute;n de tu Winwin</a></h1></span></div></div><br><br></div><div id=\"usuarios\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px\"></div><div class=\"container\"><br><br><h1 style=\"color:#547bc0; margin-bottom:0px;text-align: center\">Usuarios activos</h1><h1 style=\"color:#585858; font-size: 18px; text-align: center\">Perfil, timeline y mucho más</h1><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-male\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#11\" du-smooth-scroll=\"\" style=\"color: #585858\">Tu perfil</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-envelope-o\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#13\" style=\"color: #585858\" du-smooth-scroll=\"\">Mensajes</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-bell-o\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#14\" style=\"color: #585858\" du-smooth-scroll=\"\">Notificaciones</a></h1></span></div><div flex=\"\"><span style=\"text-align: center\"><h1 style=\"margin:0px; padding: 0px;font-size: 35px;\"><i class=\"fa fa-flash\" style=\"color: #3c6cc1\"></i></h1><h1 style=\"margin:0px; padding: 0px;font-size: 18px; font-weight: bold; color:#333;\"><a href=\"#12\" du-smooth-scroll=\"\" style=\"color: #585858\">Actividad Reciente</a></h1></span></div></div><br><br></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><div class=\"container\"><div id=\"1\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\">ABC de un Winwin</h1><p>Las bases de cada propuesta están en el encabezado de su página. Allí, se describe en qué consiste, cuántas personas se han adherido y cuántas faltan para alcanzar el quórum que estableció su creador.</p></div></div><div flex=\"\"><img src=\"../assets/images/planteo.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"2\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-plus\"></i> Sumarte al Winwin</h1><p>Para participar tenés que hacer clic en el botón verde “Sí, me sumo” y luego aceptar nuestro código de honor. Lo ideal es que colabores en su difusión y alientes el intercambio entre los participantes.</p></div></div><div flex=\"\"><img src=\"../assets/images/sumarte.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"3\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-envelope-o\"></i> Invitar al winwin</h1><p>Si estás logueado, podés “Invitar” a todos los que quieras a que se sumen al winwin. Les llegará un <strong>email con tu invitación.</strong></p></div></div><div flex=\"\"><img src=\"../assets/images/email.gif\" style=\"float: right; max-width: 500px;\"></div></div><div id=\"4\"></div><br><br><br><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-share-alt\"></i> Compartir vía RRSS</h1><p>Si te parece valioso para compartirlo entre tus contactos de facebook o twitter, simplemente hace clic en “Difundir…”, no hace falta que estés logeado.</p></div></div><div flex=\"\"><img src=\"../assets/images/share.gif\" style=\"float: right; max-width: 500px;\"></div></div><div id=\"5\"></div><br><br><br><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-comments\"></i> Muro del winwin</h1><p>Un espacio en la página del winwin para intercambiar con los demás participantes. Podes subir textos, videos y/o imágenes. También podés participar de las encuestas del winwin, responder a post de otros usuarios, etc.</p></div></div><div flex=\"\"><img src=\"../assets/images/wall.jpg\" style=\"float: right\"></div></div><hr><div id=\"6\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-users\"></i> Participantes</h1><p>A la derecha del muro, podés ver los participantes del winwin.</p></div></div><div flex=\"\"><img src=\"../assets/images/participantes.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"7\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-bell-o\"></i> Campanada</h1><p>Es un mensaje de texto corto que el creador del winwin puede envíale a todos los participantes de un winwin.<br>Son alertas para transmitir algún mensaje importante acerca del winwin.</p></div></div><div flex=\"\"><img src=\"../assets/images/campanada.jpg\" style=\"float: right\"></div></div><hr><div id=\"8\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-comment-o\" aria-hidden=\"true\"></i> Mensaje al Creador</h1><p>Desde la página del winwin podés contactarte con el creador, recibir su respuesta y mantener una conversación uno a uno.</p></div></div><div flex=\"\"><img src=\"../assets/images/mensajeww.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-user\"></i> Creadores</h1><p>Para promocionar tu winwin asegurate de que cuenta con información atractiva y útil para que los visitantes se transformen en participantes. Por eso, <strong>PUBLICÁ en el muro</strong> información, imágenes y videos que generen motivación y debate constructivo. Invitá a los demás a hacer lo mismo.<br><br></p></div></div><div flex=\"\"><img src=\"../assets/images/creadores.jpg\" style=\"float: right\"></div></div><hr><div id=\"9\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-bookmark\"></i> Destacar post</h1><p>Los creadores pueden destacar un post del muro, sin importar quien lo dejó. ¿Cómo? Haciendo clic sobre la estrella que está en el margen superior derecho del post.<br><br>Cuando un post es destacado, se coloca en el primer lugar del muro, cambia su color de fondo y queda marcada la estrella. Permanecerá así hasta tanto no se destaque otro post del muro, que pasará a ocupar el primer lugar, o se quite como destacado haciendo clic sobre la estrella.</p></div></div><div flex=\"\"><img src=\"../assets/images/wall.jpg\" style=\"float: right\"></div></div><hr><div id=\"10\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-server\"></i> Crear encuestas</h1><p>Además, los creadores y activadores de un winwin pueden generar encuestas y publicarlas en el muro. A través de ellas pueden recoger las opiniones y preferencias de los participantes.</p></div></div><div flex=\"\"><img src=\"../assets/images/encuesta.jpg\" style=\"float: right\"></div></div><hr><div id=\"11\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-male\" aria-hidden=\"true\"></i> Tu perfil</h1><p>Tu <strong>perfil público</strong> en Winwins muestra tu avatar, una imagen de portada, tu Bio, los ámbitos de acción que más te interesan, los winwins que creaste y en los que estás participando, los usuarios a los que seguís y los usuarios que te siguen.<br><br>Desde tu perfil, <strong>podés editar toda esta información y configurar tus preferencias y notificaciones.</strong></p></div></div><div flex=\"\"><img src=\"../assets/images/perfil.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"12\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-flash\" aria-hidden=\"true\"></i> Actividad Reciente</h1><p>En tu <strong>Perfil, el panel “Actividad Reciente” muestra el <strong>timeline de tus actividades</strong> en Winwins y la de los usuarios a los que seguís. También podés ver en el perfil de otros usuarios sus actividades y las de sus seguidores o seguidos.</strong></p></div></div><div flex=\"\"><img src=\"../assets/images/reciente.gif\" style=\"float: right; max-width: 500px;\"></div></div><div id=\"13\"></div><br><br><br><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-comment-o\" aria-hidden=\"true\"></i> Mensajes</h1><p>Desde el Perfil, también podés recibir o enviarte mensajes con otros usuarios de Winwins.</p></div></div><div flex=\"\"><img src=\"../assets/images/mensajep.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"14\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#585858\"><i class=\"fa fa-bell-o\" aria-hidden=\"true\"></i> Notificaciones</h1><p>Desde el<stronf>Menú Superior podés acceder a las notificaciones automáticas de Winwins: el sistema te avisa cuando una nueva persona se sumó a un winwin o cuando se activó una campanada, cuando un usuario comenzó a seguirte, etc. El <strong>ícono de campaña,</strong> te alertará cuando haya notificaciones nuevas y, en cada caso, encontrarás un enlace relacionado a ella.</stronf></p></div></div><div flex=\"\"><img src=\"../assets/images/notificaciones.gif\" style=\"float: right; max-width: 500px;\"></div></div><hr><div id=\"15\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-handshake-o\" aria-hidden=\"true\"></i> Sponsors</h1><p>Desde la p&aacute;gina del Winwin podes solicitar ser sponsor del mismo, o pod&eacute;s recibir solicitudes en un winwins que estes realizando.</p></div></div><div flex=\"\"><img src=\"../assets/images/profile.jpg\" style=\"float: right\"></div></div><hr><div id=\"16\"></div><br><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#585858\"><i class=\"fa fa-bullhorn\" aria-hidden=\"true\"></i> Difusi&oacute;n</h1><p>El equipo de comunicaci&oacute;n de Winwins te va a ayudar a difundir tus winwins en las redes sociales y otros medios digitales para llegar a la mayor cantidad de personas. Promocionamos tu desaf&iacute;o y hacemos los posible para que lo concretes.</p></div></div><div flex=\"\"><img src=\"../assets/images/profile.jpg\" style=\"float: right\"></div></div><hr></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px\"></div></md-content><div hide-xs=\"\" flex=\"\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\"></acme-footer></div><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div><a href=\"#accion\" du-smooth-scroll=\"\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 350;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n    \n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'#features\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/blog/blog.html","<iframe width=\"100%\" height=\"4000px\" src=\"http://37.48.93.13/~linkway/winwins\" frameborder=\"0\" allowfullscreen=\"\"></iframe><style type=\"text/css\">\n    iframe { display:block; width:100%; border:none; margin-top: -50px; }\n\n    md-toolbar.md-default-theme:not(.md-menu-toolbar), md-toolbar:not(.md-menu-toolbar) {\n    background-color: #30477d;\n    box-shadow: 2px 2px 5px #1f3465;\n    min-height: 50px;\n    height: 60px;\n    font-size: 14px;\n    position: fixed;\n    display: none;\n}\n</style><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer><acme-footer items=\"main.footer\" style=\"color: #fff;\" hide-gt-sm=\"\"></acme-footer></div>");
$templateCache.put("app/contact/contact.html","<md-content class=\"acme-contact\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><div class=\"container\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div flex=\"\" class=\"text-box\"><h1 class=\"big-title-b\" style=\"color: #fff; font-size: 7vh; margin-bottom: 10px;\">CONTACTO</h1><p style=\"color: #fff; padding-right: 30px\">Cont&aacute;ctanos. Nos encantar&iacute;a recibir tu mensaje, para estar en contacto, para enviarnos comentarios y sugerencias. Lo que nos quieras transmitir o consultar.<br>Podemos ayudarte y estamos para eso.</p><h1 class=\"big-title-b\" style=\"font-size: 50px; color: #fff;\">S&eacute; Partner</h1><p style=\"color: #fff; padding-right: 30px\">Si te interesa participar como voluntario, sponsor, patrocionador o aliado de Winwins completa el formulario de contacto y te contactaremos en unos minutos.</p></div><div flex=\"\" style=\"padding: 50px; background-color: #fff\"><form method=\"post\" name=\"contact.FormContacto\" ng-submit=\"contact.sendMailContact()\"><div layout=\"column\" layout-padding=\"\"><md-input-container class=\"md-block\"><label translate=\"\">Tu Nombre</label> <input required=\"\" name=\"name\" ng-model=\"contact.contact.name\" class=\"md-input\"><div ng-messages=\"contact.FormContacto.name.$error\"><div ng-message=\"required\" translate=\"\">Campo obligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label>Tu Apellido</label> <input required=\"\" name=\"lastname\" ng-model=\"contact.contact.lastname\" class=\"md-input\"><div ng-messages=\"contact.FormContacto.lastname.$error\"><div ng-message=\"required\" translate=\"\">Campo obligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label>Tu email</label> <input required=\"\" name=\"email\" ng-model=\"contact.contact.email\" type=\"email\" class=\"md-input\"><div ng-messages=\"contact.FormContacto.email.$error\"><div ng-message=\"required\" translate=\"\">Campo obligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label>Tu mensaje</label> <textarea ng-model=\"contact.contact.message\" name=\"message\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus=\"\" required=\"\" class=\"md-input\"></textarea><div ng-messages=\"contact.FormContacto.message.$error\"><div ng-message=\"required\" translate=\"\">Campo obligatorio</div></div></md-input-container><md-button type=\"submit\" name=\"action\" class=\"md-raised md-primary bt-green\">Enviar</md-button></div></form></div></div></div></md-content><div hide-xs=\"\" flex=\"\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\"></acme-footer></div>");
$templateCache.put("app/contact/modal_success.tmpl.html","<md-dialog-content class=\"login-ok\"><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" layout-magin=\"\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Gracias!</h2></div><div flex=\"\"><p class=\"gray\" translate=\"\">Tu mensaje se envió correctamente.</p></div></div></md-dialog-content>");
$templateCache.put("app/grupo/cover-post-image.tmpl.html","<div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><md-input-container><label translate=\"\">Elige una foto para subir:</label> <input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().handleFileSelect(this)\"></md-input-container><div class=\"cropArea\"><img-crop image=\"myImage\" area-type=\"rectangle\" aspect-ratio=\"1.46\" result-image=\"myCroppedImage\" result-image-size=\"{w: 414,h: 282}\" init-max-area=\"true\"></img-crop></div><md-button ng-click=\"cropImage()\" class=\"md-raised md-green\">Aceptar</md-button></div>");
$templateCache.put("app/grupo/crear-grupo.html","<md-content class=\"crear-grupo\" ng-show=\"grupo.stage==1\"><md-toolbar class=\"md-tall md-crear md-violet animated fadeIn\" layout=\"row\" layout-align=\"center center\"><h2><span translate=\"\">CREA UN GRUPO</span></h2></md-toolbar><div class=\"container\"><form method=\"post\" name=\"grupo.crearForm\" ng-submit=\"grupo.nextStage()\" class=\"form-crear\"><div layout=\"column\" layout-gt-sm=\"row\" layout-margin=\"\" layout-padding=\"\"><div flex=\"\"><div class=\"wrap-md-input-container create-cards\"><md-input-container class=\"md-block\"><label translate=\"\">Nombre para tu grupo</label><div class=\"wrap-tooltip\"><span class=\"icon-help\">?</span><div class=\"tooltip-text\" translate=\"\">Nombra tu grupo con un título que lo represente.</div></div><input required=\"\" name=\"name\" ng-model=\"grupo.grupo.name\"><div ng-messages=\"grupo.crearForm.name.$error\"><div ng-message=\"required\" translate=\"\">No se puede crear un Grupo sin nombre!</div></div></md-input-container></div><div class=\"wrap-md-input-container create-cards\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><label translate=\"\">Elegí el inter&eacute;s principal de tu Grupo.</label><div class=\"wrap-tooltip\"><span class=\"icon-help\">?</span><div class=\"tooltip-text\" translate=\"\">Clasifica tu Grupo en la lista de categorías de inter&eacute;s</div></div></div><div layout=\"row\"><md-input-container><md-select name=\"category\" ng-model=\"grupo.grupo.interests\" aria-label=\"descripci&oacute;n\"><md-option ng-value=\"item\" ng-repeat=\"item in grupo.interests\">{{item.description}}</md-option></md-select></md-input-container></div></div></div><div flex=\"\"><div class=\"wrap-md-input-container create-cards\"><md-input-container class=\"md-block\"><label translate=\"\">Descripci&oacute;n del grupo</label><div class=\"wrap-tooltip\"><span class=\"icon-help\">?</span><div class=\"tooltip-text\" translate=\"\">Acá ingresa información detallada del grupo, datos e información importante. Lugares, fechas, acciones y toda la información que te resulte relevante.</div></div><textarea name=\"description\" ng-model=\"grupo.grupo.description\" md-maxlength=\"1000\" rows=\"5\" md-select-on-focus=\"\"></textarea></md-input-container></div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox class=\"green\" ng-model=\"grupo.grupo.terms\" name=\"terms\" ng-change=\"grupo.clearError()\">{{ \'He leído y acepto los\' | translate }} <a ng-href=\"/#/terms\" target=\"_blank\" translate=\"\">términos y condiciones</a>.</md-checkbox><div ng-messages=\"grupo.crearForm.terms.$error\" class=\"help-block\" ng-if=\"grupo.crearForm.terms.$error.notTerms\"><p class=\"small\" ng-message=\"notTerms\" translate=\"\">Acepta los t&eacute;rminos y condiciones.</p></div></md-input-container><md-button md-no-ink=\"\" class=\"md-raised md-primary bt-green md-whiteframe-5dp\" ng-disabled=\"grupo.crearForm.$invalid\" type=\"submit\" name=\"action\" translate=\"\">{{ \'CONTINUAR\' | translate }}</md-button></div></div></form></div></md-content><md-content class=\"crear-grupo\" ng-show=\"grupo.stage==2\"><md-toolbar class=\"md-tall md-crear md-violet\" layout=\"row\" layout-align=\"center center\"><h2><span translate=\"\"><i class=\"fa fa-camera\"></i> SUBI UNA IMAGEN</span></h2></md-toolbar><div class=\"container wrap-crear-grupo\"><form method=\"post\" name=\"grupo.crearForm2\" ng-submit=\"grupo.saveGrupo()\"><div layout=\"column\" layout-gt-sm=\"row\" layout-margin=\"\" layout-padding=\"\"><div flex=\"\"><md-card><div class=\"md-card-wrap\"><img ng-src=\"{{ grupo.preview_image }}\" class=\"md-card-image\" alt=\"\"></div><md-card-title-text layout-align=\"center center\" layout=\"column\"><md-button class=\"md-headline\" style=\"color: #fff; text-align: center;\">{{grupo.grupo.name}}</md-button></md-card-title-text></md-card><div layout=\"row\" layout-align=\"center center\"><p class=\"legend\">Subí una foto para tu grupo.</p></div><div layout=\"row\" layout-align=\"center center\" class=\"layout-icons\"><md-whiteframe class=\"md-whiteframe-5dp\" layout=\"\" layout-align=\"center center\" flex=\"\" ng-click=\"grupo.showCropCoverDialog()\"><md-icon>photo_camera</md-icon></md-whiteframe></div></div></div><div class=\"wrap-md-input-container\"><md-button md-no-ink=\"\" class=\"md-raised md-primary bt-green md-whiteframe-5dp\" type=\"submit\" name=\"action\" ng-disabled=\"loadingFlag\" translate=\"\">{{ \'CONTINUAR\' | translate }}</md-button></div></form></div></md-content>");
$templateCache.put("app/grupo/group_list_index.html","<div class=\"container\"><group-list items=\"grupo.grupos\" title=\"\'GRUPOS DESTACADOS\'\" icon=\"icon-highlighted\"></group-list></div>");
$templateCache.put("app/grupo/grupo-profile.html","<md-content class=\"group-profile\"><div class=\"container\"><md-tabs md-dynamic-height=\"\"><md-tab md-on-select=\"grupo.show_box_muro = true\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-comments.svg\"></md-icon></md-tab-label><md-tab-body><div layout-gt-sm=\"row\" layout-align=\"center start\" layout-padding=\"\" layout=\"column\" class=\"primary-content\"><div class=\"col-left\"><md-card class=\"md-whiteframe-4dp no-padding\"><md-card-content><div class=\"wrap-card-img\"><img ng-src=\"{{ grupo.imageServer }}/390x266/{{ grupo.profile.photo }}\" alt=\"\" class=\"md-card-img\"></div><md-card-title-text layout-align=\"center center\" layout=\"column\" hide-gt-sm=\"\"><md-button class=\"md-headline\" aria-label=\"title\">{{ grupo.profile.title }}</md-button></md-card-title-text><div class=\"card-labels\"><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\">highlighted</md-icon></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"space-between center\"><div flex=\"\" layout=\"row\" hide=\"\" show-gt-xs=\"\" class=\"card-social-media\"><div socialshare=\"\" socialshare-provider=\"facebook\" socialshare-text=\"{{grupo.profile.name}}\" socialshare-url=\"{{grupo.base}}/wwg/{{grupo.profile.id}}\" socialshare-media=\"{{grupo.imageServer}}/{{grupo.profile.photo}}\" socialshare-via=\"{{grupo.facebookId}}\"><md-button class=\"md-icon-button\" ng-href=\"\" aria-label=\"facebook\"><md-icon md-svg-src=\"assets/images/icon-facebook.svg\"></md-icon></md-button></div><div socialshare=\"\" socialshare-text=\"{{ grupo.profile.name }}\" socialshare-url=\"{{grupo.base}}/wwg/{{grupo.profile.id}}\" socialshare-provider=\"twitter\"><md-button class=\"md-icon-button\" ng-href=\"\" aria-label=\"twitter\"><md-icon md-svg-src=\"assets/images/icon-twitter.svg\"></md-icon></md-button></div><div socialshare=\"\" socialshare-provider=\"google\" socialshare-url=\"{{grupo.base}}/wwg/{{grupo.profile.id}}\" socialshare-text=\"{{ grupo.profile.name }}\" socialshare-media=\"{{grupo.imageServer}}/{{ grupo.profile.photo }}\"><md-button class=\"md-icon-button\" ng-href=\"\" aria-label=\"google\"><md-icon md-svg-src=\"assets/images/icon-google.svg\"></md-icon></md-button></div></div><div class=\"card-numbers\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-item-text bg-green\"><h3 translate=\"\">Somos</h3><p>{{ grupo.profile.members_count }}</p></div></div></div></md-card-actions></md-card></div><div class=\"col-central\" hide=\"\" show-gt-xs=\"\"><div layout=\"column\" layout-align=\"center center\"><div class=\"creadores\"><img ng-src=\"{{ grupo.imageServer }}/{{ grupo.group_creator.photo }}\" alt=\"\" class=\"avatar-creador style-rounded\" ui-sref=\"home.public-profile({userId: grupo.profile.user_id})\"><h3>{{ grupo.group_creator.name }} {{ grupo.group_creator.lastname }}</h3><strong>CREADOR</strong></div><div class=\"miembros\"><div layout=\"row\" layout-align=\"center center\" layout-margin=\"\" layout-wrap=\"\"><div ng-repeat=\"miembro in grupo.profile.users | filter: { id: \'!\' + grupo.profile.user_id } as filteredMiembro\"><img ng-src=\"{{ grupo.imageServer }}/25x25/{{ miembro.photo }}\" alt=\"{{ miembro.name }}\" title=\"{{ miembro.name }}\" class=\"profile-small style-rounded\" ui-sref=\"home.public-profile({userId: miembro.id})\"></div></div></div></div></div><div class=\"col-right\"><h2 class=\"main-title\">{{grupo.profile.name}}</h2><div layout=\"col\" layout-align=\"center start\"><div flex=\"100\"><div class=\"more-details\"><p>{{ grupo.profile.description }}</p></div><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"!grupo.profile.already_joined\" ng-click=\"grupo.join()\" aria-label=\"sumarse\">SUMARSE AL GRUPO</md-button><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"grupo.profile.already_joined\" ng-click=\"grupo.showUserWinwinsModal()\" aria-label=\"agregar\">Sugerir winwin al grupo</md-button></div></div></div></div><div layout-gt-sm=\"row\" layout-padding=\"\" layout-align-gt-sm=\"center start\" layout-align=\"center center\" layout=\"column\" class=\"content-central\"><div class=\"sponsors\" hide=\"\" show-gt-sm=\"\"><div layout=\"row\" layout-gt-sm=\"column\" layout-align=\"center center\" layout-margin=\"\" layout-wrap=\"\"><div ng-repeat=\"sponsor in grupo.sponsors\"><img ng-src=\"{{ grupo.imageServer }}/250x120/{{ sponsor.photo }}\" alt=\"\" class=\"sponsors-img\"></div></div></div><div class=\"comments\"><ng-include src=\"\'app/grupo/posteador_desktop.tmpl.html\'\"></ng-include><div class=\"row\" ng-repeat=\"poll in grupo.polls\"><md-card class=\"md-whiteframe-7dp\" ng-show=\"!poll.data.has_answered && grupo.profile.already_joined\"><div class=\"card-labels\"><md-button ng-if=\"grupo.profile.is_creator\" ng-click=\"grupo.removePoll(poll, $index)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></div><md-card-content class=\"encuesta\"><span class=\"card-title center\"><h4>{{poll.question}}</h4></span><ul class=\"collection\"><li class=\"collection-item dismissable black-text\" ng-repeat=\"answer in poll.data.answers\"><div><md-progress-linear md-mode=\"determinate\" value=\"{{grupo.percentage_votes(poll, answer)}}\"></md-progress-linear><span class=\"h7 grey-text\">{{answer.content}}</span> <span class=\"secondary-content\"><input class=\"with-gap\" name=\"poll_{{poll.id}}\" type=\"radio\" ng-value=\"answer.id\" ng-checked=\"poll.selected_answer\" ng-model=\"poll.selected_answer\"></span></div></li></ul></md-card-content><button class=\"btn-large bt-green col-xs-12\" ng-click=\"grupo.votePoll(poll)\">Votar</button></md-card><md-card class=\"md-whiteframe-7dp\" ng-show=\"poll.data.has_answered\"><div class=\"card-labels\"><md-button ng-click=\"grupo.removePoll(poll, $index)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></div><md-card-content class=\"encuesta\"><span class=\"card-title center\"><h4>{{poll.question}}</h4></span><ul class=\"collection\"><div ng-repeat=\"answer in poll.data.answers\"><div class=\"progress\"><md-progress-linear md-mode=\"determinate\" value=\"{{ grupo.percentage_votes(poll, answer) }}\"></md-progress-linear></div><li class=\"collection-item dismissable black-text\"><div><span class=\"h7 grey-text\">{{answer.content}}</span> <strong class=\"badge green white-text\">{{answer.vote_count}}</strong></div></li></div></ul></md-card-content></md-card></div><div ng-repeat=\"item_post in grupo.posts\"><md-card class=\"md-whiteframe-7dp\"><div class=\"card-labels\"><md-button ng-if=\"(grupo.profile.is_creator || item_post.user.id == grupo.account.id)\" ng-click=\"grupo.removePost(item_post)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><md-button ng-if=\"(grupo.profile.is_creator && item_post.sticky==1) || item_post.sticky==1\" ng-disabled=\"!grupo.profile.is_creator\" ng-click=\"grupo.setSticky(item_post, false)\" class=\"md-icon-button\" aria-label=\"highlighted on\"><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\"></md-icon></md-button><md-button ng-if=\"grupo.profile.is_creator && item_post.sticky==0\" ng-click=\"grupo.setSticky(item_post, true)\" class=\"md-icon-button\" aria-label=\"highlighted off\"><md-icon class=\"icon icon-highlighted icon-off\" md-svg-src=\"assets/images/icon-highlighted-off.svg\"></md-icon></md-button></div><md-card-header><md-card-avatar><img class=\"md-user-avatar\" ng-src=\"{{ grupo.imageServer }}/38x38/{{item_post.user.photo}}\" ui-sref=\"home.public-profile({userId: item_post.user.id})\"></md-card-avatar><md-card-header-text>{{item_post.user.username}}</md-card-header-text></md-card-header><md-card-content><p>{{item_post.content}}</p><div ng-show=\"item_post.media.type == \'IMAGE\'\" class=\"materialboxed _embed-responsive _embed-responsive-16by9\" style=\"width:100%; min-margin-top:30px; margin-bottom:10px; background:linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));\"><img ng-src=\"{{grupo.imageServer}}/400x/smart/{{item_post.media.name}}\" class=\"img-responsive\"></div><div ng-show=\"item_post.media.type == \'VIDEO\'\" class=\"embed-responsive embed-responsive-16by9\" style=\"margin-top:30px;\"><iframe class=\"embed-responsive-item\" ng-src=\"{{ grupo.getIframeSrc(item_post.media.path) }}\" allowfullscreen=\"\" style=\"width: 100%;height: 225px;\"></iframe></div></md-card-content><md-card-actions layout=\"row\" layout-margin=\"\" layout-align=\"start end\"><div><md-icon class=\"icon icon-access_time\">access_time</md-icon>{{item_post.created_at | moment: \'DD/MM/YYYY\' }}</div><div class=\"green\"><md-button ng-disabled=\"!grupo.profile.already_joined\" ng-click=\"grupo.vote(item_post, true)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_up\">thumb_up</md-icon></md-button>{{item_post.up_votes}}</div><div class=\"red\"><md-button ng-disabled=\"!grupo.profile.already_joined\" ng-click=\"grupo.vote(item_post, false)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_down\">thumb_down</md-icon></md-button>{{item_post.down_votes}}</div><md-button class=\"md-icon-button\" ng-click=\"grupo.showSharePost(item_post)\"><md-icon>share</md-icon></md-button><md-button class=\"md-icon-button bt-comment\" ng-click=\"grupo.showReplyDialog(item_post)\"><md-icon class=\"icon insert_comment\">insert_comment</md-icon></md-button></md-card-actions></md-card><md-card class=\"md-whiteframe-7dp\" flex-offset=\"15\" ng-repeat=\"comment in item_post.comments | orderBy:\'id\'\"><div layout=\"row\" layout-align=\"space-between center\"><div layout-padding=\"\"><md-button ng-if=\"(grupo.profile.is_creator || comment.user.id == grupo.account.id)\" ng-click=\"grupo.removePost(comment)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></div><div><md-card-header><md-card-header-text>{{comment.user.username}}</md-card-header-text><md-card-avatar><img class=\"md-user-avatar\" ng-src=\"{{grupo.imageServer}}/38x38/{{comment.user.photo}}\" ui-sref=\"home.public-profile({userId: comment.user.id})\"></md-card-avatar></md-card-header></div></div><md-card-content><p>{{comment.content}}<div ng-show=\"comment.media.type == \'IMAGE\'\" class=\"materialboxed _embed-responsive _embed-responsive-16by9\" style=\"width:100%; min-margin-top:30px; margin-bottom:10px; background:linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));\"><img ng-src=\"{{grupo.imageServer}}/400x/smart/{{comment.media.name}}\" class=\"img-responsive\"></div><div ng-show=\"comment.media.type == \'VIDEO\'\" class=\"embed-responsive embed-responsive-16by9\" style=\"margin-top:30px;\"><iframe class=\"embed-responsive-item\" ng-src=\"{{grupo.getIframeSrc(comment.media.path)}}\" allowfullscreen=\"\" style=\"width: 100%;height: 225px;\"></iframe></div></p></md-card-content><md-card-actions layout=\"row\" layout-margin=\"\" layout-align=\"start end\"><div><md-icon class=\"icon icon-access_time\">access_time</md-icon>{{comment.created_at | moment: \'DD/MM/YYYY\' }}</div><div class=\"green\"><md-button ng-disabled=\"!grupo.profile.already_joined\" ng-click=\"grupo.vote(comment, true)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_up\">thumb_up</md-icon></md-button>{{comment.up_votes}}</div><div class=\"red\"><md-button ng-disabled=\"!grupo.profile.already_joined\" ng-click=\"grupo.vote(comment, false)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_down\">thumb_down</md-icon></md-button>{{comment.down_votes}}</div></md-card-actions></md-card></div></div><div class=\"aside\" hide=\"\" show-gt-sm=\"\"><div layout-align-gt-sm=\"start stretch\" layout-align=\"center stretch\" layout-padding=\"\" layout=\"column\"><md-list ng-cloak=\"\" class=\"no-padding\"><md-list-item ng-repeat=\"miembro in grupo.profile.users | limitTo: 5\"><img ng-src=\"{{grupo.imageServer}}/smart/{{miembro.photo}}\" alt=\"\" class=\"md-avatar\" ui-sref=\"home.public-profile({userId: miembro.id})\"><p>{{miembro.username}}</p></md-list-item><md-list-item class=\"md-no-proxy\"><md-button ng-href=\"\" class=\"ver-todos\" ng-click=\"grupo.showParticipantesDialog()\"><strong>+</strong>Ver miembros</md-button></md-list-item></md-list><div class=\"content-bg\" ng-if=\"!grupo.profile.is_creator && grupo.profile.already_joined\"><p><md-button ng-href=\"\" ng-click=\"grupo.left()\" class=\"no-padding\"><md-icon md-svg-src=\"assets/images/icon-entrar.svg\"></md-icon>Abandonar este Grupo</md-button></p></div><div class=\"content-bg\" ng-if=\"grupo.profile.is_creator\"><p class=\"crear-encuesta\"><md-button ng-href=\"\" ng-click=\"grupo.showModalPollDialog()\" class=\"no-padding\"><md-icon md-svg-src=\"assets/images/icon-poll.svg\"></md-icon>Crear Encuesta</md-button></p></div><div class=\"content-bg\" ng-if=\"grupo.profile.is_creator\"><p><md-button ng-href=\"\" ng-click=\"grupo.close()\" class=\"no-padding\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon>Cancelar Grupo</md-button></p></div><div class=\"content-bg\" ng-if=\"grupo.profile.interests.length > 0\"><h4>Inter&eacute;s:</h4>{{grupo.formattedCategories(grupo.profile.interests)}}<ul><li ng-repeat=\"category in grupo.profile.interests\">{{category.description}}</li></ul></div><div layout=\"column\" ng-if=\"grupo.profile.already_joined\" class=\"no-padding\"><h3 class=\"title-destacado\" ng-show=\"grupo.profile.winwins.length > 0\" translate=\"\">Winwins sugeridos por los miembros</h3><div ng-repeat=\"item in grupo.profile.winwins\" ng-show=\"true\"><md-card><img ng-src=\"{{grupo.imageServer}}/130x/{{item.image}}\" alt=\"\" class=\"md-card-img\"><md-card-content><md-card-title-text ui-sref=\"home.winwin({winwinId: item.id})\" layout-align=\"center center\" layout=\"column\" layout-wrap=\"\">{{item.title}}</md-card-title-text></md-card-content><md-card-actions class=\"winwin-list-card-actions\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start start\"><div class=\"card-members\"><translate>Somos</translate><strong>{{ item.users_already_joined }}</strong></div><md-button class=\"md-icon-button\" ng-click=\"\" arial-label=\"share\"><md-icon>share</md-icon></md-button></div></md-card-actions></md-card></div></div></div></div></div><div layout-gt-sm=\"row\" layout-padding=\"\" layout-align-gt-sm=\"center start\" layout-align=\"center center\" layout=\"column\" class=\"content-central\"><div class=\"sponsors\" hide=\"\" show-gt-sm=\"\"></div><div class=\"aside\" hide=\"\" show-gt-sm=\"\"></div></div></md-tab-body></md-tab><md-tab md-on-select=\"grupo.show_box_muro = false\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-mis-winwins.svg\"></md-icon></md-tab-label><md-tab-body><div layout=\"column\" ng-if=\"grupo.profile.winwins.length > 0\"><h3 class=\"title-destacado\" translate=\"\">WINWINS DEL GRUPO</h3><acme-highlighted items=\"grupo.profile.winwins\" icon=\"\'icon-highlighted\'\"></acme-highlighted></div><h3 class=\"title-destacado\" translate=\"\">AUN NO HAY WINWINS VINCULADOS AL GRUPO</h3><div></div></md-tab-body></md-tab><md-tab md-on-select=\"grupo.show_box_muro = false\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-miembros.svg\"></md-icon></md-tab-label><md-tab-body><md-card class=\"mobile mobile-members\" ng-repeat=\"miembro in grupo.profile.users | filter: { id: \'!\' + grupo.profile.user_id } as filteredMiembro\"><md-card-content><img ng-src=\"{{grupo.imageServer}}/{{miembro.cover_photo}}\" class=\"md-card-image\" alt=\"\"><md-card-title><div layout=\"row\" layout-align=\"space-around end\" class=\"md-card-members\"><div class=\"md-item-text bg-green\"><h3 translate=\"\">Winwins</h3><p>{{miembro.winwins_amount}}</p></div><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{grupo.imageServer}}/smart/{{miembro.photo}}\" class=\"md-card-avatar\" alt=\"\"><div class=\"email\">{{participante.username}}</div><md-button class=\"bt-green\" ng-show=\"false\">Seguir</md-button></div><div class=\"md-item-text bg-blue\"><h3 translate=\"\">Seguidores</h3><p>{{miembro.followers_amount}}</p></div></div></md-card-title></md-card-content></md-card></md-tab-body></md-tab></md-tabs></div></md-content><ng-include src=\"\'app/grupo/posteador_mobile.tmpl.html\'\" hide=\"\" show-xs=\"\"></ng-include>");
$templateCache.put("app/grupo/modal-abandonar-grupo.tmpl.html","<div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" class=\"lightbox-abandonar\"><div flex=\"\"><md-button class=\"report\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon></md-button></div><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Estás seguro que deseas abandonar este Grupo?</p></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.left()\" ng-disabled=\"loadingFlag\">{{ \'Abandonar\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cancelar\' | translate }}</md-button></div></div>");
$templateCache.put("app/grupo/modal-agregar-winwin-a-grupo.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\" ng-if=\"vm.user_have_winwins && !vm.success && !vm.all_user_winwins_added\"><h3 class=\"title\">{{ \'WINWINS\' | translate }}</h3><md-list><md-list-item ng-repeat=\"winwin in vm.not_added_winwins\"><p>{{winwin.title}}</p><md-button class=\"md-raised md-warn md-caption\" ng-click=\"vm.addWinwinToGroup(winwin.id)\" aria-label=\"Agregar Winwin\">Agregar winwin</md-button></md-list-item></md-list></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"!vm.user_have_winwins && !vm.success && !vm.all_user_winwins_added\"><div layout=\"column\" layout-align=\"center center\"><p>No formas parte de ningun winwin. <a ui-sref=\"home.crear-winwin\">Crea un winwin</a> o <a ui-sref=\"home.winwin-list\">participa de alguno</a></p></div></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"vm.all_user_winwins_added && !vm.success\"><div layout=\"column\" layout-align=\"center center\"><p>Todos tus winwins ya forman parte del grupo. <a ui-sref=\"home.crear-winwin\">Crea un nuevo winwin para el grupo</a></p></div></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"vm.success\"><div layout=\"column\" layout-align=\"center center\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Buenísimo!</h2></div><div flex=\"\"><p class=\"font-16\">Agregaste el winwin a <span class=\"blue\">{{ vm.groupName }}</span></p></div></div></div></md-dialog-content>");
$templateCache.put("app/grupo/modal-close.tmpl.html","<div layout=\"column\" layout-align=\"center center\" class=\"lightbox-abandonar\"><div flex=\"\"><md-button class=\"report\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon></md-button></div><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Estás seguro que deseas cerrar este Grupo?</p></div><form method=\"post\" ng-submit=\"vm.close()\" name=\"closeForm\"><div flex=\"\"><md-input-container flex=\"\"><label>Contanos tus motivos</label> <textarea name=\"reason\" ng-model=\"vm.reason\" required=\"\"></textarea><div ng-messages=\"closeForm.reason.$error\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa un motivo.</p></div></md-input-container></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" type=\"submit\" name=\"action\" ng-disabled=\"loadingFlag\">{{ \'Cerrar\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cancelar\' | translate }}</md-button></div></form></div>");
$templateCache.put("app/grupo/modal-confirmacion-sumarse-a-grupo.tmpl.html","<div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear\"><md-dialog-content><div layout=\"column\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti\"><h3 translate=\"\">Buenísimo!</h3><p class=\"enfasis-blue\"><span translate=\"\">Te uniste a:</span></p><p class=\"medium\"><em translate=\"\">“{{ vm.grupo.name }}”</em></p></div></md-dialog-content></div>");
$templateCache.put("app/grupo/modal-remove.tmpl.html","<div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" class=\"lightbox-abandonar\"><div flex=\"\"><md-button class=\"report\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon></md-button></div><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Está seguro que desea eliminar el post?</p></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.remove()\" ng-disabled=\"loadingFlag\">{{ \'Eliminar\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cancelar\' | translate }}</md-button></div></div>");
$templateCache.put("app/grupo/modal-share-email.tmpl.html","<div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear lightbox-email\"><md-dialog-content class=\"acme-crearwinwin\"><div class=\"container\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"comparti\" flex-xs=\"100\" flex=\"80\" ng-show=\"!vm.emailsOK\"><p class=\"enfasis\" translate=\"\">Invitá amigos por email</p><div class=\"wrap-md-input-container\"><md-input-container class=\"md-icon-float md-icon-right md-block\"><label>Ingresa mails para invitar</label><md-chips ng-model=\"vm.mails\" md-on-add=\"vm.validateMail($chip)\"><input type=\"email\" length=\"30\" class=\"validate\"></md-chips><md-button class=\"md-fab send\" aria-label=\"\" ng-click=\"vm.sentInvitations()\"><md-icon md-svg-src=\"assets/images/icon-send.svg\"></md-icon></md-button></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.emailsOK\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-oks.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\">Las invitaciones fueron enviadas!</p></div></div></div></div></md-dialog-content></div>");
$templateCache.put("app/grupo/modal-video-post.tmpl.html","<div layout=\"column\" class=\"lightbox-crear crear-video\"><md-dialog-content><form role=\"form\" ng-submit=\"vm.setVideo()\" name=\"videoForm\"><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><h2 translate=\"\">Copia el link del video</h2><img ng-show=\"vm.video_path\" ng-src=\"http://img.youtube.com/vi/{{vm.video_path}}/hqdefault.jpg\" style=\"height:190px;\"><md-input-container class=\"md-block\"><input required=\"\" name=\"video\" ng-model=\"vm.video\" placeholder=\"Ej: https://www.youtube.com/watch?v=rQxVTFVWNjA\" ng-paste=\"vm.previewVideo($event)\"><div ng-messages=\"videoForm.video.$error\"><div ng-message=\"required\" translate=\"\">Campo requerido.</div></div></md-input-container><div><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" type=\"submit\" name=\"action\" translate=\"\">LISTO</md-button><md-button class=\"md-raised md-grey\" ng-click=\"vm.cancel()\" translate=\"\">CANCELAR</md-button></md-card-actions></div></div></form></md-dialog-content></div>");
$templateCache.put("app/grupo/modal-vincular-grupo-a-winwin.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\" ng-if=\"vm.user_have_groups && !vm.success\"><h3 class=\"title\">{{ \'WINWINS\' | translate }}</h3><md-list><md-list-item ng-repeat=\"group in vm.not_added_user_groups\"><p>{{group.name}}</p><md-button class=\"md-raised md-warn md-caption\" ng-click=\"vm.addWinwinToGroup(group.id)\" aria-label=\"Vincular grupo\">Vincular grupo</md-button></md-list-item></md-list></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"!vm.user_have_groups && !vm.success\"><div layout=\"column\" layout-align=\"center center\"><p>No formas parte de ningun grupo. <a ui-sref=\"home.grupo-creacion\">Crea un grupo</a> o <a ui-sref=\"home.grupo-list\">participa de alguno</a></p></div></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"vm.success\"><div layout=\"column\" layout-align=\"center center\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Buenísimo!</h2></div><div flex=\"\"><p class=\"font-16\">Agregaste el winwin al grupo <span class=\"blue\">{{ vm.groupName }}</span></p></div></div></div></md-dialog-content>");
$templateCache.put("app/grupo/participantes.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\"><h3 class=\"title\"><md-icon md-svg-src=\"assets/images/icon-participantes-title.svg\"></md-icon>{{ \'MIEMBROS\' | translate }}</h3><md-list class=\"participantes-list\"><md-list-item ng-repeat=\"participante in vm.users | orderBy: \'username\'\"><img alt=\"\" ng-src=\"{{vm.imageServer}}/smart/{{participante.photo}}\" class=\"md-avatar\"><p>{{participante.username}}</p></md-list-item></md-list></div></md-dialog-content>");
$templateCache.put("app/grupo/posteador_desktop.tmpl.html","<form role=\"form\" ng-submit=\"grupo.submitPost()\" name=\"postForm\" hide-xs=\"\" ng-if=\"grupo.profile.already_joined\" style=\"max-width: 520px;\"><md-card class=\"md-whiteframe-7dp\" style=\"background: #5b7dbf;\"><md-card class=\"md-whiteframe-7dp\" ng-if=\"grupo.profile.already_joined\"><div><div ng-if=\"grupo.post.media_type\" class=\"content-img-video\"><md-button ng-click=\"winwin.showCropPostImageDialog()\" ng-if=\"grupo.post.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.showModalVideoPostDialog()\" ng-if=\"grupo.post.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.removeCoverPostImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"grupo.post.media_type == \'IMAGE\'\" ng-src=\"{{ grupo.photo.file }}\" style=\"width: 100%;\"> <img ng-if=\"grupo.post.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{grupo.post.media_path}}/hqdefault.jpg\" style=\"width:100%;\"></div></div></md-card><div style=\"background-color: #fff; margin-top: 5px; margin-bottom: 10px; padding:0px; border: 1px solid #dddfe2\"><div layout=\"row\"><div flex=\"\"><md-input-container style=\"min-height: 80px; max-height: 80px; width: 90%; margin-left: 20px;\"><textarea name=\"content\" id=\"post-input-focus\" ng-model=\"grupo.post.content\" md-maxlength=\"500\" style=\"height: 70px; min-height: 70px; max-height: 71px; width: 100%; float: left; border: 0px;\" rows=\"5\" placeholder=\"Deja un comentario\">\n          </textarea></md-input-container></div></div></div><div layout=\"row\" style=\"margin:10px; margin-top:0px;\"><div flex=\"30\"><button style=\"padding: 10px;width:100%;padding: 5px; border-radius: 3px;\" type=\"button\" ng-click=\"grupo.showModalVideoPostDialog()\"><i class=\"fa fa-youtube\" style=\"font-size: 30px;padding: 5px; color: #666;\"></i></button><md-tooltip md-visible=\"video.showTooltip\" md-direction=\"down\">Inserta un video de Youtube a tu post</md-tooltip></div><div flex=\"30\"><button style=\"padding: 10px;width:100%;padding: 5px; border-radius: 3px;\" type=\"button\" ng-click=\"grupo.showCropPostImageDialog()\"><i class=\"fa fa-image\" style=\"font-size: 30px;padding: 5px; color: #666;\"></i></button><md-tooltip md-visible=\"imagen.showTooltip\" md-direction=\"down\">Agrega una imagen a tu post</md-tooltip></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send bt-default\" aria-label=\"\" ng-disabled=\"postForm.$invalid || loadingFlag\" style=\"width:100%; padding: 5px;\"><i class=\"fa fa-paper-plane\"></i></button><md-tooltip md-visible=\"enviar.showTooltip\" md-direction=\"down\">Enviar</md-tooltip></div></div></md-card></form>");
$templateCache.put("app/grupo/posteador_mobile.tmpl.html","<form role=\"form\" ng-submit=\"grupo.submitPost()\" name=\"postForm\" ng-if=\"grupo.profile.already_joined\" hide=\"\" show-xs=\"\"><md-card class=\"md-whiteframe-7dp\" style=\"background: #5b7dbf; position: fixed; bottom:0px; width: 100%; margin: 0;\"><md-card class=\"md-whiteframe-7dp no-margin\" ng-if=\"grupo.profile.already_joined\"><div ng-if=\"grupo.profile.already_joined\"><div ng-if=\"grupo.post.media_type\" class=\"content-img-video\"><md-button ng-click=\"grupo.showCropPostImageDialog()\" ng-if=\"grupo.post.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"grupo.showModalVideoPostDialog()\" ng-if=\"grupo.post.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"grupo.removeCoverPostImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"grupo.post.media_type == \'IMAGE\'\" ng-src=\"{{ grupo.photo.file }}\" style=\"width: 100%;\"> <img ng-if=\"grupo.post.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{grupo.post.media_path}}/hqdefault.jpg\" style=\"width:100%;\"></div></div></md-card><div><div layout=\"row\" style=\"max-height: 65px;\"><div flex=\"65\"><md-input-container style=\"min-height: 40px; max-height: 40px; margin: 3px; width: 97%\"><textarea name=\"content\" id=\"post-input-focus\" ng-model=\"grupo.post.content\" maxlength=\"500\" style=\"border-radius: 2px;background: #fff; max-height:45px; width: 100%; float: left; border: 0px;\" rows=\"5\">\n          </textarea></md-input-container></div><div flex=\"15\"><div layout=\"column\"><div flex=\"30\"><button type=\"button\" ng-click=\"grupo.showModalVideoPostDialog()\" style=\"width: 95%; height: 90%; margin: 3px; margin-bottom:0px;\"><i class=\"fa fa-youtube\"></i></button></div><div flex=\"30\"><button type=\"button\" ng-click=\"grupo.showCropPostImageDialog()\" style=\"width: 95%; height: 90%; margin: 3px; margin-top:0px;\"><i class=\"fa fa-image\"></i></button></div></div></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send\" aria-label=\"\" ng-disabled=\"postForm.$invalid || loadingFlag\" style=\"width:90%; height:92%; float: right; margin: 3px;\"><i class=\"fa fa-paper-plane\"></i></button><md-tooltip md-visible=\"enviar.showTooltip\" md-direction=\"down\">Enviar</md-tooltip></div></div></div></md-card></form>");
$templateCache.put("app/grupo/ver-mas-detalle.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\"><h2>Más detalles de <span>{{grupo.name}}</span></h2><p><pre>{{ grupo.description }}</pre></p></div></md-dialog-content>");
$templateCache.put("app/login/login.tmpl.html","<md-dialog class=\"tabs-login\"><md-dialog-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"one\"><md-tab-label>{{ \'Ir a mi cuenta\' | translate }} {{hola}}</md-tab-label><md-tab-body><md-content layout-padding=\"\" class=\"section-login\"><form method=\"post\" ng-submit=\"login.login()\" name=\"loginForm\" ng-show=\"login.login_status == \'login\'\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Email</label> <input id=\"email\" name=\"email\" type=\"email\" length=\"30\" ng-model=\"login.login.email\" class=\"validate\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-if=\"loginForm.email.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Email invalido.</p></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Password</label> <input id=\"password\" name=\"password\" type=\"password\" length=\"12\" class=\"validate\" ng-model=\"login.login.password\" required=\"required\"><div ng-messages=\"loginForm.password.$error\" ng-if=\"loginForm.password.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Contraseña incorrecta.</p></div></md-input-container></div><button type=\"submit\" ng-disabled=\"loginForm.$invalid || loadingFlag\" name=\"action\" translate=\"\" class=\"md-ink-ripple md-raised md-primary bt-default\"><strong>{{ \'Ir a mi cuenta\' | translate }}</strong></button></form><div layout=\"row\" layout-align=\"center center\" class=\"section-login\" ng-show=\"login.login_status == \'login\'\"><button translate=\"\" class=\"md-raised md-primary btn-facebook-login md-ink-ripple\" ng-click=\"login.authenticate(\'facebook\')\" aria-label=\"Facebook\"><i class=\"fa fa-facebook\" style=\"margin:5px;\"></i> Ingresar con Facebook</button></div><div layout=\"column\" layout-align=\"center center\" class=\"login-ok envio-correo\" ng-show=\"login.login_status == \'success\'\"><div flex=\"\"><md-button aria-label=\"ok\"><i class=\"fa fa-check animated wobble check\" style=\"font-size: 60px;\"></i></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">¡Genial!</h2></div></div><div layout=\"column\" hide-xs=\"\" layout-align=\"center center\" class=\"login-ok envio-correo\" ng-if=\"login.login_status == \'error\'\" ng-click=\"login.login_status = \'login\'\"><div flex=\"\"><md-button><i class=\"fa fa-exclamation-circle animated wobble danger\" style=\"font-size: 60px;\"></i><br>Usuario o Contrase&ntilde;a incorrectos.<br><i class=\"fa fa-chevron-left\"></i> Volver</md-button></div></div><div hide=\"\" show-xs=\"\" layout=\"column\" layout-align=\"center center\" class=\"login-ok envio-correo\" ng-if=\"login.login_status == \'error\'\" ng-click=\"login.login_status = \'login\'\"><div flex=\"\"><md-button><i class=\"fa fa-exclamation-circle animated wobble danger\" style=\"font-size: 60px;\"></i><br>Usuario o Contrase&ntilde;a incorrectos.<br><i class=\"fa fa-chevron-left\"></i> Volver</md-button></div></div></md-content></md-tab-body></md-tab><md-tab label=\"two\"><md-tab-label translate=\"\">Registrarme</md-tab-label><md-tab-body><md-content layout-padding=\"\" class=\"section-login\"><form method=\"post\" ng-submit=\"login.signup()\" name=\"registerForm\" ng-show=\"login.register_status == \'register\'\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Nombre</label> <input id=\"name\" required=\"\" ng-model=\"login.register.name\" name=\"name\"><div ng-messages=\"registerForm.name.$error\" ng-if=\"registerForm.name.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa tu nombre.</p></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Apellido</label> <input id=\"lastname\" required=\"\" ng-model=\"login.register.lastname\" name=\"lastname\"><div ng-messages=\"registerForm.lastname.$error\" ng-if=\"registerForm.lastname.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa tu apellido.</p></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Email</label> <input id=\"email\" type=\"email\" name=\"email\" length=\"30\" ng-model=\"login.register.email\" class=\"validate\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-if=\"registerForm.email.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa tu correo.</p></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Contraseña</label> <input id=\"password\" type=\"password\" length=\"12\" name=\"password\" class=\"validate\" ng-model=\"login.register.password\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label translate=\"\">Repetí Contraseña</label> <input id=\"rpassword\" type=\"password\" length=\"12\" name=\"rpassword\" class=\"validate\" ng-model=\"login.register.rpassword\" required=\"\" data-password-verify=\"login.register.password\"><div ng-messages=\"registerForm.rpassword.$error\" ng-if=\"registerForm.rpassword.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"passwordVerify\" translate=\"\">Las contraseñas ingresadas no coinciden.</p></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox class=\"green\" ng-model=\"login.register.terms\" name=\"terms\">{{ \'He leído y acepto los\' | translate }} <a ng-href=\"/#/terms\" target=\"_blank\" translate=\"\">Términos y condiciones</a>.</md-checkbox><div ng-messages=\"registerForm.terms.$error\" class=\"help-block\" ng-if=\"registerForm.terms.$error.notTerms\"><p class=\"small\" ng-message=\"notTerms\" translate=\"\">Acepta los t&eacute;rminos y condiciones.</p></div></md-input-container></div><button type=\"submit\" name=\"action\" ng-disabled=\"registerForm.$invalid || loadingFlag\" translate=\"\" class=\"md-ink-ripple md-raised md-primary bt-default\">{{ \'Registrarme\' | translate }}</button><br><br><button translate=\"\" class=\"md-raised md-primary btn-facebook-login md-ink-ripple\" ng-click=\"login.authenticate(\'facebook\')\" aria-label=\"Facebook\"><i class=\"fa fa-facebook\" style=\"margin:5px;\"></i> INGRESAR CON FACEBOOK</button></form><div layout=\"column\" layout-align=\"center center\" class=\"login-ok envio-correo\" ng-show=\"login.register_status == \'success\'\"><div flex=\"\"><md-button aria-label=\"ok\"><i class=\"fa fa-check\"></i></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Genial!</h2></div><div flex=\"\"><p class=\"gray font-16\">{{ \'Te enviamos un correo a\' | translate }} <span class=\"violet\">{{ login.register.email}}</span> {{ \'para confirmar tu cuenta\' | translate }}.</p><p class=\"gray font-16\" translate=\"\">Vamos a completar tu perfil.</p></div></div><div layout=\"column\" layout-align=\"center center\" class=\"login-ok envio-correo\" ng-show=\"login.register_status == \'error\'\" ng-click=\"login.register_status = \'register\'\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-error.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\" translate=\"\">{{ login.message }}<br></p></div></div></md-content></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/main.html","<div class=\"main-container\" layout=\"column\"><a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><div id=\"header\" class=\"header-container\" layout=\"column\" layout-align=\"space-around center\" style=\"box-shadow: 1px 1px 5px #333\"><div layout=\"row\" hide-xs=\"\"><div layout=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\" style=\"max-width: 600px; margin: 50px;\"><h1 style=\"color: #fff; font-size: 55px; margin-top: 0px; line-height: 50px; letter-spacing: -1px; margin: 0px;\">La red social para<br>cambiar el mundo.</h1><p style=\"color:#fff;\">Una red donde personas y organizaciones se conectan para impulsar acciones sociales positivas. A cada desafío de acción colectiva lo llamamos winwin, porque todos los que participan, ganan.</p><br><button style=\"background-color: #f60; color: #fff; border:0px; border-radius:40px; font-weight: bold;padding:15px; padding-bottom: 10px; font-family: montserrat; margin-top: 0px; margin-bottom:10px;\" ui-sref=\"home.winwin-list\"><h3 style=\"color: #fff;\">Ver Winwins</h3></button> <button style=\"background-color: green; color: #fff; border:0px; border-radius:40px; font-weight: bold;padding:15px; padding-bottom: 10px; font-family: montserrat; margin-top: 0px; margin-bottom:10px;\" ui-sref=\"home.weare\"><h3 style=\"color: #fff;\">Conocer m&aacute;s</h3></button><br><br><a href=\"\" ng-show=\"!main.isAuthenticated()\" ng-click=\"main.showLoginDialog()\" style=\"color: #fff;\">Registrate</a> o ingresa con <a class=\"social-footer-icons\" href=\"\" ng-show=\"!main.isAuthenticated()\" ng-click=\"main.showLoginDialog()\" style=\"padding:12px; padding-top: 6px; padding-bottom: 3px; font-size: 18px; border: 0px;\"><span class=\"ng-scope\"><i class=\"fa fa-facebook\"></i></span></a></div><div flex=\"\"><iframe width=\"600\" height=\"400\" src=\"https://www.youtube.com/embed/npWNX0woM7o?autoplay=0;rel=0&amp;showinfo=0\" allowfullscreen=\"\" style=\"border-radius:5px; border:0px; margin-top: 20px;\"></iframe></div></div></div></div><div layout=\"row\" hide=\"\" show-xs=\"\"><div layout=\"container\"><div layout=\"row\" layout-xs=\"column\"><h1 style=\"color: #fff; font-size: 35px; margin-top: 0px; line-height: 35px; letter-spacing: -1px; margin: 0px; padding-top: 0px; text-align: center;\">La red social para<br>cambiar el mundo.</h1><iframe width=\"100%\" height=\"240\" src=\"https://www.youtube.com/embed/npWNX0woM7o?autoplay=0;rel=0&amp;showinfo=0\" allowfullscreen=\"\" style=\"border-radius:5px; border:0px; margin-top: 20px;\"></iframe><p style=\"font-size: 10px; color: #fff; padding:20px; padding-top: 5px; padding-bottom: 5px;\">Una red donde personas y organizaciones se conectan para impulsar acciones sociales positivas. A cada desafío de acción colectiva lo llamamos winwin, porque todos los que participan, ganan.</p><button style=\"background-color: green; color: #fff; border:0px; border-radius:40px; font-weight: bold;padding:15px; padding-bottom: 10px; font-family: montserrat; margin-top: 0px; margin-bottom:10px;\" ui-sref=\"home.about\"><h3 style=\"color: #fff;\">Conocer m&aacute;s</h3></button> <button style=\"background-color: #f60; color: #fff; border:0px; border-radius:40px; font-weight: bold;padding:15px; padding-bottom: 10px; font-family: montserrat; margin-top: 0px; margin-bottom:10px;\" ng-show=\"!main.isAuthenticated()\" ng-click=\"main.showLoginDialog()\"><h3 style=\"color: #fff;\">Ingresa</h3></button></div></div></div></div><div class=\"style13\"></div><div layout=\"row\" style=\"margin: 50px;\"><div layout=\"container\" style=\"max-width: 1280px; display: block; margin-left: auto; margin-right: auto;\"><div layout=\"row\" layout-xs=\"column\" style=\"text-align: center\"><br><br><br><br><div flex=\"\" layout-align=\"center center\"><img src=\"../assets/images/icon-recientes-title.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Crea o sumate a un Winwin</h4><p>Creá tus propios winwins o<br>sumate a los de otras personas.</p><br><a href=\"#/about\" style=\"font-family: montserrat; border: 3px solid #999; padding: 10px; border-radius: 25px; color: #999; font-weight: bold; text-decoration: none;\">Ver m&aacute;s</a><br><br></div><div flex=\"\"><img src=\"../assets/images/share.png\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Invita gente y difundilo</h4><p>Invitá a gente a participar y difundí<br>tus desafíos en las redes sociales.</p><br><a href=\"#/weare#comofunciona\" style=\"font-family: montserrat; border: 3px solid #999; padding: 8px; border-radius: 25px; color: #999; font-weight: bold; text-decoration: none;\">Ver m&aacute;s</a><br><br></div><div flex=\"\"><img src=\"../assets/images/counter-sponsors-icon.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Consegui apoyo</h4><p>Conseguí el apoyo de personas, sponsors y organizaciones.</p><br><a href=\"#/about\" style=\"font-family: montserrat; border: 3px solid #999; padding: 10px; border-radius: 25px; color: #999; font-weight: bold; text-decoration: none;\">Ver mas</a><br><br></div><div flex=\"\"><img src=\"../assets/images/wingsa.png\" height=\"75\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\" margin-top:0px;\"=\"\">Gana Alas y Reconocimientos</h4><p>Gana alas, reconocimiento y<br>beneficios por tus acciones.</p><br><a href=\"#/about\" style=\"font-family: montserrat; border: 3px solid #999; padding: 10px;border-radius: 25px; color: #999; font-weight: bold; text-decoration: none;\">Ver M&aacute;s</a><br><br><br><br><br><br></div></div></div></div><div style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height: 70px;\"></div><div class=\"style13\"></div><h1 style=\"font-size: 40px; font-weight: bold; color: #3c6cc1; text-align: center\">WINWINS DESTACADOS</h1><div class=\"style13\"></div><div layout=\"row\" layout-align=\"center\" id=\"featured\" style=\"background-color: #fff;\"></div><div class=\"ww-destacados\" layout=\"column\" layout-align=\"space-around center\"><ng-include src=\"\'app/components/highlighted/highlighted.html\'\"></ng-include><acme-highlighted items=\"main.destacados\" style=\"background:transparent;\" title=\"false\" icon=\"\'icon-concretados\'\" viewmore=\"false\" seedescription=\"false\" loading=\"main.loadingDestacados\" class=\"index-winwins\"></acme-highlighted></div><div class=\"style13\"></div><div style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height: 70px;\"></div><div class=\"style13\"></div><div class=\"testimonial-container\" hide-xs=\"\"><h1 style=\"font-size: 40px; font-weight: bold; color: #3c6cc1; text-align: center\">USUARIOS RECIENTES</h1><div class=\"style13\"></div></div><md-title style=\"text-align:center; padding:10px\"></md-title><div class=\"container\" style=\"max-width: 90%\"><acme-miembro items=\"main.miembros\" class=\"miembros-page\"></acme-miembro><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px;\"><button style=\"background-color: #f60; color: #fff; border:0px; border-radius:40px; font-weight: bold;padding:15px; font-family: montserrat; margin-top: 0px; margin-bottom:70px;\" ui-sref=\"home.miembros\">VER TODOS</button><br></div></div><div class=\"style13\"></div><div layout=\"row\" layout-align=\"center\" style=\"background-color: #547bc0\"><p class=\"ww-destacados-titulo\" style=\"font-size: 40px; font-weight: bold; color: #fff; padding-bottom: 40px; text-align: center\">HISTORIAS QUE INSPIRAN</p><br></div><div class=\"container\" style=\"max-width: 85%;\"><br><br><div layout=\"layout-row\" layout-xs=\"column\"><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/hyJcr0Hlp8M?ecver=1&autoplay=0&loop=1&rel=0&showinfo=0&loop=1\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>Club de reparadores</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">Un evento itinerante de reparación colectiva, creado con el objetivo de promover la reparación como estrategia para el consumo responsable y práctica de la sustentabilidad.<br></p></md-card-content></md-card></div><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/wqOgBsZTrJ4?ecver=1autoplay=0&loop=1&rel=0&showinfo=0\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>Jer&oacute;nimo Batista Bucher</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">Jerónimo tiene 19 años y sueña con un mundo mas sustentable. Por eso, desarrolló “Souri”: una máquina ecológica que fabrica vasos completamente biodegradables para reemplazar a los descartables<br></p></md-card-content></md-card></div><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/cPA7GL1fu_M?autoplay=0&loop=1&rel=0&showinfo=0&loop=1\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>Taller Abierto de reparación de Bicis</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">Es un encuentro periódico realizado en el predio de la facultad de Agronomía donde se encuentran a arreglar, aprender y divertirse y llevarse una bicicleta como nueva!<br></p></md-card-content></md-card></div></div><div layout=\"row\" hide-xs=\"\" style=\"background-color: #f1f1f1;\"></div><br><div layout=\"layout-row\" layout-xs=\"column\"><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/qMqD3FBjpdI?autoplay=0&loop=1&rel=0&showinfo=0&loop=1\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>EcoHouse - Oficinas Conscientes</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">El programa #OficinasConscientes es una iniciativa de EcoHouse, que busca concientizar, educar y promover el cuidado y la sustenatabilidad del planeta, esta vez, en tu oficina.</p></md-card-content></md-card></div><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/SZTNrPbExWg?autoplay=0&loop=1&rel=0&showinfo=0&loop=1\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>Compras colectivas de Verduras Org&aacute;nicas</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">Mir&aacute; como hacer para comprar verdura org&aacute;nica con otras personas para mejorar la calidad y los costos de tu alimentaci&oacute;n.<br><br></p></md-card-content></md-card></div><div flex=\"\"><md-card><div id=\"muteYouTubeVideoPlayer\"></div><iframe width=\"100%\" height=\"300\" src=\"https://www.youtube.com/embed/XiTP8WjJaj4?ecver=1autoplay=0&loop=1&rel=0&showinfo=0\" volume=\"0\" frameborder=\"0\" allowfullscreen=\"\"></iframe><md-card-title><md-card-title-text><p style=\"color:#547bc0; font-size: 20px; padding-bottom: 0px; margin-bottom: 0px; padding-top: 0px; margin-top: 5px;\"><strong>¡Separemos los residuos ya!</strong></p></md-card-title-text></md-card-title><md-card-content><p style=\"font-size: 14px;\">Si todos separamos la basura al momento de tirarla se produce un verdadero impacto en el medio ambiente, en el tuyo y en el de todos.<br></p></md-card-content></md-card></div></div><br><br><div layout=\"row\" hide-xs=\"\" style=\"background-color: #f1f1f1;\"></div></div><div class=\"style13\"></div><div layout=\"row\" layout-align=\"center\" style=\"background-color: #547bc0\"><p class=\"ww-destacados-titulo\" style=\"font-size: 40px; font-weight: bold; color: #fff; padding-bottom: 40px; text-align: center\">WINWINS EN LAS REDES SOCIALES</p></div><iframe src=\"http://linkway.me/winwins/social/example_6.html\" frameborder=\"0\" height=\"800px\" scrolling=\"no\" style=\"background-color:#dfdfdf;\"></iframe><div style=\"z-index:9999\" hide-xs=\"\"><a href=\"#\" style=\"width:90px; height:90px; background: #f60; border: solid 7px white; border-radius: 50%; display: block; margin-left:auto;margin-right:auto; margin-bottom: -90px; z-index: 5;\" hide-xs=\"\"><i class=\"fa fa-chevron-up\" style=\"font-size: 50px; color: white; margin: 18px;\"></i></a></div><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewbox=\"0 0 595.28 25.882\" enable-background=\"new 0 0 595.28 25.882\" xml:space=\"preserve\" style=\"margin-top:-20px; margin-bottom: -10px;\"><rect y=\"-8.471\" fill=\"#dfdfdf\" width=\"100%\" height=\"100%\"></rect><polyline fill=\"#3C66B0\" points=\"0,5.647 0,25.882 297.64,25.882 595.28,25.882 595.28,5.647 297.64,22.02\"></polyline></svg><div class=\"footer-v\" hide-xs=\"\" flex=\"\" layout=\"column\" layout-align=\"space-around center\" style=\"margin-bottom: 40px;\"><div class=\"bottom-logo\" layout=\"column\" layout-align=\"space-around center\"><div class=\"items-que-es\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div class=\"item-footer\" layout=\"column\" layout-align=\"center center\"><br><img class=\"footer-logo\" src=\"http://dev-winwins.net/assets/images/logo.svg\"><div class=\"footer-buttons layout-xs-column layout-align-center-center layout-row\" layout=\"row\" layout-align=\"center center\" layout-xs=\"column\"><a class=\"social-footer-icons\" href=\"http://facebook.com/winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-facebook\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://twitter.com/winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-twitter\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://www.instagram.com/winwinsorg/\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-instagram\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://plus.google.com/102466089483841190346?hl=es\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-google\"></i></span></a> <a class=\"social-footer-icons\" href=\"http://youtube.com/user/Winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-youtube\"></i></span></a></div><div style=\"margin-top: 20px;\"><iframe src=\"https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fwinwinsorg&width=165&layout=button_count&action=like&size=small&show_faces=true&share=true&height=46&appId=765722806808918\" width=\"165\" height=\"46\" style=\"border:none;overflow:hidden\" scrolling=\"no\" frameborder=\"0\" allowtransparency=\"true\"></iframe></div></div></div></div></div><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer><acme-footer items=\"main.footer\" style=\"color: #fff;\" hide-gt-sm=\"\"></acme-footer></div><div layout=\"row\" style=\"position: fixed; bottom: 0px; width:96%; z-index: 9999\" layout-wrap=\"\" show-xs=\"\" hide-gt-sm=\"\"><div flex=\"50\"><md-button class=\"ver-winwin-button\" style=\"width: 90%;\" show-xs=\"\" ui-sref=\"home.winwin-list()\"><strong>Ver Winwins</strong></md-button></div><div flex=\"50\"><md-button class=\"ver-winwin-button\" style=\"background:#00b285;\" show-xs=\"\" hide-sm=\"\" ng-click=\"$root.createWinwin()\"><strong>+ Crear un Winwin</strong></md-button></div></div></div><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n    \n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/main/video.tmpl.html","<md-dialog class=\"lightbox-video\"><div class=\"video-container\"><iframe width=\"760\" height=\"340\" ng-src=\"{{vm.getIframeSrc(\'gyyTDPe8TwY\')}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></md-dialog>");
$templateCache.put("app/master/master.html","<div layout-fill=\"\"><md-content><header><acme-navbar></acme-navbar></header><div ui-view=\"content\" class=\"wrap-content\" autoscroll=\"true\"></div></md-content></div>");
$templateCache.put("app/miembros/miembros.html","<acme-miembro items=\"miembros.miembros\" class=\"miembros-page\" on-scroll=\"miembros.nextPage()\"></acme-miembro><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div><a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n\n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/notifications/notifications.tmpl.html","<md-dialog-content class=\"dialog-primary\"><md-content class=\"acme-notifications\"><div class=\"not-title\">Notificaciones</div><div class=\"container\" infinite-scroll=\"vm.nextPage()\" infinite-scroll-container=\"\'.dialog-primary\'\" infinite-scroll-disabled=\"vm.working\"><div layout=\"column\"><md-list class=\"notificaciones\"><md-list-item ng-switch=\"\" on=\"notification.type\" ng-repeat=\"notification in vm.notifications\"><div ng-switch-when=\"WW_SUCCESSFUL\"><a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span>se ha completado con éxito!</span> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"WW_CREATED\"><span class=\"orange\">Felicitaciones!</span> Creaste el winwin <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"WW_JOIN\"><div ng-if=\"notification.user_id == notification.sender_id\"><span class=\"green\">Excelente!</span> Te uniste a <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-if=\"notification.user_id != notification.sender_id\"><span class=\"green\">Una buena noticia!</span> <a class=\"blue\" ui-sref=\"home.public-profile({userId: notification.sender_id})\" ng-click=\"vm.close()\">{{notification.sender_name}}</a> se ha unido al winwin <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div></div><div ng-switch-when=\"GROUP_JOIN\"><span class=\"green\">Excelente!</span> Te uniste a <a class=\"blue\" ui-sref=\"home.grupo({groupId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.name}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"GROUP_CREATED\"><span class=\"orange\">Felicitaciones!</span> Creaste el grupo <a class=\"blue\" ui-sref=\"home.grupo({groupId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.name}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"WW_LEFT\">Abandonaste <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"SPONSOR_REQUEST\">Han solicitado patrocinar a <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"WW_REQUEST_SPONSOR\">Han solicitado que patrocines a <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a> <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"CAMPANADA\"><span class=\"red\">Campanada activa!</span> Nueva campanada de <a class=\"blue\" ui-sref=\"home.winwin({winwinId: notification.object.id})\" ng-click=\"vm.close()\">{{notification.object.title}}</a>: <span class=\"date\">\"{{notification.body}}\" {{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div><div ng-switch-when=\"FOLLOWING\"><span class=\"green\">Nuevo seguidor!</span> <span class=\"blue\">{{notification.object.username}}</span> comenzó a seguirte <span class=\"date\">{{notification.created_at | moment: \'DD/MM/YYYY\'}}</span></div></md-list-item></md-list></div></div></md-content></md-dialog-content>");
$templateCache.put("app/profile/activacion.html","<div layout=\"column\" layout-align=\"center center\" class=\"activacion-bg\" style=\"background: #3c6cc1; min-height: 950px;\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div layout=\"row\" layout-align=\"center center\"><h1 style=\"color: #fff; text-align:center;\">Hola {{activacion.account.name}}!<br>Bienvenido al mundo Winwins!</h1></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top:30px;\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div flex=\"\"><h1 style=\"text-align:center;\"><md-button style=\"background-color: #00b285; font-size: 25px; color:#fff; padding: 30px; font-weight: bold;\" class=\"animated fadeInLeft\" ng-click=\"$root.createWinwin()\">Crear un<br>winwin</md-button></h1></div><div flex=\"\"><h1 style=\"text-align:center;\"><md-button style=\"background-color: #f60; font-size: 25px; color:#fff; padding: 30px; font-weight: bold;\" class=\"animated fadeInRight\" show-xs=\"\" ui-sref=\"home.winwin-list()\">Explorar<br>winwins</md-button></h1></div></div></div><div flex=\"\"><h1 style=\"text-align:center;\"><md-button style=\"background-color: #fff; font-size: 25px; color:#3c6cc1; padding: 20px; font-weight: bold;\" class=\"animated fadeInUp\" href=\"#/#quees\">Que es Winwins?</md-button></h1></div></div></div></div><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer><acme-footer items=\"main.footer\" style=\"color: #fff;\" hide-gt-sm=\"\"></acme-footer>");
$templateCache.put("app/profile/avatar_crop.tmpl.html","<md-dialog-content class=\"padding-lightbox\"><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><md-input-container><label translate=\"\">Elige una foto para subir:</label> <input class=\"browseButtonFix\" type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().handleFileSelect(this)\"></md-input-container><div class=\"cropArea\"><img-crop chargement=\"\'Cargando\'\" image=\"myImage\" result-image=\"myCroppedImage\"></img-crop></div><md-button ng-click=\"cropImage()\" class=\"md-raised md-green\" translate=\"\">Aceptar</md-button></div></md-dialog-content>");
$templateCache.put("app/profile/cover_crop.tmpl.html","<md-dialog-content class=\"padding-lightbox\"><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><md-input-container><label translate=\"\">Elige una foto para subir:</label> <input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().handleFileSelect(this)\"></md-input-container><div class=\"cropArea\"><img-crop chargement=\"\'Cargando\'\" image=\"myImage\" area-type=\"rectangle\" aspect-ratio=\"1.46\" result-image=\"myCroppedImage\" result-image-size=\"{w: 414,h: 282}\" init-max-area=\"true\"></img-crop></div><md-button ng-click=\"cropImage()\" class=\"md-raised md-green\">Aceptar</md-button></div></md-dialog-content>");
$templateCache.put("app/profile/message-modal-controller.tmpl.html","<md-dialog aria-label=\"List dialog\" class=\"messagedialog\" hide-xs=\"\"><md-dialog-content autoscroll=\"true\" scroll=\"msgController.conversation_messages\"><div ng-if=\"vm.sendMessageStatus == notSended\" style=\"height: 500px; width: 550px;\"><h3 ng-if=\"msgController.conversation_messages.length==0\" style=\"margin: 20px;padding: 20px; text-align: center;\">No hay mensajes...</h3><md-list><md-list-item ng-repeat=\"message in msgController.conversation_messages\" ng-hide=\"message.hidden === 1\" layout=\"row\" id=\"messages\"><div layout=\"row\"><img class=\"msg-avatar\" ng-class=\"{\'last\':$last}\" ng-src=\"{{msgController.imageServer}}/smart/{{ message.photo }}\" alt=\"\"><p class=\"msg-name\">{{message.name}}</p></div><md-card class=\"bubble you\" ng-class=\"{\'last\':$last}\" ng-show=\"message.user_id != msgController.userId\">{{message.body}}</md-card><md-button ng-class=\"{\'last\':$last}\" ng-show=\"message.user_id == msgController.mySelfId\" ng-click=\"msgController.removeMsg(message)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></md-list-item></md-list><div class=\"caja-mensaje\" style=\"background: #f1f1f1\" id=\"input-msg\" ng-form=\"\" name=\"messageForm\"><div ng-if=\"(msgController.sendMessageStatus == \'Sended\')\" layout=\"column\" layout-align=\"center center\"><md-button aria-label=\"ok\" ng-click=\"close()\"><md-icon class=\"messageSent\" md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><md-input-container class=\"block-mensaje\" style=\"width: 100%\" hide-xs=\"\"><label class=\"placeholder-mensaje\">Ingresa tu mensaje (Maximo 140 caracteres)</label> <textarea ng-required=\"true\" class=\"Mensaje\" name=\"mensaje\" ng-model=\"msgController.mensaje\" md-maxlength=\"140\" rows=\"4\" md-select-on-focus=\"\" style=\"border: 0; background: #fff; padding: 20px;\">\n        </textarea><md-button class=\"boton-enviar\" style=\"width: 95%; border-radius: 60px;\" ng-click=\"messageForm.$valid && msgController.sendMessage(cnv.conversation_id = conversation_id)\">ENVIAR</md-button></md-input-container><md-input-container class=\"block-mensaje\" style=\"width: 90%; margin: 10px;\" hide=\"\" show-xs=\"\"><label class=\"placeholder-mensaje\">Ingresa tu mensaje (Maximo 140 caracteres)</label> <textarea ng-required=\"true\" class=\"Mensaje\" name=\"mensaje\" ng-model=\"msgController.mensaje\" md-maxlength=\"140\" rows=\"4\" md-select-on-focus=\"\" style=\"border: 0; background: #fff; padding: 20px;\">\n        </textarea><md-button class=\"boton-enviar\" style=\"width: 95%; border-radius: 60px;\" ng-click=\"messageForm.$valid && msgController.sendMessage(cnv.conversation_id = conversation_id)\">ENVIAR</md-button></md-input-container></div></div></md-dialog-content></md-dialog><md-dialog aria-label=\"List dialog\" class=\"messagedialog\" hide=\"\" show-xs=\"\"><md-dialog-content autoscroll=\"true\" scroll=\"msgController.conversation_messages\"><div ng-if=\"vm.sendMessageStatus == notSended\" style=\"height: 350px; min-width: 310px;\"><h3 ng-if=\"msgController.conversation_messages.length==0\" style=\"margin: 20px;padding: 20px; text-align: center;\">No hay mensajes...</h3><md-list><md-list-item ng-repeat=\"message in msgController.conversation_messages\" ng-hide=\"message.hidden === 1\" layout=\"row\" id=\"messages\"><div layout=\"row\"><img class=\"msg-avatar\" ng-class=\"{\'last\':$last}\" ng-src=\"{{msgController.imageServer}}/smart/{{ message.photo }}\" alt=\"\" style=\"width:30px; width: 30px;\"><p class=\"msg-name\">{{message.name}}</p></div><md-card class=\"bubble you\" ng-class=\"{\'last\':$last}\" ng-show=\"message.user_id != msgController.userId\">{{message.body}}</md-card><md-button ng-class=\"{\'last\':$last}\" ng-show=\"message.user_id == msgController.mySelfId\" ng-click=\"msgController.removeMsg(message)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></md-list-item></md-list><div class=\"caja-mensaje\" style=\"padding:0px; background: #f1f1f1; width: 100%;\" id=\"input-msg\" ng-form=\"\" name=\"messageForm\"><div ng-if=\"(msgController.sendMessageStatus == \'Sended\')\" layout=\"column\" layout-align=\"center center\"><md-button aria-label=\"ok\" ng-click=\"close()\"><md-icon class=\"messageSent\" md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><md-input-container><label class=\"placeholder-mensaje\">Ingresa tu mensaje (Maximo 140 caracteres)</label> <textarea ng-required=\"true\" class=\"Mensaje\" name=\"mensaje\" ng-model=\"msgController.mensaje\" md-maxlength=\"140\" rows=\"4\" md-select-on-focus=\"\" style=\"border: 0; background: #fff; padding: 20px;\">\n        </textarea><md-button class=\"boton-enviar\" style=\"width: 95%; border-radius: 60px;\" ng-click=\"messageForm.$valid && msgController.sendMessage(cnv.conversation_id = conversation_id)\"><i class=\"fa fa-paper-plane\"></i> ENVIAR</md-button></md-input-container></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/profile/mobile-activity.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"not-title\">Actividad Reciente</div><md-content class=\"acme-notifications\"><div class=\"container\" infinite-scroll=\"profile.nextPage()\" infinite-scroll-container=\"\'.dialog-primary\'\" infinite-scroll-disabled=\"profile.working\"><md-list><md-list-item class=\"actividadRecienteContent\" ng-if=\"profile.isAuthenticated()\" ng-repeat=\"fact in profile.activity | unique: \'sent_at\'\" ng-hide=\"fact.type == \'CAMPANADA\'\"><img ng-src=\"{{profile.imageServer}}/{{fact.photo}}\" class=\"md-avatar\" href=\"/#/profile/{{fact.sender_id}}\"><div layout-align=\"row\" class=\"actividadFollowingContainer\"><a class=\"activityUsername\" ng-href=\"/#/profile/{{fact.sender_id}}\">{{fact.username}}</a><p class=\"mensajito\">{{fact.mensajito}}</p><a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_JOIN\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_CREATED\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_LEFT\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_JOIN\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_LEFT\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_CREATED\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_SUCCESFUL\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"/#/profile/{{fact.user_id}}\" ng-if=\"fact.type == \'FOLLOWING\'\">{{fact.name}} {{fact.lastname}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"/#/profile/{{fact.user_id}}\" ng-if=\"fact.type == \'UNFOLLOWING\'\">{{fact.name}} {{fact.lastname}}</a></div></md-list-item></md-list></div></md-content></md-dialog-content>");
$templateCache.put("app/profile/modal-follow.tmpl.html","<md-dialog-content class=\"dialog-primary campanada\"><div class=\"md-dialog-content\"><h3 class=\"title-notificaction\">{{ \'ENHORABUENA!\' | translate }}</h3><p>Estas siguiendo a {{profile.user.name}}</p></div></md-dialog-content>");
$templateCache.put("app/profile/modal-inbox.tmpl.html","{{msgController.conversations}}<md-dialog aria-label=\"List dialog\"><md-dialog-content class=\"inboxtmpl\"><md-tabs class=\"tabs\"><md-tab><md-tab-label>Recibidos</md-tab-label><md-tab-body><div class=\"inbox-title\">INBOX</div><md-list><md-list-item ng-repeat=\"conversation in msgController.conversations\"><md-list-item ng-repeat=\"message in conversation.messages\"><md-card class=\"carta-inbox\" ng-hide=\"message.user_id == profile.userId\" layout=\"row\" layout-align=\"space-around-center\"><img class=\"avatar-mensaje\" ng-src=\"{{profile.imageServer}}/smart/{{profile.user.photo}}\" alt=\"\" ui-sref=\"home.public-profile{{user.id}}\"><div class=\"datos-mensaje\" layout=\"column\" style=\"flex: 0.9;\">De: {{message.name}}<div>Mensaje: {{message.body}}</div><md-button class=\"mensajeria\" ng-click=\"profile.mensaje()\">Responder</md-button></div></md-card></md-list-item></md-list-item></md-list></md-tab-body></md-tab><md-tab><md-tab-label>Enviados</md-tab-label><md-tab-body><div class=\"inbox-title\">SENT</div><md-list><md-list-item class=\"mensajes-recibidos-content\" ng-repeat=\"conversation in profile.user.conversations\"><md-list-item ng-repeat=\"message in conversation.messages\"><md-card class=\"carta-inbox\" ng-show=\"message.user_id == profile.userId\" layout=\"row\" layout-align=\"space-around-center\"><img class=\"avatar-mensaje\" ng-src=\"{{profile.imageServer}}/smart/{{profile.user.photo}}\" alt=\"\" ui-sref=\"home.public-profile{{user.id}}\"><div class=\"datos-mensaje\" layout=\"column\" style=\"flex: 0.9;\">Para: {{message.name}}<div>Mensaje: {{message.body}}</div></div></md-card></md-list-item></md-list-item></md-list></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/profile/modal-seguir.tmpl.html","<md-dialog-content class=\"dialog-primary campanada\"><div class=\"md-dialog-content\"><h3 class=\"title-notificaction\">{{ \'ENHORABUENA!\' | translate }}</h3><p>Has comenzado a seguir a {{profile.user.name}}</p></div></md-dialog-content>");
$templateCache.put("app/profile/modal-unfollow.tmpl.html","<md-dialog-content class=\"dialog-primary campanada\"><div class=\"md-dialog-content\"><h3 class=\"title-notificaction\">{{ \'QUE LÁSTIMA!\' | translate }}</h3><p>Has dejado de seguir a {{profile.user.name}}</p></div></md-dialog-content>");
$templateCache.put("app/profile/modal_success.tmpl.html","<md-dialog-content class=\"login-ok\"><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" layout-magin=\"\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Genial!</h2></div><div flex=\"\"><p class=\"gray\" translate=\"\">Tu cuenta se actualizó con éxito</p></div></div></md-dialog-content>");
$templateCache.put("app/profile/profile.html","<md-content class=\"acme-profile\" layout=\"column\" layout-align=\"center center\"><div class=\"container\"><form method=\"post\" name=\"profileForm\" ng-submit=\"profile.saveProfile()\"><div layout=\"row\"><md-card class=\"public-profile\"><md-card-content style=\"padding: 0; position: relative; max-height: 380px; overflow: hidden;\"><div><img ng-src=\"{{profile.portrait}}\" class=\"md-card-image\" alt=\"\"></div><md-card-title><div layout=\"row\" layout-align=\"space-around end\" layout-margin=\"\" class=\"md-card-members\"><div class=\"md-item-text bg-violet\" ng-if=\"!profile.user.private || profile.user.myself\"><h3>Winwins</h3><p>{{profile.winwins_length}}</p></div><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{profile.avatar}}\" class=\"md-card-avatar\" alt=\"\"><md-button ng-click=\"profile.showCropAvatarDialog()\" aria-label=\"changeAvatar\"><md-icon class=\"upload-image\" md-svg-icon=\"assets/images/upload_image.svg\"></md-icon></md-button><div class=\"name\"><strong>{{profile.user.name}} {{profile.user.lastname}}</strong></div></div><div class=\"md-item-text bg-orange\" ng-if=\"!profile.user.private || profile.user.myself\"><h3>Seguidores</h3><p>{{profile.user.followers_amount}}</p></div></div><md-button class=\"change-cover\" ng-click=\"profile.showCropCoverDialog()\"><md-icon class=\"upload-image\" md-svg-icon=\"assets/images/upload_image.svg\"></md-icon></md-button></md-card-title></md-card-content></md-card></div><div class=\"blueBlock\" layout=\"column\" hide-xs=\"\"><strong>Edita tu perfil</strong></div><div class=\"blueArrow\" hide-xs=\"\"></div><div flex=\"\" class=\"editor-Perfil\" layout=\"row\" layout-xs=\"column\"><div layout=\"column\" class=\"credentials\"><md-input-container class=\"md-block\"><label>Nombre</label> <input required=\"\" name=\"name\" ng-model=\"profile.user.name\" ng-disabled=\"profile.is_public\"><div ng-messages=\"profileForm.name.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Apellido</label> <input required=\"\" name=\"lastname\" ng-model=\"profile.user.lastname\" ng-disabled=\"profile.is_public\"><div ng-messages=\"profileForm.lastname.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Email</label> <input required=\"\" name=\"email\" ng-model=\"profile.user.email\" ng-disabled=\"profile.is_public\"><div ng-messages=\"profileForm.email.$error\"><div ng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"column\" class=\"credentials\"><div class=\"md-block wrap-input\"><md-datepicker name=\"birthdate\" ng-model=\"profile.user.birthdate\" md-current-view=\"year\" md-placeholder=\"DD/MM/YYYY\">{{profile.user.birthdate}}</md-datepicker></div><md-input-container class=\"md-block\" style=\"max-width: 270px;\"><label>Intereses</label><md-input-container class=\"intereses\" style=\"max-width: 220px;\"><md-select ng-model=\"profile.user.interests_list\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"\" ng-disabled=\"profile.is_public\" aria-label=\"interests\"><md-optgroup label=\"intereses\"><md-option ng-value=\"item\" ng-repeat=\"item in profile.interests\">{{item.description}}</md-option></md-optgroup></md-select></md-input-container></md-input-container></div><div layout=\"column\" class=\"credentials\"><md-input-container class=\"md-block\" style=\"max-height: 220px;\"><label>Sobre vos</label> <textarea class=\"sobreVos\" name=\"about\" ng-model=\"profile.user.about\" md-no-asterisk=\"\" md-maxlength=\"500\" rows=\"3\" md-select-on-focus=\"\" ng-disabled=\"profile.is_public\"></textarea><div ng-messages=\"profileForm.about.$error\"><div ng-message=\"required\">Campo requerido.</div><div ng-message=\"md-maxlength\">Maximo 500 caracteres.</div></div></md-input-container></div></div><div class=\"contrasena-Notificaciones\" layout=\"column\"><div class=\"cambiar-Contrasena\"><div flex=\"\" class=\"credentials\" layout=\"row\" layout-xs=\"column\"><h6>Cambiar Contraseña</h6><md-input-container class=\"md-block\"><label>Contraseña actual</label> <input name=\"current_password\" ng-model=\"profile.user.current_password\" type=\"password\" ng-change=\"profileForm.current_password.$setValidity(\'currentPasswordWrong\', true)\"><div ng-messages=\"profileForm.current_password.$error\"><div ng-message=\"currentPasswordWrong\">Clave actual incorrecta.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Nueva Contraseña</label> <input name=\"password\" ng-model=\"profile.user.password\" type=\"password\"></md-input-container><md-input-container class=\"md-block\"><label>Reingresa nueva contraseña</label> <input name=\"confirmPassword\" ng-model=\"profile.user.confirmPassword\" data-password-verify=\"profile.user.password\" type=\"password\"><div ng-messages=\"profileForm.confirmPassword.$error\" ng-if=\"profileForm.confirmPassword.$touched\"><div ng-message=\"passwordVerify\" translate=\"\">Las contraseñas ingresadas no son iguales.</div></div></md-input-container></div></div></div><div layout=\"column\" layout-padding=\"\" class=\"profile-bottom\" layout-align-gt-sm=\"center center\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"!profile.is_public\"><div flex=\"\"><h3 translate=\"\">Notificaciones</h3><p translate=\"\">te actualizamos por email de lo importante</p></div><div flex=\"\"><div layout=\"row\" layout-align=\"center center\" class=\"bg-white\"><div><span translate=\"\">Invitación a Winwins</span></div><div><md-switch name=\"invite_ww\" ng-model=\"profile.user.invite_ww\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Invitación a winwin\"></md-switch></div></div></div><div flex=\"\"><div layout=\"row\" layout-align=\"center center\" class=\"bg-white\"><div><span translate=\"\">Winwins finalizado</span></div><div><md-switch name=\"ww_to_finish\" ng-model=\"profile.user.ww_to_finish\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Winwins finalizado\"></md-switch></div></div></div><div flex=\"\"><div layout=\"row\" layout-align=\"center center\" class=\"bg-white\"><div><span translate=\"\">Invitación a Grupo</span></div><div><md-switch name=\"invite_group\" ng-model=\"profile.user.invite_group\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Invitación a grupo\"></md-switch></div></div></div></div><div layout=\"column\" layout-align-gt-sm=\"center center\" layout-gt-sm=\"row\" flex=\"\" ng-if=\"!profile.is_public\"><div flex=\"30\" flex-offset=\"20\" layout-padding=\"\" class=\"profile-bottom\"><md-button md-no-ink=\"\" class=\"bt-green\" type=\"submit\" ng-disabled=\"loadingFlag\" name=\"action\" translate=\"\">Guardar</md-button></div></div></form></div></md-content>");
$templateCache.put("app/profile/public-profile.html","<div class=\"acme-public-profile\" layout=\"column\" layout-align=\"center center\"><div class=\"actividadRecienteButton\"><md-menu md-offset=\"0 0\" md-position-mode=\"target-right target\" class=\"menu-caterogias-btn\" hide-gt-xs=\"\"><md-button aria-label=\"Open demo menu\" ng-click=\"profile.showMobileAct()\"><md-icon><i class=\"fa fa-clock-o\" style=\"color: #fff;\"></i></md-icon></md-button></md-menu></div><md-tabs class=\"responsiveTabs\" md-dynamic-height=\"\" md-selected=\"myTabIndex\"><md-tab><md-tab-label><md-icon><i class=\"fa fa-user\" style=\"color: #fff;\"></i></md-icon></md-tab-label><md-tab-body><div class=\"acme-public-profile\" layout=\"column\" layout-align=\"center center\"><md-card class=\"public-profile\"><md-card-content><img ng-src=\"{{profile.imageServer}}/{{profile.user.cover_photo}}\" class=\"md-card-image\" style=\"min-height: 450px;\" alt=\"\"><md-card-title style=\"padding:0px;\"><div style=\"width: 350px; margin-left:50px; float: left; background: rgba(60, 108, 193, 0.84); margin:0px;\"><img ng-src=\"{{profile.avatar}}\" class=\"md-card-avatar\" style=\"border-radius: 100%; margin-top:40px; width: 120px; height: 120px\"><div ng-if=\"item.has_wings\"><img class=\"wings animate infinite pulse\" src=\"../assets/images/wings.png\" width=\"30\" style=\"border-radius: 0px; border-color: transparent; width: 60px; height: 70px; margin-top: -70px; margin-left: 60px;\"></div><p style=\"text-transform: capitalize; font-size: 20px;\"><strong>{{profile.user.name}}<br>{{profile.user.lastname}}</strong></p><p style=\"font-size: 14px; text-transform: capitalize;\"><i class=\"fa fa-comments-o\"></i> {{profile.winwins_length}} Winwins<br><i class=\"fa fa-share\"></i> {{profile.user.followers_amount}} Seguidores<br></p><md-button class=\"primary md-raised\" style=\"color: #fff; background: rgb(235, 106, 36); padding: 0px 15px 0px 15px;\" ng-show=\"!profile.user.myself && !profile.user.already_following\" ng-click=\"profile.follow(profile.userId)\" aria-label=\"seguir\"><i class=\"fa fa-share\"></i> Segu&iacute; a {{profile.user.name}}</md-button><md-button class=\"primary md-raised btn-unfollow\" ng-show=\"!profile.user.myself && profile.user.already_following\" ng-click=\"profile.unfollow(profile.userId)\" aria-label=\"dejar de seguir\" style=\"background: transparent; border: none; box-shadow: none; color: #fff;\"><i class=\"fa fa-ban\"></i> Dejar de Seguir</md-button><md-button hide-xs=\"\" hide-sm=\"\" class=\"primary md-raised\" ui-sref=\"home.profile\" ng-show=\"profile.user.myself\" aria-label=\"editar\"><i class=\"fa fa-edit\"></i> Editar</md-button></div></md-card-title></md-card-content></md-card></div><div class=\"bioTotal\" layout=\"row\" layout-align=\"center start\" \"=\"\"><div class=\"bio-Info\" layout=\"column\" layout-align=\"center strech\" style=\"max-width: 750px;\"><md-card><div class=\"bioContainer\"><h3><strong>BIO</strong></h3></div><div class=\"bioContent\"><div ng-if=\"item.has_wings\"><img class=\"wings\" src=\"../assets/images/wings.png\" width=\"30\" style=\"border-radius: 0px; border-color: transparent; width: 60px; height: 70px;\"> ings</div><p>{{profile.user.about}}</p><hr><p><strong>Estoy interesado en:</strong></p><md-chips><md-chip ng-repeat=\"category in profile.user.interests_list\">{{category.description}}</md-chip></md-chips><p ng-if=\"profile.user.myself && profile.user.interests_list.length == 0\">Aun no completaste tus intereses, <a ui-sref=\"home.profile\">completalos!</a></p><p ng-if=\"profile.user.id && profile.user.interests_list.length == 0\">{{profile.user.name}} No ha completado sus intereses</p></div></md-card><md-card><div ng-click=\"active = !active\" ng-class=\"{\'expandcollapse-heading-collapsed\': active, \'expandcollapse-heading-expanded\': !active}\"><div class=\"my-Winwins-Container\" layout=\"row\"><strong><h3>MIS WINWINS</h3></strong><div class=\"length\">{{profile.creadospormi.length}}</div><md-icon class=\"arrowdown\">keyboard_arrow_down</md-icon></div></div><div class=\"my-Winwins-Content\" layout=\"column\" ng-show=\"(profile.creadospormi) && active\"><acme-highlighted class=\"acme-profile-fix\" items=\"profile.creadospormi\" showdescription=\"false\" showallprofile=\"true\"></acme-highlighted><p class=\"mensaje\" ng-if=\"profile.user.myself && profile.creadospormi.length == 0\">Aun no creaste ning&uacute;nn Winwin. <a ui-sref=\"home.crear-winwin\">Crear Winwin.</a></p><p class=\"mensaje\" ng-if=\"profile.user.id && profile.creadospormi.length == 0 && !profile.user.myself\">{{profile.user.name}} No ha creado ning&uacute;nn Winwin.</p></div></md-card><md-card><div ng-click=\"active1 = !active1\" ng-class=\"{\'expandcollapse-heading-collapsed\': active1, \'expandcollapse-heading-expanded\': !active1}\"><div class=\"participo-Winwins-Container\" layout=\"row\"><h3><strong>WINWINS EN QUE PARTICIPO</strong></h3><div class=\"length\">{{profile.enqueparticipo.length}}</div><md-icon class=\"arrowdown\">keyboard_arrow_down</md-icon></div></div><div class=\"participo-Winwins-Content\" layout=\"column\" ng-show=\"(profile.enqueparticipo) && active1\"><acme-highlighted class=\"acme-profile\" items=\"profile.enqueparticipo\" icon=\"\'icon-highlighted\'\" showdescription=\"false\" showallprofile=\"true\"></acme-highlighted><p class=\"mensaje\" ng-if=\"profile.user.myself && profile.enqueparticipo.length == 0\">A&uacute;nn no te sumaste a ning&uacute;n Winwin. <a ui-sref=\"home.winwin-list\">Ver Wiwins.</a></p><p ng-if=\"profile.user.id && profile.enqueparticipo.length == 0 && !profile.user.myself\">{{profile.user.name}} A&uacute;n no se ha sumado a ning&uacute;n winwin...</p></div></md-card><md-card><div class=\"seguidores-Container\" layout-align=\"row\"><h3><strong>Seguidores</strong></h3><div class=\"length\">{{profile.user.followers.length}}</div></div><div class=\"seguidores-Content\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div class=\"mensaje\" ng-if=\"profile.user.followers.length == 0 && profile.user.myself\">A&uacute;nn no te sigue nadie</div><div class=\"mensaje\" ng-if=\"profile.user.followers.length == 0 && !profile.user.myself\">A&uacute;n no lo sigue nadie</div><div class=\"seguidores-items\" layout=\"column\" layout-align=\"space-around center\" ng-repeat=\"following in profile.user.followers\" ui-sref=\"home.public-profile({userId: following.user_id})\" hide-xs=\"\"><img class=\"avatarSeguidor\" ng-src=\"{{profile.imageServer}}//{{following.photo}}\"><p class=\"nombreSeguidor\">{{following.name}} {{following.lastname}}</p></div><div class=\"seguidores-items\" layout=\"column\" layout-xs=\"column\" layout-align=\"space-around center\" ng-repeat=\"following in profile.user.followers\" ui-sref=\"home.public-profile({userId: following.user_id})\" hide=\"\" show-xs=\"\"><img class=\"avatarSeguidor\" ng-src=\"{{profile.imageServer}}//{{following.photo}}\"><p class=\"nombreSeguidor\">{{following.name}} {{following.lastname}}</p></div></div></md-card><md-card><div class=\"siguiendo-Container\" layout-align=\"row\"><h3><strong>Siguiendo a</strong></h3><div class=\"length\">{{profile.user.following.length}}</div></div><div class=\"siguiendo-Content\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\"><div class=\"mensaje\" ng-if=\"profile.user.following.length == 0 && profile.user.myself\">A&uacute;n no sigues a nadie, busca amigos y seguilos.</div><div class=\"mensaje\" ng-if=\"profile.user.following.length == 0 && !profile.user.myself\">A&uacute;n no sigue a nadie.</div><div class=\"siguiendo-items\" layout=\"column\" layout-align=\"space-around center\" ng-repeat=\"follower in profile.user.following | orderBy: \'name\'\" ui-sref=\"home.public-profile({userId: follower.user_id})\" hide-xs=\"\"><img class=\"avatarSiguiendo\" ng-src=\"{{profile.imageServer}}//{{follower.photo}}\"><p class=\"nombreSiguiendo\">{{follower.name}} {{follower.lastname}}</p></div><div class=\"siguiendo-items\" layout=\"column\" layout-align=\"space-around center\" ng-repeat=\"follower in profile.user.following | orderBy: \'name\'\" ui-sref=\"home.public-profile({userId: follower.user_id})\" hide=\"\" show-xs=\"\"><img class=\"avatarSiguiendo\" ng-src=\"{{profile.imageServer}}//{{follower.photo}}\"><p class=\"nombreSiguiendo\">{{follower.name}} {{follower.lastname}}</p></div></div></md-card></div><div class=\"bio-Actions\" layout=\"column\" hide-xs=\"\" hide-sm=\"\"><div ng-if=\"profile.isAuthenticated()\"><md-card ng-if=\"!profile.user.already_following && !profile.user.myself\" class=\"not-following-msj\"><strong ng-click=\"profile.follow(profile.userId)\" aria-label=\"seguir\"><i class=\"fa fa-share\"></i> Segu&iacute; a {{profile.user.name}}</strong> para poder enviarle un mensaje</md-card><div class=\"button\" ng-if=\"profile.conversations.length == 0 && !profile.user.myself && profile.user.already_following\"><md-button class=\"primary md-raised mensajeria\" ng-click=\"profile.showMessageModal(0, [])\"><i class=\"fa fa-envelope-o\"></i> ENVIAR MENSAJE A {{profile.user.name}}</md-button></div><md-card class=\"inbox-title\" style=\"cursor: default;\" ng-if=\"!profile.canShowSendMessageButton() && profile.conversations.length == 0 && profile.user.myself\">{{profile.conversation_title}}<div class=\"sin-mensajes\">No hay mensajes...</div></md-card><md-card class=\"mensajeriaPrivada\"><div class=\"inbox\"><md-card class=\"inbox-title\" ng-if=\"!profile.canShowSendMessageButton() && profile.conversations == null && profile.user.myself\">{{profile.conversation_title}}<div class=\"sin-mensajes\">No hay mensajes...</div></md-card><div ng-if=\"profile.canShowConversations()\"><md-card class=\"inbox-title\" style=\"cursor: default;\">{{profile.conversation_title}}</md-card><div class=\"mensajes-recibidos-content\" ng-repeat=\"cnv in profile.conversations\" ng-hide=\"message.hidden === 1\"><div ng-repeat=\"message in cnv.messages\"><md-card href=\"#send-message\" du-smooth-scroll=\"\" class=\"msg-container\" layout=\"row\" ng-click=\"profile.showMessageModal(cnv.id, cnv.messages)\" ng-if=\"$last\" layout-align=\"space-around-end\" autoscroll=\"true\"><img ng-repeat=\"c in cnv.participants\" class=\"msg-avatar\" ng-src=\"{{profile.imageServer}}//smart/{{ c.photo }}\" alt=\"\"><p class=\"msg-body\" ng-hide=\"message.hidden === 1\">{{ message.body }}</p><p ng-repeat=\"p in cnv.participants\" class=\"msg-name\">{{p.name}}</p></md-card></div></div></div></div></md-card></div><md-card class=\"actividadReciente\">ACTIVIDAD RECIENTE</md-card><div layout-align=\"row\" style=\"max-width:300px;\"><md-card class=\"sinActividad\" ng-if=\"profile.activity.length == 0\">{{profile.user.name}} no tiene actividad reciente.</md-card><md-content class=\"activityMainContainer\"><div class=\"activityContent\" infinite-scroll=\"profile.nextPage()\" infinite-scroll-container=\"\'.activityMainContainer\'\" infinite-scroll-disabled=\"profile.working\"><md-list><md-list-item class=\"actividadRecienteContent\" ng-repeat=\"fact in profile.activity | unique: \'sent_at\'\" ng-hide=\"fact.type == \'CAMPANADA\'\"><img ng-src=\"{{profile.imageServer}}/{{fact.photo}}\" class=\"md-avatar\" href=\"/#/profile/{{fact.sender_id}}\"><div layout-align=\"row\" class=\"actividadFollowingContainer\"><a class=\"activityUsername\" ng-href=\"/#/profile/{{fact.sender_id}}\">{{fact.username}}</a><p class=\"mensajito\">{{fact.mensajito}}</p><a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_JOIN\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_CREATED\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'GROUP_LEFT\'\">{{fact.name}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_JOIN\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_LEFT\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_CREATED\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"{{fact.activity_url}}\" ng-if=\"fact.type == \'WW_SUCCESFUL\'\">{{fact.title}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"/#/profile/{{fact.user_id}}\" ng-if=\"fact.type == \'FOLLOWING\'\">{{fact.name}} {{fact.lastname}}</a> <a class=\"titulo {{fact.type}}\" ng-href=\"/#/profile/{{fact.user_id}}\" ng-if=\"fact.type == \'UNFOLLOWING\'\">{{fact.name}} {{fact.lastname}}</a></div></md-list-item></md-list></div></md-content></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><md-icon><i class=\"fa fa-envelope-o\" style=\"color: #fff;\"></i></md-icon></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><md-card class=\"public-profile\"><md-card-content><img class=\"md-card-image\" alt=\"\"></md-card-content></md-card></div></div><div class=\"blueBlock\" layout=\"column\"><strong>Mensajes</strong></div><div class=\"blueArrow\"></div><md-button class=\"btn-login-msg\" ng-if=\"!profile.isAuthenticated()\" ng-click=\"profile.showLoginDialog()\" layout=\"column\" layout-align=\"center center\">Por favor inicia sesion<br>para ver o enviar mensajes.</md-button><div class=\"bio-Actions\" layout=\"column\" ng-if=\"profile.isAuthenticated()\"><div class=\"button\" ng-if=\"profile.conversations.length == 0 && !profile.user.myself\"><md-button class=\"mensajeria\" ng-if=\"!profile.user.myself && profile.user.already_following\" ng-click=\"profile.showMessageModal(0, [])\">ENVIAR MENSAJE A {{profile.user.name}}</md-button></div><md-card class=\"mensajeriaPrivada\"><div class=\"inbox\"><md-card class=\"inbox-title\" ng-if=\"!profile.canShowSendMessageButton() && profile.conversations == null && profile.user.myself\">{{profile.conversation_title}}<div class=\"sin-mensajes\">No hay mensajes...</div></md-card><div ng-if=\"profile.canShowConversations()\"><md-card class=\"inbox-title\" style=\"cursor: default;\">{{profile.conversation_title}}</md-card><div class=\"mensajes-recibidos-content\" ng-repeat=\"cnv in profile.conversations\" ng-hide=\"message.hidden === 1\"><div ng-repeat=\"message in cnv.messages\"><md-card href=\"#send-message\" du-smooth-scroll=\"\" class=\"msg-container\" layout=\"row\" ng-click=\"profile.showMessageModal(cnv.id, cnv.messages)\" ng-if=\"$last\" layout-align=\"space-around-end\" autoscroll=\"true\"><img ng-repeat=\"c in cnv.participants\" class=\"msg-avatar\" ng-src=\"{{profile.imageServer}}//smart/{{ c.photo }}\" alt=\"\"><p class=\"msg-body\" ng-hide=\"message.hidden === 1\">{{ message.body }}</p><p ng-repeat=\"p in cnv.participants\" class=\"msg-name\">{{p.name}}</p></md-card></div></div></div></div></md-card></div></md-tab-body></md-tab></md-tabs></div><div hide-xs=\"\" flex=\"\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\"></acme-footer></div><a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n\n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/reports/modal_confirm_send_report.tmpl.html","<div layout=\"column\" layout-padding=\"\"><md-dialog-content><div><div layout=\"column\" layout-align=\"center center\" class=\"lightbox-abandonar\" ng-show=\"!vm.reportSuccess\"><div flex=\"\"><h1>Reportar Winwin</h1><p translate=\"\">Ingresa la raz&oacute;n del reporte</p></div><div class=\"wrap-md-input-container\"><textarea class=\"reportar\" rows=\"4\" cols=\"50\" style=\"max-width: 150px;\" ng-model=\"vm.report.report_reason\"></textarea></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.sendReport()\" ng-disabled=\"loadingFlag\">{{ \'Reportar\' | translate }}</md-button></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.reportSuccess\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-oks.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\">Gracias. El reporte ha sido enviado y verificaremos este Winwin<br>en los pr&oacute;ximos minutos.</p></div></div></div></md-dialog-content></div>");
$templateCache.put("app/search/search.html","<div class=\"acme-search\" style=\"min-height: 900px;\"><div class=\"container\"><h1 class=\"title\"><md-icon>search</md-icon>Hay <span>{{search.result_length}}</span> resultados de búsqueda para <span>{{search.query}}</span></h1></div><acme-miembro items=\"search.users\" hide-extra=\"true\" class=\"miembros-page\" ng-show=\"search.users.length > 0\"></acme-miembro><acme-highlighted items=\"search.winwins\" icon=\"\'icon-concretados\'\" ng-show=\"search.winwins.length > 0\"></acme-highlighted></div>");
$templateCache.put("app/terms/terms.html","<md-content class=\"acme-terms\"><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><div class=\"container\" style=\"padding-bottom: 0px;\"><div layout=\"row\"><div flex=\"\"><h1 class=\"big-title-b\" style=\"color: #fff; font-size: 5vh;padding-top: 20px; padding-bottom: 20px;\">T&eacute;rminos y Condiciones</h1></div></div></div></div><div class=\"container\"><div layout=\"column\"><ul><br><br><br><li translate=\"\">1.- Lea cuidadosamente este documento: el mismo es un instrumento legal que refleja un acuerdo entre Ud. (el Usuario) y HUMANET S.A. , la sociedad operadora y explotadora del sitio winwins.org (la Operadora)<ul><li translate=\"\">1.1. Este documento se describe los términos y condiciones generales (los \"Términos y Condiciones \" o \"TyC\") aplicables al uso de los servicios ofrecidos en el sitio alojado bajo los nombres de dominio winwins.org y/o winwins.net y/o winwins.info (el “Sitio”).</li><li translate=\"\">1.2. Los servicios ofrecidos a través del Sitio sólo podrán ser utilizados por aquellas personas (en adelante el Usuario, la Usuaria o los Usuarios en forma indistinta) que acepten los Términos y Condiciones que aquí se describen, y sujete su conducta a lo establecido en los mismos. El Usuario debe leer, entender y aceptar las condiciones establecidas en estos Términos y Condiciones, y podrá realizar cualquier consulta acerca de los mismos a legales@winwins.org.</li><li translate=\"\">1.3. Si Ud. es padre, madre o tutor legal y brinda consentimiento para la utilización de los servicios ofrecidos en el Sitio por parte de su hijo o personas menores de edad a su cargo, acepta estos Términos y Condiciones y se compromete a monitorear y guardar el debido y razonable control sobre las actividades de los menores de edad a su cargo mientras que utilicen el Sitio.</li><li translate=\"\">1.4. Cualquier persona que no acepte estos términos y condiciones generales, los cuales tienen un carácter obligatorio y vinculante, deberá abstenerse de utilizar el Sitio y/o los servicios ofrecidos en el mismo.</li><li translate=\"\">1.5. Cualquier Usuario que pretendiera utilizar el Sitio en condiciones distintas a las que aquí se especifican o en términos diferentes deberá contactarse con la Operadora del sitio a través de la direccion legales@winwins.org a fin de negociar un acuerdo distinto.</li><li translate=\"\">1.6. Los Términos y Condiciones que aquí se establecen podrán ser modificados por la Operadora en el momento en que ésta lo considere conveniente, consintiendo los Usuarios en que el aviso legible y destacado en la página de acceso sobre la existencia de nuevos términos y condiciones o, alternativamente, el aviso por correo electrónico configura un aviso suficiente y resulta vinculante para el Usuario en la medida en que éste utilice cualquier parte del Sitio y/o los servicios del Sitio con posterioridad a la publicación de los nuevos Términos y Condiciones.</li></ul></li></ul><ul><li translate=\"\">2.- Servicios ofrecidos a través del Sitio<ul><li translate=\"\">2.1. La Operadora administra el “Sitio” de forma tal que los Usuarios del mismo puedan compartir intereses y proyectos comunes, crear vínculos de acción constructiva y creativa, sin tener ninguna injerencia de ningún tipo en el modo de relacionarse ni de los objetivos con los cuales los Usuarios se relacionan.</li><li translate=\"\">2.2. A fin de promover diversos modos de relacionamiento, el Sitio provee espacios de interacción tecnológica, a través de la creación de “Grupos” y/o “Winwins”, dando también a algunos Usuarios la posibilidad de constituirse como “Sponsors” de cada uno de ellos.</li><li>2.3. El Sitio es exclusivamente un lugar de encuentro, que actúa como un punto de reunión que permite a los Usuarios aprovechar su potencial colectivo y sumar esfuerzos para las causas que el Usuario considere pertinentes dentro de los límites de las normas de uso que se describen más abajo.</li><li translate=\"\">2.4. La Operadora no produce ni edita los contenidos que son expuestos en el Sitio, no los promociona, ni patrocina, no apoya ni impulsa en modo alguno las distintas iniciativas que los Usuarios del Sitio pudieran expresar a través de los Grupos o Winwins. La Operadora tampoco interviene (salvo cuando lo anuncie expresamente) en los winwins o grupos, ni controla la calidad, seguridad o legalidad de las iniciativas que los Usuarios propongan.</li><li translate=\"\">2.5. Sin perjuicio de lo expuesto en los párrafos anteriores, la Operadora se reserva el derecho de suspender temporaria o definitivamente cualquiera de estos espacios de interacción, sean Grupos o Winwins, patrocinados o no; en cualquier momento y sin aviso previo.</li></ul></li></ul><ul><li translate=\"\">3. Tratamiento de la Información Personal de los Usuarios<ul><li translate=\"\">3.1. Al registrarse y/o navegar el Sitio, el Usuario brinda información personal, prestando su consentimiento para que la misma sea almacenada en bases de datos administradas y/o controladoas por la Operadora, las que serán protegidas utilizando un estándar de seguridad informática de protección de la información que resulte razonablemente eficaz como para mantener dicha información en total confidencialidad, conforme a la Ley Nº 25.326 de Hábeas Data, pudiendo el Usuario puede acceder a esta información y solicitar su eliminación. El Usuario pordré efectuar consultas sobre los derechos que le asisten respecto de este punto a legales@winwins.org o al órgano de aplicación de la norma mencionada más arriba, la Dirección Nacional de Protección de Datos Personales, del Ministerio de Justicia, Seguridad y Derechos Humanos de la Nación (<a href=\"http://www.jus.gov.ar/datospersonales/\" target=\"_blank\">http://www.jus.gov.ar/datospersonales/</a>).</li><li translate=\"\">3.2. La dirección de e-mail informada por el Usuario en el acto del registro será utilizada solamente para los fines autorizados por los Usuarios, así como para enviar información sobre el Sitio y los Servicios del Sitio a los Usuarios y responder las dudas.</li></ul></li></ul><ul><li translate=\"\">4. Derechos de propiedad intelectual de la Operadora y los Usuarios<ul><li translate=\"\">4.1. Winwins es una marca registrada, y su uso se encunentra protegido por la ley 11.723 (modif. Ley 25.036) y por el Acuerdo Sobre los Aspectos de Los Derechos de Propiedad Intelectual Relacionados con el Comercio – ADPIC. Asimismo, la Operadora conserva los derechos de publicación del Sitio, conforme las normas que rigen el derecho de autor en la República Argentina. El nombre Winwins y el logo no pueden ser utilizados de ningún modo sin el previo consentimiento de la Operadora.</li><li translate=\"\">4.2. El resto de los contenidos de la Operadora son licenciados en forma gratuita a quien los desee bajos los términos de la licencia Atribución 2.5 (Argentina) de Creative Commons, cuyo texto completo puede consultarse en <a href=\"http://creativecommons.org/licenses/by/2.5/ar/legalcode\" target=\"_blank\">http://creativecommons.org/licenses/by/2.5/ar/legalcode</a></li><li translate=\"\">4.3. Al publicar en el Sitio textos, videos, fotografías, fonogramas o contenido de cualquier tipo, el Usuario conserva la propiedad de los mismos, otorgando al resto de los Usuarios una licencia gratuita bajos los términos de la licencia Atribución 2.5 (Argentina) de Creative Commons, cuyo texto completo puede consultarse en <a href=\"http://creativecommons.org/licenses/by/2.5/ar/legalcode\" target=\"_blank\">http://creativecommons.org/licenses/by/2.5/ar/legalcode</a></li><li translate=\"\">4.4. Asimismo, al publicar en el Sitio textos, videos, fotografías, fonogramas o contenido de cualquier tipo el Usuario concede a la Operadora una licencia mundial para usar, alojar, almacenar, reproducir, modificar, crear obras derivadas (que resulten de la traducción o la adaptación de los contenidos), comunicar, publicar, difundir, ejecutar o mostrar públicamente y distribuir dicho contenido, aún con fines comerciales, siempre que tenga por objeto la promoción del Sitio y los servicios del Sitio.</li></ul></li></ul><ul><li translate=\"\">5. Responsabilidad de la Operadora<ul><li translate=\"\">5.1. La Operadora efectuará esfuerzos razonables para mantener los servicios del Sitio on line durante el mayor tiempo posible. Sin perjuicio de ello, el Sitio y los servicios brindados a través del Sitio se proporcionan en el estado en que se encuentran, sin garantías de ningún tipo. La Operadora no garantiza la fiabilidad ni disponibilidad del contenido, ni la exactitud en los mismos ni la identidad de las personas, ni que sus servidores estén libres de virus o programas informáticos espía, limitándose a poner sus mejores esfuerzos en el mantenimiento y mejora de los espacios de interacción, sean Grupos, Winwins u otros que se desarrollen en el futuro.</li><li translate=\"\">5.2. El Usuario asume la total responsabilidad por los contenidos descargados del Sitio y su relación con otros Usuarios, eximiendo expresamente a la Operadora de cualquier responsabilidad derivada de acciones, demandas o indemnizaciones por daños de cualquier clase o naturaleza, que sean resultado de, o tengan conexión alguna con enfrentamientos o disputas con otros Usuarios del Sitio.</li><li translate=\"\">5.3. Los padres o tutores legales, al prestar su consentimiento para la participación de Usuarios menores de edad, declaran comprender los riesgos que entraña la utilización de servicios alojados en redes informáticas y la red Internet en general y el Sitio en modo particular, asumiendo la responsabilidad por eventuales daños directos o indirectos que los menores pudieran sufrir como consecuencia de la utilización de servicios del Sitio o de acceso a contenido no apto para los mismos.</li><li translate=\"\">5.4. La Operadora ha diseñado un sistema de denuncias para reducir al menor grado posible la utilizacion y/o disponibilidad de contenidos contrarios a las normas de conducta del Sitio, limitándose su responsabilidad a asegurar el funcionamiento del sistema, pero sin garantizar resultados de ningún tipo. Los Usuarios aceptan que el rol de la Operadora del Sitio se limita a proveer las herramientas para la puesta a disposición y control del contenido, actividades que son realizadas por los propios Usuarios.</li><li translate=\"\">5.5. La Operadora no asume ninguna obligación contractual en relación al sistema de denuncias, ni de indentificación de usuarios, ni tampoco respecto de la integridad de la información. No estará obligada por estos Términos y Condiciones a dar de baja o borrar del sitio contenido subido por los Usuarios, salvo orden judicial o mandato legal expreso.</li><li translate=\"\">5.6. Sin perjuicio de lo expuesto en el punto anterior, la Operadora se reserva el derecho de excluir y/o suspender, a cualquier Usuario del Sitio; y borrar o suspender contenido de cualquier tipo del Sitio, cuando exista una clara violación a las normas de conducta del Sitio, o reciba denuncias que posean entidad suficiente a criterio de la Operadora.</li><li translate=\"\">5.7. Los Usuarios aceptan que la Operadora no será considerada responsable por el ataque informático al sistema o uso indebido de las cuentas, ni de las contraseñas de los Usuarios o datos de acceso, salvo casos de grave negligencia por parte de la Operadora.</li></ul></li></ul><ul><li translate=\"\">6. Responsabilidad de los usuarios por los contenidos subidos al Sitio - Indemnidad<ul><li translate=\"\">6.1. El Usuario es responsable por el buen uso de los servicios ofrecidos a través del Sitio, comprometiéndose a evitar cualquier tipo de acción que pueda dañar a sistemas, equipos o servicios accesibles directa o indirectamente a través de Internet, incluyendo la congestión intencional de enlaces o sistemas y la utilización de software espía.</li><li translate=\"\">6.2. El Usuario asume la responsabilidad total por los daños directos e indirectos que todos los textos, videos, fotografías, fonogramas, información y contenido de cualquier otro tipo que publique, promocione y/o difunda en el Sitio pudieran generar a otros Usuarios o a terceras partes.</li><li translate=\"\">6.3. La Operadora no será responsable de ninguna manera por cualquier contenido de Usuario o de Terceros publicados por Usuarios en el Sitio, ya sea publicado o causado por los Usuarios del Sitio o por cualquiera de los equipos o programas asociados con o utilizados en el Sitio.</li><li translate=\"\">6.4. Asimismo, la tampoco será considerada responsable por la publicación, veracidad y/o exactitud de la información que se ofrezcan en el Sitio, ni de los cambios que sobre la misma pudieran acontecer, o el uso inapropiado de este contenido por parte de terceros.</li><li translate=\"\">6.5. El Usuario se obliga a mantener indemne a la Operadora por las consecuencias que se deriven de contenido ilegal, ofensivo, inapropiado, obsceno, ilegal o cuestionable judicialmente que el Usuario haya incorporado por cualquier medio al Sitio; como asi también por las consecuencias derivadas de acciones que pudieran dañar sistemas, equipos o servicios accesibles directa o indirectamente a través de Internet, incluyendo la congestión intencional de enlaces o sistemas y la utilización de software espía.</li></ul></li></ul><ul><li translate=\"\">7.- Normas de conducta<ul><li translate=\"\">7.1. Las normas de conducta que aquí se describen poseen carácter orientativo y no exhaustivo, y están destinadas a mejorar la experiencia general de los Usuarios en el Sitio y a limitar los riesgos que supone cualquier interacción social. Las Normas de conducta no han sido diseñadas ni incluidas aquí con el propósito de limitar la responsabilidad de los Usuarios por sus actos. Por el contrario, conforme lo establecido más arriba, el Usuario asume la responsabilidad total por los daños directos e indirectos que todos los textos, videos, fotografías, fonogramas, información y contenido de cualquier otro tipo que publique, promocione y/o difunda en el Sitio pudieran generar a otros Usuarios o a terceras partes, con independencia del cumplimiento o incumplimiento de estas normas de conducta.</li><li translate=\"\">7.2. El Usuario acepta y declara que no publicará, enviará por ningún canal de comunicación, ni pondrá a disposición ningún contenido, ni usará el Sitio: - de forma discriminatoria por motivos de raza, color, sexo, religión, nacionalidad, origen étnico o nacional, estado civil, discapacidad, orientación sexual o de cualquier otro modo que pudiera resultar inadecuado o dañoso conforme las normas legales vigentes; - de forma injuriosa, difamatoria o de modo amenazante, abusivo, violento, acosador, malicioso o dañino para cualquier persona o entidad; - de cualquier manera que sea perjudicial para menores de edad; - para invadir la privacidad de otra persona o para suplantar a la identidad de cualquier otra persona, o afirmar falsamente o de otro hacer declaraciones falsas de su afiliación con otra persona o entidad o para obtener acceso a los servicios del Sitio sin autorización; - de una forma que sea falsa, engañosa o fraudulenta o de otro modo ilegal, o que promueva actividades ilegales, incluidas la suplantación de identidad u otro modo de obtener información personal o de otro tipo de forma maliciosa o con fines fraudulentos o engañosos; - para vehiculizar actividades de correo no deseado, cadena de mensajes, estafas de forma que infrinja, viole, distribuya ilegalmente o se apropie indebidamente de cualquier derecho de propiedad intelectual u otros derechos contractuales o de propiedad de terceros; piramidales, publicidad de productos o servicios ilegales o controlados, u otras actividades publicitarias o de marketing que infringen estos Términos y Condiciones, cualquier ley, reglamento o pautas de la industria publicitaria aplicables o generalmente aceptadas; - para interferir o intentar interferir con el funcionamiento correcto Winwins o impedir que otros usen esta red social, o de una manera que vulnere el flujo normal o el intercambio de Winwins o que de otro modo afecte la capacidad de otras personas de usar esta red social; - de forma que contenga virus de software o cualquier otro código informático, archivos o programas diseñados para interrumpir, destruir o limitar la funcionalidad de cualquier software informático, hardware o equipo de telecomunicaciones; independientemente y sin exclusión de la responsabilidad que asume por los daños que esto pudiera generar y la obligación de indemnidad asociada a dicha responsabilidad. - para usar cualquier medio manual o automatizado -incluidos robots, secuencias de comandos o arañas- para tener acceso o administrar la cuenta de cualquier usuario o para supervisar o copiar esta red social o su contenido; - en una manera que utilice direcciones de correo electrónico o IP falsas o encabezados falsificados o identificadores manipulados de otro modo con el fin de ocultar el origen del contenido transmitido a través del Sitio o a los usuarios;</li><li translate=\"\">7.3. El Usuario acepta y se compromete a: - mantener el intercambio con otros usuarios en términos de respeto y cordialidad, sin ofender, insultar ni maltratar. - no acechar o acosar a una persona por intermedio del Sitio; - no recopilar, usar o revelar datos -incluida información personal- sobre otros usuarios sin su consentimiento o con fines ilegítimos, o en violación de las leyes y reglamentos aplicables; - no publicar contenido que incluya pornografía infantil en el Sitio; - no publicar contenido que incite, represente o incluya discriminación, violaciones, violencia extrema, asesinatos, bestialidad, incesto u otro contenido similar. - Colaborar con la disponibilidad e integridad de los servicios del Sitio efectuando las denuncias que correspondan a través de los mecanismos previstos en el Sitio, sin perjuicio de la obligación legalmente impuesta a determinadas personas que por su profesión y oficio estén obligadas a efectuar las denuncias que correspondan ante la justicia.</li><li translate=\"\">7.4. Determinados servicios ofrecidos a través del Sitio exigen la creación de una cuenta para poder participar y obtener otros beneficios. El Usuario se compromete a suministrar información exacta y verdadera, completa e íntegra, sobre su persona y sus descendientes o personas a su cargo, absteniéndose de suplantar a una tercera parte – salvo en el caso de los menores de edad – incluyendo el uso de nombre de usuario, la contraseña u otra información de la cuenta o el nombre o la imagen. No debe proporcionar detalles falsos para un padre o tutor. El Usuario reconoce que no puede sublicenciar, transferir, vender ni ceder su membresía ni la identificación de su cuenta. Todo intento de sublicenciar, transferir, subastar, vender o ceder la titularidad o la identificación de una cuenta es nulo y tales intentos, independientemente de si fueron realizados o no por el titular de la cuenta, serán causa de cancelación inmediata de la cuenta. Usted también se compromete a notificar de inmediato a través del sistema de denuncias ofrecido por la Operadora sobre todo uso no autorizado de su nombre de usuario, contraseña, otra información de la cuenta o cualquier otra violación a la seguridad que detecte y que se relacione con el Sitio. Además, el Usuario se compromete a salir de su cuenta al finalizar cada sesión. La Operadora no será considerada responsable, en ningún caso, por el uso de la cuenta de usuario por terceras partes.</li></ul></li></ul><ul><li translate=\"\">8.- Menores de edad<ul><li translate=\"\">8.1. Los servicios del Sitio están dirigidos a personas de todas las edades. Sin perjuicio de ello, y en atención a que la Operadora no controla ni supervisa los contenidos y las iniciativas de los Usuarios, las personas menores de 14 años únicamente podrán utilizar los servicios del Sitio con autorización expresa de su padre, madre o tutor legal.</li><li translate=\"\">8.2. Si Ud. es padre, madre o tutor legal y brinda consentimiento para la utilización de los servicios ofrecidos en el Sitio por parte de su hijo o personas menores de edad a su cargo, entiende que está a su cargo monitorear y guardar el debido y razonable control sobre las actividades de los menores de edad a su cargo mientras que utilicen el Sitio, que la Operadora no controla ni lleva un registro de las actividades del Sitio, y que, como todo espacio de interacción con personas extrañas la utilización del Sitio entraña un riesgo para determinadas personas. En función de ello, exime a la Operadora de cualquier responsabilidad que no sea derivada directamente de las acciones de la Operadora, en especial de los daños que pudieran provocarse o derivarse de la interacción del menor con otros Usuarios del Sitio.</li></ul></li></ul><ul><li translate=\"\">9.- Sponsors<ul><li translate=\"\">9.1. Los Usuarios que actúan como sponsors (los \"Sponsors\") de distintas iniciativas y/o servicios que se brinden a través del el Sitio, no asumen ninguna responsabilidad por el contenido puesto a disposición por el resto de los usuarios. Los contenidos patrocinados serán responsabilidad exclusiva del Usuario que los publica y/o sube al sitio y/o pone a disposición de otros usuarios.</li><li translate=\"\">9.2. Sin perjuicio de lo expuesto en la cláusula anterior, los Sponsors y la Operadora colaborarán con la disponibilidad e integridad de los servicios del Sitio; los Sponsors efectuando las denuncias que correspondan a través de los mecanismos previstos en el Sitio, y la Operadora respondiendo a tales denuncias de manera rápida y expeditiva.</li></ul></li></ul><ul><li translate=\"\">10. Ley aplicable y jurisdicción<ul><li translate=\"\">10.1. Los Usuarios del Sitio reconocen expresamente que su relación con el Sitio y estos Términos y Condiciones como así también cualquier acuerdo que los complemente en el futuro se rigen y se regirán por las leyes de la República Argentina.</li><li translate=\"\">10.2. Los Usuarios aceptan someter cualquier controversia que pudiera llegar a suscitarse como consecuencia del uso de los servicios del Sitio o en relación a los contenidos del mismo, a la jurisdicción de los Tribunales Nacionales en lo Civil, con asiento en la Capital Federal, sin reservas de ningún tipo.</li></ul></li></ul></div></div></md-content><br><br><br><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height: 120px;\"></div><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div>");
$templateCache.put("app/weare/weare.html","<md-content class=\"acme-weare\" style=\"background: #fff\"><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><div class=\"container\" style=\"padding-bottom: 0px;\"><div layout=\"row\"><div flex=\"\"><h1 class=\"big-title-b\" style=\"color: #fff\">¿Qué es Winwins?</h1></div></div></div></div><br><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><iframe width=\"100%\" height=\"400px\" src=\"https://www.youtube.com/embed/UZh9QzkCY3c?autoplay=1;rel=0&amp;showinfo=0\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p>A través de Winwins aspiramos a construir una red de personas y organizaciones comprometidas a <strong>mejorar nuestro entorno.</strong> Por eso, necesitamos tus ideas, tu energía y tu participación para sumar propuestas positivas e invitar a tu gente valiosa para que también lo haga.<br><br><strong>La idea es simple</strong> cuando sabemos que todos estamos comprometidos a llevar adelante una acción, perdemos el miedo a quedarnos solos, ganamos potencia colectiva y nos animamos a cambiar.<br><br>Winwins es una <strong>red social</strong> donde personas y organizaciones se conectan y colaboran a través de desafíos de acción colectiva. A los desafíos los llamamos <strong>winwins porque todos los que participan, ganan.</strong><br><br><strong>Cambiar el mundo es posible</strong> si nos ponemos de acuerdo y cooperamos para realizar nuestros sueños.</p></div></div></div></div><div id=\"comofunciona\" style=\"margin-top:40px;\"></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><div class=\"container\" style=\"padding-bottom: 0px;\"><div layout=\"row\"><div flex=\"\"><h1 class=\"big-title-b\" style=\"color: #fff\">¿C&oacute;mo funciona?</h1></div></div></div></div><br><br><br><br><div layout=\"row\" layout-xs=\"column\"><div layout=\"container\" style=\"display: block; margin-left: auto; margin-right: auto;\"><div layout=\"row\" layout-xs=\"column\" style=\"text-align: center\"><br><br><br><br><div flex=\"\" layout-align=\"center center\"><img src=\"../assets/images/icon-recientes-title.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Crea o sumate a un Winwin</h4><p>Creá tus propios winwins o<br>sumate a los de otras personas.</p><br></div><div flex=\"\"><img src=\"../assets/images/share.png\"><h4 style=\"font-size: 20px; margin-bottom: 0px; margin-top:\">Invita gente y difundilo</h4><p>Invitá a gente a participar y difundí<br>tus desafíos en las redes sociales.</p><br></div><div flex=\"\"><img src=\"../assets/images/counter-sponsors-icon.svg\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Consegui apoyo</h4><p>Conseguí el apoyo de personas, sponsors y organizaciones.</p><br></div><div flex=\"\"><img src=\"../assets/images/wingsa.png\"><h4 style=\"font-size: 20px; margin-bottom: 0px;\">Gana Alas y Reconocimientos</h4><p>Ganá alas, reconocimiento y<br>beneficios por tus acciones.</p><br><br><br><br><br>.</div></div></div></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\">Simple y f&aacute;cil</h1>Además de simple, winwins es fácil!<br><br>Todos pueden crear winwins o sumarse a las propuestas de otros, invitar a participar en ellas, difundirlas, conseguir apoyos, etc.<br><br>Podés también seguir a los usuarios que te inspiran, y otros seguirte a vos.<br><br>Logueate con tu sesión de Facebook, o generá tu usuario desde “Entrar” y comenzá esta aventura por un mundo en el que todos ganemos.<p></p></div></div><div flex=\"\"><iframe width=\"100%\" height=\"330px\" src=\"https://www.youtube.com/embed/npWNX0woM7o?autoplay=0;rel=0&amp;showinfo=0\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\">Los desaf&iacute;os Winwin</h1>Los winwins te invitan a colaborar para lograr algo juntos, algo que interesa y beneficia también a los demás. Son propuestas de beneficio mutuo que buscan sumar voluntades para llevarlas a cabo.<br><br>Por eso, el creador de un winwin, además de formular su propuesta de acción colectiva, establece qué cantidad de participantes es necesarias para pasar acción.<br>Una vez que se alcanza la cantidad de participantes, el sistema alerta a todos que ya están dadas las condiciones para concretar el winwin. Si no se alcanza el quórum, no hay obligación de participar.<p></p></div></div><div flex=\"\"><img src=\"../assets/images/comunidadwinwins.png\" height=\"300\"></div></div></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px;\"></div><br><br><br><div class=\"container\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\">ABC de un Winwin</h1><p>Las bases de cada propuesta están en el encabezado de su página. Allí, se describe en qué consiste, cuántas personas se han adherido y cuántas faltan para alcanzar el quórum que estableció su creador.</p></div></div><div flex=\"\"><img src=\"../assets/images/planteo.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-plus\"></i> Sumarte al Winwin</h1><p>Para participar tenés que hacer clic en el botón verde “Sí, me sumo” y luego aceptar nuestro código de honor. Lo ideal es que colabores en su difusión y alientes el intercambio entre los participantes.</p></div></div><div flex=\"\"><img src=\"../assets/images/codigo.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-envelope-o\"></i> Invitar al winwin</h1><p>Si estás logeado, podés “Invitar” a que se sumen a tantos como quieras. Les llegará un email con tu invitación.</p></div></div><div flex=\"\"><img src=\"../assets/images/invitar.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-share-alt\"></i> Compartir vía RRSS</h1><p>Si te parece valioso para compartirlo entre tus contactos de facebook o twitter, simplemente hace clic en “Difundir…”, no hace falta que estés logeado.</p></div></div><div flex=\"\"><img src=\"../assets/images/share.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-comments\"></i> Muro del winwin</h1><p>Un espacio en la página del winwin para intercambiar con los demás participantes. Podes subir textos, videos y/o imágenes. También podés participar de las encuestas del winwin, responder a post de otros usuarios, etc.</p></div></div><div flex=\"\"><img src=\"../assets/images/wall.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-users\"></i> Participantes</h1><p>A la derecha del muro, podés ver los participantes del winwin.</p></div></div><div flex=\"\"><img src=\"../assets/images/users.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-bell-o\"></i> Campanada</h1><p>Es un mensaje de texto corto que el creador del winwin le envía a todos los participantes.</p></div></div><div flex=\"\"><img src=\"../assets/images/campanada.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-comment-o\" aria-hidden=\"true\"></i> Mensaje al Creador</h1><p>Podés contactarte con el creador desde la página del winwin.</p></div></div><div flex=\"\"><img src=\"../assets/images/hola.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-user\"></i> Creadores y activadores</h1><p>Para promocionar tu winwin asegurate de que cuenta con información atractiva y útil para que los visitantes se transformen en participantes. Por eso, PUBLICÁ en el muro información, imágenes y videos que generen motivación y debate constructivo. Invitá a los demás a hacer lo mismo.<br><br>Los creadores cuentan con algunas herramientas especiales para moderar su winwin: destacar post del muro , recibir mensajes de los participantes y responderlos, crear encuestas, enviar campanadas, aceptar sponsors, etc.. Además, pueden darle a los participantes que deseen permisos especiales para usarlas, haciendo que los participantes elegidos se conviertan en activadores.</p></div></div><div flex=\"\"><img src=\"../assets/images/creadores.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-bookmark\"></i> Destacar post</h1><p>Los creadores y activadores de un winwin (siempre que estén logeados) pueden destacar un post del muro, sin importar quien lo dejó. Esto se logra haciendo clic sobre la estrella que está en el margen superior derecho del post. Cuando un post es destacado, se coloca en el primer lugar del muro, cambia su color de fondo y queda marcada la estrella. Permanecerá así hasta tanto no se destaque otro post del muro, el que pasará a ocupar el primer lugar.</p></div></div><div flex=\"\"><img src=\"../assets/images/wall.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-server\"></i> Crear encuestas</h1><p>Además, los creadores y activadores de un winwin pueden generar encuestas y publicarlas en el muro. A través de ellas pueden recoger las opiniones y preferencias de los participantes.</p></div></div><div flex=\"\"><img src=\"../assets/images/encuesta.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-male\" aria-hidden=\"true\"></i> Tu perfil</h1><p>Haciendo clic en tu avatar, en el lado derecho del menú superior, podés editar tu perfil: cambiar tu avatar, colocar una imagen de portada, completar tu Bio, elegir los ámbitos de acción que más te interesan, etc. En el Perfil se muestran además los Winwins que creaste y los winwins en los que estás participando, los usuarios a los que seguís y los usuarios que te siguen.</p></div></div><div flex=\"\"><img src=\"../assets/images/profile.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#333\"><i class=\"fa fa-flash\" aria-hidden=\"true\"></i> Actividad Reciente</h1><p>En el panel Actividad Reciente se muestra el timeline de tus actividades en la red winwins y la de los usuarios a los que seguís.</p></div></div><div flex=\"\"><img src=\"../assets/images/actividad.jpg\" style=\"float: right\"></div></div><hr><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div style=\"padding:30px; padding-top: 0px; margin-top: 0px;\"><p></p><h1 style=\"color:#547bc0\"><i class=\"fa fa-comment-o\" aria-hidden=\"true\"></i> Mensajes</h1><p>También, podés recibir o enviar mensajes desde tu Perfil.</p></div></div><div flex=\"\"><img src=\"../assets/images/profile.jpg\" style=\"float: right\"></div></div><hr></div><div layout=\"row\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; height:70px\"></div></md-content><div hide-xs=\"\" flex=\"\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\"></acme-footer></div><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div>");
$templateCache.put("app/winwin/cover_crop.tmpl.html","<div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><md-input-container><label translate=\"\">Elige una foto para subir:</label> <input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().handleFileSelect(this)\"></md-input-container><div class=\"cropArea\"><img-crop chargement=\"\'Cargando\'\" image=\"myImage\" area-type=\"rectangle\" aspect-ratio=\"1.46\" result-image=\"myCroppedImage\" result-image-size=\"{w: 414,h: 282}\" init-max-area=\"true\"></img-crop></div><md-button ng-click=\"cropImage()\" class=\"md-raised md-green\">Aceptar</md-button></div>");
$templateCache.put("app/winwin/cover_post_image.tmpl.html","<div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><md-input-container><label translate=\"\">Elige una foto para subir:</label> <input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().handleFileSelect(this)\"></md-input-container><div class=\"cropArea\"><img-crop image=\"myImage\" chargement=\"\'Cargando\'\" area-type=\"rectangle\" aspect-ratio=\"1.46\" result-image=\"myCroppedImage\" result-image-size=\"{w: 414,h: 282}\" init-max-area=\"true\"></img-crop></div><md-button ng-click=\"cropImage()\" class=\"md-raised md-green\">Aceptar</md-button></div>");
$templateCache.put("app/winwin/crear-winwin.html","<div class=\"wrapper\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover;\"><md-content class=\"acme-crearwinwin\" ng-show=\"winwin.stage==1\" style=\"background-image: url(\'../assets/images/main-back.png\'); background-size: cover; background-repeat: repeat-y; min-height: 1000px;\"><span id=\"scrollToTop\"></span><form method=\"post\" name=\"winwin.crearForm1\"><div layout=\"row\" layout-align=\"center center\"><wizard on-finish=\"winwin.tryToSaveWinwin()\" class=\"box\"><wz-step wz-title=\"1-Participantes\" canexit=\"winwin.checkStage1()\"><div class=\"create-title animated fadeIn\" style=\"color: #fff\">¿Cuántas personas necesit&aacute;s o quer&eacute;s que se sumen?<br><span class=\"subtitle\" hide-xs=\"\">Ingres&aacute; la cantidad de participantes que necesit&aacute;s o quer&eacute;s que se sumen a tu winwin.</span></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><md-radio-group ng-model=\"winwin.winwin.tipo_quorum\"><div class=\"create-cards\"><md-radio-button value=\"{{winwin.quorumId(\'QUORUM_ILIMITADO\')}}\"><strong>¡La mayor cantidad posible! <i class=\"fa fa-info-circle\" style=\"color: #f60;\"></i><md-tooltip md-direction=\"down\">Si seleccionás esta opción <strong>estás invitando a todas las personas</strong> a sumarse a tu Winwin.</md-tooltip></strong></md-radio-button><p style=\"font-size: smaller;\"><strong>Todas las personas pueden participar.</strong> Generalmente es para Winwins orientados a la sociedad: un barrio, una ciudad o el mundo.</p></div><div class=\"create-cards\"><div layout=\"column\" layout-xs=\"column\"><div flex=\"\"><md-radio-button value=\"{{winwin.quorumId(\'QUORUM_FIJO\')}}\"><strong>Necesito sólo <i class=\"fa fa-info-circle\" style=\"color: #f60;\"></i><md-tooltip md-direction=\"down\">Es necesaria una cantidad exacta de personas, ni más ni menos, para realizar el Winwin. Una vez alcanzado ese número se cerrará la participación.</md-tooltip></strong></md-radio-button></div><div flex=\"\"><md-input-container><input md-input=\"\" type=\"number\" min=\"2\" ng-min=\"2\" name=\"users_amount\" placeholder=\"Ej:200\" ng-model=\"winwin.users_amount_fijo\" ng-focus=\"winwin.setQuorumFijo()\" ng-required=\"winwin.quorum_fijo()\" ng-minlength=\"1\" style=\"width:90px;\"><div ng-messages=\"winwin.crearForm1.users_amount.$error\" md-auto-hide=\"false\" ng-if=\"winwin.crearForm1.users_amount.$touched\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Requerido.</div></div></div><strong>personas</strong></md-input-container></div></div><p style=\"font-size: small;\">Es necesaria una <strong>cantidad exacta de personas</strong>, ni más ni menos, para realizar el Winwin. Una vez alcanzado ese número se cerrará la participación.</p></div></md-radio-group></div><div flex=\"\" hide-xs=\"\"><div class=\"tips\"><br><i class=\"fa fa-arrow-left\"></i> Si seleccionás esta opción <strong>estás invitando a todas las personas</strong> a sumarse a tu Winwin.<br><br>Causas sociales o propuestas de cambio de comportamiento social son Winwins apropiados para elegir esta opci&oacute;n.<br><br></div><div class=\"tips\"><br><i class=\"fa fa-arrow-left\"></i> Hay acciones que por sus características requieren de un <strong>número exacto</strong> de participantes.<br><br>Las <strong>caracteristicas del lugar</strong> donde sucederá el Winwin, las <strong>personas necesarias</strong> para realizar una compra colectiva o compartir un viaje en auto pueden ser aspectos que te lleven a seleccionar esta opción.<br><br>Tené en cuenta que no podrán participar <strong>ni más ni menos</strong> que el número de personas que indiques.<br><br></div><button type=\"submit\" ng-click=\"winwin.check1andNext()\" value=\"Continuar\" class=\"md-ink-ripple md-raised bt-default md-primary\" style=\"width: 95%; float: right;\">Continuar <i class=\"fa fa-arrow-right animated fadeInLeft infinite\" style=\"margin-left: 10px;\"></i></button></div></div><button type=\"submit\" ng-click=\"winwin.check1andNext()\" value=\"Continuar\" class=\"md-ink-ripple md-raised bt-default md-primary\" style=\"width: 100%; float: right;\" hide=\"\" show-xs=\"\">Continuar <i class=\"fa fa-arrow-right animated fadeInLeft infinite\" style=\"margin-left: 10px;\"></i></button></wz-step><wz-step wz-title=\"2-PLANTEA TU WINWIN\" canexit=\"winwin.checkStage2()\"><div class=\"create-title animated fadeIn\" style=\"color: #fff\">Propon&eacute; tu Winwin a la Comunidad<br><span class=\"subtitle\" hide-xs=\"\">Plantea tu idea winwin para comenzar a sumar participantes interesados en hacerlo realidad.</span></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div class=\"create-cards\"><div layout=\"column\" ng-if=\"winwin.quorum_ilimitado()\"><md-input-container class=\"no-margin\"><strong>¿Si supieras que <span style=\"color: #f60;\">todos</span> vamos a...</strong> <textarea name=\"what_we_do\" ng-model=\"winwin.winwin.what_we_do\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus=\"\" required=\"\" aria-label=\"what we do\" style=\"background:#fff; min-height:110px; height:120px; max-height: 120px;font-family: montserrat;\" \"=\"\"></textarea><div ng-messages=\"winwin.crearForm1.what_we_do.$error\" md-auto-hide=\"false\" ng-if=\"winwin.crearForm1.what_we_do.$touched\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Completa el planteo de tu winwin!</div></div></div><p><strong>te sumar&iacute;as?</strong></p></md-input-container></div><div layout=\"column\" ng-if=\"winwin.quorum_fijo()\"><md-input-container class=\"no-margin\"><p><strong>¿Si supieras que somos <span style=\"color: #f60; font-size: 20px;\">{{winwin.users_amount_fijo}}</span> personas que vamos a...</strong></p><textarea name=\"what_we_do\" ng-model=\"winwin.winwin.what_we_do\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus=\"\" required=\"\" aria-label=\"what we do\" style=\"background:#fff; min-height:110px; height:120; max-height: 120px;font-family: montserrat;\" \"=\"\"></textarea><div ng-messages=\"winwin.crearForm1.what_we_do.$error\" md-auto-hide=\"false\" ng-if=\"winwin.crearForm1.what_we_do.$touched\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Completa el planteo de tu winwin!</div></div></div><p><strong>te sumar&iacute;as?</strong></p></md-input-container></div><div layout=\"column\" ng-if=\"winwin.quorum_movil()\"><md-input-container class=\"no-margin\"><p>¿Si supieras que somos entre <span style=\"color: #f60;font-size: 20px;\">{{winwin.min_users_amount}}</span> y <span style=\"color: #f60\">{{winwin.users_amount_movil}}</span> personas que vamos a... <textarea name=\"what_we_do\" ng-model=\"winwin.winwin.what_we_do\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus=\"\" required=\"\" aria-label=\"what we do\" style=\"background:#fff; min-height:120px; height:120; max-height: 110px;font-family: montserrat;\"></textarea><div ng-messages=\"winwin.crearForm1.what_we_do.$error\" md-auto-hide=\"false\" ng-if=\"winwin.crearForm1.what_we_do.$touched\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Completa el planteo de tu winwin!</div></div></div></p><p><strong>te sumar&iacute;as?</strong></p></md-input-container></div><div class=\"tips\" style=\"margin-left:0px;\"><p style=\"font-size: 12px;\"><strong><i class=\"fa fa-arrow-up\"></i> Plantea tu winwin brevemente y yendo al punto.</strong></p><p style=\"font-size: 12px;\"><i class=\"fa fa-check\" style=\"color: green;\"></i><strong>Ejemplo Bueno:</strong> Si supieras que todos vamos a comprar frutas y verduras organicas para comer mejor, mas sano y barato, te sumarias?</p></div></div></div><div flex=\"\"><div class=\"create-cards\" style=\"margin-left:10px; padding:10px;\"><md-input-container style=\"width: 100%;\"><div style=\"text-align: center; padding-bottom: 10px; font-size: 14px; font-weight: bold;\"><strong>Describi todos los detalles</strong><md-tooltip md-direction=\"down\">Describi todos los detalles de tu winwin, inclui lugares, fechas, personas necesitas y toda la info que te resulte relevante.</md-tooltip></div><text-angular ta-toolbar=\"[[ \'h1\', \'h2\', \'h3\',\'bold\',\'italics\',\'ul\',\'justifyLeft\', \'justifyCenter\']]\" ng-model=\"winwin.winwin.description\" name=\"description\" ta-max-text=\"5000\" rows=\"5\" md-select-on-focus=\"\" aria-label=\"description\" style=\"width:100%;height: 70px; max-height: 180px; background: #fff;\"></text-angular></md-input-container><div class=\"tips\" style=\"margin-left:0px;\"><p style=\"font-size: 12px;\"><strong><i class=\"fa fa-arrow-up\"></i> Todos los detalles y la informaci&oacute;n necesaria, &uacute;til y relevante.</strong><br><br><i class=\"fa fa-check\" style=\"color: green;\"></i> Fechas, horarios, datos, personas y habilidades necesarias, nivel de compromiso, urgencia del winwin.<br></p></div><br></div></div></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"></div><div flex=\"\"></div></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div class=\"create-cards\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"50\"><span style=\"font-size: 14px; line-height: 40px;\"><strong><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> Fecha l&iacute;mite</strong></span></div><div flex=\"50\"><md-datepicker name=\"closing_date\" ng-model=\"winwin.winwin.closing_date\" md-min-date=\"winwin.minDate\" md-placeholder=\"{{winwin.hoy}}\"></md-datepicker></div></div></div></div><div flex=\"\"><div class=\"tips\" hide-xs=\"\"><p style=\"font-size: 12px;\"><strong><i class=\"fa fa-arrow-left\"></i> Fecha l&iacute;mite</strong> que tienen los usuarios para sumarse. Si tu winwin no tiene una fecha o no la necesita omite este campo.</p></div></div></div><div layout=\"row\" layout-xs=\"row\"><div flex=\"\"><span style=\"font-size: 1rem;\"><input type=\"submit\" wz-previous=\"\" value=\"< Volver\" class=\"previous\"></span></div><div flex=\"\"><button type=\"submit\" ng-click=\"winwin.check2andNext()\" value=\"Continuar\" class=\"md-ink-ripple md-raised bt-default md-primary\" style=\"width: 95%; float: right;\">Continuar <i class=\"fa fa-arrow-right animated fadeInLeft infinite\" style=\"margin-left: 10px;\"></i></button></div></div></wz-step><wz-step wz-title=\"3-Portada\"><div class=\"create-title animated fadeIn\" style=\"color: #fff\">Insert&aacute; un Video o sub&iacute; una Imagen<br><span style=\"font-size: 16px;font-weight: 800;\" hide-xs=\"\">Insert&aacute; un video desde Youtube, sub&iacute; una imagen o seleccion&aacute; una de nuestra galer&iacute;a.</span></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div class=\"create-cards\" style=\"height: 300px; border: 5px dashed #666; background: #f1f1f1;\" hide-xs=\"\"><img ng-src=\"{{ winwin.preview_image }}\" style=\"background-color: #f1f1f1; height: 300px; min-width: 320px; max-width:410px;\" alt=\"\"></div><div class=\"create-cards\" style=\"height: auto; border: 5px dashed #666; background: #f1f1f1;\" hide=\"\" show-xs=\"\"><img ng-src=\"{{ winwin.preview_image }}\" class=\"prev-img\" alt=\"\"></div><div layout=\"row\" layout-xs=\"row\"><div flex=\"\"><md-whiteframe class=\"md-whiteframe-5dp\" style=\"width: 100%; background-color: #fff; padding:20px;\" layout=\"\" layout-align=\"center center\" flex=\"\" ng-click=\"winwin.showCropCoverDialog()\"><md-icon>photo_camera</md-icon><md-tooltip md-direction=\"down\">Subir Im&aacute;gen</md-tooltip></md-whiteframe></div><div flex=\"\"><md-whiteframe class=\"md-whiteframe-5dp\" style=\"width: 100%;background-color: #fff; padding:20px;\" layout=\"\" layout-align=\"center center\" flex=\"\" ng-click=\"winwin.showModalVideoPostDialog()\"><md-icon md-svg-src=\"assets/images/icon-youtube.svg\"></md-icon><md-tooltip md-direction=\"down\">Insertar Video desde Youtube</md-tooltip></md-whiteframe></div><div flex=\"\"><md-whiteframe class=\"md-whiteframe-5dp\" style=\"width: 100%;background-color: #fff;padding:20px;\" layout=\"\" layout-align=\"center center\" flex=\"\" ng-click=\"winwin.showGaleriaDialog()\"><md-icon>image</md-icon><md-tooltip md-direction=\"down\">Abrir Galeria de im&aacute;genes</md-tooltip></md-whiteframe></div></div></div><div flex=\"\" hide-xs=\"\"><div class=\"tips\"><strong><i class=\"fa fa-arrow-left\"></i> Esta va a ser la imagen de tu Winwin y aparecerá cada vez que alguien lo comparta en las redes sociales!</strong><br><br><i class=\"fa fa-youtube\"></i> Te recomendamos hacer un video que explique el Winwin y convoque a tus potenciales participantes.<br><br>-Pensá en cómo <strong>transmitir el entusiasmo</strong> para que más gente se sume!<br><br>-Si no sabés cómo <strong>editar un video</strong> podés hacerlo <strong>f&aacute;cil y gratis</strong> a través de esta herramienta online: <a href=\"http://www.kizoa.es/\" target=\"_blank\"><strong>Kizoa</strong></a><br><br>-También podés elegir fotos de la <strong>galer&iacute;a de imágenes</strong>.</div></div></div><br><div layout=\"row\" layout-xs=\"row\"><div flex=\"\"><input type=\"submit\" wz-previous=\"\" value=\"< Volver\" class=\"previous\"></div><div flex=\"\"><button type=\"submit\" ng-click=\"winwin.check3andNext()\" value=\"Continuar\" class=\"md-ink-ripple md-raised bt-default md-primary\" style=\"width: 95%; float: right;\">Continuar <i class=\"fa fa-arrow-right animated fadeInLeft infinite\" style=\"margin-left: 10px;\"></i></button></div></div></wz-step><wz-step wz-title=\"4-Lanzar Winwin\"><div class=\"create-title animated fadeIn style=\" color:=\"\" #fff\"\"=\"\">Un nombre para tu Winwin<br><span style=\"font-size: 16px;font-weight: 800;\" hide-xs=\"\">Escrib&iacute; un nombre para tu winwin, selecciona una categor&iacute;a y palabras clave.</span></div><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><div class=\"create-cards\"><div style=\"text-align: center; padding-bottom: 10px; font-size: 18px; font-weight: bold;\"><strong>UN NOMBRE PARA TU WINWIN</strong><md-tooltip md-direction=\"down\">El nombre es lo primero que llama la atenci&oacute;n de los usuarios</md-tooltip></div><md-input-container class=\"no-margin\" style=\"display: block; margin-left: auto; margin-right: auto;\"><input md-input=\"\" type=\"text\" name=\"title\" ng-model=\"winwin.winwin.title\" required=\"\" style=\"background:white; height:50px;\"><div ng-messages=\"winwin.crearForm1.title.$error\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Tu winwin no tiene nombre, ponele uno!</div></div></div><br></md-input-container></div></div><div flex=\"\"><div class=\"tips\" hide-xs=\"\"><strong><i class=\"fa fa-arrow-left\"></i> Esto es lo primero que atrae a las personas.</strong><br><br>Capta su atención con un <strong>nombre corto y poderoso</strong>que los enfoque en el cambio que buscas.<br><br>Un t&iacute;tulo <strong>positivo</strong> llama la atención de los usuarios y las chances que lo vean y se sumen, se multiplican.<br><br></div></div></div><div layout=\"row\" layout-xs=\"column\"><br><div flex=\"\"><br><div class=\"create-cards\"><strong>Selecciona categor&iacute;a</strong><br><md-input-container style=\"width:100%;\"><md-select name=\"category\" ng-model=\"winwin.winwin.interests[0]\" required=\"\" ng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"descripci&oacute;n\"><md-option ng-value=\"item\" ng-repeat=\"item in winwin.interests\">{{item.description}}</md-option></md-select><div ng-messages=\"winwin.crearForm1.category.$error\" ng-show=\"winwin.crearForm1.category.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Seleccion&aacute; al menos una categor&iacute;a</div></div></div></md-input-container></div><div class=\"tips\" hide-xs=\"\" style=\"margin-left: 0px;\"><i class=\"fa fa-arrow-up\"></i> Selecciona el <strong>&aacute;rea o tem&aacute;tica</strong> de tu desafío<br>Esto te ayudará que mejorar la comunicación de tu Winwin.<br></div></div><div flex=\"\"><br><div class=\"create-cards\" style=\"margin-left: 20px; padding: 15px;\"><strong>Ingresa palabras clave</strong><br><tags-input ng-model=\"winwin.winwin.tags\"></tags-input></div><div class=\"tips\" hide-xs=\"\"><i class=\"fa fa-arrow-up\"></i> Escribí <strong>palabras claves</strong> relacionadas con tu Winwin y que más personas se enteren de lo que querés hacer<br></div></div></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-sm=\"\"><md-checkbox class=\"green\" style=\"background-color: #fff; width:10px;\" ng-model=\"winwin.winwin.terms\" name=\"terms\" ng-change=\"winwin.clearError()\"></md-checkbox><span style=\"font-size: 12px; color: #fff;\">{{ \'He leído y acepto\' | translate }}</span> <a ng-href=\"/#/terms\" target=\"_blank\" translate=\"\" style=\"color: #fff; font-size: 12px;\">los t&eacute;rminos y condiciones.</a><div ng-messages=\"winwin.crearForm1.terms.$error\" class=\"help-block\" ng-if=\"winwin.crearForm1.terms.$error.notTerms\"><p class=\"small\" ng-message=\"notTerms\" translate=\"\">Acept&aacute; los t&eacute;rminos y condiciones.</p></div></md-input-container></div><div layout=\"row\" layout-xs=\"row\"><div flex=\"\"><input type=\"submit\" wz-previous=\"\" value=\"< Volver\" class=\"previous\"></div><div flex=\"\"><input type=\"submit\" ng-if=\"winwin.crearWinwin\" class=\"next\" style=\"background:#00b285; font-family:montserrat;\" value=\"Lanzar Winwin>\" wz-next=\"\" name=\"action\" translate=\"\" aria-label=\"send\"> <button ng-if=\"winwin.editarWinwin\" md-no-ink=\"\" class=\"next\" style=\"background:#00b285; font-family:montserrat;\" ng-disabled=\"winwin.crearForm1.$invalid\" type=\"submit\" wz-next=\"\" name=\"action\" translate=\"\" aria-label=\"send\">{{ \'Actualizar Winwin\' | translate }}</button></div></div></wz-step></wizard></div></form></md-content></div><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div>");
$templateCache.put("app/winwin/mis-winwin.html","<a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><md-tabs md-dynamic-height=\"\" class=\"acme-tabs tabs-mis-winwin\"><md-tab id=\"tab1\"><md-tab-label><span style=\"font-weight: bold\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon>Creados por m&iacute;</span></md-tab-label><md-tab-body><acme-highlighted items=\"winwin.creadospormi\" title=\"winwin.tdestacados\" icon=\"\'icon-highlighted\'\"></acme-highlighted></md-tab-body></md-tab><md-tab id=\"tab2\"><md-tab-label><span style=\"font-weight: bold\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon>En que participo</span></md-tab-label><md-tab-body><acme-highlighted items=\"winwin.enqueparticipo\" title=\"winwin.tpopulares\" icon=\"\'icon-whatshot\'\"></acme-highlighted></md-tab-body></md-tab></md-tabs><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n    \n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/winwin/modal-abandonar.tmpl.html","<div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" class=\"lightbox-abandonar\"><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Estás seguro que deseas abandonar este Winwin?</p></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.left()\" ng-disabled=\"loadingFlag\">Si! Abandonar</md-button><md-button class=\"md-gray\" ng-click=\"vm.cancel()\">No estoy seguro...</md-button></div></div>");
$templateCache.put("app/winwin/modal-agregar-winwin-a-grupo.tmpl.html","<acme-highlighted items=\"winwins\" title=\"winwin.tpopulares\" icon=\"\'icon-whatshot\'\"></acme-highlighted>");
$templateCache.put("app/winwin/modal-campanadas.tmpl.html","<md-dialog-content class=\"dialog-primary campanada\"><div class=\"md-dialog-content\"><h3 class=\"title-notificaction\"><md-icon>notifications</md-icon>{{ \'CAMPANADA ACTIVA\' | translate }}</h3><md-list><md-list-item ng-repeat=\"campanada in vm.campanadas\"><p>{{campanada.body}}</p></md-list-item></md-list><div class=\"campanada-mensaje\" id=\"input-msg\" ng-form=\"\" name=\"campanadaForm\" ng-if=\"vm.is_creator\"><div ng-if=\"(vm.sendMessageStatus == \'Sended\')\" layout=\"column\" layout-align=\"center center\"><md-button aria-label=\"ok\" ng-click=\"close()\"><md-icon class=\"messageSent\" md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><md-input-container class=\"block-mensaje\"><label class=\"placeholder-mensaje\">Ingresa tu mensaje (Maximo 140 caracteres)</label> <textarea ng-required=\"true\" class=\"Mensaje\" name=\"mensaje\" ng-model=\"vm.body\" md-maxlength=\"140\" rows=\"4\" md-select-on-focus=\"\" style=\"border: 1px solid #f1f1f1; width:90%; background: #fff; padding: 20px;\">\n        </textarea><md-button type=\"submit\" name=\"action\" ng-click=\"campanadaForm.$valid && vm.sendMessage()\" class=\"md-raised md-primary bt-green\">Enviar</md-button></md-input-container></div></div></md-dialog-content>");
$templateCache.put("app/winwin/modal-close.tmpl.html","<div layout=\"column\" layout-align=\"center center\" class=\"lightbox-abandonar\"><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Estás seguro que deseas cancelar este Winwin?</p></div><form method=\"post\" ng-submit=\"vm.close()\" name=\"closeForm\"><div flex=\"\"><md-input-container flex=\"\"><label>Contanos tus motivos</label> <textarea name=\"reason\" ng-model=\"vm.reason\" required=\"\" style=\"max-width: 300px;\"></textarea><div ng-messages=\"closeForm.reason.$error\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa un motivo.</p></div></md-input-container></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" type=\"submit\" name=\"action\" ng-disabled=\"loadingFlag\">{{ \'Cancelar Winwin\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cerrar\' | translate }}</md-button></div></form></div>");
$templateCache.put("app/winwin/modal-comment.tmpl.html","<md-card class=\"md-whiteframe-7dp all\"><div ng-if=\"vm.comment.media_type\" class=\"content-img-video\"><md-button ng-click=\"vm.showCropPostImageDialog()\" ng-if=\"vm.comment.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"vm.showModalVideoPostDialog()\" ng-if=\"winwin.comment.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"vm.removeCoverCommentImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"vm.comment.media_type == \'IMAGE\'\" ng-src=\"{{ vm.cover_comment_image.file }}\" style=\"width: 100%; height: 190px;\"> <img ng-if=\"vm.comment.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{vm.comment.media_path}}/hqdefault.jpg\" style=\"width:100%; height: 190px;\"></div></md-card><md-card class=\"md-whiteframe-7dp all\" style=\"background: #5b7dbf;\"><form role=\"form\" ng-submit=\"vm.submitComment()\" name=\"commentForm\"><div style=\"background-color: #fff; margin-top: 5px; margin-bottom: 10px; padding:0px; border: 1px solid #dddfe2\"><div layout=\"row\"><md-input-container style=\"min-height: 80px; max-height: 80px; width: 90%; margin-left: 20px;\"><textarea name=\"content\" ng-model=\"vm.comment.content\" maxlength=\"500\" style=\"font-size: 14px; font-family: montserrat; height: 70px; min-height: 70px; max-height: 71px; width: 100%; float: left; border: 0px;\" rows=\"5\" placeholder=\"Deja un comentario\" md-select-on-focus=\"\">\n          </textarea></md-input-container></div></div><div layout=\"row\" style=\"margin:10px; margin-top:0px;\"><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" aria-label=\"\" type=\"button\" ng-click=\"vm.showModalVideoPostDialog()\"><i class=\"fa fa-youtube\"></i></button></div><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" aria-label=\"\" type=\"button\" ng-click=\"vm.showCropPostImageDialog()\"><i class=\"fa fa-image\"></i></button></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send\" aria-label=\"\" ng-disabled=\"commentForm.$invalid || loadingFlag\" style=\"width:100%; padding: 5px;\"><i class=\"fa fa-paper-plane\"></i></button></div></div></form></md-card><style>\n\n@media (max-width: 320px) {\n\n  .all {\n     max-width: 240px\n      }\n    }\n\n</style>");
$templateCache.put("app/winwin/modal-confirmacion-sumarse.tmpl.html","<div class=\"confirmationBoxContainer\" layout=\"column\" layout-align=\"space-around center\" ng-show=\"vm.status == \'honorCode\'\"><h1><i class=\"fa fa-code animated fadeInDown\"></i><br>C&oacute;digo De Honor</h1><md-dialog-content class=\"confirmationBoxText\"><p>1- Evitá sumarte si no estás seguro!<br><br>2- Si en el proceso no podés<br>participar avisale al creador para que no cuente con vos.<br><br>3- Si pensas que un Winwin va en contra de<br>nuestros t&eacute;rminos y condiciones, reportalo.</p><br><br><div layout=\"row\" layout-xs=\"column\"><div flex=\"\"><md-button ng-click=\"vm.cancel()\" class=\"primary\">LO VOY A PENSAR</md-button></div><div flex=\"\"><md-button ng-click=\"vm.join()\" class=\"bt-green\">SI, ACEPTO!</md-button></div></div></md-dialog-content></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.status == \'success\'\"><md-dialog-content class=\"acme-crearwinwin\" style=\"background-color: #e7e6e6;\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti\"><h1 style=\"color:#585858; text-align: center;\"><i class=\"fa fa-thumbs-o-up animated fadeInUp\" style=\"color: #144a9d\"></i><br>Buenísimo!</h1><p class=\"enfasis-blue\"><span translate=\"\">Te uniste a:</span></p><p style=\"color:#144a9d; font-size: 20px;\"><i><strong>{{vm.winwin.title}}</strong></i></p></div></md-dialog-content></div><div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear\" ng-show=\"vm.status == \'share\'\"><md-dialog-content class=\"acme-crearwinwin\"><div class=\"container\"><div layout=\"column\" layout-align=\"center center\" class=\"comparti\"><h1 style=\"color: #585858; text-align: center; margin-bottom: 5px; margin-top: 0px;\"><i class=\"fa fa-bullhorn animated infinite pulse\"></i><br>Difundí este Winwin</h1><p style=\"text-align: center;\">en las redes sociales y<br><strong><i>sumá personas</i></strong> para concretarlo!</p></div><div layout=\"row\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti-social-media\"><div class=\"fb\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"feed\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-url=\"{{vm.base}}/#/winwin/{{vm.winwinId}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.image}}\" socialshare-via=\"{{vm.facebookId}}\"><md-icon md-svg-src=\"assets/images/icon-facebook-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px; cursor: pointer;\"></md-icon></div><div class=\"tw\" socialshare=\"\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-url=\"{{vm.base}}/#/winwin/{{vm.winwinId}}\" socialshare-provider=\"twitter\"><md-icon md-svg-src=\"assets/images/icon-twitter-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px; cursor: pointer;\"></md-icon></div><div class=\"go\" socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.image}}\" socialshare-url=\"{{vm.base}}/#/winwin/{{vm.winwinId}}\"><md-icon md-svg-src=\"assets/images/icon-google-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px; cursor: pointer;\"></md-icon></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"comparti\" flex-xs=\"100\" flex=\"80\" ng-show=\"!vm.emailsOK\"><br><hr><p style=\"text-align: center;\"><strong>Invitá amigos</strong> a tu Winwin por <strong>email</strong><span style=\"font-size: x-small;\"><br>Apreta enter para agregar cada email.</span></p><div class=\"wrap-md-input-container\"><md-input-container class=\"md-icon-float md-icon-right md-block\" style=\"width: 100%;\"><md-chips ng-model=\"vm.mails\" md-add-on-blur=\"true\" md-on-add=\"vm.validateMail($chip)\" style=\"background: #fff; width: 100%; border: 1px solid #80808066; height: 30px; margin-left: 10px;\"><input type=\"email\" ng-model=\"vm.mail\" length=\"30\" class=\"validate\"></md-chips><span ng-show=\"vm.noEmailsFlag\">Debes ingresar al menos una direcci&oacute;n</span><md-button class=\"md-primary create-winwin-button\" aria-label=\"\" ng-click=\"vm.sentInvitations()\" style=\"width: 100%; background-color: #21ad85; cursor: pointer;\"><md-icon md-svg-src=\"assets/images/icon-send.svg\"></md-icon></md-button></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.emailsOK\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-oks.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\">Las invitaciones fueron enviadas!</p></div></div></div></div></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-edit-winwin-post.tmpl.html","<md-card class=\"md-whiteframe-7dp\"><div ng-if=\"vm.comment.media_type\" class=\"content-img-video\"><img ng-if=\"vm.comment.media_type == \'IMAGE\'\" ng-src=\"{{ vm.cover_comment_image.file }}\" style=\"width: 100%; height: 220px;\"> <img ng-if=\"vm.comment.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{vm.comment.media_path}}/hqdefault.jpg\" style=\"width:100%; height: 220px;\"></div></md-card><md-card class=\"md-whiteframe-7dp\"><form role=\"form\" ng-submit=\"vm.editPost()\" name=\"commentForm\"><div style=\"background-color: #fff; margin-top: 5px; margin-bottom: 10px; padding:0px; border: 1px solid #dddfe2\"><div layout=\"row\"><md-input-container style=\"min-height: 80px; max-height: 80px; width: 90%; margin-left: 20px;\"><textarea name=\"content\" ng-model=\"vm.comment.content\" md-maxlength=\"500\" style=\"font-size: 14px; font-family: montserrat; height: 70px; min-height: 70px; max-height: 71px; width: 100%; float: left; border: 0px;\" rows=\"5\" placeholder=\"Deja un comentario\" md-select-on-focus=\"\">\n          </textarea></md-input-container></div></div><div layout=\"row\" style=\"margin:10px; margin-top:0px;\"><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" aria-label=\"\" type=\"button\" ng-click=\"vm.showModalVideoPostDialog()\"><i class=\"fa fa-youtube\"></i></button></div><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" aria-label=\"\" type=\"button\" ng-click=\"vm.showCropPostImageDialog()\"><i class=\"fa fa-image\"></i></button></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send\" aria-label=\"\" ng-disabled=\"commentForm.$invalid || loadingFlag\" style=\"width:100%; padding: 5px;\"><i class=\"fa fa-paper-plane\"></i></button></div></div></form></md-card><style>\nmd-dialog.md-transition-in {\n width: 100%;\n max-width: 480px;\n}\n</style>");
$templateCache.put("app/winwin/modal-first-post-and-share.tmpl.html","<div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear\" layout-align=\"center center\" ng-show=\"winwin.status == \'post\'\" style=\"background-color: #fff;\"><md-dialog-content class=\"dialog-primary\" style=\"border:0px; background-color: #fff;\"><div class=\"md-dialog-content\"><h2 style=\"text-align: center;\">Primer post de<br><span>{{ winwin.winwinName }}</span></h2><p style=\"text-align: center;\">Sumale emoci&oacute;n a tu winwin con una primera publicacion</p></div><ng-include src=\"\'app/winwin/posteador_dialog.tmpl.html\'\"></ng-include><md-button aria-label=\"\" ng-click=\"winwin.toShareStage()\"><pre> Publicar luego </pre></md-button></md-dialog-content></div><div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear\" ng-show=\"winwin.status == \'share\'\"><md-dialog-content class=\"acme-crearwinwin\"><div class=\"container\" style=\"padding:0px;\"><div layout=\"column\" layout-align=\"center center\" class=\"comparti\"><h1 style=\"text-align: center\">Compartí tu Winwin</h1><p style=\"text-align: center\">en las redes sociales y sumá personas para concretarlo!</p></div><div layout=\"row\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti-social-media\"><div class=\"fb-big\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"share\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/ww/{{winwin.winwinId}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.image}}\" socialshare-via=\"{{winwin.facebookId}}\"><md-icon md-svg-src=\"assets/images/icon-facebook-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px; cursor: pointer;\"></md-icon></div><div class=\"tw-big\" socialshare=\"\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwinId}}\" socialshare-provider=\"twitter\"><md-icon md-svg-src=\"assets/images/icon-twitter-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px; cursor: pointer;\"></md-icon></div><div class=\"gl-big\" socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.image}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwinId}}\"><md-icon md-svg-src=\"assets/images/icon-google-share.svg\" ng-href=\"#\" target=\"_blank\" style=\"height: 60px; width: 60px;cursor: pointer;\"></md-icon></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"comparti\" flex-xs=\"100\" flex=\"80\" ng-show=\"!winwin.emailsOK\"><hr><p style=\"text-align: center;\"><strong>Invitá amigos</strong> a tu Winwin por <strong>email</strong><span style=\"font-size: x-small;\"><br>Apreta enter para agregar cada email.</span></p><div class=\"wrap-md-input-container\"><md-input-container class=\"md-icon-float md-icon-right md-block\"><md-chips ng-model=\"winwin.mails\" md-add-on-blur=\"true\" md-on-add=\"winwin.validateMail($chip)\"><input style=\"background: #fff; border: 1px solid lightgrey\" type=\"email\" ng-model=\"vm.mail\" length=\"30\" class=\"validate\"></md-chips><span ng-show=\"winwin.noEmailsFlag\">Debes ingresar al menos una direcci&oacute;n</span><md-button class=\"md-raised md-primary bt-default\" aria-label=\"\" ng-click=\"winwin.sentInvitations()\" style=\"width: 100%; background-color: #21ad85; cursor: pointer;\"><md-icon md-svg-src=\"assets/images/icon-send.svg\"></md-icon></md-button></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"winwin.emailsOK\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-oks.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\">Las invitaciones fueron enviadas!</p></div></div></div></div></md-dialog-content></div><style type=\"text/css\">\n\n    .dialog-primary {\n    border: 5px solid #e0e0e0;\n max-width: 1000%;\n}\n</style>");
$templateCache.put("app/winwin/modal-galeria.tmpl.html","<div layout=\"column\" class=\"lightbox-crear\"><md-dialog-content><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><h2 translate=\"\">Elegí una imagen de la galería.</h2><div layout=\"row\" layout-margin=\"\" layout-wrap=\"\" class=\"galeria\"><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-1.jpg\" alt=\"Tierra\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-1.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-1.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-2.jpg\" alt=\"Casas\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-2.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-2.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-3.jpg\" alt=\"Manos\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-3.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-3.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-4.jpg\" alt=\"Libros\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-4.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-4.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-5.jpg\" alt=\"Juego\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-5.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-5.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-6.jpg\" alt=\"Gente\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-6.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-6.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-7.jpg\" alt=\"Trabajo\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-7.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-7.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-8.jpg\" alt=\"Oficio\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-8.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-8.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/400x200/smart/ww-default-9.jpg\" alt=\"Colaborar\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'ww-default-9.jpg\'}\" ng-click=\"vm.setImage(\'ww-default-9.jpg\')\"></div><div><img ng-src=\"http://images.dev-winwins.net/winwin_f3ccdd27d2000e3f9255a7e3e2c48800_13.png\" alt=\"Buenos Aires\" class=\"galeria-img\" ng-class=\"{selected: vm.image_gallery_selected == \'winwin_f3ccdd27d2000e3f9255a7e3e2c48800_13.png\'}\" ng-click=\"vm.setImage(\'winwin_f3ccdd27d2000e3f9255a7e3e2c48800_13.png\')\"></div></div></div></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-poll.tmpl.html","<div layout=\"column\" layout-padding=\"\" class=\"modal-encuesta\"><md-dialog-content><h3 class=\"title\">+ {{ \'NUEVA ENCUESTA\' | translate }}</h3><div layout=\"column\" ng-show=\"!vm.pollOk\"><form id=\"create-poll\" role=\"form\" ng-submit=\"vm.submitPoll()\" name=\"pollForm\"><md-input-container class=\"md-block\"><label translate=\"\">Nombre para tu encuesta</label> <input id=\"name\" required=\"\" ng-model=\"vm.poll.name\" name=\"name\"><div ng-messages=\"pollForm.name.$error\" ng-if=\"pollForm.name.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa nombre de la encuesta.</p></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Pregunta/Consigna</label> <input id=\"question\" required=\"\" ng-model=\"vm.poll.question\" name=\"question\"><div ng-messages=\"pollForm.question.$error\" ng-if=\"pollForm.question.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa una Pregunta/Consigna</p></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Opción/Respuesta 1</label> <input id=\"option_1\" required=\"\" ng-model=\"vm.poll.option_1\" name=\"option_1\"><div ng-messages=\"pollForm.option_1.$error\" ng-if=\"pollForm.option_1.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa al menos dos Opciones/Respuestas</p></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Opción/Respuesta 2</label> <input id=\"option_2\" required=\"\" ng-model=\"vm.poll.option_2\" name=\"option_2\"><div ng-messages=\"pollForm.option_2.$error\" ng-if=\"pollForm.option_2.$touched\" class=\"help-block\"><p class=\"small\" ng-message=\"required\" translate=\"\">Ingresa al menos dos Opciones/Respuestas</p></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Opción/Respuesta 3</label> <input id=\"option_3\" ng-model=\"vm.poll.option_3\" name=\"option_3\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Opción/Respuesta 4</label> <input id=\"option_4\" ng-model=\"vm.poll.option_4\" name=\"option_4\"></md-input-container><button type=\"submit\" name=\"action\" ng-disabled=\"pollForm.$invalid || loadingFlag\" translate=\"\" class=\"md-raised md-primary bt-default bt-green\">{{ \'CREAR ENCUESTA\' | translate }}</button></form></div><div layout=\"column\" layout-align=\"center center\" class=\"gracias\" ng-show=\"vm.pollOk\"><div flex=\"\"><md-button aria-label=\"ok\"><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Genial!</h2></div><div flex=\"\"><p class=\"gray font-16\">{{ \'Se creó la encuesta correctamente\' | translate }}</p></div></div></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-remove-poll.tmpl.html","<div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" class=\"lightbox-abandonar\"><div flex=\"\"><md-button class=\"report\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon></md-button></div><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Está seguro que desea eliminar la encuesta?</p></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.removePoll(current_poll)\" ng-disabled=\"loadingFlag\">{{ \'Eliminar\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cancelar\' | translate }}</md-button></div></div>");
$templateCache.put("app/winwin/modal-remove.tmpl.html","<div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" class=\"lightbox-abandonar\"><div flex=\"\"><md-button class=\"report\"><md-icon md-svg-src=\"assets/images/icon-report.svg\"></md-icon></md-button></div><div flex=\"\"><h2 translate=\"\">Atención!</h2></div><div flex=\"\"><p translate=\"\">Está seguro que desea eliminar el post?</p></div><div flex=\"\"><md-button class=\"md-raised md-primary md-green\" ng-click=\"vm.remove()\" ng-disabled=\"loadingFlag\">{{ \'Eliminar\' | translate }}</md-button><md-button class=\"md-raised md-primary md-gray\" ng-click=\"vm.cancel()\">{{ \'Cancelar\' | translate }}</md-button></div></div>");
$templateCache.put("app/winwin/modal-share-email.tmpl.html","<div layout=\"column\" layout-padding=\"\" class=\"lightbox-crear lightbox-email\"><md-dialog-content class=\"acme-crearwinwin\"><div class=\"container\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"comparti\" flex-xs=\"100\" flex=\"80\" ng-show=\"!vm.emailsOK\"><h2 style=\"text-align: center;\"><strong>Invita amigos por email</strong><span style=\"font-size: x-small;\"><br>Apreta enter para agregar cada email.</span></h2><div class=\"wrap-md-input-container\"><md-input-container class=\"md-icon-float md-icon-right md-block\"><md-chips ng-model=\"vm.mails\" md-add-on-blur=\"true\" md-on-add=\"vm.validateMail($chip)\"><input style=\"background: #fff;\" type=\"email\" ng-model=\"vm.mail\" length=\"30\" class=\"validate\"></md-chips><span style=\"font-size: smaller; color: red;\" ng-show=\"vm.noEmailsFlag\">Debes ingresar al menos una direcci&oacute;n</span><md-button class=\"md-raised md-primary bt-default\" aria-label=\"\" ng-click=\"vm.sentInvitations()\" style=\"width: 100%; background-color: #21ad85; cursor: pointer;\"><md-icon md-svg-src=\"assets/images/icon-send.svg\"></md-icon></md-button></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.emailsOK\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-oks.svg\" class=\"s44\"></md-icon></md-button></div><div flex=\"\"><p class=\"gray\">Las invitaciones fueron enviadas!</p></div></div></div></div></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-share-post.tmpl.html","<div layout=\"column\" class=\"lightbox-crear\"><md-dialog-content class=\"acme-crearwinwin acme-share-post\" style=\"max-height: 130px; overflow: hidden;\"><div layout=\"row\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti-social-media\"><div socialshare=\"\" socialshare-provider=\"facebook\" socialshare-text=\"{{vm.post.content}}\" socialshare-url=\"{{vm.base}}/ww-post/{{vm.post.id}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.post.media.name}}\" socialshare-via=\"{{vm.facebookId}}\"><md-icon md-svg-src=\"assets/images/icon-facebook-share.svg\" ng-href=\"#\" target=\"_blank\" class=\"fb\" style=\"height:60px; width:60px;\"></md-icon></div><div socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"{{vm.post.content}}\" socialshare-url=\"{{vm.base}}/ww-post/{{vm.post.id}}\"><md-icon md-svg-src=\"assets/images/icon-twitter-share.svg\" ng-href=\"#\" target=\"_blank\" class=\"tw\" style=\"height:60px; width:60px;\"></md-icon></div><div socialshare=\"\" socialshare-provider=\"google+\" socialshare-text=\"{{vm.post.content}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.post.media.name}}\" socialshare-url=\"{{vm.base}}/ww-post/{{vm.post.id}}\"><md-icon md-svg-src=\"assets/images/icon-google-share.svg\" ng-href=\"#\" target=\"_blank\" class=\"go\" style=\"height:60px; width:60px;\"></md-icon></div></div></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-video-post.tmpl.html","<div layout=\"column\" class=\"lightbox-crear crear-video\"><md-dialog-content><form role=\"form\" ng-submit=\"vm.setVideo()\" name=\"videoForm\"><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><h2 translate=\"\">Copia el link del video</h2><img ng-show=\"vm.video_path\" ng-src=\"http://img.youtube.com/vi/{{vm.video_path}}/hqdefault.jpg\" style=\"height:190px;\"><md-input-container class=\"md-block\"><input required=\"\" name=\"video\" ng-model=\"vm.video\" placeholder=\"Ej: https://www.youtube.com/watch?v=rQxVTFVWNjA\" ng-paste=\"vm.previewVideo($event)\"><div ng-messages=\"videoForm.video.$error\"><div ng-message=\"required\" translate=\"\">Copia y pega el link del video.</div></div></md-input-container><div><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" type=\"submit\" name=\"action\" translate=\"\">Cargar</md-button><md-button class=\"md-raised md-grey\" ng-click=\"vm.cancel()\" translate=\"\">Cancelar</md-button></md-card-actions></div></div></form></md-dialog-content></div>");
$templateCache.put("app/winwin/modal-vincular-winwin-a-grupo.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\"><h3 class=\"title\">{{ \'GRUPOS\' | translate }}</h3><md-list class=\"participantes-list\"><md-list-item ng-repeat=\"grupo in vm.group_list\"><img alt=\"\" ng-src=\"{{vm.imageServer}}/smart/{{grupo.photo}}\" class=\"md-avatar\"><p>{{ grupo.name }}</p><md-button ng-show=\"participante.pivot.moderator == 0 && vm.is_moderator\" class=\"md-raised md-warn md-caption\" ng-click=\"\">Agregar grupo</md-button></md-list-item></md-list></div></md-dialog-content>");
$templateCache.put("app/winwin/participantes.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content\" ng-show=\"!vm.activator_success && !vm.normal_success\"><h3 class=\"title\" style=\"background-color: rgb(46, 68, 107); padding: 20px; margin-top: -25px; margin-left: -30px; margin-right: -23px; color: white; font-size: 21px; text-align: center;\">{{ \'Se sumaron a este winwin\' | translate }}</h3><md-list class=\"participantes-list\"><md-list-item ng-repeat=\"participante in vm.users | orderBy:\'username\'\"><img alt=\"\" ng-src=\"{{vm.imageServer}}/smart/{{participante.photo}}\" ui-sref=\"home.public-profile({userId: participante.id})\" class=\"md-avatar\"> <a href=\"\" style=\"font-size: 12px; color: #595959; text-decoration: none; text-transform: capitalize;\" ui-sref=\"home.public-profile({userId: participante.id})\">{{participante.username}}</a></md-list-item></md-list></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"vm.activator_success\" ng-click=\"vm.activator_success = false\"><div layout=\"column\" layout-align=\"center center\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Buenísimo!</h2></div><div flex=\"\"><p class=\"font-16\">Nombraste activador a <span class=\"blue\">{{vm.activated_name}}</span></p></div></div></div><div class=\"md-dialog-content md-dialog-ok\" ng-show=\"vm.normal_success\" ng-click=\"vm.normal_success = false\"><div layout=\"column\" layout-align=\"center center\"><div flex=\"\"><md-button><md-icon md-svg-src=\"assets/images/icon-ok.svg\"></md-icon></md-button></div><div flex=\"\"><h2 class=\"gray\" translate=\"\">Buenísimo!</h2></div><div flex=\"\"><p class=\"font-16\">Nombraste usuario regular a <span class=\"blue\">{{vm.activated_name}}</span></p></div></div></div></md-dialog-content>");
$templateCache.put("app/winwin/posteador_desktop.tmpl.html","<form role=\"form\" ng-submit=\"!winwin.submitPost()\" name=\"postForm\" hide-xs=\"\" ng-if=\"winwin.winwin.already_joined\" style=\"max-width: 520px;\"><md-card class=\"md-whiteframe-7dp\" style=\"background: #5b7dbf;\"><md-card class=\"md-whiteframe-7dp\" ng-if=\"winwin.winwin.already_joined\"><div class=\"\" ng-show=\"winwin.show_box_muro\" ng-if=\"winwin.winwin.already_joined && !winwin.winwin.canceled\"><div ng-if=\"winwin.post.media_type\" class=\"content-img-video\"><md-button ng-click=\"winwin.showCropPostImageDialog()\" ng-if=\"winwin.post.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.showModalVideoPostDialog()\" ng-if=\"winwin.post.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.removeCoverPostImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"winwin.post.media_type == \'IMAGE\'\" ng-src=\"{{ winwin.post.cover_post_image.file }}\" style=\"width: 100%;\"> <img ng-if=\"winwin.post.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{winwin.post.media_path}}/hqdefault.jpg\" style=\"width:100%;\"></div></div></md-card><div style=\"background-color: #fff; margin-top: 5px; margin-bottom: 10px; padding:0px; border: 1px solid #dddfe2\"><div layout=\"row\"><div flex=\"\"><md-input-container style=\"min-height: 80px; max-height: 80px; width: 90%; margin-left: 20px;\"><textarea name=\"content\" id=\"post-input-focus\" ng-model=\"winwin.post.content\" md-maxlength=\"500\" style=\"height: 70px; min-height: 70px; max-height: 71px; width: 100%; float: left; border: 0px;\" rows=\"5\" placeholder=\"Deja un comentario\">\n          </textarea></md-input-container></div></div></div><div layout=\"row\" style=\"margin:10px; margin-top:0px;\"><div flex=\"30\"><button style=\"padding: 10px;width:100%;padding: 5px; border-radius: 3px;\" type=\"button\" ng-click=\"winwin.showModalVideoPostDialog()\"><i class=\"fa fa-youtube\" style=\"font-size: 30px;padding: 5px; color: #666;\"></i></button><md-tooltip md-visible=\"video.showTooltip\" md-direction=\"down\">Inserta un video de Youtube a tu post</md-tooltip></div><div flex=\"30\"><button style=\"padding: 10px;width:100%;padding: 5px; border-radius: 3px;\" type=\"button\" ng-click=\"winwin.showCropPostImageDialog()\"><i class=\"fa fa-image\" style=\"font-size: 30px;padding: 5px; color: #666;\"></i></button><md-tooltip md-visible=\"imagen.showTooltip\" md-direction=\"down\">Agrega una imagen a tu post</md-tooltip></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send bt-default\" aria-label=\"\" ng-disabled=\"postForm.$invalid || loadingFlag\" style=\"width:100%; padding: 5px;\"><i class=\"fa fa-paper-plane\"></i></button><md-tooltip md-visible=\"enviar.showTooltip\" md-direction=\"down\">Enviar</md-tooltip></div></div></md-card></form>");
$templateCache.put("app/winwin/posteador_dialog.tmpl.html","<form role=\"form\" ng-submit=\"!winwin.submitPost()\" name=\"postForm\" ng-if=\"winwin.winwin.already_joined\" style=\"max-width: 400px;\"><md-card class=\"md-whiteframe-7dp all\" style=\"background: #5b7dbf;\"><md-card class=\"md-whiteframe-7dp all\" ng-if=\"winwin.winwin.already_joined\"><div class=\"\" ng-show=\"winwin.show_box_muro\" ng-if=\"winwin.winwin.already_joined && !winwin.winwin.canceled\"><div ng-if=\"winwin.post.media_type\" class=\"content-img-video\"><md-button ng-click=\"winwin.showCropPostImageDialog()\" ng-if=\"winwin.post.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.showModalVideoPostDialog()\" ng-if=\"winwin.post.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.removeCoverPostImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"winwin.post.media_type == \'IMAGE\'\" ng-src=\"{{ winwin.post.cover_post_image.file }}\" style=\"width: 100%;\"> <img ng-if=\"winwin.post.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{winwin.post.media_path}}/hqdefault.jpg\" style=\"width:100%;\"></div></div></md-card><div style=\"background-color: #fff; margin-top: 5px; margin-bottom: 10px; padding:0px; border: 1px solid #dddfe2\"><div layout=\"row\"><div flex=\"\"><md-input-container style=\"min-height: 80px; max-height: 80px; width: 90%; margin-left: 20px;\"><textarea name=\"content\" id=\"post-input-focus\" ng-model=\"winwin.post.content\" md-maxlength=\"500\" style=\"height: 70px; min-height: 70px; max-height: 71px; width: 100%; float: left; border: 0px;\" rows=\"5\" placeholder=\"Deja un comentario\">\n          </textarea></md-input-container></div></div></div><div layout=\"row\" style=\"margin:10px; margin-top:0px;\"><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" type=\"button\" ng-click=\"winwin.showModalVideoPostDialog()\"><i class=\"fa fa-youtube\"></i></button><md-tooltip md-visible=\"video.showTooltip\" md-direction=\"down\">Inserta un video de Youtube a tu post</md-tooltip></div><div flex=\"30\"><button style=\"width:100%;padding: 5px;\" type=\"button\" ng-click=\"winwin.showCropPostImageDialog()\"><i class=\"fa fa-image\"></i></button><md-tooltip md-visible=\"imagen.showTooltip\" md-direction=\"down\">Agrega una imagen a tu post</md-tooltip></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send\" aria-label=\"\" ng-disabled=\"postForm.$invalid || loadingFlag\" style=\"width:100%; padding: 5px;\"><i class=\"fa fa-paper-plane\"></i></button><md-tooltip md-visible=\"enviar.showTooltip\" md-direction=\"down\">Enviar</md-tooltip></div></div></md-card></form>");
$templateCache.put("app/winwin/posteador_mobile.tmpl.html","<form role=\"form\" ng-submit=\"!winwin.submitPost()\" name=\"postForm\" ng-if=\"winwin.winwin.already_joined\" hide=\"\" show-xs=\"\" ng-show=\"winwin.show_box_muro\"><md-card class=\"md-whiteframe-7dp\" style=\"background: #5b7dbf; position: fixed; bottom:0px; width: 100%; margin: 0;\"><md-card class=\"md-whiteframe-7dp no-margin\" ng-if=\"winwin.winwin.already_joined\"><div class=\"\" ng-show=\"winwin.show_box_muro\" ng-if=\"winwin.winwin.already_joined && !winwin.winwin.canceled\"><div ng-if=\"winwin.post.media_type\" class=\"content-img-video\"><md-button ng-click=\"winwin.showCropPostImageDialog()\" ng-if=\"winwin.post.media_type == \'IMAGE\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.showModalVideoPostDialog()\" ng-if=\"winwin.post.media_type == \'VIDEO\'\" class=\"editarpost\" title=\"editar\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-click=\"winwin.removeCoverPostImageOrVideo()\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><img ng-if=\"winwin.post.media_type == \'IMAGE\'\" ng-src=\"{{ winwin.post.cover_post_image.file }}\" style=\"width: 100%;\"> <img ng-if=\"winwin.post.media_type == \'VIDEO\'\" ng-src=\"http://img.youtube.com/vi/{{winwin.post.media_path}}/hqdefault.jpg\" style=\"width:100%;\"></div></div></md-card><div><div layout=\"row\" style=\"max-height: 65px;\"><div flex=\"65\"><md-input-container style=\"min-height: 40px; max-height: 40px; margin: 3px; width: 97%\"><textarea name=\"content\" id=\"post-input-focus\" ng-model=\"winwin.post.content\" maxlength=\"500\" style=\"border-radius: 2px;background: #fff; max-height:45px; width: 100%; float: left; border: 0px;\" rows=\"5\">\n          </textarea></md-input-container></div><div flex=\"15\"><div layout=\"column\"><div flex=\"30\"><button type=\"button\" ng-click=\"winwin.showModalVideoPostDialog()\" style=\"width: 95%; height: 90%; margin: 3px; margin-bottom:0px;\"><i class=\"fa fa-youtube\"></i></button></div><div flex=\"30\"><button type=\"button\" ng-click=\"winwin.showCropPostImageDialog()\" style=\"width: 95%; height: 90%; margin: 3px; margin-top:0px;\"><i class=\"fa fa-image\"></i></button></div></div></div><div flex=\"\"><button type=\"submit\" name=\"action\" class=\"send\" aria-label=\"\" ng-disabled=\"postForm.$invalid || loadingFlag\" style=\"width:90%; height:92%; float: right; margin: 3px;\"><i class=\"fa fa-paper-plane\"></i></button><md-tooltip md-visible=\"enviar.showTooltip\" md-direction=\"down\">Enviar</md-tooltip></div></div></div></md-card></form>");
$templateCache.put("app/winwin/request-sponsorship-modal-controller.tmpl.html","<md-dialog aria-label=\"List dialog\" style=\"width: 420px; overflow-x:hidden; background: #f4f4f4;\"><md-dialog-content><h3 class=\"modal-title\">SE SPONSOR DE ESTE WINWIN</h3><div layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.sendMessageStatus == notSended\"><div ng-form=\"\" name=\"reqSponsorController.reqSponsorForm\"><div ng-if=\"(reqSponsorController.sendMessageStatus == \'Sended\')\" layout=\"column\" layout-align=\"center center\" style=\"margin: 30px;\"><label translate=\"\">&iexcl;Gracias! Se envi&oacute; tu solicitud al creador del winwin.</label></div><md-input-container class=\"md-block\"><label translate=\"\">Organizaci&oacute;n</label> <input class=\"input\" required=\"\" name=\"org\" ng-model=\"reqSponsorController.org\" style=\"width: 300px; background-color: #fff; height:40px;\"><div ng-messages=\"reqSponsorController.reqSponsorForm.org.$error\" ng-show=\"reqSponsorController.reqSponsorForm.org.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Campo requerido</div></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Nombre del contacto</label> <input class=\"input\" required=\"\" name=\"nombre\" ng-model=\"reqSponsorController.contact\" style=\"width: 300px; background-color: #fff; height:40px;\"><div ng-messages=\"reqSponsorController.reqSponsorForm.nombre.$error\" ng-show=\"reqSponsorController.reqSponsorForm.nombre.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Campo requerido</div></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Tel&eacute;fono</label> <input class=\"input\" required=\"\" name=\"tel\" ng-model=\"reqSponsorController.tel\" style=\"width: 300px; background-color: #fff; height:40px;\"><div ng-messages=\"reqSponsorController.reqSponsorForm.tel.$error\" ng-show=\"reqSponsorController.reqSponsorForm.tel.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Campo requerido</div></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"\">Email</label> <input class=\"input\" required=\"\" type=\"email\" name=\"email\" ng-model=\"reqSponsorController.email\" style=\"width: 300px; background-color: #fff; height:40px;\"><div ng-messages=\"reqSponsorController.reqSponsorForm.email.$error\" ng-show=\"reqSponsorController.reqSponsorForm.email.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Campo requerido</div></div><div ng-message=\"email\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> No es una direcci&oacute;n de email v&aacute;lida</div></div></div></md-input-container><md-input-container class=\"block-mensaje\"><label class=\"placeholder-mensaje\">Mensaje</label> <textarea class=\"input\" ng-required=\"true\" name=\"mensaje\" ng-model=\"reqSponsorController.mensaje\" md-maxlength=\"140\" rows=\"4\" md-select-on-focus=\"\" style=\"width: 300px; background-color: #fff; height:40px;\"> \n          </textarea><div ng-messages=\"reqSponsorController.reqSponsorForm.mensaje.$error\" ng-show=\"reqSponsorController.reqSponsorForm.mensaje.$dirty\"><div ng-message=\"required\" translate=\"\"><div class=\"error\"><i class=\"fa fa-exclamation-circle animated infinite flash\" aria-hidden=\"true\"></i> Campo requerido</div></div></div><button name=\"action\" ng-click=\"reqSponsorController.sendMessage()\" translate=\"\" class=\"md-raised md-primary bt-default\">ENVIAR</button></md-input-container></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/winwin/sponsors.tmpl.html","<div layout-align=\"left\" layout=\"column\"><div class=\"sponsors\" hide-xs=\"\"><div layout=\"column\" style=\"width: 250px; max-width: 250px;\"><div><div style=\"text-align: center;margin-top:10px;\"><h3>Te pueden interesar...</h3><br><a href=\"http://winwins.org/#/winwin/12\" target=\"_blank\"><img src=\"https://i.ytimg.com/vi/XiTP8WjJaj4/sddefault.jpg\" style=\"width: 250px; max-width: 250px; margin-bottom: 10px\"></a> <a href=\"http://winwins.org/#/winwin/12\" style=\"font-weight: bold; color: #333; text-transform: uppercase; text-decoration: none; text-align: center\" target=\"_blank\"><h3>Separemos los residuos ya!</h3></a><div><div><a href=\"http://winwins.org/#/winwin/32\" target=\"_blank\"><img src=\"http://images.winwins.org/400x/smart/post_28cc1ca7f4496aadc8ebd1afd4f95624_129.png\" style=\"width: 250px; max-width: 250px; margin-bottom: 10px\"></a> <a href=\"http://winwins.org/#/winwin/32\" style=\"font-weight: bold; color: #333; text-transform: uppercase; text-decoration: none; text-align: center\" target=\"_blank\"><h3>Bicireparadores</h3></a><div><a href=\"http://winwins.org/#/winwin/51\" target=\"_blank\"><img src=\"https://i.ytimg.com/vi/BiFTS6N7LJg/maxresdefault.jpg\" style=\"width: 250px; max-width: 250px;margin-bottom: 10px\"></a> <a href=\"http://winwins.org/#/winwin/51\" style=\"font-weight: bold; color: #333; text-transform: uppercase; text-decoration: none; text-align: center\" target=\"_blank\"><h3>Haciendo compost</h3></a></div><div><div><a href=\"http://winwins.org/#/winwin/54\" target=\"_blank\"><img src=\"http://images.winwins.org/400x/smart/post_9263ab047e011a27ef3b47cd95776c3f_181.png\" style=\"width: 250px; max-width: 250px;margin-bottom: 10px\"></a> <a href=\"http://winwins.org/#/winwin/54\" style=\"font-weight: bold; color: #333; text-transform: uppercase; text-decoration: none; text-align: center\" target=\"_blank\"><h3>Rescate de Alimentos</h3></a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/winwin/ver-mas-detalle.tmpl.html","<md-dialog-content class=\"dialog-primary\"><div class=\"md-dialog-content more-details-dialog\"><span class=\"more-details\" ng-bind-html=\"sanitized_description\"></span> <span class=\"more-details\">{{winwin.what_happen}}</span></div></md-dialog-content>");
$templateCache.put("app/winwin/winwin-left-sidebar.tmpl.html","<div layout=\"column\"><div class=\"content-bg\" ng-if=\"winwin.winwin.already_joined && (winwin.isCreator || winwin.campanadas.length > 0)\"><h3 class=\"title-notificaction\"><md-icon>notifications</md-icon><span class=\"badge\" ng-show=\"(winwin.campanadas | filter:{is_read:0}).length > 0\">{{(winwin.campanadas | filter:{is_read:0}).length }}</span><md-button ng-if=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.showCampanadasDialog()\">Campanada activa!</md-button><md-button ng-if=\"winwin.winwin.is_moderator\" ng-click=\"winwin.showCampanadasDialog()\">Enviar campanada</md-button></h3></div><div style=\"margin-bottom: 5px; border-top: 2px solid #f60\"><div ng-if=\"winwin.isAuthenticated()\"><md-card class=\"inbox-title\" ng-if=\"!winwin.showSendMessageButton() && winwin.isCreator\">Mensajes con los participantes:</md-card><md-card class=\"inbox-title\" ng-if=\"!winwin.showSendMessageButton() && !winwin.isCreator\">Mensajes con el creador del Winwin:</md-card><div class=\"mensajes-recibidos-content\" ng-repeat=\"cnv in winwin.conversations\"><div ng-repeat=\"message in cnv.messages\"><div class=\"mensajeria\" layout=\"row\" ng-click=\"winwin.showMessageModal(cnv.id, cnv.messages)\" ng-if=\"$last\" layout-align=\"space-around-end\"><img ng-src=\"{{winwin.imageServer}}/{{cnv.show_avatar[0]}}\" alt=\"\" class=\"avatar-creador-mensajeria\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><p class=\"msg-body\">{{ message.body }}</p><p class=\"msg-name\">{{message.name}}</p></div></div><md-card class=\"inbox-title\" ng-if=\"!winwin.showSendMessageButton() && winwin.conversations.length == 0\"><div class=\"sin-mensajes\">No hay mensajes...</div></md-card></div></div></div><md-card style=\"margin:0px;\"><div flex=\"\"><md-button ng-href=\"\" aria-label=\"facebook\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"share\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/ww/{{winwin.winwin.id}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-via=\"{{winwin.facebookId}}\" class=\"md-primary\" style=\"color: #fff; background: #3b5998; width:95%;\"><i class=\"fa fa-facebook\"></i> Difundir en Facebook</md-button><md-tooltip md-visible=\"other.showTooltip\" md-direction=\"right\">Comparti en Facebook y ayudas a difundir este Winwin!</md-tooltip></div><div flex=\"\"><md-button socialshare=\"\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-provider=\"twitter\" class=\"md-primary\" style=\"color: #fff; background: #4099FF; width:95%;\"><i class=\"fa fa-twitter\"></i> Difundir en Twitter</md-button><md-tooltip md-visible=\"twitter.showTooltip\" md-direction=\"right\">Comparti a tu red de Twitter y potencia este Winwin</md-tooltip></div><div flex=\"\"><md-button socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" class=\"md-primary\" style=\"color: #fff; background: #d34836; width:95%;\"><i class=\"fa fa-google\"></i> Difundir en Google +</md-button><md-tooltip md-visible=\"google.showTooltip\" md-direction=\"right\">Comparti en Google+!</md-tooltip></div><div flex=\"\" ng-hide=\"winwin.winwin.outdated\"><md-button ng-click=\"winwin.showModalShareEmailDialog()\" class=\"md-primary\" style=\"color: #fff; background: orange; width:95%;\"><i class=\"fa fa-envelope-o\"></i> Invitar por Email</md-button><md-tooltip md-visible=\"email.showTooltip\" md-direction=\"right\">Envia emails con 1 clic para invitar a tus amigos.</md-tooltip></div><div flex=\"\" ng-hide=\"winwin.winwin.outdated\"><md-button class=\"md-primary\" style=\"color: #fff; background: #666; width:95%\" ng-show=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.showRequestSponsorshipMessageModal()\">Solicitar ser Sponsor</md-button><md-tooltip md-visible=\"sponsor.showTooltip\" md-direction=\"right\">Se sponsor y recibi beneficios</md-tooltip></div><div flex=\"\"><md-button class=\"md-primary\" style=\"color: #fff; background: #f60; width:95%\" ng-show=\"winwin.winwin.is_moderator\" ng-href=\"\" ng-click=\"winwin.showModalPollDialog()\"><i class=\"fa fa-list-ol\" aria-hidden=\"true\"></i> Crear una encuesta</md-button><md-tooltip md-visible=\"encuesta.showTooltip\" md-direction=\"right\">Crea una encuesta para los participantes</md-tooltip></div></md-card><md-card style=\"margin:0px;\"><div class=\"content-bg\" ng-if=\"!winwin.winwin.is_successful && winwin.winwin.already_joined && !winwin.winwin.canceled && !winwin.winwin.is_creator\" style=\"margin-left:10px;\"><p><md-button ng-href=\"\" ng-click=\"winwin.left()\" class=\"no-padding\"><md-icon md-svg-src=\"assets/images/icon-entrar.svg\"></md-icon>Abandonar este Winwin</md-button></p></div><div class=\"content-bg\" ng-if=\"winwin.winwin.is_creator && !winwin.winwin.canceled\" style=\"margin-left:10px;\"><p><md-button ng-href=\"\" ng-click=\"winwin.close()\" class=\"no-padding\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i> Cancelar Winwin</md-button></p></div><div class=\"content-bg\"><p><div ng-href=\"\" ng-click=\"winwin.reportWinwin()\" class=\"no-padding\" style=\"margin-left:10px;\"><p style=\"font-family: lato; cursor: pointer; margin: 10px\"><i class=\"fa fa-exclamation-circle danger\"></i> Reportar este Winwin</p><md-tooltip md-visible=\"reportar.showTooltip\" md-direction=\"down\">Este winwin incumple nuestros terminos? Reportalo.</md-tooltip></div></p></div></md-card><md-list ng-cloak=\"\" style=\"margin:0px;\"><md-list-item ui-sref=\"home.public-profile({userId: participante.id})\" ng-repeat=\"participante in winwin.winwin.users | limitTo: 10 | orderBy: \'username\'\" style=\"background: #fff; border-radius: 3px; margin: 0 5px 0 0;\"><img ng-src=\"{{winwin.imageServer}}/smart/{{participante.photo}}\" alt=\"\" class=\"md-avatar\" ui-sref=\"home.public-profile({userId: participante.id})\"> <a href=\"\" style=\"font-size: 12px; color: #595959; text-decoration: none; text-transform: capitalize;\" ui-sref=\"home.public-profile({userId: participante.id})\">{{participante.username}}</a></md-list-item><md-list-item class=\"md-no-proxy\" style=\"padding:0px\"><md-button ng-href=\"\" class=\"ver-todos\" ng-click=\"winwin.showParticipantesDialog()\" ng-show=\"!winwin.winwin.is_moderator\"><strong>+</strong> Ver todos los participantes</md-button><md-button ng-href=\"\" class=\"ver-todos\" ng-click=\"winwin.showParticipantesDialog()\" ng-show=\"winwin.winwin.is_moderator\"><strong>+</strong> Ver y Definir Roles</md-button><md-tooltip md-visible=\"roles.showTooltip\" md-direction=\"right\">Selecciona participantes activadores y regulares</md-tooltip></md-list-item></md-list></div>");
$templateCache.put("app/winwin/winwin-list.html","<section class=\"acme-listado\" infinite-scroll=\"winwin.nextPage()\"><div class=\"menu-caterogias\" hide=\"\" show-gt-sm=\"\"></div><md-tabs md-dynamic-height=\"\" class=\"acme-tabs\" style=\"position:relative; margin-top:10px;box-shadow: 2px 2px 5px #1f3465;\">-<md-tab id=\"tab1\" ng-click=\"winwin.doFilter(\'last\')\"><md-tab-label><i class=\"fa fa-clock-o\" style=\"color: #fff; font-size: 20px;\"></i><br>{{\'Recientes\' | translate }}</md-tab-label>--><md-tab-body></md-tab-body></md-tab><md-tab id=\"tab2\" ng-click=\"winwin.doFilter(\'select\')\"><md-tab-label><md-icon>bookmark</md-icon>{{\'Destacados\' | translate }}</md-tab-label>--><md-tab-body></md-tab-body></md-tab><md-tab id=\"tab3\" ng-click=\"winwin.doFilter(\'popular\')\"><md-tab-label><md-icon>whatshot</md-icon>{{ \'Populares\' | translate }}</md-tab-label><md-tab-body></md-tab-body></md-tab><md-tab id=\"tab4\" ng-click=\"winwin.doFilter(\'finishing\')\"><md-tab-label><md-icon md-svg-src=\"assets/images/icon-tab-por-terminar.svg\"></md-icon>{{\' Por terminar\' | translate }}</md-tab-label><md-tab-body></md-tab-body></md-tab><md-tab id=\"tab5\" ng-click=\"winwin.doFilter(\'success\')\"><md-tab-label><i class=\"fa fa-child\" style=\"color: #fff; font-size: 20px;\"></i><br>{{\'Concretados\' | translate }}</md-tab-label><md-tab-body></md-tab-body></md-tab></md-tabs><acme-highlighted items=\"winwin.winwins\" title=\"winwin.destacadosTitle\" icon=\"\'icon-concretados\'\" loading=\"winwin.loadingDestacados\"></acme-highlighted><a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n\n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script></section>");
$templateCache.put("app/winwin/winwin-wall.tmpl.html","<div class=\"comments\" style=\"max-width: 520px;\"><md-card class=\"md-whiteframe-7dp\" ng-if=\"!winwin.winwin.already_joined\" style=\"padding:20px; color: #555\"><span ng-bind-html=\"winwin.sanitized_description\"></span></md-card><div class=\"notice-message\" ng-if=\"winwin.winwin.canJoin && winwin.posts.length == 0\">Sumate y s&eacute; el primero en publicar un post.</div><div class=\"notice-message\" ng-if=\"winwin.winwin.already_joined && winwin.posts.length == 0\">S&eacute; el primero en publicar un post.</div><div class=\"row\" ng-if=\"winwin.winwin.already_joined\" ng-repeat=\"poll in winwin.polls\"><md-card class=\"md-whiteframe-7dp\" ng-show=\"!poll.data.has_answered && winwin.winwin.already_joined\"><div class=\"card-labels\"><md-button ng-if=\"winwin.winwin.is_moderator\" ng-click=\"winwin.showRemovePoll(poll)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></div><md-card-content class=\"encuesta\"><span class=\"card-title center\"><h4>{{poll.question}}</h4></span><ul class=\"collection\"><li class=\"collection-item dismissable black-text\" ng-repeat=\"answer in poll.data.answers\"><div><md-progress-linear md-mode=\"determinate\" value=\"{{winwin.percentage_votes(poll, answer)}}\"></md-progress-linear><span class=\"h7 grey-text\">{{answer.content}}</span> <span class=\"secondary-content\"><input class=\"with-gap\" name=\"poll_{{poll.id}}\" type=\"radio\" ng-value=\"answer.id\" ng-checked=\"poll.selected_answer\" ng-model=\"poll.selected_answer\"></span></div></li></ul></md-card-content><button class=\"btn-large bt-green col-xs-12\" ng-click=\"winwin.votePoll(poll)\">Votar</button></md-card><md-card class=\"md-whiteframe-7dp\" ng-show=\"poll.data.has_answered || !winwin.winwin.already_joined\"><div class=\"card-labels\"><md-button ng-if=\"winwin.winwin.already_joined\" ng-click=\"winwin.showRemovePoll(poll)\" class=\"md-icon-button\" aria-label=\"eliminar\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button></div><md-card-content class=\"encuesta\"><span class=\"card-title center\"><h4>{{poll.question}}</h4></span><ul class=\"collection\"><div ng-repeat=\"answer in poll.data.answers\"><div class=\"progress\"><md-progress-linear md-mode=\"determinate\" value=\"{{winwin.percentage_votes(poll, answer)}}\"></md-progress-linear></div><li class=\"collection-item dismissable black-text\"><div><span class=\"h7 grey-text\">{{answer.content}}</span> <strong class=\"badge green white-text\">{{answer.vote_count}}</strong></div></li></div></ul></md-card-content></md-card></div><div ng-repeat=\"item_post in winwin.posts\"><md-card class=\"md-whiteframe-7dp\"><div class=\"card-labels\"><md-button ng-if=\"(winwin.winwin.is_moderator || item_post.user.id == winwin.account.id)\" ng-click=\"winwin.showEditDialog(item_post)\" class=\"editarpost\" title=\"editar post\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button><md-button ng-if=\"(winwin.winwin.is_moderator || item_post.user.id == winwin.account.id)\" ng-click=\"winwin.removePost(item_post)\" class=\"editarpost\" aria-label=\"eliminar\" title=\"eliminar post\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><md-button ng-if=\"(winwin.winwin.is_moderator && item_post.sticky==1) || item_post.sticky==1\" ng-disabled=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.setSticky(item_post, false)\" class=\"md-icon-button\" aria-label=\"highlighted on\"><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\"></md-icon><md-tooltip md-visible=\"featured.showTooltip\" md-direction=\"down\">Quitar Destacado</md-tooltip></md-button><md-button ng-if=\"winwin.winwin.is_moderator && item_post.sticky==0\" ng-click=\"winwin.setSticky(item_post, true)\" class=\"md-icon-button\" aria-label=\"highlighted off\"><md-icon class=\"icon icon-highlighted icon-off\" md-svg-src=\"assets/images/icon-highlighted-off.svg\"></md-icon><md-tooltip md-visible=\"unfeatured.showTooltip\" md-direction=\"down\">Destacar Post</md-tooltip></md-button></div><md-card-header style=\"border-bottom: 1px solid #f1f1f1; padding: 10px;\"><md-card-avatar><img class=\"md-user-avatar\" ng-src=\"{{winwin.imageServer}}/38x38/{{item_post.user.photo}}\" ui-sref=\"home.public-profile({userId: item_post.user.id})\"></md-card-avatar><md-card-header-text><span style=\"text-transform: capitalize\">{{item_post.user.username}}</span></md-card-header-text></md-card-header><md-card-content style=\"border-bottom: 1px solid #f1f1f1\"><div ng-if=\"item_post.post_edit.length == 0\"><p>{{item_post.content}}</p></div><div ng-repeat=\"post in item_post.post_edit\" ng-show=\"$first\"><p>{{post.content}}</p></div><div ng-show=\"item_post.media.type == \'IMAGE\'\" class=\"materialboxed _embed-responsive _embed-responsive-16by9\" style=\"width:100%; margin-top:10px; margin-bottom:10px; background:linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));\"><img ng-src=\"{{winwin.imageServer}}/400x/smart/{{item_post.media.name}}\" class=\"img-responsive\"></div><div ng-show=\"item_post.media.type == \'VIDEO\'\" class=\"embed-responsive embed-responsive-16by9\" style=\"margin-top:30px;\"><iframe class=\"embed-responsive-item\" ng-src=\"{{winwin.getIframeSrc(item_post.media.path)}}\" allowfullscreen=\"\" style=\"width: 100%;height: 225px\"></iframe></div></md-card-content><md-card-actions layout=\"row\" layout-margin=\"\" layout-align=\"start end\" style=\"padding: 5px;\"><div><md-icon class=\"icon icon-access_time\">access_time</md-icon>{{item_post.created_at | moment: \'DD/MM/YYYY\' }}</div><div class=\"green\"><md-button ng-disabled=\"!winwin.winwin.already_joined\" ng-click=\"winwin.vote(item_post, true)\" class=\"md-icon-button\" style=\"cursor: pointer;\"><md-icon class=\"icon thumb_up\">thumb_up</md-icon><md-tooltip md-visible=\"like.showTooltip\" md-direction=\"down\">Excelente!</md-tooltip></md-button>{{item_post.up_votes}}</div><div class=\"red\"><md-button ng-disabled=\"!winwin.winwin.already_joined\" ng-click=\"winwin.vote(item_post, false)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_down\">thumb_down</md-icon><md-tooltip md-visible=\"dislike.showTooltip\" md-direction=\"down\">No me gusta</md-tooltip></md-button>{{item_post.down_votes}}</div><md-button class=\"md-icon-button\" ng-click=\"winwin.showSharePost(item_post)\" style=\"cursor: pointer;\"><md-icon>share</md-icon><md-tooltip md-visible=\"like.showTooltip\" md-direction=\"down\">Compartir post!</md-tooltip></md-button><md-button class=\"md-icon-button bt-comment\" ng-if=\"winwin.winwin.already_joined\" ng-click=\"winwin.showReplyDialog(item_post)\"><md-icon class=\"icon insert_comment\">insert_comment</md-icon><md-tooltip md-visible=\"comentar.showTooltip\" md-direction=\"down\">Comentar a este post</md-tooltip></md-button></md-card-actions></md-card><md-card class=\"md-whiteframe-7dp\" flex-offset=\"15\" ng-repeat=\"comment in item_post.comments | orderBy:\'id\'\"><div layout=\"row\" layout-align=\"space-between center\"><div layout-padding=\"\"><md-button ng-if=\"(winwin.winwin.is_moderator || comment.user.id == winwin.account.id)\" ng-click=\"winwin.removePost(comment)\" class=\"md-icon-button\" aria-label=\"eliminar\" title=\"Eliminar Post\"><md-icon class=\"icon\" md-svg-src=\"assets/images/icon-delete.svg\"></md-icon></md-button><md-button ng-if=\"(winwin.winwin.is_moderator || comment.user.id == winwin.account.id)\" ng-click=\"winwin.showEditDialog(comment)\" class=\"editarpost\" title=\"editar comentario\" aria-label=\"edit\"><i class=\"fa fa-edit\"></i></md-button></div><div><md-card-header><md-card-header-text>{{comment.user.username}}</md-card-header-text><md-card-avatar><img class=\"md-user-avatar\" ng-src=\"{{winwin.imageServer}}/30x30/{{comment.user.photo}}\" ui-sref=\"home.public-profile({userId: comment.user.id})\"></md-card-avatar></md-card-header></div></div><md-card-content><div ng-if=\"comment.comment_edit.length == 0\"><p>{{comment.content}}</p></div><div ng-repeat=\"c in comment.comment_edit\" ng-show=\"$first\"><p>{{c.content}}</p></div><div ng-show=\"comment.media.type == \'IMAGE\'\" class=\"materialboxed _embed-responsive _embed-responsive-16by9\" style=\"height: 225px;width:100%; margin-top:30px; margin-bottom:10px; background:linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));\"><img ng-src=\"{{winwin.imageServer}}/400x/smart/{{comment.media.name}}\" class=\"img-responsive\"></div><div ng-show=\"comment.media.type == \'VIDEO\'\" class=\"embed-responsive embed-responsive-16by9\" style=\"margin-top:30px;\"><iframe class=\"embed-responsive-item\" ng-src=\"{{winwin.getIframeSrc(comment.media.path)}}\" allowfullscreen=\"\" style=\"width: 100%;height: 225px;\"></iframe></div></md-card-content><md-card-actions layout=\"row\" layout-margin=\"\" layout-align=\"start end\"><div><md-icon class=\"icon icon-access_time\">access_time</md-icon>{{comment.created_at | moment: \'DD/MM/YYYY\' }}</div><div class=\"green\"><md-button ng-disabled=\"!winwin.winwin.already_joined\" ng-click=\"winwin.vote(comment, true)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_up\">thumb_up</md-icon></md-button>{{comment.up_votes}}</div><div class=\"red\"><md-button ng-disabled=\"!winwin.winwin.already_joined\" ng-click=\"winwin.vote(comment, false)\" class=\"md-icon-button\"><md-icon class=\"icon thumb_down\">thumb_down</md-icon></md-button>{{comment.down_votes}}</div></md-card-actions></md-card></div></div><br><br><br>");
$templateCache.put("app/winwin/winwin.html","<md-content class=\"acme-winwin\" hide=\"\" show-xs=\"\"><a href=\"#\" class=\"back-to-top\" hide-xs=\"\"><i class=\"fa fa-arrow-up animated infinite pulse\"></i></a><md-tabs md-dynamic-height=\"\"><md-tab md-on-select=\"winwin.show_box_muro = true\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-comments.svg\"></md-icon></md-tab-label><md-tab-body><div layout=\"column\" hide=\"\" show-xs=\"\"><div flex=\"\"><md-card class=\"md-whiteframe-4dp no-padding\"><md-card-content><status-ribbon caption=\"CANCELADO\" background-color=\"#d34836\" ng-if=\"winwin.winwin.canceled\"></status-ribbon><status-ribbon caption=\"CONCRETADO\" ng-if=\"winwin.winwin.is_successful\"></status-ribbon><status-ribbon caption=\"VENCIDO\" background-color=\"#d34836\" ng-if=\"!winwin.winwin.is_successful && !winwin.winwin.canceled && winwin.winwin.outdated\"></status-ribbon><div class=\"icon-concretado\" ng-hide=\"winwin.winwin.is_video\" style=\"font-size: 35px; text-shadow: 1px 1px 5px #333; text-transform: uppercase; color: #fff; text-align: center; font-weight: bold;\" ng-if=\"winwin.winwin.is_successful\"><i class=\"fa fa-child fadeInLeft\" style=\"text-shadow: none; font-size: 110px; color: white; font-size: 90px;border: 8px solid #fff;color: white; border-radius: 100%; padding: 10px 30px; background: #4cae4e;\"></i><br>¡Lo hicimos!</div><div class=\"icon-concretado\" style=\"font-size: 90px; text-shadow: 1px 1px 3px #333; text-transform: uppercase;\" ng-if=\"winwin.winwin.is_succesful && winwin.winwin.outdated\"><i class=\"fa fa-clock-o animated infinite fadeIn\" style=\"font-size: 110px;color: white;background: #d34836;border-radius: 100%;padding: 10px;\"></i><br><br>Se pas&oacute; el tiempo.</div><div class=\"icon-concretado\" style=\"font-size: 40px; text-shadow: 1px 1px 3px rgb(51, 51, 51); text-transform: uppercase; color: #fff; text-align: center;\" ng-if=\"winwin.winwin.canceled\"><i class=\"fa fa-exclamation-circle infinite fadeIn\" style=\"font-size: 60px;color: #fff; background: #d24735;border-radius: 100%;padding: 10px;\"></i> Cancelado</div><div class=\"rate-box\" ng-show=\"false\"><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button></div><div class=\"\"><img ng-src=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" alt=\"\" class=\"md-card-img\" ng-if=\"!winwin.winwin.is_video\"><iframe class=\"embed-responsive-item\" ng-src=\"{{winwin.getIframeSrc(winwin.winwin.video)}}\" allowfullscreen=\"\" style=\"width: 100%;height: 300px;\" ng-if=\"winwin.winwin.is_video\"></iframe></div><md-card-title-text ng-hide=\"winwin.winwin.is_video\" layout-align=\"center center\" layout=\"column\" hide-gt-sm=\"\"><md-button class=\"md-headline\" aria-label=\"title\">{{winwin.winwin.title}}</md-button></md-card-title-text><div class=\"card-labels\"><i class=\"icon fa fa-clock-o\" ng-if=\"winwin.winwin.finishing\" ng-cloak=\"\" style=\"font-size: 20px;color: white;background: #587aba;padding: 10px; margin-top: 10px;\"></i> <i class=\"icon fa fa-fire\" ng-if=\"winwin.winwin.popular\" style=\"font-size: 17px;color: white;background: #d34836;padding: 5px 8px; margin-top: 10px;\"></i><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\" ng-if=\"winwin.winwin.remarkable\" style=\"margin-top: -5px; height: 60px;\">highlighted</md-icon></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"space-between center\"><div class=\"card-numbers\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-item-text bg-green\"><a ng-href=\"\" ng-click=\"winwin.showParticipantesDialog()\"><h3>Somos</h3></a> <a ng-href=\"\" ng-click=\"winwin.showParticipantesDialog()\" style=\"cursor: pointer;\"><p>{{winwin.winwin.users_already_joined}}</p></a></div><div class=\"md-item-text bg-orange\" ng-show=\"winwin.hasUsersLeft()\"><h3 translate=\"\">Faltan</h3><p ng-show=\"winwin.winwin.users_left\">{{winwin.winwin.users_left}}</p><p class=\"infinito\" ng-show=\"!winwin.winwin.users_left\">{{\"&infin;\"}}</p></div><div class=\"md-item-text bg-orange\" ng-show=\"winwin.quorum_movil\"><h3 translate=\"\">M&aacute;ximo</h3><p style=\"background: grey;\">{{winwin.winwin.users_amount}}</p></div></div></div><div class=\"\" ng-show=\"winwin.winwin.has_date && !winwin.winwin.outdated\"><h3 translate=\"\">Hay tiempo hasta el</h3><strong><md-icon class=\"icon icon-access_time\">access_time</md-icon><span style=\"color: green;\"><strong>{{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}</strong></span></strong></div><div class=\"\" ng-if=\"winwin.winwin.outdated\" ng-show=\"winwin.winwin.has_date\"><h3 translate=\"\"><span style=\"color: red;\">Ya no hay tiempo...</span></h3><strong><md-icon class=\"icon icon-access_time\">access_time</md-icon>{{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}</strong></div><div class=\"card-time\" ng-show=\"!winwin.winwin.has_date\"><h3 translate=\"\">Sin límite de tiempo</h3><strong><span style=\"font-size: 20px;\">{{\"&infin;\"}}</span></strong></div></md-card-actions></md-card></div><div flex=\"\" style=\"padding: 20px;\"><br><md-button ng-model=\"winwin.winwin\" ui-sref=\"home.editar-winwin({winwinId: winwin.winwin.id})\" ng-if=\"winwin.winwin.editable\"><i class=\"fa fa-edit\"></i> Editar</md-button><div layout=\"column\" layout-align=\"center start\"><div flex=\"83\"><md-button ng-show=\"winwin.winwin.is_video\" class=\"md-headline\" aria-label=\"title\">{{winwin.winwin.title}}</md-button><p class=\"detalle\" ng-if=\"winwin.quorum_fijo && !winwin.winwin.is_successfull\"><strong>¿Si supieras que somos {{winwin.winwin.users_amount}} personas</strong> para {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><p class=\"detalle\" ng-if=\"winwin.quorum_movil && !winwin.winwin.is_successfull\"><strong>¿Si supieras que somos entre {{winwin.winwin.min_users_amount}} y {{winwin.winwin.users_amount}} personas</strong> para {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><p class=\"detalle\" ng-if=\"winwin.quorum_ilimitado && !winwin.winwin.is_successfull\"><strong>¿Si supieras que todos vamos a</strong> {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><div class=\"more-details\"><md-button aria-label=\"menu\" class=\"md-raised\" ng-click=\"open = !open\">Más detalles</md-button><div class=\"toggle-content\" ng-show=\"open\"><div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\" class=\"slide-detalles\" ng-show=\"winwin.winwin.description\"><p ng-bind-html=\"winwin.sanitized_description\"></p></div><div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\" class=\"slide-detalles\"><div><h3>Estado:</h3><p class=\"activo\"><md-icon>done</md-icon>{{winwin.winwin.published? \'Activo\' : \'Inactivo\'}}</p></div><div><h3>Escala:</h3><p class=\"escala\"><md-icon>public</md-icon><strong>{{winwin.winwin.scope}}</strong>{{winwin.winwin.location.formatted_address}}</p></div><div><md-button ng-href=\"\" ng-click=\"winwin.reportWinwin()\" class=\"no-padding\"><i class=\"fa fa-exclamation-circle danger\"></i> Reportar</md-button></div></div><div class=\"slide-categorias content-bg\" ng-if=\"winwin.winwin.interests.length > 0\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><h4>Categorías:</h4><div ng-repeat=\"category in winwin.winwin.interests\">{{category.description}}</div></div></div></div><div style=\"padding:0px; margin-top:5px;\" hide=\"\" show-gt-xs=\"\"><a ng-href=\"\" class=\"ver-mas\" ng-click=\"winwin.showMasDetalleDialog()\" ng-if=\"winwin.winwin.description\" hide=\"\" show-gt-sm=\"\">+ VER MAS DETALLES</a> <a ng-href=\"\" aria-label=\"facebook\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"feed\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-via=\"{{winwin.facebookId}}\"><i class=\"fa fa-facebook social-ww-icons fb\"></i></a> <a ng-href=\"\" aria-label=\"twitter\" socialshare=\"\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-provider=\"twitter\"><i class=\"fa fa-twitter social-ww-icons tw\"></i></a> <a socialshare=\"\" ng-href=\"\" aria-label=\"google\" socialshare-provider=\"google\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\"><i class=\"fa fa-google social-ww-icons gl\"></i></a> <a ng-href=\"\" aria-label=\"email\" ng-click=\"winwin.showModalShareEmailDialog()\"><i class=\"fa fa-envelope-o social-ww-icons em\"></i></a><div class=\"fb-like\" data-href=\"{{winwin.base}}/#/winwin/{{winwin.winwinId}}\" data-layout=\"button_count\" data-action=\"like\" data-size=\"small\" data-show-faces=\"true\" data-share=\"false\" style=\"margin-left: 10px;\"></div></div><br><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"winwin.winwin.canJoin\" ng-click=\"winwin.join()\">SI, ME SUMO!</md-button><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"false && winwin.winwin.already_joined && !winwin.winwin.canceled\" ng-click=\"winwin.showGroupsModal()\">SUGERIR WINWIN A GRUPO</md-button><div class=\"califica\" ng-show=\"false\"><p translate=\"\">CALIFICA LA CAMPAÑA DE ESTE WINWIN</p><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button></div></div></div><div layout=\"row\" hide-xs=\"\"><div flex=\"\"><br><img ng-src=\"{{winwin.imageServer}}/{{winwin.winwin.user.photo}}\" alt=\"\" style=\"border-radius: 100%; width: 60px; height: 60px; border: 3px solid #fff;\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><md-button style=\"line-height: 1; margin-top: -30px; text-transform: capitalize;\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><span style=\"border-bottom: 1px dashed #999;\">{{winwin.winwin.user.detail.name}} {{winwin.winwin.user.detail.lastname}}</span></md-button></div><div flex=\"\"><br><md-button ng-if=\"winwin.showSendMessageButton()\" style=\"border: 2px solid #666; padding: 5px; font-family: montserrat; padding: 0 10px 0 10px; text-transform: capitalize;\" ng-click=\"winwin.showMessageModal(0, [])\"><i class=\"fa fa-share\"></i> Enviar mensaje a {{winwin.winwin.user.detail.name}}</md-button></div></div><div class=\"creadores\" layout=\"row\"><div hide=\"\" show-xs=\"\" flex=\"\"><img ng-src=\"{{winwin.imageServer}}/{{winwin.winwin.user.photo}}\" alt=\"\" class=\"avatar-creador style-rounded\" style=\"width: 60px; height: 60px\"><h3>{{winwin.winwin.user.detail.name}} {{winwin.winwin.user.detail.lastname}}</h3><md-button ng-if=\"winwin.showSendMessageButton()\" style=\"font-family: montserrat; font-size: 12px;\" ng-click=\"winwin.showMessageModal(0, [])\"><i class=\"fa fa-share\"></i> <span style=\"border-bottom: 1px dashed #58585;\">Enviar mensaje a {{winwin.winwin.user.detail.name}}</span></md-button></div></div><ng-include src=\"\'app/winwin/ww-buttons.tmpl.html\'\"></ng-include></div></div><ng-include src=\"\'app/winwin/winwin-wall.tmpl.html\'\" hide=\"\" show-xs=\"\"></ng-include></md-tab-body></md-tab><md-tab md-on-select=\"winwin.show_box_muro = false\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-sponsors-title.svg\"></md-icon></md-tab-label><md-tab-body><div class=\"notice-star\" ng-if=\"!winwin.sponsors.length\"><md-icon>star_rate</md-icon><p transalte=\"\">AÚN NO HAY SPONSORS!</p></div><md-button class=\"bt-green\" ng-show=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.showRequestSponsorshipMessageModal()\">Solicitar ser Sponsor</md-button><md-card class=\"mobile\" ng-repeat=\"sponsor in winwin.sponsors\"><md-card-content><img ng-src=\"{{winwin.imageServer}}/smart/{{sponsor.cover_photo}}\" class=\"md-card-image\" alt=\"\" style=\"min-width: 100%;\"></md-card-content></md-card></md-tab-body></md-tab><md-tab md-on-select=\"winwin.show_box_muro = false\"><md-tab-label><md-icon md-svg-icon=\"assets/images/icon-miembros.svg\"></md-icon></md-tab-label><md-tab-body><md-card class=\"mobile mobile-members\" ng-repeat=\"participante in winwin.winwin.users\"><md-card-content href=\"\" ui-sref=\"home.public-profile({userId: participante.id})\" style=\"cursor: pointer;\"><img ng-src=\"{{winwin.imageServer}}/{{participante.cover_photo}}\" class=\"md-card-image\" alt=\"\"><md-card-title><div layout=\"row\" layout-align=\"space-around end\" class=\"md-card-members\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{winwin.imageServer}}/smart/{{participante.photo}}\" class=\"md-card-avatar\" alt=\"\"><div class=\"email\">{{participante.username}}</div><md-button class=\"bt-green\" ng-show=\"false\">Seguir</md-button></div></div></md-card-title></md-card-content></md-card></md-tab-body></md-tab><md-tab md-on-select=\"winwin.show_box_muro = false\"><md-tab-label><i class=\"fa fa-envelope-o\" style=\"font-size: 16px; color: #fff;\"></i></md-tab-label><md-tab-body><div ng-if=\"winwin.isAuthenticated()\"><md-button class=\"bt-blue\" ng-if=\"winwin.showSendMessageButton()\" ng-click=\"winwin.showMessageModal(0, [])\"><i class=\"fa fa-envelope-o\"></i> Mensaje a {{winwin.winwin.user.detail.name}}</md-button><md-card class=\"inbox-title\" style=\"cursor: none;\" ng-if=\"!winwin.showSendMessageButton() && winwin.isCreator\">Mensajes con los participantes:</md-card><md-card class=\"inbox-title\" style=\"cursor:none;\" ng-if=\"!winwin.showSendMessageButton() && !winwin.isCreator\">Mensajes con el creador</md-card><div class=\"mensajes-recibidos-content\" ng-repeat=\"cnv in winwin.conversations\"><div ng-repeat=\"message in cnv.messages\"><md-card class=\"mensajeria\" style=\"max-width: 300px\" layout=\"row\" ng-click=\"winwin.showMessageModal(cnv.id, cnv.messages)\" ng-if=\"$last\" layout-align=\"space-around-end\"><img ng-src=\"{{winwin.imageServer}}/{{cnv.show_avatar[0]}}\" alt=\"\" class=\"avatar-creador-mensajeria\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><p class=\"msg-body\" style=\"float:left;\">{{ message.body }}</p><p class=\"msg-name\">{{message.name}}</p></md-card></div></div><md-card class=\"inbox-title\" ng-if=\"!winwin.showSendMessageButton() && winwin.conversations.length == 0\"><div class=\"sin-mensajes\">No hay mensajes...</div></md-card></div></md-tab-body></md-tab></md-tabs></md-content><md-content class=\"acme-winwin\" hide-xs=\"\"><div class=\"container\" hide-xs=\"\"><div layout=\"row\"><div flex=\"50\"><md-card class=\"md-whiteframe-4dp no-padding\"><md-card-content><status-ribbon caption=\"CANCELADO\" background-color=\"#d34836\" ng-if=\"winwin.winwin.canceled\"></status-ribbon><status-ribbon caption=\"CONCRETADO\" ng-if=\"winwin.winwin.is_successful\"></status-ribbon><status-ribbon caption=\"VENCIDO\" background-color=\"#d34836\" ng-if=\"!winwin.winwin.is_successful && !winwin.winwin.canceled && winwin.winwin.outdated\"></status-ribbon><div class=\"icon-concretado\" style=\"font-size: 35px; text-shadow: 1px 1px 5px #333; text-transform: uppercase; color: #fff; text-align: center; font-weight: bold;\" ng-if=\"winwin.winwin.is_successful && !winwin.winwinw.is_video\"><i class=\"fa fa-child fadeInLeft\" style=\"text-shadow: none; font-size: 110px; color: white; font-size: 90px;border: 8px solid #fff;color: white; border-radius: 100%; padding: 10px 30px; background: #4cae4e;\"></i><br>¡Lo hicimos!</div><div class=\"icon-concretado\" style=\"font-size: 35px; text-shadow: 1px 1px 5px #333; text-transform: uppercase; color: #fff; text-align: center; font-weight: bold;\" ng-if=\"!winwin.winwin.is_successful && !winwin.winwin.canceled && winwin.winwin.outdated\"><i class=\"fa fa-clock-o animated infinite fadeIn\" style=\"box-shadow: none; font-size: 110px;color: white;background: #d34836;border-radius: 100%;padding: 10px;\"></i><br><br>Se pas&oacute; el tiempo.</div><div class=\"icon-concretado\" style=\"font-size: 40px; text-shadow: 1px 1px 3px rgb(51, 51, 51); text-transform: uppercase; color: #fff; text-align: center;\" ng-if=\"winwin.winwin.canceled\"><i class=\"fa fa-exclamation-circle infinite fadeIn\" style=\"text-shadow: none; font-size: 110px; color: white; font-size: 90px;border: 8px solid #fff;color: white; border-radius: 100%; padding: 5px 10px; background: #d24735;\"></i> Cancelado</div><div class=\"rate-box\" ng-show=\"false\"><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button></div><div class=\"\"><img ng-src=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" alt=\"\" class=\"md-card-img\" ng-if=\"!winwin.winwin.is_video\"><iframe class=\"embed-responsive-item\" ng-src=\"{{winwin.getIframeSrc(winwin.winwin.video)}}\" allowfullscreen=\"\" style=\"width: 100%;height: 350px;\" ng-if=\"winwin.winwin.is_video\"></iframe></div><md-card-title-text layout-align=\"center center\" layout=\"column\" hide-gt-sm=\"\"><md-button class=\"md-headline\" aria-label=\"title\">{{winwin.winwin.title}}</md-button></md-card-title-text><div class=\"card-labels\"><i class=\"icon fa fa-clock-o\" ng-if=\"winwin.winwin.finishing\" ng-cloak=\"\" style=\"margin: 5px; font-size: 20px;color: white;background: #587aba;padding: 10px; margin-top: 10px;\"></i> <i class=\"icon fa fa-fire\" ng-if=\"winwin.winwin.popular\" style=\"margin: 5px; font-size: 17px;color: white;background: #dd2c00; border: 2px solid #fff; padding: 5px 8px; margin-top: 10px;\"></i><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\" ng-if=\"winwin.winwin.remarkable\" style=\"margin-top: -5px; height:60px;\">highlighted</md-icon></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"space-between center\"><div class=\"card-numbers\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-item-text bg-green\"><a ng-href=\"\" ng-click=\"winwin.showParticipantesDialog()\"><h3>Somos</h3></a> <a ng-href=\"\" ng-click=\"winwin.showParticipantesDialog()\" style=\"cursor: pointer;\"><p>{{winwin.winwin.users_already_joined}}</p></a></div><div class=\"md-item-text bg-orange\" ng-show=\"winwin.hasUsersLeft()\"><h3 translate=\"\">Faltan</h3><p ng-show=\"winwin.winwin.users_left\">{{winwin.winwin.users_left}}</p><p class=\"infinito\" ng-show=\"!winwin.winwin.users_left\">{{\"&infin;\"}}</p></div><div class=\"md-item-text bg-orange\" ng-show=\"winwin.quorum_movil\"><h3 translate=\"\">M&aacute;ximo</h3><p style=\"background: grey;\">{{winwin.winwin.users_amount}}</p></div></div></div><div class=\"\" ng-if=\"!winwin.winwin.is_succesful && winwin.winwin.has_date && !winwin.winwin.outdated\"><h3 translate=\"\">Hay tiempo hasta el</h3><strong><md-icon class=\"icon icon-access_time\">access_time</md-icon><span style=\"color: green;\"><strong>{{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}</strong></span></strong><md-tooltip md-visible=\"fechalimite.showTooltip\" md-direction=\"down\">Sumate hasta esta el {{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}!</md-tooltip></div><div class=\"\" ng-if=\"!winwin.winwin.is_successful && !winwin.winwin.canceled && winwin.winwin.outdated\" ng-show=\"winwin.winwin.has_date\"><h3 translate=\"\"><span style=\"color: red;\">Se pas&oacute; el tiempo...</span></h3><strong><md-icon class=\"icon icon-access_time\">access_time</md-icon><span style=\"color: red;\">{{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}</span></strong><md-tooltip md-visible=\"fechalimite.showTooltip\" md-direction=\"down\">Este Winwins venci&oacute; el {{winwin.winwin.closing_date | date:\"dd/MM/yyyy\" }}!</md-tooltip></div><div class=\"card-time\" ng-show=\"!winwin.winwin.has_date\"><h3 translate=\"\">Sin límite de tiempo</h3><strong><span style=\"font-size: 20px;\">{{\"&infin;\"}}</span></strong></div></md-card-actions></md-card></div><div flex=\"\" style=\"padding: 15px;\"><br><h2 class=\"main-title\" hide-xs=\"\">{{winwin.winwin.title}}</h2><md-button ng-model=\"winwin.winwin\" ui-sref=\"home.editar-winwin({winwinId: winwin.winwin.id})\" ng-if=\"winwin.winwin.editable\"><i class=\"fa fa-edit\"></i> Editar<md-tooltip ng-show=\"winwin.winwin.is_moderator\" md-visible=\"edicion.showTooltip\" md-direction=\"down\">Edita la info de este Winwin. Solo podes hacerlo hasta que sumes tu primer participante.</md-tooltip></md-button><div layout=\"column\" layout-align=\"center start\"><div flex=\"83\"><p class=\"detalle\" ng-if=\"winwin.winwin.is_successful\"><strong>Somos {{winwin.winwin.users_amount}} personas</strong> que nos pusimos de acuerdo para {{winwin.winwin.what_we_do}}</p><p class=\"detalle\" ng-if=\"winwin.quorum_fijo\" ng-hide=\"winwin.winwin.is_successful\"><strong>¿Si supieras que somos {{winwin.winwin.users_amount}} personas</strong> que vamos a {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><p class=\"detalle\" ng-if=\"winwin.quorum_movil\" ng-hide=\"winwin.winwin.is_successful\"><strong>¿Si supieras que somos entre {{winwin.winwin.min_users_amount}} y {{winwin.winwin.users_amount}} personas</strong> que vamos a {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><p class=\"detalle\" ng-if=\"winwin.quorum_ilimitado\" ng-hide=\"winwin.winwin.is_successful\"><strong>¿Si supieras que todos vamos a</strong> {{winwin.winwin.what_we_do}} <strong>te sumarías?</strong></p><div class=\"more-details\"><md-button aria-label=\"menu\" class=\"md-raised\" ng-click=\"open = !open\">Más detalles</md-button><div class=\"toggle-content\" ng-show=\"open\"><div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\" class=\"slide-detalles\" ng-show=\"winwin.winwin.description\"><p ng-bind-html=\"winwin.sanitized_description\"></p></div><div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\" class=\"slide-detalles\"><div><md-button ng-href=\"\" ng-click=\"winwin.reportWinwin()\" class=\"no-padding\"><i class=\"fa fa-exclamation-circle danger\"></i> Reportar</md-button></div></div><div class=\"slide-categorias content-bg\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><h4>Categorías:</h4><div ng-repeat=\"category in winwin.winwin.interests\">{{category.description}}</div></div></div></div><div style=\"padding:0px; margin-top:5px;\" hide=\"\" show-gt-xs=\"\"><a ng-href=\"\" class=\"ver-mas\" ng-click=\"winwin.showMasDetalleDialog()\" ng-if=\"winwin.winwin.description\" hide=\"\" show-gt-sm=\"\">+ VER MAS DETALLES</a> <a ng-href=\"\" aria-label=\"facebook\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"feed\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-via=\"{{winwin.facebookId}}\"><i class=\"fa fa-facebook social-ww-icons fb\"></i></a> <a ng-href=\"\" aria-label=\"twitter\" socialshare=\"\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-provider=\"twitter\"><i class=\"fa fa-twitter social-ww-icons tw\"></i></a> <a socialshare=\"\" ng-href=\"\" aria-label=\"google\" socialshare-provider=\"google\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\"><i class=\"fa fa-google social-ww-icons gl\"></i></a> <a ng-hide=\"winwin.winwin.outdated\" ng-href=\"\" aria-label=\"email\" ng-click=\"winwin.showModalShareEmailDialog()\"><i class=\"fa fa-envelope-o social-ww-icons em\"></i></a><div class=\"fb-like\" data-href=\"{{winwin.base}}/#/winwin/{{winwin.winwinId}}\" data-layout=\"button_count\" data-action=\"like\" data-size=\"small\" data-show-faces=\"true\" data-share=\"false\"></div></div><br><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"winwin.winwin.canJoin\" ng-click=\"winwin.join()\">S&iacute;, ME SUMO!</md-button><md-button class=\"bt-green md-whiteframe-17dp\" ng-if=\"false && winwin.winwin.already_joined && !winwin.winwin.canceled\" ng-click=\"winwin.showGroupsModal()\">VINCULAR WINWIN A GRUPO</md-button><div class=\"califica\" ng-show=\"false\"><p translate=\"\">CALIFICA LA CAMPAÑA DE ESTE WINWIN</p><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star active\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button><md-button class=\"md-star\" md-ink-ripple=\"false\"><md-icon>star_rate</md-icon></md-button></div></div></div><div layout=\"row\" hide-xs=\"\"><div flex=\"50\"><br><img ng-src=\"{{winwin.imageServer}}/{{winwin.winwin.user.photo}}\" alt=\"\" style=\"border-radius: 100%; width: 60px; height: 60px; border: 3px solid #fff; cursor: pointer;\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><md-button style=\"line-height: 1; margin-top: -30px; text-transform: capitalize;\" ui-sref=\"home.public-profile({userId: winwin.winwin.user.id})\"><span style=\"border-bottom: 1px dashed #999;\">{{winwin.winwin.user.detail.name}} {{winwin.winwin.user.detail.lastname}}</span></md-button><md-tooltip md-visible=\"creador.showTooltip\" md-direction=\"down\" style=\"margin-top: -20px;\">{{winwin.winwin.user.detail.name}} es el creador de este winwin!</md-tooltip></div><div flex=\"\"><br><md-button ng-if=\"winwin.showSendMessageButton()\" style=\"border: 2px solid #666; padding: 5px; font-family: montserrat; padding: 0 10px 0 10px; text-transform: capitalize;\" ng-click=\"winwin.showMessageModal(0, [])\"><i class=\"fa fa-share\"></i> Enviar mensaje a {{winwin.winwin.user.detail.name}}</md-button><md-tooltip ng-if=\"winwin.showSendMessageButton()\" md-visible=\"mensaje.showTooltip\" md-direction=\"down\" style=\"margin-top: -20px;\">Envia una pregunta o mensaje a {{winwin.winwin.user.detail.name}}</md-tooltip></div></div><br><span style=\"font-family: lato; font-size: 14px;\"><strong>Estado:</strong></span> <span style=\"font-family: lato; font-size:14px;\"><i class=\"fa fa-check\" style=\"color: green;\" ng-cloak\"=\"\"></i>{{winwin.winwin.published? \'Activo\' : \'Inactivo\'}}</span> <span ng-if=\"winwin.winwin.interests.length > 0\" ng-repeat=\"category in winwin.winwin.interests\" style=\"font-family: lato; font-size: 14px;\"><strong>Tema:</strong> {{category.description}}</span></div></div></div><div class=\"container\"><aside style=\"float:left; width: 250px;\"><ng-include src=\"\'app/winwin/sponsors.tmpl.html\'\"></ng-include></aside><div style=\"float:left;\"><ng-include src=\"\'app/winwin/posteador_desktop.tmpl.html\'\"></ng-include><ng-include src=\"\'app/winwin/winwin-wall.tmpl.html\'\"></ng-include></div><aside style=\"float:right; width: 250px;\"><ng-include src=\"\'app/winwin/winwin-left-sidebar.tmpl.html\'\"></ng-include></aside></div></md-content><ng-include src=\"\'app/winwin/posteador_mobile.tmpl.html\'\" hide=\"\" show-xs=\"\"></ng-include><div class=\"fo\"><acme-footer items=\"main.footer\" style=\"position: fixed; bottom: 0px; width:100%; z-index: 9999\" hide-xs=\"\"></acme-footer></div><script>\njQuery(document).ready(function() {\n    var offset = 220;\n    var duration = 500;\n    jQuery(window).scroll(function() {\n        if (jQuery(this).scrollTop() > offset) {\n            jQuery(\'.back-to-top\').fadeIn(duration);\n        } else {\n            jQuery(\'.back-to-top\').fadeOut(duration);\n        }\n    });\n\n    jQuery(\'.back-to-top\').click(function(event) {\n        event.preventDefault();\n        jQuery(\'html, body, container\').animate({scrollTop: 0}, duration);\n        return false;\n    })\n});\n</script>");
$templateCache.put("app/winwin/ww-buttons.tmpl.html","<md-card style=\"margin:0px;\" hide=\"\" show-xs=\"\"><div flex=\"\"><md-button ng-href=\"\" aria-label=\"facebook\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"share\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/ww/{{winwin.winwin.id}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-via=\"{{winwin.facebookId}}\" class=\"md-primary\" style=\"color: #fff; background: #3b5998; width:95%;\"><i class=\"fa fa-facebook\"></i> Difundir en Facebook</md-button></div><div flex=\"\"><md-button socialshare=\"\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" socialshare-provider=\"twitter\" class=\"md-primary\" style=\"color: #fff; background: #4099FF; width:95%;\"><i class=\"fa fa-twitter\"></i> Difundir en Twitter</md-button></div><div flex=\"\"><md-button socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{winwin.winwin.title}}\" socialshare-media=\"{{winwin.imageServer}}/{{winwin.winwin.image}}\" socialshare-url=\"{{winwin.base}}/#/winwin/{{winwin.winwin.id}}\" class=\"md-primary\" style=\"color: #fff; background: #d34836; width:95%;\"><i class=\"fa fa-google\"></i> Difundir en Google +</md-button></div><div flex=\"\" ng-hide=\"winwin.winwin.outdated\"><md-button ng-click=\"winwin.showModalShareEmailDialog()\" class=\"md-primary\" style=\"color: #fff; background: orange; width:95%;\"><i class=\"fa fa-envelope-o\"></i> Invitar por Email</md-button></div><div flex=\"\" ng-hide=\"winwin.winwin.outdated\"><md-button class=\"md-primary\" style=\"color: #fff; background: #666; width:95%\" ng-show=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.showRequestSponsorshipMessageModal()\">Solicitar ser Sponsor</md-button></div><div flex=\"\"><md-button class=\"md-primary\" style=\"color: #fff; background: #f60; width:95%\" ng-show=\"winwin.winwin.is_moderator\" ng-href=\"\" ng-click=\"winwin.showModalPollDialog()\"><i class=\"fa fa-list-ol\" aria-hidden=\"true\"></i> Crear una encuesta</md-button><md-tooltip md-visible=\"encuesta.showTooltip\" md-direction=\"right\">Crea una encuesta para los participantes</md-tooltip></div><div class=\"content-bg\" style=\"text-align:center\" ng-if=\"winwin.winwin.already_joined && (winwin.isCreator || winwin.campanadas.length > 0)\"><h3 class=\"title-notificaction\"><md-icon>notifications</md-icon><span class=\"badge\" ng-show=\"(winwin.campanadas | filter:{is_read:0}).length > 0\">{{(winwin.campanadas | filter:{is_read:0}).length }}</span><md-button ng-if=\"!winwin.winwin.is_moderator\" ng-click=\"winwin.showCampanadasDialog()\">Campanada activa!</md-button><md-button ng-if=\"winwin.winwin.is_moderator\" ng-click=\"winwin.showCampanadasDialog()\">Enviar campanada</md-button></h3></div></md-card><md-card style=\"margin:0px;\"><div class=\"content-bg\" ng-if=\"!winwin.winwin.is_successful && winwin.winwin.already_joined && !winwin.winwin.canceled && !winwin.winwin.is_creator\" style=\"margin-left:10px;\"><p><md-button ng-href=\"\" ng-click=\"winwin.left()\" class=\"no-padding\"><md-icon md-svg-src=\"assets/images/icon-entrar.svg\"></md-icon>Abandonar este Winwin</md-button></p></div><div class=\"content-bg\" ng-if=\"winwin.winwin.is_creator && !winwin.winwin.canceled\"><p><md-button ng-href=\"\" ng-click=\"winwin.close()\" class=\"no-padding\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i> Cancelar Winwin</md-button></p></div><div class=\"content-bg\"><p><div ng-href=\"\" ng-click=\"winwin.reportWinwin()\" class=\"no-padding\"><p style=\"font-family: lato; cursor: pointer; margin: 10px\"><i class=\"fa fa-exclamation-circle danger\"></i> Reportar este Winwin</p><md-tooltip md-visible=\"reportar.showTooltip\" md-direction=\"down\">Este winwin incumple nuestros terminos? Reportalo.</md-tooltip></div></p></div></md-card>");
$templateCache.put("app/components/contador/contador.html","<md-content class=\"acme-contador\"><div class=\"container\"><div layout-gt-xs=\"row\" layout-align=\"space-around center\"><div flex=\"\"><md-icon md-svg-src=\"assets/images/counter-winwin-icon.svg\"></md-icon><h2 class=\"orange\">WINWINS</h2><p class=\"counters-section-subtitles\">Son desafios positivos que, en equipo, se hacen realidad</p><br></div><div flex=\"\"><md-icon md-svg-src=\"assets/images/group-icon.svg\"></md-icon><h2 class=\"group-counter-title\">GRUPOS</h2><p class=\"counters-section-subtitles\"><translate>Son personas como vos, dialogando y decidiendo sobre intereses comunes</translate></p></div><div flex=\"\"><md-icon md-svg-src=\"assets/images/counter-sponsors-icon.svg\"></md-icon><h2 class=\"sponsor-counter-title\" translate=\"\">SPONSORS</h2><p class=\"counters-section-subtitles\"><translate>Son organizaciones que pueden apoyar un desafio Winwin o un Grupo</translate></p></div></div></div></md-content>");
$templateCache.put("app/components/footer/footer.html","<md-content class=\"acme-footer\" hide-xs=\"\"><div class=\"footer-buttons\" layout=\"row\" layout-align=\"center center\" layout-xs=\"column\"><md-button class=\"ver-winwin-button\" hide-sm=\"\" ui-sref=\"home.winwin-list()\"><strong>Explorar Winwins</strong></md-button><md-button class=\"footer-button\" href=\"#/weare\">¿Qué es Winwins?</md-button><a class=\"privacidad\" href=\"#/terms\" target=\"_blank\"><i class=\"fa fa-lock\"></i> T&eacute;rminos y Condiciones</a><md-button class=\"footer-button\" href=\"#/about\">¿C&oacute;mo funciona?</md-button><md-button class=\"footer-button\" href=\"#/contact\">Contactanos</md-button><md-button class=\"footer-button\" href=\"http://blog.winwins.org\" target=\"_blank\">Blog</md-button></div></md-content><md-content class=\"acme-footer\" hide=\"\" show-xs=\"\"><div class=\"footer-buttons\" layout=\"row\" layout-align=\"center center\" layout-xs=\"column\"><md-button class=\"footer-button\" style=\"width:100%\" href=\"#/weare\">¿Qué es Winwins?</md-button><md-button class=\"footer-button\" style=\"width:100%\" href=\"#/about\">¿C&oacute;mo funciona?</md-button><md-button class=\"footer-button\" style=\"width:100%\" href=\"#/contact\">Cont&aacute;ctanos</md-button><md-button class=\"footer-button\" style=\"width:100%\" href=\"http://blog.winwins.org\" target=\"_blank\">Blog</md-button><a class=\"privacidad\" align=\"center\" style=\"color: #fff; text-align: center; font-size: 12px;\" href=\"#/terms\" target=\"_blank\"><br><i class=\"fa fa-lock\"></i> T&eacute;rminos y Condiciones</a></div><div class=\"footer-buttons layout-xs-column layout-align-center-center layout-row\" layout=\"row\" layout-align=\"center center\" layout-xs=\"row\"><a class=\"social-footer-icons\" href=\"http://facebook.com/winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-facebook\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://twitter.com/winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-twitter\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://www.instagram.com/winwinsorg/\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-instagram\"></i></span></a> <a class=\"social-footer-icons\" href=\"https://plus.google.com/102466089483841190346?hl=es\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-google\"></i></span></a> <a class=\"social-footer-icons\" href=\"http://youtube.com/user/Winwinsorg\" target=\"_blank\"><span class=\"ng-scope\"><i class=\"fa fa-youtube\"></i></span></a><br></div><br><br><br><span class=\"color: transparent;\">Winwins.org</span><br><div></div></md-content>");
$templateCache.put("app/components/footer/que-es-winwins.tmpl.html","<div class=\"video-container\" style=\"z-index: 9999999999999\"><iframe width=\"100%\" height=\"100%\" src=\"https://www.youtube.com/embed/UZh9QzkCY3c?autoplay=1;rel=0&amp;showinfo=0\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div><style>\n\n.video-container {\nposition: relative;\nmin-height: 600px;\nwidth: 960px;\noverflow: hidden;\n}\n \n.video-container iframe,\n.video-container object,\n.video-container embed {\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 960px;\nheight: 600px; }\n\n\n@media only screen and (max-device-width:480px){\n       /* styles for mobile browsers smaller than 480px; (iPhone) */\n       .video-container {\nposition: relative;\nmin-height: 200px;\nwidth: 300px;\npadding-bottom: 56.25%;\nheight: 0; overflow: hidden;\n}\n \n.video-container iframe,\n.video-container object,\n.video-container embed {\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\n}\n}\n\n</style>");
$templateCache.put("app/components/group_list/group_list.html","<md-content class=\"group-list\"><div class=\"container\" layout=\"column\"></div><div layout=\"column\" class=\"title-container\" layout-align=\"center center\" layout-margin=\"\"><span class=\"title\" ng-if=\"vm.title\">{{ vm.title }}</span> <span class=\"subtitle\" ng-if=\"vm.title\" style=\"font-family: montserrat; font-weight: bold;\"><translate></translate></span></div><div layout=\"row\" layout-wrap=\"\" layout-margin=\"\" layout-xs=\"column\" layout-align=\"center center\" class=\"groups-container\"><div ng-repeat=\"item in vm.items\"><md-card ui-sref=\"home.grupo-profile({groupId: item.id})\" alt=\"{{ item.name }}\"><md-card-content><md-button class=\"md-headline\" style=\"color: #585858; text-align: center;\">{{ item.name }}</md-button><div class=\"wrap-md-card-img\"><img ng-src=\"{{ vm.imageServer }}/315x/{{ item.photo }}\" alt=\"\" class=\"md-card-img\"></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><div class=\"card-members\"><translate>Somos</translate><strong>{{ item.users_already_joined }}</strong></div></div></md-card-actions></md-card></div></div><br><br><div layout=\"row\" class=\"view-more-container\" layout-align=\"center center\"><md-button ng-show=\"vm.viewmore\" ui-sref=\"home.grupo-list\" class=\"btn-orange\" arial-label=\"see all\">{{ \'Ver todos\' | translate }}</md-button></div></md-content>");
$templateCache.put("app/components/highlighted/highlighted.html","<md-content class=\"acme-highlighted\" title=\"{{item.title}}\"><div class=\"container\" layout=\"column\"></div><div layout=\"row\" layout-align=\"center center\"></div><div layout=\"row\" layout-wrap=\"\" layout-xs=\"column\" layout-margin=\"\" layout-align=\"center center\"><div ng-repeat=\"item in vm.items\" class=\"winwins-container\" ng-show=\"!vm.loading\"><md-card><md-card-content><status-ribbon caption=\"CANCELADO\" background-color=\"#d34836\" ng-if=\"item.canceled\"></status-ribbon><status-ribbon caption=\"CONCRETADO\" ng-if=\"item.status == \'SUCCESSFUL\'\"></status-ribbon><status-ribbon caption=\"VENCIDO\" background-color=\"#d34836\" ng-if=\"item.status != \'SUCCESSFUL\' && !item.canceled && item.outdated\"></status-ribbon><div class=\"wrap-md-card-img\"><div ng-repeat=\"category in winwin.winwin.interests\">{{item.category.description}}</div><md-button class=\"md-raised md-primary\" style=\"background-color: transparent; border:0px;margin:0px;padding: 0px; width:100%;\" ui-sref=\"home.winwin({winwinId: item.id})\" title=\"{{item.title}}\"><img ng-src=\"{{vm.imageServer}}/315x/{{item.image}}\" title=\"{{item.title}}\" alt=\"\" class=\"md-card-img\"></md-button></div><div class=\"card-labels\"><i class=\"icon fa fa-clock-o\" ng-if=\"winwin.winwin.finishing\" ng-cloak=\"\" style=\"font-size: 24px;\"></i> <i class=\"icon fa fa-fire\" ng-if=\"winwin.winwin.popular\" style=\"font-size: 20px;color: white;background: #d34836;padding: 5px 8px; margin-top: 10px;\"></i><md-icon class=\"icon icon-highlighted\" md-svg-src=\"assets/images/icon-highlighted.svg\" ng-if=\"winwin.winwin.remarkable\" style=\"margin-top: -10px;\">highlighted</md-icon></div><md-card-avatar layout=\"row\" layout-align=\"start center\" style=\"margin-top: -30px;\"><md-button class=\"\" ui-sref=\"home.public-profile({userId: item.user.id})\"><img class=\"md-user-avatar\" ng-src=\"{{vm.imageServer}}/40x40/{{item.user.photo}}\" ui-sref=\"home.public-profile({userId: item.user.id})\"><md-tooltip md-visible=\"demo.showTooltip\" md-direction=\"{{demo.tipDirection}}\">{{item.user.username}}</md-tooltip></md-button></md-card-avatar></md-card-content><md-card-title-text layout-align=\"center center\" layout=\"column\"><md-button class=\"md-headline ww-card\" ui-sref=\"home.winwin({winwinId: item.id})\" title=\"{{item.title}}\"><span style=\"color: #555; margin-top: -10px;\">{{item.title}}</span></md-button></md-card-title-text><div style=\"display:block; margin-left: auto; margin-right: auto; height: 70px; max-height:70px; width: 85%; text-overflow: ellipsis; overflow: hidden; font-size: 14px; font-family: lato; color: #555; margin-top: 0px; margin-bottom: 0px; text-transform: lowercase;\"><span style=\"text-transform: capitalize;\">Vamos</span> a {{ item.what_we_do }}</div><div class=\"ultimos-participantes\" layout=\"row\" layout-align=\"start center\" style=\"cursor: pointer; padding-bottom: 0px;\"><img ng-repeat=\"usr in item.users | limitTo: 6\" class=\"md-user-avatar-members\" ng-if=\"usr.id!=item.user.id\" ng-src=\"{{vm.imageServer}}//{{usr.photo}}\" ui-sref=\"home.public-profile({userId: usr.id})\" title=\"{{usr.username}}\"></div><md-card-actions layout=\"row\" class=\"card\" layout-align=\"start center\"><div class=\"somos\">Somos <span class=\"card-num\">{{ item.users_already_joined }}</span></div><div socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"feed\" socialshare-text=\"{{item.title}}\" socialshare-url=\"{{vm.base}}/ww/{{item.id}}\" socialshare-media=\"{{vm.imageServer}}/{{item.image}}\" socialshare-via=\"{{vm.facebookId}}\"><md-button class=\"md-icon-button\"><i class=\"fa fa-facebook icons-card\"></i></md-button></div><div socialshare=\"\" socialshare-text=\"{{item.title}}\" socialshare-url=\"{{vm.base}}/ww/{{item.id}}\" socialshare-provider=\"twitter\"><md-button class=\"md-icon-button\"><i class=\"fa fa-twitter icons-card\"></i></md-button></div><div socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{item.title}}\" socialshare-media=\"{{vm.imageServer}}/{{item.image}}\" socialshare-url=\"{{vm.base}}/ww/{{item.id}}\"><md-button class=\"md-icon-button\" aria-label=\"Settings\"><i class=\"fa fa-google icons-card\"></i></md-button></div></md-card-actions></md-card></div></div></md-content>");
$templateCache.put("app/components/highlighted/modal-share.tmpl.html","<div layout=\"column\" class=\"lightbox-crear\" style=\"max-height: 110px; background: #fff;\"><md-dialog-content class=\"\" style=\"max-height: 110px; background: #fff;\"><div layout=\"row\" layout-align=\"center center\" layout-margin=\"\" class=\"comparti-social-media\"><div class=\"fb\" socialshare=\"\" socialshare-provider=\"facebook\" socialshare-type=\"feed\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-url=\"{{vm.base}}/ww/{{vm.winwin.id}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.winwin.image}}\" socialshare-via=\"{{vm.facebookId}}\"><md-icon md-svg-src=\"assets/images/icon-facebook-share.svg\" ng-href=\"#\" target=\"_blank\"></md-icon></div><div class=\"tw\" socialshare=\"\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-url=\"{{vm.base}}/ww/{{vm.winwin.id}}\" socialshare-provider=\"twitter\"><md-icon md-svg-src=\"assets/images/icon-twitter-share.svg\" ng-href=\"#\" target=\"_blank\"></md-icon></div><div class=\"go\" socialshare=\"\" socialshare-provider=\"google\" socialshare-text=\"{{vm.winwin.title}}\" socialshare-media=\"{{vm.imageServer}}/{{vm.winwin.image}}\" socialshare-url=\"{{vm.base}}/ww/{{vm.winwin.id}}\"><md-icon md-svg-src=\"assets/images/icon-google-share.svg\" ng-href=\"#\" target=\"_blank\"></md-icon></div></div></md-dialog-content></div>");
$templateCache.put("app/components/miembro/miembro.html","<md-content class=\"acme-miembro\" infinite-scroll=\"vm.nextPage()\"><div class=\"container\" style=\"max-width: 95%\"><h1 class=\"title\" ng-show=\"!vm.hideExtra\"><md-icon md-svg-src=\"assets/images/icon-members.svg\"></md-icon>{{ \'MIEMBROS\' | translate }} <small>{{ \'Personas que crean y participan en acciones de consenso colectivo\' | translate }}</small></h1><div layout=\"row\" layout-align=\"center\" layout-wrap=\"\"><div ng-repeat=\"item in vm.items\" flex-gt-md=\"15\" ui-sref=\"home.public-profile({userId: item.id})\" style=\"text-align: center\"><img ng-src=\"{{winwin.imageServer}}/{{participante.cover_photo}}\" class=\"md-card-image\" alt=\"\"><div class=\"acme-miembro-thumb\"><img ng-src=\"{{vm.imageServer}}/smart/{{item.photo}}\" alt=\"{{item.username}}\"><div ng-if=\"item.has_wings\"><img class=\"wings animate infinite pulse\" src=\"../assets/images/wings.png\" width=\"30\" style=\"border-radius: 0px; border-color: transparent; width: 60px; height: 70px; margin-top: -70px; margin-left: 60px;\"></div><p style=\"text-transform: capitalize; font-size: 14px; text-align: center;\">{{item.username?item.username:item.name+\' \'+item.lastname}}</p></div></div></div><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-primary md-right\" ui-sref=\"home.miembros\">{{\'+ Ver todos los participantes\' | translate }}</md-button><h3 ng-if=\"!vm.isAuthenticated() && !vm.hideExtra\">{{ \'Sólo faltas vos,\' | translate }} <span>{{ \'sumate!\' | translate }}</span></h3><md-button class=\"md-raised md-green\" ng-click=\"vm.showLoginDialog()\" ng-if=\"!vm.isAuthenticated() && !vm.hideExtra\">{{\'Comenzar\' | translate }}</md-button></div></div></md-content>");
$templateCache.put("app/components/navbar/navbar.html","<div layout-align=\"column\"><md-toolbar md-scroll-shrink=\"\" lg=\"true\" layout-align=\"center center\" layout=\"row\"><div class=\"menu hide-xs\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\"><div><md-input-container md-no-float=\"\" class=\"md-block\" style=\"padding: 0px;\"><input required=\"required\" ng-model=\"vm.search_query\" enter=\"vm.search()\" placeholder=\"{{ \'Buscar\' | translate }}\"><md-icon ng-click=\"vm.search()\" ng-cloak=\"\">search</md-icon></md-input-container><md-tooltip md-visible=\"buscar.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\"><i class=\"fa fa-search\"></i> Busca Winwins y Usuarios</md-tooltip></div></div><div><a href=\"#\" class=\"md-primary logo-md\"><img src=\"../assets/images/logo.svg\" alt=\"\"></a></div><div class=\"seccion space-left\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button menu-notifications\" aria-label=\"Login\" ng-if=\"vm.isAuthenticated()\" ng-click=\"vm.showNotificationsDialog()\"><md-icon>notifications</md-icon><span class=\"badge animated pulse\" ng-show=\"(vm.notifications | filter:{is_read:0}).length > 0\">{{(vm.notifications | filter:{is_read:0}).length }}</span><md-tooltip md-visible=\"notififcaciones.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\"><i class=\"fa fa-bell-o\"></i> Ver Notificaciones</md-tooltip></md-button><md-button class=\"md-primary create-winwin-button\" hide-sm=\"\" ui-sref=\"home.winwin-list\" ng-show=\"!vm.isAuthenticated()\" style=\"box-shadow: 1px 1px 2px #333; background-color:#3c6cc1; padding-left: 5px;padding-right: 5px; width: 115px; padding-top: 14px;\"><translate><strong>VER WINWINS</strong></translate><md-tooltip md-visible=\"ver.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\"><i class=\"fa fa-bulleye\"></i> Descubr&iacute; nuevos Winwins</md-tooltip></md-button><button hide-sm=\"\" ui-sref=\"home.winwin-list\" ng-show=\"vm.isAuthenticated()\" style=\"border:none; background-color: transparent; color:#fff; font-family: montserrat;\"><translate><strong>VER</strong></translate></button><md-button ng-show=\"!vm.isAuthenticated()\" class=\"md-primary create-winwin-button\" hide-sm=\"\" ng-click=\"$root.createWinwin()\" style=\"box-shadow: 1px 1px 2px #333; background-color:#e56f29; padding-left: 5px; width: 140px;\"><translate><strong>+ CREAR WINWIN</strong></translate><md-tooltip md-visible=\"crear.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\">Vamos a crear un Winwin!</md-tooltip></md-button><md-button ng-show=\"vm.isAuthenticated()\" class=\"md-primary create-winwin-button\" hide-sm=\"\" ng-click=\"$root.createWinwin()\" style=\"box-shadow: 1px 1px 2px #333; background-color:#e56f29; padding-left: 5px; width: 80px;\"><translate><strong>+ CREAR</strong></translate><md-tooltip md-visible=\"crear.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\">Vamos a crear un Winwin!</md-tooltip></md-button><md-button ng-if=\"!vm.isAuthenticated()\" class=\"md-primary create-winwin-button\" ng-href=\"\" ng-click=\"vm.showLoginDialog()\" style=\"box-shadow: 1px 1px 2px #333; background-color: #3c6cc1; padding-left: 5px; width: 90px; padding-top: 12px;\"><translate><strong><i class=\"fa fa-sign-in\"></i> ENTRAR</strong></translate><md-tooltip md-visible=\"crear.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\">Ingresa o Registrate!</md-tooltip></md-button><md-button class=\"avatar-button\" ng-if=\"vm.isAuthenticated()\" ui-sref=\"home.public-profile({userId: vm.account.id})\" aria-label=\"avatar\"><md-card-avatar><img class=\"md-user-avatar\" ng-src=\"{{vm.imageServer}}/80x80/{{vm.account.photo}}\"></md-card-avatar><md-tooltip md-visible=\"avatar.showTooltip\" md-direction=\"down\" style=\"background-color: #fff; color: #333; opacity: 1;\"><i class=\"fa fa-user\"></i> Ir a tu perfil</md-tooltip></md-button><div class=\"dropdown\" ng-show=\"vm.isAuthenticated()\"><md-button class=\"\" ng-click=\"vm.openLeftMenu()\"><span style=\"font-weight: bold; background-color:#3c6cc1; padding: 15px; box-shadow: 1px 1px 3px #333; border-radius: 3px;\">Menú <i class=\"fa fa-chevron-down\"></i></span></md-button><div class=\"dropdown-content\"><md-button ng-if=\"vm.isAuthenticated()\" class=\"md-primary\" ui-sref=\"home.mis-winwin({uId: vm.account.id})\"><translate><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon>Mis Winwins</span></translate></md-button><md-button class=\"md-primary\" ui-sref=\"home.winwin-list\"><translate><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon>Ver Winwins</span></translate></md-button><md-button class=\"md-primary\" ui-sref=\"home.crear-winwin\" ng-if=\"!vm.isAuthenticated()\"><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon>Crear Winwin</span></md-button><md-button class=\"md-primary\" ui-sref=\"home.crear-winwin\" ng-if=\"vm.isAuthenticated()\"><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon>Crear Winwin</span></md-button><md-button class=\"md-primary\" ui-sref=\"home.miembros\"><md-icon md-svg-src=\"assets/images/icon-miembros.svg\"></md-icon><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\">Personas</span></md-button><md-button class=\"md-primary\" ui-sref=\"home.grupo-list\"><md-icon md-svg-src=\"assets/images/icon-miembros.svg\"></md-icon><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\">Grupos</span></md-button><md-button class=\"md-primary\" ui-sref=\"home.grupo-creacion\"><md-icon md-svg-src=\"assets/images/icon-miembros.svg\"></md-icon><span style=\"font-weight: bold; color:#fff; text-transform: capitalize;\">Crear un Grupo</span></md-button><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ui-sref=\"home.profile\"><translate><span style=\"font-weight: bold;color:#fff; text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-perfil.svg\"></md-icon>Editar mi Perfil</span></translate></md-button></div><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ng-href=\"#\" ng-click=\"vm.logout();\"><translate><span style=\"font-weight: bold; color:#fff;text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-salir.svg\"></md-icon>Salir</span></translate></md-button></div><div ng-if=\"!vm.isAuthenticated()\"><md-button class=\"md-primary\" ng-href=\"#\" ng-click=\"vm.showLoginDialog()\"><translate><span style=\"font-weight: bold; color:#fff;text-transform: capitalize;\"><md-icon md-svg-src=\"assets/images/icon-salir.svg\"></md-icon>Ingresar</span></translate></md-button></div></div></div></div></div><div class=\"menu hide show-xs\"><div layout=\"row\"><div layout=\"row\"></div><div><a href=\"#\" class=\"logo-md\"><img src=\"../assets/images/logo.svg\" alt=\"\" style=\"max-width:130px; margin-top:5px\"></a></div><div class=\"seccion space-left\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button menu-notifications\" aria-label=\"Login\" ng-if=\"vm.isAuthenticated()\" ng-click=\"vm.showNotificationsDialog()\"><md-icon>notifications</md-icon><span class=\"badge\" ng-show=\"(vm.notifications | filter:{is_read:0}).length > 0\">{{(vm.notifications | filter:{is_read:0}).length }}</span></md-button><md-button hide=\"\" show-xs=\"\" ng-show=\"!vm.isAuthenticated()\" ng-click=\"vm.openLeftMenu()\" class=\"md-primary menu-toggle\"><md-icon>menu</md-icon></md-button><md-button hide=\"\" show-xs=\"\" ng-show=\"vm.isAuthenticated()\" ng-click=\"vm.openLeftMenu()\" class=\"md-primary menu-toggle\"><md-icon>menu</md-icon></md-button></div></div></div><div class=\"beta\" hide-xs=\"\">beta</div><md-button hide=\"\" show-xs=\"\" ng-if=\"!vm.isAuthenticated()\" style=\"left: -20px; position: fixed;\" class=\"md-primary\" ng-href=\"\" ng-click=\"vm.showLoginDialog()\"><h1 style=\"margin-top:9px;\"><i class=\"fa fa-sign-in\" style=\"color: #fff;\"></i></h1></md-button><div class=\"dropdownl\" ng-show=\"vm.isAuthenticated()\" hide=\"\" show-xs=\"\"><button style=\"background-color: transparent; color: #fff; font-size: 18px; border: none; position: absolute; display: block; float: left; margin: -13px 5px;\"><span><i class=\"fa fa-search\"></i></span></button><div class=\"dropdown-contentl\"><md-input-container md-no-float=\"\" style=\"border:none; margin-left: 0px; margin-right: 0px; display: block; background-color: #30477d; height:50px; border-top: 1px solid white;\"><input ng-model=\"vm.search_query\" enter=\"vm.search()\" placeholder=\"{{\'Buscar\' | translate}}\" style=\"border: none; height: 35px; background-color: #fff; width: 100%; margin: 5px; padding: 5px; border-radius: 3px;\"><md-icon class=\"search-icon\" ng-click=\"vm.search()\" style=\"padding-top: 5px; color: #fff\">search</md-icon></md-input-container></div></div></md-toolbar></div><md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-whiteframe=\"4\"><md-toolbar class=\"md-theme-indigo\" layout-align=\"center center\" ng-if=\"vm.isAuthenticated()\"><div class=\"card-wrap\"><div class=\"card-wrap-img\"><img ng-src=\"{{vm.imageServer}}/{{vm.account.cover_photo}}\" alt=\"\" class=\"md-card-image\"></div><span class=\"card-opacity\"></span></div><md-card-avatar><md-button ui-sref=\"home.public-profile({userId: vm.account.id})\" aria-label=\"avatar\" ng-click=\"vm.openLeftMenu()\"><img class=\"md-user-avatar\" ng-src=\"{{vm.imageServer}}/{{vm.account.photo}}\"></md-button></md-card-avatar><md-card-title><md-card-title-text><span class=\"md-headline\">{{\'Hola,\'| translate}} {{vm.account.name}}!</span></md-card-title-text></md-card-title></md-toolbar><md-content layout-padding=\"\"><div layout=\"column\" class=\"menu\"><div class=\"hide-gt-sm\"><md-input-container md-no-float=\"\"><input ng-model=\"vm.search_query\" enter=\"vm.search(); vm.openLeftMenu();\" placeholder=\"{{\'Buscar\' | translate}}\" style=\"width: 150px;\"><md-icon class=\"search-icon\" ng-click=\"vm.search()\">search</md-icon></md-input-container></div><div><md-button class=\"md-primary\" ui-sref=\"home.winwin-list\" ng-click=\"vm.openLeftMenu()\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon><translate>Ver Winwins</translate></md-button></div><div><md-button class=\"md-primary\" ui-sref=\"home.mis-winwin({uId: vm.account.id})\" ng-click=\"vm.openLeftMenu()\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon><translate>Mis Winwins</translate></md-button></div><div><md-button class=\"md-primary\" ui-sref=\"home.crear-winwin\" ng-click=\"vm.openLeftMenu()\" ng-if=\"vm.isAuthenticated()\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon><translate>Crear Winwin</translate></md-button><md-button class=\"md-primary\" ng-href=\"\" ng-click=\"vm.openLeftMenu(); vm.showLoginDialog(\'home.crear-winwin\');\" ng-if=\"!vm.isAuthenticated()\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon><translate>Crear Winwin</translate></md-button></div><div><md-button class=\"md-primary\" ui-sref=\"home.grupo-list\" ng-click=\"vm.openLeftMenu()\"><md-icon md-svg-src=\"assets/images/icon-cuenta.svg\"></md-icon><translate>Ver Grupos</translate></md-button></div><div><md-button class=\"md-primary\" ui-sref=\"home.grupo-creacion\" ng-click=\"vm.openLeftMenu()\" ng-if=\"vm.isAuthenticated()\"><md-icon md-svg-src=\"assets/images/icon-crear-winwins.svg\"></md-icon><translate>Crear Grupo</translate></md-button></div><div><md-button class=\"md-primary\" ui-sref=\"home.miembros\" ng-click=\"vm.openLeftMenu()\"><md-icon md-svg-src=\"assets/images/icon-miembros.svg\"></md-icon><translate>Personas</translate></md-button></div><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ui-sref=\"home.profile\" ng-click=\"vm.openLeftMenu()\"><md-icon md-svg-src=\"assets/images/icon-perfil.svg\"></md-icon><translate>Editar Perfil</translate></md-button></div><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ng-href=\"#\" ng-click=\"vm.openLeftMenu(); vm.logout();\"><md-icon md-svg-src=\"assets/images/icon-salir.svg\"></md-icon><translate>Salir</translate></md-button></div><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ng-href=\"#\" ng-click=\"vm.openLeftMenu(); vm.logout();\"></md-button></div><div ng-if=\"vm.isAuthenticated()\"><md-button class=\"md-primary\" ng-href=\"#\" ng-click=\"vm.openLeftMenu(); vm.logout();\"></md-button></div></div></md-content></md-sidenav><div><md-toolbar class=\"md-accent notice\" ng-class=\"{ true: \'green\', false: \'warning\' }[ vm.sentActivationMail ]\" layout=\"row\" layout-align=\"center center\" ng-show=\"!vm.isActive && vm.userId != null\" style=\"height: 55px; margin-top: 62px;\"><p><i class=\"fa fa-exclamation animated infinite fadeIn\"></i><strong translate=\"\">ACTIVA TU CUENTA para sumarte y crear Winwins</strong> - {{ \'Te enviamos un email a\' | translate }} <strong>{{vm.account.email}}.</strong> <span ng-show=\"!vm.sentActivationMail\">{{ \'No te llegó? Hace\' | translate }}</span> <a href=\"\" ng-click=\"vm.resendActivationMail()\" translate=\"\" ng-show=\"!vm.sentActivationMail\" ng-disabled=\"loadingFlag\">clic para reenviartelo.</a> <span ng-show=\"vm.sentActivationMail\">{{ \'Te reenviamos el mail.\' | translate }}</span></p></md-toolbar></div><style>\n\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    margin-right: 30px;\n    background-color: #3c6cc1;\n    width: 200px;\n    z-index: 1;\n    float:left;\n    font-family: montserrat;\n    font-weight: bold;\n    padding: 10px;\n    box-shadow: 1px 1px 3px #333;\n    border-radius: 3px;\n\n}\n\n.dropdown {\n    position: relative;\n    display: block;\n    float: left;\n}\n\n.dropdownl:hover .dropdown-contentl {\n    display: block;\n}\n\n.dropdownl {\n    position: absolute;\n    display: block;\n    float: left;\n    left: 0px;\n    padding: 0px;\n}\n\n.dropdown-contentl {\n    display: none;\n    position: absolute;\n    background-color: transparent;\n    min-width: 320px;\n    z-index: 1;\n    padding: 0px;\n    padding-top:12px;\n    float: left;\n    font-family: montserrat;\n    font-weight: bold;\n    border-radius: 0px;\n    max-width: 700px;\n    margin-left: 0px;\n    margin-right: 0px;\n\n}\n\n</style>");
$templateCache.put("app/components/partner/partner.html","<md-content class=\"acme-partner\"><div class=\"container\"><h1 class=\"title\"><md-icon md-svg-src=\"assets/images/icon-partners.svg\"></md-icon><translate>PARTNERS <small>ALGUNAS DE LAS ORGANIZACIONES<br>QUE CONSTRUYEN JUNTO A WINWINS</small></translate></h1><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div ng-repeat=\"item in vm.items | limitTo: 8\"><img class=\"md-user-avatar\" ng-src=\"{{vm.imageServer}}/250x120/smart/{{item.cover_photo}}\" alt=\"{{item.name}}\" title=\"{{item.name}}\"></div></div></div></md-content>");
$templateCache.put("app/components/sponsor/sponsor.html","<md-content class=\"acme-sponsor\"><div class=\"container\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align\"center=\"\" center\"=\"\"><span class=\"title\" ng-if=\"vm.title\">{{ vm.title }}</span> <span class=\"subtitle\" ng-if=\"vm.title\">Organizaciones que ofrecen recursos para concretar winwins</span></div><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div ng-repeat=\"item in vm.items\" class=\"sponsors-box\"><img ng-src=\"{{vm.imageServer}}/200x110/smart/{{item.cover_photo}}\" alt=\"{{item.name}}\" title=\"{{item.name}}\"></div></div></div></md-content>");
$templateCache.put("app/components/utils/statusribbon.tmpl.html","<span ng-style=\"{\'background-color\':vm.backgroundColor}\">{{vm.caption}}</span>");
$templateCache.put("app/components/utils/wait.tmpl.html","<md-dialog id=\"plz_wait\" style=\"background-color: white;box-shadow:none; overflow: hidden; border-radius: 100%; padding: 10px; min-width: 50px;\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" aria-label=\"wait\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><p>{{vm.message}}</p><br><div></div></div></md-dialog>");}]);